import { Children as e, Fragment as t, cloneElement as n, isValidElement as r, useCallback as i, useEffect as a, useLayoutEffect as o, useMemo as s, useRef as c, useState as l } from "react";
import { BACKGROUND_COLOR_HEX as u, Badge as d, Box as f, Button as p, Card as m, Center as h, Collapse as g, Divider as _, Flex as v, GreyGrey0 as ee, GreyGrey10 as te, GreyGrey100 as ne, GreyGrey20 as re, GreyGrey30 as y, GreyGrey40 as b, GreyGrey60 as x, GreyGrey70 as ie, GreyGrey80 as S, GreyWhite as ae, Grid as oe, GridItem as se, IconArrowInbox as ce, IconArrowRight as le, IconBag as ue, IconBuildings as de, IconCalendar as fe, IconCalendarDays as pe, IconChevronDown as me, IconChevronTop as he, IconCircleBanSign as ge, IconCircleInfo as _e, IconCreditCard as ve, IconFileBend as ye, IconPeopleCircle as be, IconPeopleIdCard as xe, Image as Se, IndigoIndigo50 as Ce, Link as we, ListItem as Te, OrderedList as Ee, Pill as De, PillRow as Oe, PopoverWrapper as ke, Primary12Regular as Ae, Primary13Regular as C, Primary13SemiBold as w, Primary14ExtendedRegular as T, Primary14ExtendedSemiBold as je, Primary14SemiBold as Me, Primary16SemiBold as Ne, Primary20SemiBold as Pe, Primary24SemiBold as Fe, REACT_TO_PDF_SCALE as Ie, ReactPdfBullet as Le, ReactPdfHollowBullet as Re, ReactPdfImage as ze, ReactPdfLink as Be, ReactPdfPage as Ve, ReactPdfSquareBullet as He, ReactPdfText as E, ReactPdfView as D, SignerStatusList as Ue, TEXT_COLOR_HEX as We, Table as Ge, Tbody as Ke, Td as qe, Text as O, Tooltip as Je, Tr as Ye, UnorderedList as Xe, isNamedPaletteColor as Ze, useNotifications as Qe } from "@sequencehq/core-components";
import { Provider as $e, atom as k, useAtom as et, useAtomValue as A, useSetAtom as tt } from "jotai";
import { ScopeProvider as nt } from "jotai-scope";
import { dequal as rt } from "dequal";
import { calculateDiscountedPrice as it, calculateIntervalMultiplier as at, downloadBlob as ot, formatFileSizeToHumanReadable as st, getSignedAssetUrl as ct, isAUsageBasedPrice as lt, isExternalAssetUrl as ut, isOpenEndedPhaseDuration as dt, registerReactPdfFonts as ft, toBillingFrequencyLabel as pt, toBillingFrequencyName as mt, toCurrencyScale as ht, toMoney as gt, toScaledMoney as j, toScaledRate as _t, useGetSignedAssetUrl as vt, useMediaQuery as yt } from "@sequencehq/utils";
import { add as bt, addDurations as xt, apiDatesAdapters as St, format as Ct, formatDuration as wt } from "@sequencehq/utils/dates";
import { match as M } from "ts-pattern";
import { useNavigate as Tt } from "react-router-dom";
import { Fragment as N, jsx as P, jsxs as F } from "react/jsx-runtime";
import Et from "tiny-invariant";
import I from "big.js";
import { inflect as Dt } from "inflection";
import { Document as Ot, pdf as kt } from "@react-pdf/renderer";
import { useHydrateAtoms as At } from "jotai/utils";
import { AlignmentType as jt, BorderStyle as Mt, Document as Nt, ExternalHyperlink as Pt, Footer as Ft, HeadingLevel as It, HeightRule as Lt, HorizontalPositionAlign as Rt, HorizontalPositionRelativeFrom as zt, ImageRun as Bt, ImportedXmlComponent as Vt, LevelFormat as Ht, LineRuleType as Ut, Packer as Wt, PageNumber as Gt, Paragraph as L, ShadingType as Kt, Table as qt, TableCell as Jt, TableLayoutType as Yt, TableRow as Xt, TextRun as R, TextWrappingType as Zt, UnderlineType as Qt, VerticalAlign as $t, VerticalPositionAlign as en, VerticalPositionRelativeFrom as tn, WidthType as nn } from "docx";
//#region src/renderers/common/quoteRenderer.guards.ts
var z = (e) => "text" in e, rn = (e) => "src" in e && "alt" in e, an = (e) => "items" in e, on = (e) => "items" in e, sn = (e) => "items" in e, cn = (e) => "phases" in e, ln = (e) => "asset" in e, un = (e) => "assetPath" in e, dn = (e) => "blockType" in e && "version" in e && "config" in e, fn = (e) => Array.isArray(e) && e.length > 0 && "styles" in e[0], pn = (e) => "columnWidths" in e && "rows" in e, mn = "d LLLL yyyy", hn = "d MMM yyyy", gn = "Open ended", _n = "Due upfront", vn = "Overall total ¹", yn = "Amended overall total ¹", bn = "Net difference", xn = {
	from: "From",
	to: "To"
}, B = {
	heading: "Terms",
	startDate: "Start date",
	duration: "Duration",
	type: "Type",
	validUntil: "Valid until",
	paymentTerms: "Payment terms"
}, Sn = "762px", Cn = Ce, wn = ({ lineTotal: e }) => ({
	description: "Name",
	quantity: "Qty",
	billingFrequency: "Billed",
	discount: "Discount",
	rate: e ? "Unit price" : "Price",
	billingPeriods: "Repeats",
	total: "Total"
}), Tn = [
	"discount",
	"rate",
	"total"
], En = [
	"description",
	"billingFrequency",
	"billingPeriods",
	"quantity",
	"discount",
	"rate",
	"total"
], Dn = ({ hasUsageBasedPrices: e, asFootnote: t = !0 }) => {
	let n = e ? "Final amount may change due to usage, proration, credit or local taxes" : "Final amount may change due to proration, credit or local taxes";
	return t ? `¹ ${n}` : n;
}, On = 1.23, kn = 1.33, An = 1.45, jn = 1.36, Mn = 1.2, Nn = 4.5, Pn = (e) => e.map((e) => {
	if (dn(e)) return M(e).with({ blockType: "bulletList" }, { blockType: "numberList" }, (t) => {
		if (t.version === 3 && sn(t.config)) return {
			...t,
			config: {
				...t.config,
				items: t.config.items.map((e) => ({
					...e,
					textAlignment: e.textAlignment ?? "left"
				}))
			}
		};
		if (t.version === 2 && on(t.config) || t.version === 1 && an(t.config)) return e;
	}).with({ blockType: "heading1" }, { blockType: "heading2" }, { blockType: "heading3" }, { blockType: "paragraph" }, (t) => {
		if (z(t.config)) return e;
	}).with({ blockType: "image" }, (t) => {
		if (rn(t.config)) return e;
	}).with({ blockType: "phases" }, (t) => {
		if (cn(t.config)) return e;
	}).with({ blockType: "coverImage" }, (t) => {
		if (t.version === 2 && un(t.config) || t.version === 1 && ln(t.config)) return e;
	}).with({ blockType: "pdfCoverImage" }, (t) => {
		if (t.version === 1 && un(t.config)) return e;
	}).with({ blockType: "divider" }, (t) => {
		if (t.version === 1) return e;
	}).with({ blockType: "table" }, (t) => {
		if (t.version === 1 && pn(t.config)) return e;
	}).exhaustive();
}).filter(Boolean), Fn = (e) => {
	let t = e ?? 0;
	return t < 1 ? 0 : t + 1;
}, In = (e) => {
	if (e.length !== 0) return e.at(-1)?.duration ? wt(e.map((e) => e.duration).filter(Boolean).reduce((e, t) => xt(e, {
		...t,
		days: Fn(t?.days)
	}), {}), { format: [
		"years",
		"months",
		"days"
	] }) : gn;
}, Ln = (e) => {
	let t = (() => {
		if (e.absolute.start) return Ct(new Date(e.absolute.start), hn);
	})(), n = e.absolute.end ? Ct(new Date(e.absolute.end), hn) : gn, r = (() => {
		if (!(!e.duration || typeof e.duration == "string")) return wt({
			...e.duration,
			days: Fn(e.duration.days)
		}, { format: [
			"years",
			"months",
			"days"
		] });
	})(), i = !!t && !!n;
	return {
		isOpenEnded: !e.absolute.end,
		dateStartResolved: t,
		dateEndResolved: n,
		durationResolved: r,
		showDateRange: i
	};
}, Rn = (e, t) => {
	let { dateStartResolved: n, dateEndResolved: r, durationResolved: i, showDateRange: a, isOpenEnded: o } = Ln(e), s = a ? o ? `From ${n} (${gn})` : `${n} to ${r}` : i || "";
	return t ? `${s} ${t}` : s;
}, V = (e) => Ze(e) ? We[e] : "inherit", H = (e) => Ze(e) ? u[e] : "transparent", zn = (e) => M(e).with("left", () => "flex-start").with("center", () => "center").with("right", () => "flex-end").with("justify", () => "space-between").exhaustive(), Bn = (e) => M(e).with("center", "right", () => !0).otherwise(() => !1), Vn = (e) => e.map((e) => typeof e == "number" ? e : 120), Hn = (e) => e || "Untitled", Un = ({ preliminaryBillingStartDate: e, phases: t, dateFormat: n = mn }) => {
	if (!e || !t.length) return;
	if (!t.at(-1)?.duration) return gn;
	let r = t.map((e) => e.duration).filter(Boolean);
	if (r.length !== 0) return Ct(r.reduce((e, t, n) => {
		let i = bt(e, t);
		return n === r.length - 1 ? i : bt(i, { days: 1 });
	}, new Date(e)), n);
}, Wn = ({ dealType: e, preliminaryBillingStartDate: t, amendment: n }) => M(e).with("AMENDMENT", () => n?.effectiveFrom).with("NEW_BUSINESS", "RENEWAL", () => t).exhaustive(), Gn = (e) => M(e).with("NEW_BUSINESS", () => "New Business").with("RENEWAL", () => "Renewal").with("AMENDMENT", () => "Amendment").exhaustive(), Kn = (e, t = mn) => {
	if (e) return Ct(new Date(e), t);
}, qn = (e) => e === void 0 ? void 0 : `Net ${e}`, Jn = (e) => `Prepared for ${e}`, Yn = ({ price: e, minimum: t }) => t ? M(t.scope.target).with("allUsage", () => "usageMetricId" in e.structure).with("specific", () => t.scope.priceIds.includes(e.id)).exhaustive() : !1, Xn = ({ currency: e, value: t }) => t === void 0 || t === 0 ? void 0 : j({
	currency: e,
	value: `${t}`,
	appendCurrencyCode: !0
}), Zn = (e) => Xn(e), Qn = (e) => Xn(e), $n = ({ legalName: e, email: t, address: n, linkEditCustomer: r, linkGoToCustomer: i }) => {
	let a = Tt(), o = !!r || !!i;
	return /* @__PURE__ */ F(f, {
		width: "300px",
		"data-testid": "popoverCustomerCard",
		children: [/* @__PURE__ */ F(f, {
			padding: "12px",
			children: [
				/* @__PURE__ */ P(O, {
					...w,
					lineHeight: "18px",
					color: S,
					children: e
				}),
				t && /* @__PURE__ */ P(O, {
					...C,
					lineHeight: "18px",
					color: S,
					children: t
				}),
				n.map((e, t) => /* @__PURE__ */ P(O, {
					...C,
					lineHeight: "18px",
					color: S,
					children: e
				}, t))
			]
		}), o && /* @__PURE__ */ F(v, {
			paddingY: "8px",
			paddingX: "12px",
			gap: "8px",
			borderTop: `${y} 1px solid`,
			children: [r && /* @__PURE__ */ P(f, {
				flex: "1",
				children: /* @__PURE__ */ P(p, {
					onClick: () => {
						a(r);
					},
					variant: "secondary",
					fullWidth: !0,
					children: "Edit details"
				})
			}), i && /* @__PURE__ */ P(f, {
				flex: "1",
				children: /* @__PURE__ */ P(p, {
					onClick: () => {
						a(i);
					},
					variant: "secondary",
					fullWidth: !0,
					children: "Go to customer"
				})
			})]
		})]
	});
}, er = ({ name: e, email: t, signedAt: n, style: r, isCounterSigner: i = !1, showSignedStatusBadge: a = !1 }) => /* @__PURE__ */ F(v, {
	borderBottom: r?.borderBottom,
	paddingX: r?.paddingX ?? "12px",
	paddingY: r?.paddingY ?? "8px",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "8px",
	children: [/* @__PURE__ */ F(v, {
		gap: "4px",
		flex: "1",
		overflow: "hidden",
		children: [
			/* @__PURE__ */ P(h, {
				boxSize: "16px",
				flexShrink: "0",
				marginRight: r?.iconMarginRight,
				children: /* @__PURE__ */ P(be, { color: ie })
			}),
			/* @__PURE__ */ P(O, {
				...r?.nameFontWeight === "normal" ? C : w,
				color: S,
				whiteSpace: "nowrap",
				children: e
			}),
			/* @__PURE__ */ P(O, {
				...C,
				color: x,
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				children: t
			}),
			/* @__PURE__ */ P(f, { flex: 1 }),
			i && /* @__PURE__ */ P(h, {
				flexShrink: "0",
				children: /* @__PURE__ */ P(xe, {})
			})
		]
	}), a && /* @__PURE__ */ P(N, { children: n ? /* @__PURE__ */ P(d, {
		sentiment: "success",
		children: "Signed"
	}) : /* @__PURE__ */ P(d, {
		sentiment: "highlight",
		children: "Pending"
	}) })]
}), tr = ({ contacts: e, counterSigners: t = [], width: n = "352px", showSignedStatusBadge: r = !1, "data-testid": i }) => {
	let a = {
		nameFontWeight: "normal",
		paddingX: "8px",
		paddingY: "6px",
		iconMarginRight: "4px"
	};
	return /* @__PURE__ */ F(v, {
		flexDirection: "column",
		padding: "4px",
		width: n,
		"data-testid": i,
		children: [e.map((e) => /* @__PURE__ */ P(er, {
			...e,
			style: a,
			showSignedStatusBadge: r
		}, e.email)), t.map((e) => /* @__PURE__ */ P(er, {
			...e,
			isCounterSigner: !0,
			style: a,
			showSignedStatusBadge: r
		}, e.email))]
	});
}, nr = (e) => {
	let t = Array.from(new Set(e.orderedProductIds)).filter((t) => e.products.find((e) => e.productId === t)).map((t) => e.products.find((e) => e.productId === t)).filter((e) => !!e), n = e.products.filter((t) => !t.productId || !e.orderedProductIds.includes(t.productId));
	return [...t, ...n];
}, rr = (e) => {
	if (e.name) return e.name;
	let { showDateRange: t, durationResolved: n, dateStartResolved: r, dateEndResolved: i } = Ln(e.dates);
	return t ? `${r} - ${i}` : n || "Open ended";
}, ir = ({ phases: e, subTotals: t }) => e.map((e, n) => {
	let r = t.at(n)?.totalDiscountedRate, i = t.at(n)?.totalFullRate, a = e.minimums.at(0), o = e.prices.filter((e) => !Yn({
		price: e,
		minimum: a
	})), s = e.prices.filter((e) => Yn({
		price: e,
		minimum: a
	}));
	return {
		phaseId: e.id,
		label: rr(e),
		subTotal: r,
		totalFullRate: i,
		prices: o.map((e) => ({
			priceId: e.id,
			productId: e.productId,
			name: e.name
		})),
		minimum: s.length > 0 ? s.map((e) => ({
			priceId: e.id,
			productId: e.productId,
			name: e.name
		})) : void 0
	};
}), ar = !1, or = !0, sr = !1, cr = !1, lr = !1, ur = [], dr = !1, fr = !1, pr = !1, mr = !0, hr = !1, gr = "Contracted minimum", _r = ({ presentation: e, skipPresentationUpgrade: t = !1 }) => {
	if (t) return {
		...e,
		blocks: Pn(e.blocks === void 0 ? e : e.blocks)
	};
	if (Array.isArray(e)) {
		let t = ar;
		return {
			version: 3,
			blocks: Pn(e),
			settings: {
				showTotals: or,
				groupPricesByPhase: t,
				showImagesInPdfBody: cr,
				showPdfCoverPage: sr,
				showProductDescriptions: lr,
				priceEditorProductOrder: ur,
				showMonthlyRateForAnnualPrices: dr,
				columns: vr({ groupPricesByPhase: t }),
				hideOpenEndedPhases: hr,
				seatBasedMinimumText: gr
			}
		};
	}
	if (e.version === 2) {
		let t = e.settings.groupPricesByPhase;
		return {
			version: 3,
			blocks: Pn(e.blocks),
			settings: {
				showTotals: or,
				groupPricesByPhase: t,
				showImagesInPdfBody: cr,
				showPdfCoverPage: sr,
				showProductDescriptions: lr,
				priceEditorProductOrder: ur,
				showMonthlyRateForAnnualPrices: dr,
				columns: vr({ groupPricesByPhase: t }),
				hideOpenEndedPhases: hr,
				seatBasedMinimumText: gr
			}
		};
	}
	let n = e.settings.groupPricesByPhase ?? ar;
	return {
		version: 3,
		blocks: Pn(e.blocks),
		settings: {
			showTotals: e.settings.showTotals,
			groupPricesByPhase: n,
			showImagesInPdfBody: e.settings.showImagesInPdfBody ?? cr,
			showPdfCoverPage: e.settings.showPdfCoverPage,
			showProductDescriptions: e.settings.showProductDescriptions ?? lr,
			priceEditorProductOrder: e.settings.priceEditorProductOrder ?? ur,
			showMonthlyRateForAnnualPrices: e.settings.showMonthlyRateForAnnualPrices ?? dr,
			columns: {
				quantity: e.settings.columns?.quantity ?? !n,
				lineTotal: e.settings.columns?.lineTotal ?? fr,
				billingPeriods: e.settings.columns?.billingPeriods ?? pr,
				billingType: e.settings.columns?.billingType ?? mr
			},
			hideOpenEndedPhases: e.settings.hideOpenEndedPhases ?? hr,
			seatBasedMinimumText: e.settings.seatBasedMinimumText ?? gr
		},
		...e.metadata ? { metadata: e.metadata } : {}
	};
}, vr = ({ groupPricesByPhase: e }) => ({
	quantity: !e,
	lineTotal: fr,
	billingPeriods: pr,
	billingType: mr
}), yr = ({ currency: e, amendment: t }) => {
	if (t) return {
		amendedOverallTotal: gt({
			currency: e,
			value: t.amendedContractValue,
			appendCurrencyCode: !0
		}),
		netDifference: gt({
			currency: e,
			value: t.adjustmentTotal,
			appendCurrencyCode: !0
		})
	};
}, br = ({ dealType: e, overallTotal: t, amendmentTotals: n, dueUpfront: r }) => M(e).with("AMENDMENT", () => Sr({
	amendmentTotals: n,
	dueUpfront: r
})).with("NEW_BUSINESS", "RENEWAL", () => xr({
	overallTotal: t,
	dueUpfront: r
})).exhaustive(), xr = ({ overallTotal: e, dueUpfront: t }) => ({
	rows: [...e ? [{
		label: vn,
		amount: e
	}] : [], ...Cr(t)],
	showDisclaimer: !!e
}), Sr = ({ amendmentTotals: e, dueUpfront: t }) => ({
	rows: [...e ? [{
		label: yn,
		amount: e.amendedOverallTotal
	}, {
		label: bn,
		amount: e.netDifference
	}] : [], ...Cr(t)],
	showDisclaimer: !!e
}), Cr = (e) => e ? [{
	label: _n,
	amount: e
}] : [], U = k(), wr = k(), Tr = k(!1), Er = k(), Dr = k(void 0), Or = k((e) => {
	let t = e(U)?.presentation;
	if (t) return _r({ presentation: t });
}), kr = k((e) => e(Or)?.blocks.map((e) => ({
	...e,
	uuid: crypto.randomUUID()
})) ?? []), Ar = k((e) => e(Or)?.settings), jr = k((e) => e(U)?.contacts.map((e) => ({
	name: e.name ?? e.email,
	email: e.name ? e.email : "",
	signedAt: e.signedAt
})) ?? []), Mr = k((e) => e(U)?.counterSigners.map((e) => ({
	name: e.name ?? e.email,
	email: e.name ? e.email : "",
	signedAt: e.signedAt
})) ?? []), Nr = k((e) => {
	let t = e(jr), n = e(Mr);
	return [...t, ...n];
}), Pr = k((e) => e(U)?.title || "Untitled"), Fr = k((e) => !e(U)?.title), Ir = k((e) => e(U)?.merchantLogoUrl), Lr = k((e) => e(U)?.merchantName), Rr = k((e) => e(U)?.prospectName), zr = k((e) => e(U)?.prospectAddress), Br = k((e) => {
	let t = e(U)?.dealType;
	return t ? Gn(t) : "";
}), Vr = k((e) => {
	let t = e(U)?.phases;
	if (t) return In(t);
}), Hr = k((e) => {
	let t = e(U), n = t ? Wn(t) : void 0;
	if (n) return {
		formatLong: Kn(n),
		formatShort: Kn(n, hn)
	};
}), Ur = k((e) => {
	let t = e(U)?.phases;
	if (t) return {
		formatLong: Un({
			preliminaryBillingStartDate: e(U)?.preliminaryBillingStartDate,
			phases: t
		}),
		formatShort: Un({
			preliminaryBillingStartDate: e(U)?.preliminaryBillingStartDate,
			phases: t,
			dateFormat: hn
		})
	};
}), Wr = k((e) => {
	let t = e(U)?.expiresAt;
	if (t) return {
		formatLong: Kn(t),
		formatShort: Kn(t, hn)
	};
}), Gr = k((e) => qn(e(U)?.defaultDueDateDays)), Kr = k((e) => e(U)?.attachmentAssets ?? []), qr = k((e) => e(U)?.phaseSubTotals ?? []), Jr = k((e) => e(U)?.quotePriceTotalsPerPhase ?? []), Yr = k((e) => e(U)?.currency ?? "USD"), Xr = k((e) => e(Ar)?.showTotals ?? !1), Zr = k((e) => Qn({
	currency: e(Yr),
	value: e(U)?.totalDueOnStartDate
})), Qr = k((e) => e(U)?.dealType ?? "NEW_BUSINESS"), $r = k((e) => yr({
	currency: e(Yr),
	amendment: e(U)?.amendment
})), ei = k((e) => {
	let t = e(Yr), n = e(U)?.totalFullRate, r = e(U)?.totalDiscountedRate;
	if (!(n === void 0 || n === 0)) return j(r !== void 0 && n !== r ? {
		currency: t,
		value: `${r}`,
		appendCurrencyCode: !0
	} : {
		currency: t,
		value: `${n}`,
		appendCurrencyCode: !0
	});
}), ti = k((e) => {
	let t = e(Yr), n = e(U)?.totalFullRate;
	if (n !== void 0) return j({
		currency: t,
		value: `${n}`
	});
}), ni = k((e) => {
	let t = e(U)?.totalFullRate, n = e(U)?.totalDiscountedRate;
	return t === void 0 || n === void 0 ? !1 : t !== n;
}), ri = k((e) => {
	let t = e(kr).find((e) => e.blockType === "coverImage");
	if (t) return t;
}), ii = k((e) => {
	let t = e(kr).find((e) => e.blockType === "phases");
	if (t) return t;
}), ai = k((e) => e(U)?.phaseMinimumTotals), oi = k((e) => e(U)?.priceCommitments ?? []), si = ({ assetLoader: e }) => {
	let t = A(ri);
	if (!t) return null;
	let { version: n, config: r } = t;
	return n === 2 && un(r) ? /* @__PURE__ */ P(li, {
		config: r,
		assetLoader: e
	}) : n === 1 && ln(r) ? /* @__PURE__ */ P(ui, {
		config: r,
		assetLoader: e
	}) : null;
}, ci = ({ backgroundImage: e }) => /* @__PURE__ */ P(f, {
	flexShrink: "0",
	height: "240px",
	backgroundImage: e,
	backgroundSize: "cover",
	backgroundPosition: "50% 50%",
	backgroundRepeat: "no-repeat"
}), li = ({ config: e, assetLoader: t }) => /* @__PURE__ */ P(ci, { backgroundImage: vt({
	url: e.assetPath,
	assetLoader: t
}) }), ui = ({ config: e, assetLoader: t }) => /* @__PURE__ */ P(ci, { backgroundImage: vt({
	url: e.asset.url,
	assetLoader: t
}) }), di = ({ "data-testid": e }) => {
	let t = A(Fr), n = A(Pr), r = A(Ir), i = A(Lr);
	return /* @__PURE__ */ F(v, {
		gap: "24px",
		direction: "column",
		"data-testid": e ? `${e}.header` : void 0,
		children: [/* @__PURE__ */ F(v, {
			justifyContent: "space-between",
			alignItems: "center",
			gap: "24px",
			children: [/* @__PURE__ */ P(O, {
				flex: "1",
				minWidth: "0",
				...t ? {
					...Fe,
					color: x
				} : {
					...Fe,
					color: ne
				},
				children: n
			}), r && /* @__PURE__ */ P(Se, {
				src: r,
				alt: `Logo for ${i}`,
				height: "20px",
				flexShrink: "0"
			})]
		}), /* @__PURE__ */ F(Oe, { children: [
			/* @__PURE__ */ P(fi, {}),
			/* @__PURE__ */ P(pi, {}),
			/* @__PURE__ */ P(mi, {}),
			/* @__PURE__ */ P(hi, {}),
			/* @__PURE__ */ P(gi, {}),
			/* @__PURE__ */ P(_i, {}),
			/* @__PURE__ */ P(vi, {})
		] })]
	});
}, fi = () => {
	let e = A(Rr), t = A(zr);
	return !e || !t ? null : /* @__PURE__ */ P(ke, {
		popover: /* @__PURE__ */ P($n, {
			legalName: e,
			address: t
		}),
		children: /* @__PURE__ */ P(De, {
			icon: /* @__PURE__ */ P(de, {}),
			"data-testid": "reactQuoteRenderer.header.prospectPill",
			children: e
		})
	});
}, pi = () => {
	let e = A(jr);
	if (!e.length) return null;
	let t = e.at(0)?.name ?? "";
	return /* @__PURE__ */ P(ke, {
		popover: /* @__PURE__ */ P(tr, { contacts: e }),
		children: /* @__PURE__ */ P(De, {
			icon: /* @__PURE__ */ P(be, {}),
			more: e.length > 1 ? e.length - 1 : void 0,
			"data-testid": "reactQuoteRenderer.header.contactsPill",
			children: t
		})
	});
}, mi = () => {
	let e = A(Br);
	return /* @__PURE__ */ P(De, {
		icon: /* @__PURE__ */ P(ue, {}),
		children: e
	});
}, hi = () => {
	let e = A(Vr);
	return e ? /* @__PURE__ */ P(De, {
		icon: /* @__PURE__ */ P(fe, {}),
		"data-testid": "quote.contractLength",
		children: e
	}) : null;
}, gi = () => {
	let e = A(Hr), t = A(Ur);
	return e?.formatLong ? /* @__PURE__ */ P(De, {
		icon: /* @__PURE__ */ P(pe, {}),
		"data-testid": "quote.contractDateRange",
		children: /* @__PURE__ */ F(v, {
			gap: "4px",
			children: [/* @__PURE__ */ P(O, {
				as: "span",
				fontFamily: "inherit",
				fontSize: "inherit",
				fontWeight: "inherit",
				"data-testid": "quote.contractDateRange.start",
				children: e.formatLong
			}), t?.formatLong && /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(le, {}), /* @__PURE__ */ P(O, {
				as: "span",
				fontFamily: "inherit",
				fontSize: "inherit",
				fontWeight: "inherit",
				"data-testid": "quote.contractDateRange.end",
				children: t.formatLong
			})] })]
		})
	}) : null;
}, _i = () => {
	let e = A(Wr);
	return e ? /* @__PURE__ */ P(De, {
		icon: /* @__PURE__ */ P(ge, {}),
		children: e.formatLong
	}) : null;
}, vi = () => {
	let e = A(Gr);
	return e ? /* @__PURE__ */ P(De, {
		icon: /* @__PURE__ */ P(ve, {}),
		"data-testid": "quote.paymentTerms",
		children: e
	}) : null;
}, yi = ({ config: { items: e } }) => /* @__PURE__ */ P(Xe, { children: e.map((t, n) => /* @__PURE__ */ P(Te, {
	marginBottom: n === e.length - 1 ? void 0 : "3px",
	children: /* @__PURE__ */ P(O, {
		...T,
		color: S,
		children: t
	})
}, n)) }), bi = ({ text: e, font: t }) => (Array.isArray(e) ? e : [e]).filter((e) => !!e).map((e) => typeof e == "string" ? e : Ci(t)(e)), xi = {
	wordBreak: "break-word",
	overflowWrap: "anywhere"
}, Si = (e, t) => ({
	...xi,
	fontWeight: e.bold || t.fontWeight > 400 ? "bold" : "normal",
	fontStyle: e.italic ? "italic" : "normal",
	textDecoration: [e.underline && "underline", e.strike && "line-through"].filter(Boolean).join(" "),
	color: e.textColor ? V(e.textColor) : "inherit",
	backgroundColor: e.backgroundColor ? H(e.backgroundColor) : "transparent"
}), Ci = (e) => (n) => {
	if (n.href) return /* @__PURE__ */ P(we, {
		...e,
		target: "_blank",
		to: n.href,
		...Si(n.styles, e),
		color: n.styles.textColor ? V(n.styles.textColor) : Cn,
		textDecorationColor: `${Cn} !important`,
		whiteSpace: "pre-line",
		children: n.text
	});
	let r = n.text?.split("\n");
	return r ? r.map((i, a) => /* @__PURE__ */ F(t, { children: [/* @__PURE__ */ P(O, {
		as: "span",
		...e,
		...Si(n.styles, e),
		whiteSpace: "pre-line",
		children: i
	}), a !== r.length - 1 && /* @__PURE__ */ P("br", {})] }, a)) : null;
}, wi = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(Xe, { children: e.map((n, r) => /* @__PURE__ */ P(Te, {
	marginBottom: r === e.length - 1 ? void 0 : "3px",
	children: /* @__PURE__ */ P(O, {
		...t,
		color: S,
		children: bi({
			text: n,
			font: t
		})
	})
}, r)) }), Ti = ({ config: { src: e, alt: t, width: n, textAlignment: r }, assetLoader: i }) => {
	let a = vt({
		url: e,
		assetLoader: i
	});
	return a ? /* @__PURE__ */ P(f, {
		width: "100%",
		display: "flex",
		justifyContent: zn(r ?? "left"),
		children: /* @__PURE__ */ P(Se, {
			src: a,
			alt: t,
			width: n,
			maxWidth: "100%"
		})
	}) : null;
}, Ei = ({ config: { items: e } }) => /* @__PURE__ */ P(Ee, { children: e.map((t, n) => /* @__PURE__ */ P(Te, {
	...T,
	marginBottom: n === e.length - 1 ? void 0 : "7px",
	children: /* @__PURE__ */ P(O, {
		...T,
		color: S,
		children: t
	})
}, t)) }), Di = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(Ee, { children: e.map((n, r) => /* @__PURE__ */ P(Te, {
	...t,
	marginBottom: r === e.length - 1 ? void 0 : "7px",
	children: /* @__PURE__ */ P(O, {
		...t,
		color: S,
		children: bi({
			text: n,
			font: t
		})
	})
}, r)) }), Oi = (e) => `${new Intl.NumberFormat("en-GB", {
	minimumFractionDigits: Math.min(String(e).split(".")[1]?.length ?? 0, 2),
	maximumFractionDigits: 2,
	useGrouping: !1
}).format(Number(e))}%`, ki = ({ price: e, includedSeats: t }) => {
	if (e.structure.pricingType !== "SEAT_BASED" || !("tiers" in e.structure) || !e.structure.tiers || e.structure.tiers.length === 0) return [];
	let n = e.structure.tiers;
	return n.map((e, r) => {
		let i = r === 0 ? 1 : Number(n[r - 1].upperBound) + 1, a = e.upperBound ? Number(e.upperBound) : Infinity;
		return {
			minInclusive: i,
			maxInclusive: a,
			seatsConsumed: Array.from({ length: t }).reduce((e, t, n) => {
				let r = n + 1;
				return r >= i && r <= a ? e + 1 : e;
			}, 0),
			pricePerSeat: Number(e.price),
			fee: e.fee ? Number(e.fee) : void 0
		};
	});
}, Ai = ({ productId: e, phasesWithProductId: t }) => {
	if (t.length <= 1 || !t.some((e) => e.discounts.length > 0)) return !0;
	let n = t.map((t) => {
		let { discounts: n } = t;
		if (n.length === 0) return { hasDiscount: !1 };
		if (n[0] && n[0].applyToAllPrices) return {
			hasDiscount: !0,
			amount: n[0].amount,
			discountCalculationType: n[0].discountCalculationType
		};
		let r = t.prices.find((t) => t.productId === e)?.id;
		if (!r) throw Error();
		let i = n.find((e) => e.priceIds.includes(r));
		return i ? {
			hasDiscount: !0,
			amount: i.amount,
			discountCalculationType: i.discountCalculationType
		} : { hasDiscount: !1 };
	}), r = n[0];
	return n.map((e) => rt(r, e)).includes(!1) === !1;
}, ji = "The rate is based on the final tier reached.", Mi = "Each tier applies progressively as quantity increases.", Ni = "Each tier applies progressively as quantity increases.", W = {
	description: { fontWeight: "bold" },
	varies: { color: "GreyGrey60" },
	discountedRate: {
		textDecoration: "line-through",
		color: "GreyGrey60"
	}
}, Pi = {
	varies: "Varies",
	variesWithUsage: "Varies",
	variesWithSeatUsage: "Varies",
	usageBased: "Varies",
	seatBasedContractedMinimum: "contracted"
}, G = {
	quantity: !1,
	lineTotal: !1,
	billingPeriods: !1,
	billingType: !0
}, Fi = ({ value: e, currency: t, isDiscounted: n = !1 }) => {
	if (!n || !e || !Number.isFinite(Number(e))) return _t({
		value: e,
		currency: t
	});
	let r = new I(e), i = ht(t), a = r.round(i, I.roundHalfUp), o = new I(10).pow(-i).times("0.0000001");
	return _t({
		currency: t,
		value: !a.eq(0) && r.minus(a).abs().lte(o) ? a.toFixed() : e
	});
}, Ii = 12, Li = ({ value: e, currency: t }) => {
	if (!e || Number.isNaN(Number(e))) return e;
	let n = e.split(".")[1]?.length ?? 0, r = new I(e).div(Ii), i = r.round(n + 2, I.roundHalfUp);
	if (i.eq(r)) return i.toFixed();
	let a = r.round(Math.max(ht(t), n), I.roundHalfUp);
	return a.eq(0) ? r.round(1 - r.e, I.roundHalfUp).toFixed() : a.toFixed();
}, Ri = ({ value: e, intervalMultiplier: t, currency: n }) => {
	let r = ht(n), i = Math.floor(t), a = new I(t).minus(i), o = new I(e).round(r, I.roundHalfUp).times(i), s = a.gt(0) ? new I(e).times(a).round(r, I.roundHalfUp) : new I(0);
	return o.plus(s).toString();
}, zi = (e) => {
	let t = new I(e);
	return t.lt(0) ? new I(0) : t;
}, Bi = ({ gross: e, net: t, currency: n }) => {
	let r = zi(e), i = zi(t), a = {
		type: "TEXT",
		text: j({
			currency: n,
			value: i.toString()
		})
	};
	return r.eq(i) ? { total: a } : {
		total: a,
		totalBeforeDiscount: {
			type: "TEXT",
			text: j({
				currency: n,
				value: r.toString()
			}),
			style: {
				color: "GreyGrey60",
				textDecoration: "line-through"
			}
		}
	};
}, Vi = ({ value: e, quantity: t, intervalMultiplier: n, currency: r, discount: i }) => {
	let a = new I(e).times(t), o = ht(r), s = new I(a.round(o, I.roundHalfUp)).times(n);
	if (!i) return {
		gross: s.toString(),
		net: s.toString()
	};
	let c = M(i.discountCalculationType).with("PERCENTAGE", () => a.times(new I(100).minus(i.amount)).div(100).round(o, I.roundHalfUp).times(n)).with("NOMINAL", () => {
		let e = new I(i.amount), t = Math.floor(Number(n)), r = new I(n).minus(t), s = a.minus(e).round(o, I.roundHalfUp), c = (s.lt(0) ? new I(0) : s).times(t), l = a.times(r).minus(e).round(o, I.roundHalfUp), u = r.gt(0) && l.gt(0) ? l : new I(0);
		return c.plus(u);
	}).exhaustive(), l = c.lt(0) ? new I(0) : c;
	return {
		gross: s.toString(),
		net: l.toString()
	};
}, Hi = (e) => new I(e).round(2).toString(), Ui = {
	type: "TEXT",
	text: ""
}, K = (e) => e.lineTotal ? void 0 : "per unit", Wi = ({ price: e, phasesWithProductId: t }) => t.find((t) => t.prices.some((t) => t.id === e.id))?.discounts.find((t) => !t.applyToAllPrices && t.priceIds.includes(e.id)), Gi = (e) => e && {
	amount: e.amount,
	discountCalculationType: e.discountCalculationType,
	restrictToPrices: e.priceIds
}, Ki = ({ amount: e, discount: t, currency: n, isBilledAmount: r = !1 }) => {
	if (!t || t.discountCalculationType !== "PERCENTAGE") return e;
	let i = new I(e).times(new I(100).minus(t.amount)).div(100);
	return r ? i.round(ht(n), I.roundHalfUp).toString() : i.toString();
}, qi = ({ discount: e, currency: t }) => {
	if (e.discountCalculationType === "NOMINAL") return `${j({
		currency: t,
		value: String(e.amount)
	})} off`;
	if (e.discountCalculationType === "PERCENTAGE") return `${Oi(e.amount)} off`;
}, Ji = ({ price: e, discount: t }) => {
	if (t !== void 0 && !t.applyToAllPrices && t.priceIds.includes(e.id) && t.discountCalculationType === "NOMINAL" && lt(e)) return e.structure.pricingType === "SEAT_BASED" && e.structure.tiers?.length ? void 0 : "usage";
}, Yi = ({ price: e, discount: t }) => {
	let n = Ji({
		price: e,
		discount: t
	});
	return n ? { discountExplanation: n } : {};
}, Xi = ({ price: e, showMonthlyRateForAnnualPrices: t }) => t && e.billingFrequency === "YEARLY", Zi = ({ columns: e = G, intervalMultiplier: t, billingFrequency: n, displayAnnualPriceAsMonthly: r = !1 }) => e.billingPeriods ? n === "ON_DEMAND" || n === "PER_EVENT" ? { billingPeriods: {
	type: "TEXT",
	text: "N/A",
	style: { color: "GreyGrey60" }
} } : typeof t == "number" ? { billingPeriods: {
	type: "TEXT",
	text: Hi(r ? new I(t).times(12).toNumber() : t)
} } : {} : {}, Qi = ({ price: e, phasePriceTotals: t }) => {
	let n = t?.[e.id];
	return n || !e.productId ? n : Object.values(t ?? {}).find((t) => t.productId === e.productId);
}, $i = ({ columns: e, phaseAmount: t, currency: n, isDiscountShownInUnitRate: r }) => !e.lineTotal || !t?.isCommitted ? {} : Bi({
	gross: r ? t.discountedRate : t.fullRate,
	net: t.discountedRate,
	currency: n
}), ea = ({ columns: e }) => e.lineTotal ? { total: {
	type: "TEXT",
	text: Pi.variesWithUsage,
	style: W.varies
} } : {}, ta = ({ columns: e, value: t, quantity: n, intervalMultiplier: r, currency: i, discount: a, isExcluded: o = !1 }) => {
	if (!e.lineTotal || typeof r != "number" || o) return {};
	let s = Vi({
		value: t,
		quantity: n,
		intervalMultiplier: r,
		currency: i,
		discount: Gi(a)
	});
	return Bi({
		gross: a?.discountCalculationType === "PERCENTAGE" ? s.net : s.gross,
		net: s.net,
		currency: i
	});
}, na = ({ commitment: e, price: t, displayAnnualPriceAsMonthly: n }) => e?.isCommitted ? { rate: {
	type: "TEXT",
	text: q({
		currency: t.currency,
		value: `${e.amount}`,
		isAmount: !0,
		billingFrequency: t.billingFrequency,
		billingType: t.billingType,
		includeBillingFrequency: n,
		showBillingType: !1,
		displayAnnualPriceAsMonthly: n
	})
} } : {}, ra = ({ price: e, commitment: t, phaseAmount: n, ownDiscount: r, columns: i, showBillingTypeInRate: a, displayAnnualPriceAsMonthly: o, seatBasedMinimumText: s }) => {
	if (e.structure.pricingType !== "SEAT_BASED" || !i.lineTotal || !e.structure.includedSeats) return;
	let c = e.structure.includedSeats, l = "tiers" in e.structure && Array.isArray(e.structure.tiers) && e.structure.tiers.length > 0, u = it({
		price: e,
		discount: Gi(r)
	}), d = typeof u == "number" ? u.toString() : e.structure.pricePerSeat, f = ia({
		price: e,
		commitment: t,
		ownDiscount: r
	}), p = f ? n?.fullRate : n?.discountedRate, m = n?.isCommitted && i.lineTotal && p !== void 0 ? Bi({
		gross: p,
		net: n.discountedRate,
		currency: e.currency
	}) : {};
	return {
		description: {
			type: "TEXT",
			text: i.quantity ? s : `${s}: ${String(c)} ${Dt("unit", c)}`
		},
		billingFrequency: {
			type: "TEXT",
			text: pa({
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				showBillingType: !a
			})
		},
		...Zi({
			columns: i,
			intervalMultiplier: n?.intervalMultiplier,
			billingFrequency: e.billingFrequency,
			displayAnnualPriceAsMonthly: o
		}),
		quantity: {
			type: "TEXT",
			text: String(c)
		},
		discount: f,
		...Yi({
			price: e,
			discount: f ? r : void 0
		}),
		rate: l ? {
			type: "TEXT",
			text: Pi.varies,
			style: W.varies
		} : {
			type: "TEXT",
			text: q({
				currency: e.currency,
				value: d,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: o,
				showBillingType: a,
				rateLabel: K(i),
				displayAnnualPriceAsMonthly: o,
				isDiscounted: typeof u == "number"
			})
		},
		...m,
		"data-testid": `quote.contractedMinimum.${e.id}`,
		indentation: 1
	};
}, ia = ({ price: e, commitment: t, ownDiscount: n }) => {
	if (e.structure.pricingType !== "SEAT_BASED") return;
	if (Array.isArray(e.structure.tiers) && e.structure.tiers.length > 0 && n?.discountCalculationType === "PERCENTAGE") return {
		type: "TEXT",
		text: qi({
			discount: n,
			currency: e.currency
		})
	};
	let r = n?.discountCalculationType === "NOMINAL" && t?.isCommitted && typeof t.fullAmount == "number" ? new I(t.fullAmount).minus(t.preGlobalDiscountAmount ?? t.amount) : void 0;
	if (r?.gt(0)) return {
		type: "TEXT",
		text: `${j({
			currency: e.currency,
			value: r.toString()
		})} off`
	};
}, aa = ({ price: e, phasesWithProductId: t, descriptionType: n, showBillingTypeInRate: r, showProductDescription: i, showMonthlyRateForAnnualPrices: a = !1, columns: o = G, phaseAmount: s }) => {
	if (e.structure.pricingType !== "FIXED" && e.structure.pricingType !== "ONE_TIME") return [];
	let c = Wi({
		phasesWithProductId: t,
		price: e
	}), l = ma({
		descriptionType: n,
		price: e,
		phasesWithProductId: t,
		showProductDescription: i
	}), u = {
		type: "TEXT",
		text: "1"
	}, d = (() => {
		if (c) return {
			type: "TEXT",
			text: qi({
				discount: c,
				currency: e.currency
			})
		};
	})(), f = it({
		price: e,
		discount: Gi(c)
	}), p = {
		type: "TEXT",
		text: pa({
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			showBillingType: !r
		})
	}, m = Xi({
		price: e,
		showMonthlyRateForAnnualPrices: a
	});
	return [{
		description: l,
		billingFrequency: p,
		quantity: u,
		discount: d,
		discountedRate: (() => {
			if (typeof f == "number") return {
				type: "TEXT",
				text: q({
					isAmount: !0,
					currency: e.currency,
					value: e.structure.price,
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					rateOnly: !0,
					showBillingType: r,
					displayAnnualPriceAsMonthly: m
				}),
				style: W.discountedRate
			};
		})(),
		rate: typeof f == "number" ? {
			type: "TEXT",
			text: q({
				isAmount: !0,
				currency: e.currency,
				value: f.toString(),
				isDiscounted: !0,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: m,
				showBillingType: r,
				displayAnnualPriceAsMonthly: m
			})
		} : {
			type: "TEXT",
			text: q({
				isAmount: !0,
				currency: e.currency,
				value: e.structure.price,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: m,
				showBillingType: r,
				displayAnnualPriceAsMonthly: m
			})
		},
		...Zi({
			columns: o,
			intervalMultiplier: s?.intervalMultiplier,
			billingFrequency: e.billingFrequency,
			displayAnnualPriceAsMonthly: m
		}),
		...$i({
			columns: o,
			phaseAmount: s,
			currency: e.currency,
			isDiscountShownInUnitRate: typeof f == "number"
		})
	}];
}, oa = ({ price: e, phasesWithProductId: t, hasCollapsibleMinMaxRates: n, descriptionType: r, showBillingTypeInRate: i, showProductDescription: a, baseIndentation: o = 0, columns: s = G, phaseAmount: c }) => {
	if (e.structure.pricingType !== "LINEAR") return [];
	let l = Wi({
		phasesWithProductId: t,
		price: e
	}), u = it({
		price: e,
		discount: Gi(l)
	}), d = (() => {
		if (typeof u == "number") return {
			type: "TEXT",
			text: q({
				currency: e.currency,
				value: e.structure.pricePerUnit,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				rateOnly: !0,
				showBillingType: i
			}),
			style: W.discountedRate
		};
	})(), f = e.structure.minPrice ? {
		description: {
			type: "TEXT",
			text: e.structure.isPricePercentage ? "Min. unit rate" : "Min. price"
		},
		billingFrequency: Ui,
		rate: {
			type: "TEXT",
			text: q({
				currency: e.currency,
				rateLabel: e.structure.isPricePercentage ? K(s) : void 0,
				value: e.structure.minPrice,
				isAmount: !e.structure.isPricePercentage,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: !1,
				showBillingType: i
			})
		},
		indentation: o + 1
	} : void 0, p = e.structure.maxPrice ? {
		description: {
			type: "TEXT",
			text: e.structure.isPricePercentage ? "Max. unit rate" : "Max. price"
		},
		billingFrequency: Ui,
		rate: {
			type: "TEXT",
			text: q({
				currency: e.currency,
				rateLabel: e.structure.isPricePercentage ? K(s) : void 0,
				value: e.structure.maxPrice,
				isAmount: !e.structure.isPricePercentage,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: !1,
				showBillingType: i
			})
		},
		indentation: o + 1
	} : void 0, m = [...f ? [f] : [], ...p ? [p] : []], h = typeof u == "number" ? {
		type: "TEXT",
		text: q({
			currency: e.currency,
			value: u.toString(),
			isDiscounted: !0,
			rateLabel: e.structure.isPricePercentage ? "of volume" : K(s),
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: !1,
			showBillingType: i
		})
	} : {
		type: "TEXT",
		text: q({
			currency: e.currency,
			rateLabel: e.structure.isPricePercentage ? "of volume" : K(s),
			value: e.structure.pricePerUnit,
			isPricePercentage: e.structure.isPricePercentage,
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: !1,
			showBillingType: i
		})
	};
	return [{
		description: ma({
			descriptionType: r,
			price: e,
			phasesWithProductId: t,
			showProductDescription: a
		}),
		billingFrequency: {
			type: "TEXT",
			text: pa({
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				showBillingType: !i
			})
		},
		quantity: {
			type: "TEXT",
			text: Pi.usageBased,
			style: W.varies
		},
		rate: h,
		discount: l ? {
			type: "TEXT",
			text: qi({
				discount: l,
				currency: e.currency
			})
		} : void 0,
		...Yi({
			price: e,
			discount: l
		}),
		...d ? { discountedRate: d } : {},
		...Zi({
			columns: s,
			intervalMultiplier: c?.intervalMultiplier,
			billingFrequency: e.billingFrequency
		}),
		...ea({ columns: s }),
		...n && m.length > 0 ? { subrows: m } : {},
		...o > 0 ? { indentation: o } : {}
	}, ...n ? [] : m];
}, sa = ({ price: e, phasesWithProductId: t, descriptionType: n, hasCollapsibleTiers: r, showBillingTypeInRate: i, showProductDescription: a, baseIndentation: o = 0, showMonthlyRateForAnnualPrices: s = !1, columns: c = G, phaseAmount: l }) => {
	if (e.structure.pricingType !== "VOLUME" && e.structure.pricingType !== "GRADUATED") return [];
	let u = Wi({
		phasesWithProductId: t,
		price: e
	}), d = [...ca({
		price: e,
		showBillingTypeInRate: i,
		baseIndentation: o,
		showMonthlyRateForAnnualPrices: s,
		intervalMultiplier: l?.intervalMultiplier,
		columns: c,
		ownDiscount: u,
		ignoreFlatFeeTotals: t.some((e) => {
			let t = e.minimums.at(0);
			return t ? t.scope.target === "allUsage" || t.scope.priceIds.some((t) => e.prices.some((e) => e.id === t && e.structure.pricingType === "GRADUATED")) : !1;
		})
	})];
	return [{
		description: ma({
			descriptionType: n,
			price: e,
			phasesWithProductId: t,
			showProductDescription: a
		}),
		billingFrequency: {
			type: "TEXT",
			text: pa({
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				showBillingType: !i
			})
		},
		quantity: {
			type: "TEXT",
			text: Pi.usageBased,
			style: W.varies
		},
		rate: {
			type: "TEXT",
			text: Pi.variesWithUsage,
			style: W.varies
		},
		discount: u ? {
			type: "TEXT",
			text: qi({
				discount: u,
				currency: e.currency
			})
		} : void 0,
		...Yi({
			price: e,
			discount: u
		}),
		...Zi({
			columns: c,
			intervalMultiplier: l?.intervalMultiplier,
			billingFrequency: e.billingFrequency
		}),
		...ea({ columns: c }),
		...r ? { subrows: d } : {},
		...o > 0 ? { indentation: o } : {}
	}, ...r ? [] : d];
}, ca = ({ price: e, unitText: t = "units", showBillingTypeInRate: n, baseIndentation: r, showMonthlyRateForAnnualPrices: i, intervalMultiplier: a, columns: o = G, ownDiscount: s, ignoreFlatFeeTotals: c }) => {
	if (!("tiers" in e.structure)) return [];
	let l = Xi({
		price: e,
		showMonthlyRateForAnnualPrices: i
	});
	return e.structure.tiers.flatMap((i, u) => {
		if (!("tiers" in e.structure)) return;
		let d = e.structure.tiers[u - 1], f = i.isPricePercentage ? `${d && d.upperBound ? gt({
			currency: e.currency,
			value: (parseFloat(d.upperBound) + .01).toString()
		}) : gt({
			currency: e.currency,
			value: "0.00"
		})} ${i.upperBound ? `to ${gt({
			currency: e.currency,
			value: i.upperBound
		})}` : "and above"}` : `${d && d.upperBound ? `${(Number(d.upperBound) + 1).toLocaleString()}` : "1"} ${i.upperBound ? `to ${Number(i.upperBound).toLocaleString()} ${t}` : `${t} and above`}`, p = u === 0 && i.isPricePercentage ? `Flat fee for first ${gt({
			currency: e.currency,
			value: i.upperBound || "0.00"
		})}` : u === 0 && !i.isPricePercentage ? `Flat fee for first ${i.upperBound} ${t}` : `Flat fee for ${f}`, m = o.lineTotal && s?.discountCalculationType === "PERCENTAGE", h = {
			type: "TEXT",
			text: q({
				currency: e.currency,
				rateLabel: i.isPricePercentage ? "of volume" : K(o),
				value: m ? Ki({
					amount: i.price,
					discount: s,
					currency: e.currency
				}) : i.price,
				isPricePercentage: i.isPricePercentage,
				isDiscounted: m,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				includeBillingFrequency: !1,
				showBillingType: n
			})
		}, g = m ? {
			type: "TEXT",
			text: q({
				currency: e.currency,
				rateLabel: i.isPricePercentage ? "of volume" : K(o),
				value: i.price,
				isPricePercentage: i.isPricePercentage,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				rateOnly: !0,
				includeBillingFrequency: !1,
				showBillingType: n
			}),
			style: W.discountedRate
		} : void 0;
		return [
			{
				description: {
					type: "TEXT",
					text: `From ${f}`
				},
				billingFrequency: Ui,
				...g ? { discountedRate: g } : {},
				rate: h,
				indentation: r + 1
			},
			...i.fee && Number(i.fee) !== 0 ? [{
				description: {
					type: "TEXT",
					text: p
				},
				billingFrequency: Ui,
				...m ? { discountedRate: {
					type: "TEXT",
					text: q({
						currency: e.currency,
						value: i.fee,
						isAmount: !0,
						billingFrequency: e.billingFrequency,
						billingType: e.billingType,
						rateOnly: !0,
						showBillingType: n,
						displayAnnualPriceAsMonthly: l
					}),
					style: W.discountedRate
				} } : {},
				rate: {
					type: "TEXT",
					text: q({
						currency: e.currency,
						value: m ? Ki({
							amount: i.fee,
							discount: s,
							currency: e.currency,
							isBilledAmount: !0
						}) : i.fee,
						isAmount: !0,
						isDiscounted: m,
						billingFrequency: e.billingFrequency,
						billingType: e.billingType,
						includeBillingFrequency: l,
						showBillingType: n,
						displayAnnualPriceAsMonthly: l
					})
				},
				...o.quantity ? { quantity: {
					type: "TEXT",
					text: "1"
				} } : {},
				...Zi({
					columns: o,
					intervalMultiplier: a,
					billingFrequency: e.billingFrequency,
					displayAnnualPriceAsMonthly: l
				}),
				...ta({
					columns: o,
					value: i.fee,
					quantity: 1,
					intervalMultiplier: a,
					currency: e.currency,
					discount: s,
					isExcluded: c
				}),
				indentation: r + 2
			}] : [],
			...i.minPrice ? [{
				description: {
					type: "TEXT",
					text: i.isPricePercentage ? "Min. unit rate" : "Min. fee"
				},
				billingFrequency: Ui,
				rate: {
					type: "TEXT",
					text: q({
						currency: e.currency,
						rateLabel: i.isPricePercentage ? K(o) : void 0,
						value: i.minPrice,
						isAmount: !i.isPricePercentage,
						billingFrequency: e.billingFrequency,
						billingType: e.billingType,
						includeBillingFrequency: !1,
						showBillingType: n
					})
				},
				indentation: r + 2
			}] : [],
			...i.maxPrice ? [{
				description: {
					type: "TEXT",
					text: i.isPricePercentage ? "Max. unit rate" : "Max. fee"
				},
				billingFrequency: Ui,
				rate: {
					type: "TEXT",
					text: q({
						currency: e.currency,
						rateLabel: i.isPricePercentage ? K(o) : void 0,
						value: i.maxPrice,
						isAmount: !i.isPricePercentage,
						billingFrequency: e.billingFrequency,
						billingType: e.billingType,
						includeBillingFrequency: !1,
						showBillingType: n
					})
				},
				indentation: r + 2
			}] : []
		];
	}).filter(Boolean);
}, la = ({ price: e, phasesWithProductId: t, descriptionType: n, showBillingTypeInRate: r, showProductDescription: i, baseIndentation: a = 0, columns: o = G, phaseAmount: s }) => {
	if (e.structure.pricingType !== "PACKAGE") return [];
	let c = Wi({
		phasesWithProductId: t,
		price: e
	}), l = ma({
		descriptionType: n,
		price: e,
		phasesWithProductId: t,
		additionalText: `(${e.structure.packageSize} units per package)`,
		showProductDescription: i
	}), u = {
		type: "TEXT",
		text: Pi.usageBased,
		style: W.varies
	}, d = (() => {
		if (c) return {
			type: "TEXT",
			text: qi({
				discount: c,
				currency: e.currency
			})
		};
	})(), f = it({
		price: e,
		discount: Gi(c)
	}), p = (() => {
		if (typeof f == "number") return {
			type: "TEXT",
			text: q({
				currency: e.currency,
				value: e.structure.pricePerPackage,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				rateOnly: !0,
				showBillingType: r
			}),
			style: W.discountedRate
		};
	})(), m = typeof f == "number" ? {
		type: "TEXT",
		text: q({
			currency: e.currency,
			rateLabel: "per package",
			value: f.toString(),
			isDiscounted: !0,
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: !1,
			showBillingType: r
		})
	} : {
		type: "TEXT",
		text: q({
			currency: e.currency,
			rateLabel: "per package",
			value: e.structure.pricePerPackage,
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: !1,
			showBillingType: r
		})
	};
	return [{
		description: l,
		billingFrequency: {
			type: "TEXT",
			text: pa({
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				showBillingType: !r
			})
		},
		quantity: u,
		discount: d,
		...Yi({
			price: e,
			discount: c
		}),
		discountedRate: p,
		rate: m,
		...Zi({
			columns: o,
			intervalMultiplier: s?.intervalMultiplier,
			billingFrequency: e.billingFrequency
		}),
		...ea({ columns: o }),
		...a > 0 ? { indentation: a } : {}
	}];
}, ua = ({ price: e, commitment: t, phasesWithProductId: n, groupBy: r = "product", descriptionType: i, hasCollapsibleTiers: a, showBillingTypeInRate: o, showProductDescription: s, showMonthlyRateForAnnualPrices: c = !1, seatBasedMinimumText: l, columns: u = G, phaseAmount: d }) => {
	if (e.structure.pricingType !== "SEAT_BASED") return [];
	let f = Wi({
		phasesWithProductId: n,
		price: e
	}), p = !!e.structure.includedSeats, m = Xi({
		price: e,
		showMonthlyRateForAnnualPrices: c
	}), h = "tiers" in e.structure && Array.isArray(e.structure.tiers) && e.structure.tiers.length > 0, g = ra({
		price: e,
		commitment: t,
		phaseAmount: d,
		ownDiscount: f,
		columns: u,
		showBillingTypeInRate: o,
		displayAnnualPriceAsMonthly: m,
		seatBasedMinimumText: l
	}), _ = ia({
		price: e,
		commitment: t,
		ownDiscount: f
	}), v = !u.lineTotal && r === "phase" && p ? {
		description: {
			type: "TEXT",
			text: `${l}: ${String(e.structure.includedSeats)} ${Dt("unit", e.structure.includedSeats)}`
		},
		billingFrequency: Ui,
		..._ ? { discount: _ } : {},
		...Yi({
			price: e,
			discount: _ ? f : void 0
		}),
		...na({
			commitment: t,
			price: e,
			displayAnnualPriceAsMonthly: m
		}),
		"data-testid": `quote.contractedMinimum.${e.id}`,
		indentation: 1
	} : void 0, ee = u.lineTotal ? {
		type: "TEXT",
		text: Pi.usageBased,
		style: W.varies
	} : p ? {
		type: "TEXT",
		text: `${String(e.structure.includedSeats)} (${Pi.seatBasedContractedMinimum})`
	} : {
		type: "TEXT",
		text: Pi.variesWithSeatUsage,
		style: W.varies
	}, te = !u.lineTotal && r === "phase" && p ? 1 : 0;
	if (h) {
		let t = da({
			price: e,
			baseIndentation: te,
			showBillingTypeInRate: o,
			showMonthlyRateForAnnualPrices: c,
			columns: u,
			intervalMultiplier: d?.intervalMultiplier,
			ownDiscount: f
		});
		return [
			{
				description: ma({
					descriptionType: i,
					price: e,
					phasesWithProductId: n,
					showProductDescription: s
				}),
				billingFrequency: {
					type: "TEXT",
					text: pa({
						billingFrequency: e.billingFrequency,
						billingType: e.billingType,
						showBillingType: !o
					})
				},
				quantity: ee,
				rate: {
					type: "TEXT",
					text: Pi.varies,
					style: W.varies
				},
				discount: void 0,
				...Zi({
					columns: u,
					intervalMultiplier: d?.intervalMultiplier,
					billingFrequency: e.billingFrequency,
					displayAnnualPriceAsMonthly: m
				}),
				...ea({ columns: u }),
				...a && g ? { rowsBeforeSubrows: [g] } : {},
				...a ? { subrows: t } : {}
			},
			...v ? [v] : [],
			...!a && g ? [g] : [],
			...a ? [] : t
		];
	}
	let ne = it({
		price: e,
		discount: Gi(f)
	}), re = (() => {
		if (typeof ne == "number") return {
			type: "TEXT",
			text: q({
				currency: e.currency,
				value: e.structure.pricePerSeat,
				billingFrequency: e.billingFrequency,
				billingType: e.billingType,
				rateOnly: !0,
				showBillingType: o,
				rateLabel: K(u),
				includeBillingFrequency: m,
				displayAnnualPriceAsMonthly: m
			}),
			style: W.discountedRate
		};
	})(), y = typeof ne == "number" ? {
		type: "TEXT",
		text: q({
			currency: e.currency,
			value: ne.toString(),
			isDiscounted: !0,
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: m,
			showBillingType: o,
			rateLabel: K(u),
			displayAnnualPriceAsMonthly: m
		})
	} : {
		type: "TEXT",
		text: q({
			currency: e.currency,
			value: e.structure.pricePerSeat,
			billingFrequency: e.billingFrequency,
			billingType: e.billingType,
			includeBillingFrequency: m,
			showBillingType: o,
			rateLabel: K(u),
			displayAnnualPriceAsMonthly: m
		})
	}, b = f?.discountCalculationType === "PERCENTAGE" || !p ? f : void 0;
	return [
		{
			description: ma({
				descriptionType: i,
				price: e,
				phasesWithProductId: n,
				showProductDescription: s
			}),
			billingFrequency: {
				type: "TEXT",
				text: pa({
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					showBillingType: !o
				})
			},
			quantity: ee,
			discount: b ? {
				type: "TEXT",
				text: qi({
					discount: b,
					currency: e.currency
				})
			} : void 0,
			...Yi({
				price: e,
				discount: b
			}),
			discountedRate: re,
			rate: y,
			...Zi({
				columns: u,
				intervalMultiplier: d?.intervalMultiplier,
				billingFrequency: e.billingFrequency,
				displayAnnualPriceAsMonthly: m
			}),
			...ea({ columns: u })
		},
		...v ? [v] : [],
		...g ? [g] : []
	];
}, da = ({ price: e, baseIndentation: t = 0, showBillingTypeInRate: n, showMonthlyRateForAnnualPrices: r = !1, columns: i, intervalMultiplier: a, ownDiscount: o }) => {
	if (!("tiers" in e.structure) || !Array.isArray(e.structure.tiers) || e.structure.tiers.length === 0 || e.structure.pricingType !== "SEAT_BASED") return [];
	let s = Xi({
		price: e,
		showMonthlyRateForAnnualPrices: r
	}), c = ki({
		price: e,
		includedSeats: e.structure.includedSeats
	}), l = !!e.structure.includedSeats, u = t === 0 ? 1 : 2, d = t === 0 ? 2 : 3;
	return c.flatMap((t, r) => {
		let c = `${t.minInclusive.toLocaleString()} ${t.maxInclusive === Infinity ? "units and above" : `to ${t.maxInclusive.toLocaleString()} units`}`, f = r === 0 ? `Flat fee for first ${t.maxInclusive.toString()} units` : `Flat fee for ${c}`, p = i.lineTotal && o?.discountCalculationType === "PERCENTAGE", m = i.lineTotal && !l && r === 0, h = i.lineTotal && r === 0 && t.maxInclusive !== Infinity ? `First ${t.maxInclusive.toLocaleString()} units` : `From ${c}`, g = i.lineTotal ? { descriptionSpan: [
			"billingFrequency",
			"billingPeriods",
			"quantity"
		] } : {};
		return [{
			description: {
				type: "TEXT",
				text: h
			},
			...g,
			billingFrequency: Ui,
			...!i.lineTotal && t.seatsConsumed > 0 ? { quantity: {
				type: "TEXT",
				text: String(t.seatsConsumed)
			} } : {},
			...p ? { discountedRate: {
				type: "TEXT",
				text: q({
					currency: e.currency,
					rateLabel: K(i),
					value: String(t.pricePerSeat),
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					rateOnly: !0,
					showBillingType: n,
					displayAnnualPriceAsMonthly: s
				}),
				style: W.discountedRate
			} } : {},
			rate: {
				type: "TEXT",
				text: q({
					currency: e.currency,
					rateLabel: K(i),
					value: p ? Ki({
						amount: String(t.pricePerSeat),
						discount: o,
						currency: e.currency
					}) : String(t.pricePerSeat),
					isDiscounted: p,
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					includeBillingFrequency: s,
					showBillingType: n,
					displayAnnualPriceAsMonthly: s
				})
			},
			...i.lineTotal ? {} : Zi({
				columns: i,
				intervalMultiplier: a,
				billingFrequency: e.billingFrequency,
				displayAnnualPriceAsMonthly: s
			}),
			...i.lineTotal ? {} : ta({
				columns: i,
				value: t.pricePerSeat,
				quantity: t.seatsConsumed,
				intervalMultiplier: a,
				currency: e.currency,
				discount: o,
				isExcluded: t.seatsConsumed === 0
			}),
			indentation: u
		}, ...t.fee ? [{
			description: {
				type: "TEXT",
				text: f
			},
			...m ? {} : g,
			billingFrequency: Ui,
			...p ? { discountedRate: {
				type: "TEXT",
				text: q({
					currency: e.currency,
					value: String(t.fee),
					isAmount: !0,
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					rateOnly: !0,
					showBillingType: n,
					displayAnnualPriceAsMonthly: s
				}),
				style: W.discountedRate
			} } : {},
			rate: {
				type: "TEXT",
				text: q({
					currency: e.currency,
					value: p ? Ki({
						amount: String(t.fee),
						discount: o,
						currency: e.currency,
						isBilledAmount: !0
					}) : String(t.fee),
					isAmount: !0,
					isDiscounted: p,
					billingFrequency: e.billingFrequency,
					billingType: e.billingType,
					includeBillingFrequency: s,
					showBillingType: n,
					displayAnnualPriceAsMonthly: s
				})
			},
			...(!i.lineTotal || m) && i.quantity ? { quantity: {
				type: "TEXT",
				text: "1"
			} } : {},
			...!i.lineTotal || m ? Zi({
				columns: i,
				intervalMultiplier: a,
				billingFrequency: e.billingFrequency,
				displayAnnualPriceAsMonthly: s
			}) : {},
			...!i.lineTotal || m ? ta({
				columns: i,
				value: t.fee,
				quantity: 1,
				intervalMultiplier: a,
				currency: e.currency,
				discount: o
			}) : {},
			indentation: d
		}] : []];
	});
}, fa = ({ prices: e, phasesWithProductId: t, allPhases: n, productId: r }) => {
	let i = e.map((e) => e.structure), a = i[0], o = i.map((e) => rt(a, e)).includes(!1) === !1, s = Ai({
		productId: r,
		phasesWithProductId: t
	}), c = e.every((t) => t.billingFrequency === e[0]?.billingFrequency), l = t.length === n.length;
	return o && s && c && l;
}, q = ({ currency: e, value: t, billingFrequency: n, billingType: r, isPricePercentage: i = !1, rateLabel: a, rateOnly: o = !1, includeBillingFrequency: s = !0, showBillingType: c, displayAnnualPriceAsMonthly: l = !1, isAmount: u = !1, isDiscounted: d = !1 }) => {
	let f = l ? Li({
		value: t,
		currency: e
	}) : t, p = M({
		isPricePercentage: i,
		isAmount: u
	}).with({ isPricePercentage: !0 }, () => Oi(f)).with({ isAmount: !0 }, () => j({
		currency: e,
		value: f
	})).otherwise(() => Fi({
		currency: e,
		value: f,
		isDiscounted: d
	}));
	return [a ? `${p} ${a}` : p, ...o ? [] : [s && n ? mt(l ? "MONTHLY" : n) : void 0, ...c && r === "IN_ADVANCE" ? ["In advance"] : []]].filter(Boolean).join(" / ");
}, pa = ({ billingFrequency: e, billingType: t, showBillingType: n }) => [pt(e), ...n && t === "IN_ADVANCE" ? ["In advance"] : []].filter(Boolean).join(" / "), ma = ({ descriptionType: e, price: t, phasesWithProductId: n, additionalText: r, showProductDescription: i }) => {
	let a = n.find((e) => e.prices.flatMap((e) => e.id).includes(t.id));
	if (!a) throw Error("unable to find phase with this price");
	return M(e).with("PHASE_LABEL", () => a.name ? {
		type: "TEXT",
		text: [a.name, r].filter(Boolean).join(" ")
	} : {
		type: "DATE_RANGE",
		dates: a.dates,
		...r ? { additionalText: r } : {}
	}).with("PRICE_NAME", () => ({
		type: "TEXT",
		text: [t.name, r].filter(Boolean).join(" "),
		style: W.description,
		...i && t.productDescription ? { secondaryText: t.productDescription } : {}
	})).exhaustive();
}, ha = (e) => ![
	"ONE_TIME",
	"ON_DEMAND",
	"PER_EVENT"
].includes(e.billingFrequency), ga = ({ recurringPrice: e, phaseTotals: t }) => {
	if (!e) return {
		type: "TEXT",
		text: "N/A"
	};
	if (typeof t?.intervalMultiplier == "number") return {
		type: "TEXT",
		text: Hi(t.intervalMultiplier)
	};
}, _a = ({ phase: e, phaseTotals: t, columns: n = G }) => {
	let r = e.globalDiscount;
	if (!r) return [];
	let i = e.prices.at(0)?.currency || "USD", a = e.prices.find(ha);
	return [{
		description: {
			type: "TEXT",
			text: "Global Discount",
			secondaryText: r.message,
			style: { fontWeight: "bold" }
		},
		discount: va({ phase: e }),
		...n.lineTotal || n.billingPeriods ? {
			billingFrequency: a ? {
				type: "TEXT",
				text: pa({
					billingFrequency: a.billingFrequency,
					billingType: a.billingType,
					showBillingType: !1
				})
			} : void 0,
			billingPeriods: n.billingPeriods ? ga({
				recurringPrice: a,
				phaseTotals: t
			}) : void 0,
			total: n.lineTotal && typeof t?.globalDiscountAmount == "number" ? {
				type: "TEXT",
				text: j({
					currency: i,
					value: new I(t.globalDiscountAmount).times(-1).toString()
				})
			} : void 0
		} : {},
		"data-testid": `quote.globalDiscount.${e.id}`
	}];
}, va = ({ phase: e, includeOffSuffix: t = !1 }) => {
	let n = e.globalDiscount;
	if (!n) return;
	let r = e.prices.at(0)?.currency || "USD", i = ht(r), a = n.discountCalculationType === "NOMINAL" ? gt({
		value: n.amount.toString(),
		currency: r,
		minimumFractionDigits: i,
		maximumFractionDigits: i
	}) : Oi(n.amount);
	return {
		type: "TEXT",
		text: t ? `${a} off` : a
	};
}, ya = ({ config: e, phaseSubTotals: t = [], columns: n = G }) => {
	let { phases: r } = e, i = r.filter((e) => e.globalDiscount);
	return i.length === 0 ? [] : [{
		title: {
			type: "TEXT",
			text: "Global Discounts"
		},
		rows: i.map((e) => {
			let i = e.prices.at(0)?.currency || "USD", a = e.prices.find(ha), o = t.at(r.indexOf(e));
			return {
				description: {
					type: "DATE_RANGE",
					dates: e.dates
				},
				discount: va({ phase: e }),
				...n.lineTotal || n.billingPeriods ? {
					billingFrequency: a ? {
						type: "TEXT",
						text: pa({
							billingFrequency: a.billingFrequency,
							billingType: a.billingType,
							showBillingType: !1
						})
					} : void 0,
					billingPeriods: n.billingPeriods ? ga({
						recurringPrice: a,
						phaseTotals: o
					}) : void 0,
					total: n.lineTotal && typeof o?.globalDiscountAmount == "number" ? {
						type: "TEXT",
						text: j({
							currency: i,
							value: new I(o.globalDiscountAmount).times(-1).toString()
						})
					} : void 0
				} : {}
			};
		})
	}];
}, ba = ({ config: e, productOrder: t, columns: n = G, quotePriceTotalsPerPhase: r = [] }) => {
	let i = e.phases.filter((e) => e.minimums.length > 0);
	if (i.length === 0) return [];
	let a = xa({ allPhases: e.phases }) === !1;
	if (xa({ allPhases: e.phases })) {
		let o = i.map((t) => Ea({
			phase: t,
			phasePriceTotals: r.at(e.phases.indexOf(t))
		})), s = o.every((e) => typeof e == "number") ? o.reduce((e, t) => e + t, 0) : void 0;
		return [{
			title: {
				type: "TEXT",
				text: "Minimum commitment"
			},
			rows: Sa({
				phase: i[0],
				showDateInDescription: a,
				productOrder: t,
				columns: n,
				intervalMultiplier: s
			})
		}];
	}
	return [{
		title: {
			type: "TEXT",
			text: "Minimum commitment"
		},
		rows: i.flatMap((i) => Sa({
			phase: i,
			showDateInDescription: a,
			productOrder: t,
			columns: n,
			intervalMultiplier: Ea({
				phase: i,
				phasePriceTotals: r.at(e.phases.indexOf(i))
			})
		}))
	}];
}, xa = ({ allPhases: e }) => {
	if (Array.from([...new Set(e.map((e) => e.minimums.length > 0))]).length !== 1 || Array.from([...new Set(e.map((e) => e.minimums[0].value))]).length !== 1) return !1;
	let t = Array.from([...new Set(e.map((e) => e.minimums[0].scope.target))]);
	if (t.length === 1 && t[0] === "allUsage") return !0;
	let n = e.map((e) => M(e.minimums[0].scope.target).with("allUsage", () => e.prices.filter((e) => "usageMetricId" in e.structure).map((e) => e.productId).sort()).with("specific", () => e.minimums[0].scope.priceIds.map((t) => e.prices.find((e) => e.id === t)?.productId).filter(Boolean).sort()).exhaustive().join(","));
	return Array.from([...new Set(n)]).length === 1;
}, Sa = ({ phase: e, showDateInDescription: t, productOrder: n, columns: r = G, intervalMultiplier: i }) => {
	let a = Da({
		phase: e,
		productOrder: n
	}).map((e) => ({
		description: {
			type: "TEXT",
			text: e
		},
		billingFrequency: {
			type: "TEXT",
			text: ""
		},
		indentation: 1
	}));
	return [...Ca({
		phase: e,
		showDateInDescription: t,
		columns: r,
		intervalMultiplier: i
	}), ...a];
}, Ca = ({ phase: e, showDateInDescription: t, columns: n = G, intervalMultiplier: r = Ea({ phase: e }) }) => {
	let i = e.minimums[0], a = wa(e.prices), o = Ta(e.prices, i);
	return [{
		description: t ? {
			type: "DATE_RANGE",
			dates: e.dates
		} : {
			type: "TEXT",
			text: "Minimum commitment",
			style: { fontWeight: "bold" }
		},
		billingFrequency: {
			type: "TEXT",
			text: o ? pa({
				billingFrequency: o,
				showBillingType: !1,
				billingType: "IN_ADVANCE"
			}) : ""
		},
		quantity: {
			type: "TEXT",
			text: "1"
		},
		rate: {
			type: "TEXT",
			text: a ? j({
				currency: a,
				value: i.value
			}) : ""
		},
		...n.billingPeriods && typeof r == "number" ? { billingPeriods: {
			type: "TEXT",
			text: Hi(r)
		} } : {},
		...n.lineTotal && a && typeof r == "number" ? Bi({
			gross: Ri({
				value: i.value,
				intervalMultiplier: r,
				currency: a
			}),
			net: Ri({
				value: i.value,
				intervalMultiplier: r,
				currency: a
			}),
			currency: a
		}) : {}
	}];
}, wa = (e) => {
	if (e.length !== 0) return e[0].currency;
}, Ta = (e, t) => e.filter((e) => Yn({
	price: e,
	minimum: t
})).at(0)?.billingFrequency, Ea = ({ phase: e, phasePriceTotals: t }) => {
	let n = e.minimums[0];
	if (!n) return;
	let r = e.prices.find((e) => Yn({
		price: e,
		minimum: n
	})), i = r ? Qi({
		price: r,
		phasePriceTotals: t
	})?.intervalMultiplier : void 0;
	if (typeof i == "number") return i;
	if (typeof e.dates.duration != "object") return;
	let a = Ta(e.prices, n);
	if (!a) return;
	let o = e.dates.absolute.start, s = o ? new Date(o) : void 0;
	return at({
		billingFrequency: a,
		duration: e.dates.duration,
		startDate: s && !Number.isNaN(s.getTime()) ? s : void 0
	});
}, Da = ({ phase: e, productOrder: t }) => {
	if (!e.minimums[0]) return [];
	let n = nr({
		orderedProductIds: t,
		products: e.prices
	});
	return M(e.minimums[0].scope.target).with("allUsage", () => n.filter((e) => "usageMetricId" in e.structure).map((e) => e.name)).with("specific", () => n.filter((t) => e.minimums[0].scope.priceIds.includes(t.id)).map((e) => e.name)).exhaustive();
}, Oa = [
	"billingFrequency",
	"billingPeriods",
	"quantity",
	"discount",
	"rate",
	"total"
], ka = ({ config: e, context: t, showProductDescriptions: n, productOrder: r, showMonthlyRateForAnnualPrices: i = !1, seatBasedMinimumText: a, columns: o = G, priceCommitments: s = [], quotePriceTotalsPerPhase: c = [] }) => {
	let { phases: l } = e, u = M(t).with("react", "pdf", () => !0).with("react_v3", "pdf_v3", () => !1).exhaustive(), d = l.flatMap(({ prices: e }) => e);
	return Array.from(/* @__PURE__ */ new Set([...r, ...d.map((e) => e.productId)])).flatMap((e) => {
		let r = l.filter((t) => t.prices.some((t) => t.productId === e)), d = r.flatMap((t) => t.prices.filter((t) => t.productId === e).map((e) => ({
			price: e,
			phase: t
		})));
		if (d.length === 0) return;
		let f = d[0].price, p = !d.some(({ price: e }) => e.structure.pricingType !== f.structure.pricingType), m = {
			type: "TEXT",
			text: f.name
		}, h = t === "react_v3" && n && f.productDescription ? {
			type: "TEXT",
			text: f.productDescription
		} : void 0, g = p ? Pa(f) : void 0;
		if (fa({
			prices: d.map((e) => e.price),
			phasesWithProductId: r,
			productId: e,
			allPhases: l
		})) return {
			title: m,
			...h ? { subtitle: h } : {},
			...g ? { caption: g } : {},
			rows: [...Aa({
				pricingType: f.structure.pricingType,
				price: f,
				phasesWithProductId: r,
				descriptionType: "PRICE_NAME",
				isCollapsible: !1,
				showBillingTypeInRate: u,
				showProductDescription: n && t === "pdf_v3",
				showMonthlyRateForAnnualPrices: i,
				seatBasedMinimumText: a,
				columns: o,
				commitment: d.flatMap(({ price: e, phase: t }) => {
					let n = Ma({
						price: e,
						phase: t,
						phases: l,
						priceCommitments: s
					});
					return n ? [n] : [];
				}).at(0),
				phaseAmount: Na(d.flatMap(({ price: e, phase: t }) => {
					let n = ja({
						price: e,
						phase: t,
						phases: l,
						quotePriceTotalsPerPhase: c
					});
					return n ? [n] : [];
				}))
			}), ...t === "pdf_v3" && g ? [{
				description: {
					type: "TEXT",
					text: g,
					style: { color: "GreyGrey60" }
				},
				descriptionSpan: [...Oa]
			}] : []]
		};
		let _ = [
			"SEAT_BASED",
			"GRADUATED",
			"VOLUME"
		];
		return t === "pdf" && p ? d.map(({ price: e, phase: t }) => {
			let n = _.includes(e.structure.pricingType), r = (() => {
				if (!n) return;
				let { dateStartResolved: e, dateEndResolved: r, durationResolved: i, showDateRange: a } = Ln(t.dates);
				return {
					type: "TEXT",
					text: a ? `${e} to ${r}` : i ?? ""
				};
			})();
			return {
				title: m,
				...g ? { caption: g } : {},
				...r ? { subtitle: r } : {},
				rows: Aa({
					pricingType: e.structure.pricingType,
					price: e,
					phasesWithProductId: [t],
					seatBasedMinimumText: a,
					descriptionType: n ? "PRICE_NAME" : "PHASE_LABEL",
					isCollapsible: !1,
					showBillingTypeInRate: u,
					showProductDescription: !1,
					showMonthlyRateForAnnualPrices: i,
					columns: o,
					commitment: Ma({
						price: e,
						phase: t,
						phases: l,
						priceCommitments: s
					}),
					phaseAmount: ja({
						price: e,
						phase: t,
						phases: l,
						quotePriceTotalsPerPhase: c
					})
				})
			};
		}) : {
			title: m,
			...h ? { subtitle: h } : {},
			...g ? { caption: g } : {},
			rows: [
				...t === "pdf_v3" ? [{ description: {
					...m,
					style: { fontWeight: "bold" },
					secondaryText: n && f.productDescription ? f.productDescription : void 0
				} }] : [],
				...d.flatMap(({ price: e, phase: n }) => Aa({
					pricingType: e.structure.pricingType,
					price: e,
					phasesWithProductId: [n],
					descriptionType: "PHASE_LABEL",
					seatBasedMinimumText: a,
					isCollapsible: M(t).with("react", "react_v3", () => !0).with("pdf", () => p).with("pdf_v3", () => !1).exhaustive(),
					showBillingTypeInRate: u,
					showProductDescription: !1,
					showMonthlyRateForAnnualPrices: i,
					columns: o,
					commitment: Ma({
						price: e,
						phase: n,
						phases: l,
						priceCommitments: s
					}),
					phaseAmount: ja({
						price: e,
						phase: n,
						phases: l,
						quotePriceTotalsPerPhase: c
					})
				})),
				...t === "pdf_v3" && g ? [{
					description: {
						type: "TEXT",
						text: g,
						style: { color: "GreyGrey60" }
					},
					descriptionSpan: [...Oa]
				}] : []
			]
		};
	}).filter(Boolean);
}, Aa = ({ pricingType: e, price: t, phasesWithProductId: n, descriptionType: r, isCollapsible: i, showBillingTypeInRate: a, showProductDescription: o, showMonthlyRateForAnnualPrices: s, seatBasedMinimumText: c, columns: l, commitment: u, phaseAmount: d }) => M(e).with("FIXED", "ONE_TIME", () => aa({
	price: t,
	phasesWithProductId: n,
	descriptionType: r,
	showBillingTypeInRate: a,
	showProductDescription: o,
	showMonthlyRateForAnnualPrices: s,
	columns: l,
	phaseAmount: d
})).with("LINEAR", () => oa({
	price: t,
	phasesWithProductId: n,
	descriptionType: r,
	hasCollapsibleMinMaxRates: i,
	showBillingTypeInRate: a,
	showProductDescription: o,
	columns: l,
	phaseAmount: d
})).with("VOLUME", "GRADUATED", () => sa({
	price: t,
	phasesWithProductId: n,
	descriptionType: r,
	hasCollapsibleTiers: i,
	showBillingTypeInRate: a,
	showProductDescription: o,
	showMonthlyRateForAnnualPrices: s,
	columns: l,
	phaseAmount: d
})).with("PACKAGE", () => la({
	price: t,
	phasesWithProductId: n,
	descriptionType: r,
	showBillingTypeInRate: a,
	showProductDescription: o,
	columns: l,
	phaseAmount: d
})).with("SEAT_BASED", () => ua({
	price: t,
	phasesWithProductId: n,
	descriptionType: r,
	hasCollapsibleTiers: i,
	showBillingTypeInRate: a,
	showProductDescription: o,
	showMonthlyRateForAnnualPrices: s,
	seatBasedMinimumText: c,
	columns: l,
	commitment: u,
	phaseAmount: d
})).exhaustive(), ja = ({ price: e, phase: t, phases: n, quotePriceTotalsPerPhase: r }) => Qi({
	price: e,
	phasePriceTotals: r.at(n.indexOf(t))
}), Ma = ({ price: e, phase: t, phases: n, priceCommitments: r }) => r.at(n.indexOf(t))?.[e.productId], Na = (e) => {
	if (e.length !== 0) return e.reduce((e, t) => ({
		fullRate: new I(e.fullRate).plus(t.fullRate).toNumber(),
		discountedRate: new I(e.discountedRate).plus(t.discountedRate).toNumber(),
		commitmentRate: new I(e.commitmentRate).plus(t.commitmentRate).toNumber(),
		intervalMultiplier: new I(e.intervalMultiplier).plus(t.intervalMultiplier).toNumber(),
		isCommitted: e.isCommitted || t.isCommitted
	}), {
		fullRate: 0,
		discountedRate: 0,
		commitmentRate: 0,
		intervalMultiplier: 0,
		isCommitted: !1
	});
}, Pa = (e) => M(e).with({ structure: { pricingType: "GRADUATED" } }, () => Mi).with({ structure: { pricingType: "VOLUME" } }, () => ji).with({ structure: { pricingType: "SEAT_BASED" } }, ({ structure: e }) => e.tiers.length > 0 ? Ni : void 0).with({ structure: { pricingType: "FIXED" } }, { structure: { pricingType: "LINEAR" } }, { structure: { pricingType: "ONE_TIME" } }, { structure: { pricingType: "PACKAGE" } }, () => void 0).exhaustive(), Fa = [
	"billingFrequency",
	"billingPeriods",
	"quantity",
	"discount"
], Ia = [...Fa, "rate"], La = ({ config: e, context: t, phaseSubTotals: n, showTotals: r, showProductDescriptions: i, productOrder: a, showMonthlyRateForAnnualPrices: o = !1, seatBasedMinimumText: s, priceCommitments: c, quotePriceTotalsPerPhase: l = [], columns: u = G }) => {
	let { phases: d } = e, f = d[0]?.prices[0]?.currency, p = M(t).with("react", "pdf", () => !0).with("react_v3", "pdf_v3", () => !1).exhaustive();
	return d.map((e, d) => {
		let m = (() => {
			if (e.name) return {
				type: "TEXT",
				text: e.name
			};
			let { showDateRange: t, durationResolved: n } = Ln(e.dates);
			return t ? {
				type: "DATE_RANGE",
				dates: e.dates
			} : {
				type: "TEXT",
				text: n || "Open ended"
			};
		})(), h = (() => {
			if (e.name) {
				let { showDateRange: t, durationResolved: n } = Ln(e.dates);
				return t ? {
					type: "DATE_RANGE",
					dates: e.dates
				} : {
					type: "TEXT",
					text: n ?? ""
				};
			}
		})(), g = (() => {
			let { showDateRange: t, durationResolved: n, dateStartResolved: r, dateEndResolved: i } = Ln(e.dates), a = t ? `${r} - ${i}` : n || "Open ended";
			return { description: {
				type: "TEXT",
				text: e.name || a,
				secondaryText: e.name ? a : void 0,
				style: { fontWeight: "bold" }
			} };
		})(), _ = n.at(d), v = M({
			context: t,
			showTotals: r
		}).with({ showTotals: !1 }, { context: "react" }, { context: "pdf" }, () => !1).with({ context: "react_v3" }, { context: "pdf_v3" }, () => !0).exhaustive(), ee = v && !!_ && !!e.globalDiscount, te = (() => {
			if (!_) return [];
			if (ee && e.globalDiscount) {
				let t = _.globalDiscountAmount ?? new I(_.totalPreGlobalDiscountRate).minus(_.totalDiscountedRate).toNumber(), n = e.globalDiscount.message.trim() || "Discount", r = M(e.globalDiscount).with({ discountCalculationType: "PERCENTAGE" }, (e) => ` (${Oi(e.amount)})`).with({ discountCalculationType: "NOMINAL" }, () => "").exhaustive();
				return [
					{
						id: "subtotal",
						label: "Subtotal",
						value: _.totalPreGlobalDiscountRate,
						isBold: !1
					},
					{
						id: "discount",
						label: `${n}${r}`,
						value: new I(t).times(-1).toNumber(),
						isBold: !1
					},
					{
						id: "phase-total",
						label: "Phase total",
						value: _.totalDiscountedRate,
						isBold: !0
					}
				].map(({ id: t, label: n, value: r, isBold: i }) => {
					let a = t !== "subtotal", o = {
						type: "TEXT",
						text: j({
							currency: f,
							value: String(r)
						}),
						...i ? { style: { fontWeight: "bold" } } : {}
					};
					return {
						isSummaryContinuation: a,
						description: {
							type: "TEXT",
							text: n,
							...i ? { style: { fontWeight: "bold" } } : {}
						},
						descriptionAlignment: "end",
						descriptionSpan: u.lineTotal ? Ia : Fa,
						...u.lineTotal ? { total: o } : { rate: o },
						"data-testid": `quote.phaseSummary.${e.id}.${t}`
					};
				});
			}
			let t = _.totalPreGlobalDiscountRate !== _.totalDiscountedRate;
			return [{
				description: {
					type: "TEXT",
					text: "Subtotal",
					style: { fontWeight: "bold" }
				},
				...u.lineTotal ? { total: {
					type: "TEXT",
					text: j({
						currency: f,
						value: `${_.totalDiscountedRate}`
					})
				} } : {
					discountedRate: t ? {
						type: "TEXT",
						text: j({
							currency: f,
							value: `${_.totalPreGlobalDiscountRate}`
						}),
						style: W.discountedRate
					} : void 0,
					rate: {
						type: "TEXT",
						text: j({
							currency: f,
							value: `${_.totalDiscountedRate}`
						})
					}
				},
				"data-testid": `quote.phaseSubtotal.${e.id}`
			}];
		})(), ne = e.minimums.at(0), re = c.at(d), y = (e) => re?.[e.productId], b = (e) => Qi({
			price: e,
			phasePriceTotals: l.at(d)
		}), x = e.prices.filter((e) => Yn({
			price: e,
			minimum: ne
		})), ie = nr({
			orderedProductIds: a,
			products: e.prices.filter((e) => !Yn({
				price: e,
				minimum: ne
			}))
		}), S = [...t === "pdf_v3" ? [g] : [], ...ie.flatMap((t) => Ra({
			phasePrice: t,
			phase: e,
			commitment: y(t),
			phaseAmount: b(t),
			showBillingTypeInRate: p,
			showProductDescriptions: i,
			showMonthlyRateForAnnualPrices: o,
			seatBasedMinimumText: s,
			columns: u
		}))], ae = (() => {
			if (x.length === 0) return [];
			let t = nr({
				orderedProductIds: a,
				products: x
			});
			return [...Ca({
				phase: e,
				showDateInDescription: !1,
				columns: u,
				intervalMultiplier: Ea({
					phase: e,
					phasePriceTotals: l.at(d)
				})
			}), ...t.flatMap((t) => Ra({
				phasePrice: t,
				phase: e,
				commitment: y(t),
				phaseAmount: b(t),
				showBillingTypeInRate: p,
				showProductDescriptions: i,
				baseIndentation: 1,
				showMonthlyRateForAnnualPrices: o,
				seatBasedMinimumText: s,
				columns: u
			}))];
		})(), oe = ee ? [] : _a({
			phase: e,
			phaseTotals: n.at(d),
			columns: u
		});
		return {
			title: m,
			subtitle: h,
			"data-testid": `quote.phase.${e.id}`,
			rows: [
				...S,
				...ae,
				...oe,
				...v ? te : []
			]
		};
	});
}, Ra = ({ phasePrice: e, phase: t, commitment: n, phaseAmount: r, showBillingTypeInRate: i, showProductDescriptions: a, baseIndentation: o, showMonthlyRateForAnnualPrices: s, seatBasedMinimumText: c, columns: l }) => M(e).with({ structure: { pricingType: "FIXED" } }, { structure: { pricingType: "ONE_TIME" } }, (e) => aa({
	price: e,
	phasesWithProductId: [t],
	descriptionType: "PRICE_NAME",
	showBillingTypeInRate: i,
	showProductDescription: a,
	showMonthlyRateForAnnualPrices: s,
	columns: l,
	phaseAmount: r
})).with({ structure: { pricingType: "LINEAR" } }, (e) => oa({
	price: e,
	phasesWithProductId: [t],
	descriptionType: "PRICE_NAME",
	hasCollapsibleMinMaxRates: !1,
	showBillingTypeInRate: i,
	showProductDescription: a,
	baseIndentation: o,
	columns: l,
	phaseAmount: r
})).with({ structure: { pricingType: "VOLUME" } }, { structure: { pricingType: "GRADUATED" } }, (e) => sa({
	price: e,
	phasesWithProductId: [t],
	descriptionType: "PRICE_NAME",
	hasCollapsibleTiers: !1,
	showBillingTypeInRate: i,
	showProductDescription: a,
	baseIndentation: o,
	showMonthlyRateForAnnualPrices: s,
	columns: l,
	phaseAmount: r
})).with({ structure: { pricingType: "PACKAGE" } }, (e) => la({
	price: e,
	phasesWithProductId: [t],
	descriptionType: "PRICE_NAME",
	showBillingTypeInRate: i,
	showProductDescription: a,
	baseIndentation: o,
	columns: l,
	phaseAmount: r
})).with({ structure: { pricingType: "SEAT_BASED" } }, (e) => ua({
	price: e,
	commitment: n,
	phasesWithProductId: [t],
	descriptionType: "PRICE_NAME",
	groupBy: "phase",
	hasCollapsibleTiers: !1,
	showBillingTypeInRate: i,
	showProductDescription: a,
	showMonthlyRateForAnnualPrices: s,
	seatBasedMinimumText: c,
	columns: l,
	phaseAmount: r
})).exhaustive(), za = ({ config: e, context: t, settings: n, phaseSubTotals: r, priceCommitments: i, quotePriceTotalsPerPhase: a = [] }) => ({
	pricingTables: n.groupPricesByPhase ? La({
		config: e,
		context: t,
		phaseSubTotals: r,
		showTotals: n.showTotals,
		showProductDescriptions: n.showProductDescriptions,
		productOrder: n.priceEditorProductOrder,
		showMonthlyRateForAnnualPrices: n.showMonthlyRateForAnnualPrices,
		seatBasedMinimumText: n.seatBasedMinimumText,
		priceCommitments: i,
		quotePriceTotalsPerPhase: a,
		columns: n.columns
	}) : [
		...ka({
			config: e,
			context: t,
			showProductDescriptions: n.showProductDescriptions,
			productOrder: n.priceEditorProductOrder,
			showMonthlyRateForAnnualPrices: n.showMonthlyRateForAnnualPrices,
			seatBasedMinimumText: n.seatBasedMinimumText,
			priceCommitments: i,
			quotePriceTotalsPerPhase: a,
			columns: n.columns
		}),
		...ba({
			config: e,
			productOrder: n.priceEditorProductOrder,
			columns: n.columns,
			quotePriceTotalsPerPhase: a
		}),
		...ya({
			config: e,
			columns: n.columns,
			phaseSubTotals: r
		})
	],
	defaultVisibleColumns: [
		"description",
		...n.columns.billingType === !1 ? [] : ["billingFrequency"],
		...n.columns.billingPeriods ? ["billingPeriods"] : [],
		...n.columns.quantity ? ["quantity"] : [],
		"discount",
		"rate",
		...n.columns.lineTotal ? ["total"] : []
	]
}), Ba = ({ config: e, context: t, settings: n, phaseSubTotals: r, priceCommitments: i, quotePriceTotalsPerPhase: a = [] }) => s(() => {
	let { pricingTables: o, defaultVisibleColumns: s } = za({
		config: e,
		context: t,
		settings: n,
		phaseSubTotals: r,
		priceCommitments: i,
		quotePriceTotalsPerPhase: a
	});
	return {
		pricingTables: o.map((e) => ({
			uuid: crypto.randomUUID(),
			...e
		})),
		defaultVisibleColumns: s
	};
}, [
	e,
	t,
	n,
	r,
	i,
	a
]), Va = k(), Ha = k(), Ua = k(), Wa = () => {
	let e = Ka();
	return e === 0 ? { width: "100%" } : {
		width: {
			base: "100%",
			lg: `${762 + e}px`
		},
		marginLeft: {
			base: "0",
			lg: `-${e / 2}px`
		}
	};
}, Ga = () => {
	let e = Ka();
	return e === 0 ? {} : {
		marginLeft: {
			base: "0",
			lg: `${e / 2}px`
		},
		maxWidth: {
			base: "100%",
			lg: Sn
		}
	};
}, Ka = () => (A(Ua) ?? 762) - 762, qa = ({ children: e }) => /* @__PURE__ */ P(v, {
	flexDirection: "column",
	gap: "24px",
	"data-testid": "quote.pricingTables",
	...Wa(),
	children: e
}), Ja = "480px", Ya = "104px", Xa = ({ visibleColumns: e }) => {
	let n = A(Va), r = A(wr), i = wn({ lineTotal: A(Ar)?.columns.lineTotal ?? !1 });
	if (!e || !r) return null;
	let a = {
		...w,
		color: ie
	}, o = {
		padding: "9px 12px",
		justifyContent: "flex-end"
	}, s = e.includes("description") && /* @__PURE__ */ P(v, {
		...o,
		flex: "1",
		minWidth: "104px",
		justifyContent: "flex-start",
		"data-phase-column-id": "description",
		"data-testid": "quote.pricingHeader.description",
		children: /* @__PURE__ */ P(O, {
			...a,
			children: i.description
		})
	}), c = e.includes("billingFrequency") && /* @__PURE__ */ P(v, {
		...o,
		justifyContent: "flex-start",
		"data-phase-column-id": "billingFrequency",
		"data-testid": "quote.pricingHeader.billingFrequency",
		width: n?.billingFrequency,
		maxWidth: "176px",
		flexShrink: "0",
		children: /* @__PURE__ */ P(O, {
			...a,
			children: M(r).with(3, () => i.billingFrequency).with(2, () => "Billing frequency").exhaustive()
		})
	}), l = e.includes("quantity") && /* @__PURE__ */ P(v, {
		...o,
		...M(r).with(3, () => ({ justifyContent: "flex-start" })).with(2, () => ({})).exhaustive(),
		"data-phase-column-id": "quantity",
		"data-testid": "quote.pricingHeader.quantity",
		width: n?.quantity,
		maxWidth: "104px",
		flexShrink: "0",
		children: /* @__PURE__ */ P(O, {
			...a,
			children: i.quantity
		})
	}), u = e.includes("discount") && /* @__PURE__ */ P(v, {
		...o,
		"data-phase-column-id": "discount",
		"data-testid": "quote.pricingHeader.discount",
		width: n?.discount,
		flexShrink: "0",
		children: /* @__PURE__ */ P(O, {
			...a,
			children: i.discount
		})
	}), d = e.includes("rate") && /* @__PURE__ */ P(v, {
		...o,
		"data-phase-column-id": "rate",
		"data-testid": "quote.pricingHeader.rate",
		width: n?.rate,
		flexShrink: "0",
		children: /* @__PURE__ */ P(O, {
			...a,
			children: i.rate
		})
	}), f = {
		description: s,
		billingFrequency: c,
		quantity: l,
		discount: u,
		rate: d,
		billingPeriods: e.includes("billingPeriods") && /* @__PURE__ */ P(v, {
			...o,
			justifyContent: "flex-start",
			"data-phase-column-id": "billingPeriods",
			"data-testid": "quote.pricingHeader.billingPeriods",
			width: n?.billingPeriods,
			flexShrink: "0",
			children: /* @__PURE__ */ P(O, {
				...a,
				children: i.billingPeriods
			})
		}),
		total: e.includes("total") && /* @__PURE__ */ P(v, {
			...o,
			"data-phase-column-id": "total",
			"data-testid": "quote.pricingHeader.total",
			width: n?.total,
			minWidth: "120px",
			flexShrink: "0",
			children: /* @__PURE__ */ P(O, {
				...a,
				children: i.total
			})
		})
	};
	return /* @__PURE__ */ P(v, {
		background: te,
		children: M(r).with(3, () => /* @__PURE__ */ P(N, { children: e.map((e) => /* @__PURE__ */ P(t, { children: f[e] }, e)) })).with(2, () => /* @__PURE__ */ F(N, { children: [
			s,
			c,
			l,
			u,
			d
		] })).exhaustive()
	});
}, Za = ({ dates: e, additionalText: t }) => {
	let { dateStartResolved: n, dateEndResolved: r, durationResolved: i, showDateRange: a } = Ln(e);
	return /* @__PURE__ */ F(v, {
		gap: "4px",
		flexWrap: "wrap",
		children: [a && /* @__PURE__ */ F(N, { children: [
			/* @__PURE__ */ P(O, {
				...C,
				color: S,
				children: n
			}),
			/* @__PURE__ */ P(le, { color: ie }),
			/* @__PURE__ */ P(O, {
				...C,
				color: S,
				children: r
			}),
			t && /* @__PURE__ */ P(O, {
				...C,
				color: S,
				children: t
			})
		] }), i && !a && /* @__PURE__ */ F(O, {
			...C,
			color: S,
			children: [i, t ? ` ${t}` : ""]
		})]
	});
}, Qa = (e) => e.flatMap((e) => [e, ...Qa([...e.rowsBeforeSubrows ?? [], ...e.subrows ?? []])]), $a = (e, t) => t === "rate" ? !!(e.rate || e.discountedRate) : t === "total" ? !!(e.total || e.totalBeforeDiscount) : !!e[t], eo = ({ row: e, visibleColumns: t }) => {
	let n = t.filter((e) => e !== "description");
	return e.descriptionSpan?.filter((e) => t.includes(e)) || (n.some((t) => $a(e, t)) ? [] : n);
}, to = "Fixed discounts are applied to total usage, not the price per unit", no = ({ row: e, isOpen: n, visibleColumns: r }) => {
	let a = A(Va), o = A(wr), c = {
		display: "flex",
		alignItems: "flex-start",
		padding: e.isSummaryContinuation ? "6px 12px 10px" : "10px 12px",
		justifyContent: "flex-end"
	}, l = n !== void 0, u = i(({ style: e, text: t, secondaryText: n }) => {
		let r = M(e?.fontWeight).with("regular", void 0, () => C).with("bold", () => w).exhaustive(), i = M(e?.color).with("GreyGrey60", () => x).with("GreyGrey80", void 0, () => S).exhaustive(), a = M(e?.textDecoration).with("line-through", () => "line-through").with(void 0, () => "initial").exhaustive();
		return /* @__PURE__ */ F(v, {
			flexDir: "column",
			gap: "4px",
			minWidth: "0",
			maxWidth: "100%",
			children: [/* @__PURE__ */ P(O, {
				...r,
				color: i,
				textDecoration: a,
				wordBreak: "break-word",
				overflowWrap: "anywhere",
				children: t
			}), n && /* @__PURE__ */ P(O, {
				...C,
				color: x,
				wordBreak: "break-word",
				overflowWrap: "anywhere",
				children: n
			})]
		});
	}, []), d = i((e) => e ? M(e).with({ type: "DATE_RANGE" }, (e) => /* @__PURE__ */ P(Za, {
		dates: e.dates,
		additionalText: e.additionalText
	})).with({ type: "TEXT" }, u).with({ type: "STACK" }, (e) => /* @__PURE__ */ P(v, {
		flexDirection: "column",
		gap: "16px",
		children: e.cells.map((e, n) => /* @__PURE__ */ P(t, { children: u(e) }, `${e.text}-${String(n)}`))
	})).exhaustive() : null, [u]), f = s(() => M(e).with({ indentation: 1 }, () => "16px").with({ indentation: 2 }, () => "24px").with({ indentation: 3 }, () => "32px").otherwise(() => "12px"), [e]);
	if (!r || !o) return null;
	let p = e.descriptionAlignment === "end", m = r.includes("description") && /* @__PURE__ */ P(v, {
		...c,
		flex: "1",
		minWidth: "104px",
		justifyContent: p ? "flex-end" : "flex-start",
		textAlign: p ? "end" : "start",
		paddingLeft: f,
		"data-phase-column-id": "description",
		"data-testid": "quote.pricingCell.description",
		children: d(e.description)
	}), g = r.includes("billingFrequency") && /* @__PURE__ */ P(v, {
		...c,
		justifyContent: "flex-start",
		textAlign: "start",
		"data-phase-column-id": "billingFrequency",
		"data-testid": "quote.pricingCell.billingFrequency",
		width: a?.billingFrequency,
		maxWidth: "176px",
		flexShrink: "0",
		children: d(e.billingFrequency)
	}), _ = r.includes("quantity") && /* @__PURE__ */ P(v, {
		...c,
		...M(o).with(3, () => ({
			justifyContent: "flex-start",
			textAlign: "start"
		})).with(2, () => ({ textAlign: "end" })).exhaustive(),
		"data-phase-column-id": "quantity",
		"data-testid": "quote.pricingCell.quantity",
		width: a?.quantity,
		maxWidth: "104px",
		flexShrink: "0",
		children: d(e.quantity)
	}), ee = r.includes("discount") && /* @__PURE__ */ F(v, {
		...c,
		gap: "4px",
		textAlign: "end",
		"data-phase-column-id": "discount",
		"data-testid": "quote.pricingCell.discount",
		width: a?.discount,
		flexShrink: "0",
		children: [e.discount && d(e.discount), e.discountExplanation && /* @__PURE__ */ P(Je, {
			label: to,
			placement: "bottom",
			children: /* @__PURE__ */ P(h, {
				flexShrink: "0",
				"data-testid": "quote.pricingCell.discount.explanation",
				children: /* @__PURE__ */ P(_e, { color: x })
			})
		})]
	}), te = r.includes("rate") && /* @__PURE__ */ F(v, {
		...c,
		textAlign: "end",
		"data-phase-column-id": "rate",
		"data-testid": "quote.pricingCell.rate",
		width: a?.rate,
		flexShrink: "0",
		gap: "6px",
		children: [/* @__PURE__ */ F(v, {
			...M(o).with(3, () => ({
				flexDirection: "column",
				alignItems: "flex-end"
			})).with(2, () => ({ gap: "6px" })).exhaustive(),
			children: [e.discountedRate && d(e.discountedRate), d(e.rate)]
		}), l && /* @__PURE__ */ P(N, { children: P(n ? he : me, { color: "inherit" }) })]
	}), ne = {
		description: m,
		billingFrequency: g,
		quantity: _,
		discount: ee,
		rate: te,
		billingPeriods: r.includes("billingPeriods") && /* @__PURE__ */ P(v, {
			...c,
			justifyContent: "flex-start",
			textAlign: "start",
			"data-phase-column-id": "billingPeriods",
			"data-testid": "quote.pricingCell.billingPeriods",
			width: a?.billingPeriods,
			flexShrink: "0",
			children: d(e.billingPeriods)
		}),
		total: r.includes("total") && /* @__PURE__ */ F(v, {
			...c,
			flexDirection: "column",
			alignItems: "flex-end",
			justifyContent: "flex-start",
			textAlign: "end",
			"data-phase-column-id": "total",
			"data-testid": "quote.pricingCell.total",
			width: a?.total,
			minWidth: "120px",
			flexShrink: "0",
			whiteSpace: "nowrap",
			gap: "4px",
			children: [e.totalBeforeDiscount && d(e.totalBeforeDiscount), d(e.total)]
		})
	}, re = eo({
		row: e,
		visibleColumns: r
	}), b = r.filter((e) => !re.includes(e));
	return /* @__PURE__ */ P(v, {
		borderTop: e.isSummaryContinuation ? void 0 : `${y} 1px solid`,
		"data-testid": e["data-testid"],
		children: M(o).with(3, () => /* @__PURE__ */ P(N, { children: b.map((e) => /* @__PURE__ */ P(t, { children: ne[e] }, e)) })).with(2, () => /* @__PURE__ */ F(N, { children: [
			m,
			g,
			_,
			ee,
			te
		] })).exhaustive()
	});
}, ro = ({ trigger: e, afterTrigger: t, children: n, defaultIsOpen: r = !1 }) => {
	let [a, o] = l(r);
	return /* @__PURE__ */ F(N, { children: [
		/* @__PURE__ */ P(f, {
			as: "button",
			"aria-expanded": a,
			"data-testid": "quote.pricingRow.collapse",
			onClick: i(() => o(!a), [a]),
			background: "none",
			border: "none",
			padding: "0",
			margin: "0",
			height: "initial",
			lineHeight: "inherit",
			color: "inherit",
			cursor: "pointer",
			display: "block",
			width: "100%",
			children: e(a)
		}),
		t,
		/* @__PURE__ */ P(g, {
			in: a,
			children: /* @__PURE__ */ P(f, { children: n })
		})
	] });
}, io = ({ row: e, defaultIsOpen: t, visibleColumns: n }) => {
	let r = s(() => e.subrows ? e.subrows.map((e) => ({
		uuid: crypto.randomUUID(),
		...e
	})) : [], [e.subrows]);
	return /* @__PURE__ */ P(ro, {
		trigger: (t) => /* @__PURE__ */ P(no, {
			row: e,
			isOpen: t,
			visibleColumns: n
		}),
		afterTrigger: s(() => (e.rowsBeforeSubrows ?? []).map((e) => ({
			uuid: crypto.randomUUID(),
			...e
		})), [e.rowsBeforeSubrows]).map((e) => /* @__PURE__ */ P(no, {
			row: e,
			visibleColumns: n
		}, e.uuid)),
		defaultIsOpen: t,
		children: r.map((e) => /* @__PURE__ */ P(no, {
			row: e,
			visibleColumns: n
		}, e.uuid))
	});
}, ao = ({ caption: e }) => /* @__PURE__ */ F(v, {
	background: ee,
	borderTop: `${y} 1px solid`,
	paddingX: "12px",
	paddingY: "10px",
	gap: "4px",
	width: "100%",
	children: [/* @__PURE__ */ P(h, {
		flexShrink: "0",
		children: /* @__PURE__ */ P(_e, { color: x })
	}), /* @__PURE__ */ P(O, {
		...C,
		color: ie,
		flex: "1",
		children: e
	})]
}), oo = ({ pricingTable: e }) => {
	let { title: t, subtitle: n } = e;
	return /* @__PURE__ */ F(v, {
		flexDir: "column",
		gap: "4px",
		alignItems: "baseline",
		flexWrap: "wrap",
		"data-testid": "quote.pricingTableTitle",
		children: [M(t).with({ type: "TEXT" }, ({ text: e }) => /* @__PURE__ */ P(O, {
			...Me,
			color: S,
			children: e
		})).with({ type: "DATE_RANGE" }, ({ dates: e }) => {
			let { dateStartResolved: t, dateEndResolved: n } = Ln(e);
			return !t || !n ? null : /* @__PURE__ */ F(v, {
				gap: "8px",
				children: [
					/* @__PURE__ */ P(O, {
						...Me,
						color: S,
						children: t
					}),
					/* @__PURE__ */ P(le, { color: S }),
					/* @__PURE__ */ P(O, {
						...Me,
						color: S,
						children: n
					})
				]
			});
		}).exhaustive(), n && /* @__PURE__ */ P(N, { children: M(n).with({ type: "TEXT" }, ({ text: e }) => /* @__PURE__ */ P(O, {
			...T,
			color: x,
			children: e
		})).with({ type: "DATE_RANGE" }, ({ dates: e }) => {
			let { dateStartResolved: t, dateEndResolved: n } = Ln(e);
			return !t || !n ? null : /* @__PURE__ */ F(v, {
				gap: "4px",
				alignItems: "center",
				children: [
					/* @__PURE__ */ P(O, {
						...T,
						color: x,
						children: t
					}),
					/* @__PURE__ */ P(le, { color: x }),
					/* @__PURE__ */ P(O, {
						...T,
						color: x,
						children: n
					})
				]
			});
		}).exhaustive() })]
	});
}, so = ({ pricingTable: e, footer: t }) => {
	let { caption: n, rows: r } = e, i = A(Ha), a = A(Ua) ?? 762, o = a + 4, c = Ga(), l = s(() => r.map((e) => ({
		uuid: crypto.randomUUID(),
		...e
	})), [r]);
	return i ? /* @__PURE__ */ F(v, {
		flexDirection: "column",
		gap: "16px",
		"data-testid": e["data-testid"],
		children: [/* @__PURE__ */ P(v, {
			...c,
			children: /* @__PURE__ */ P(oo, { pricingTable: e })
		}), /* @__PURE__ */ P(v, {
			"data-testid": "quote.pricingTableScrollContainer",
			overflowX: "auto",
			margin: "-2px",
			width: "calc(100% + 4px)",
			children: /* @__PURE__ */ F(v, {
				flexDirection: "column",
				flexShrink: 0,
				width: `${o}px`,
				minWidth: `${o}px`,
				padding: "2px",
				children: [/* @__PURE__ */ P(v, {
					"data-testid": "quote.pricingTable",
					flexDirection: "column",
					flexShrink: 0,
					width: `${a}px`,
					minWidth: `${a}px`,
					borderRadius: "8px",
					border: `${b} 1px solid`,
					overflow: "hidden",
					boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)",
					children: /* @__PURE__ */ F(v, {
						flexDirection: "column",
						minWidth: Ja,
						children: [
							/* @__PURE__ */ P(Xa, { visibleColumns: i }),
							l.map((e, t) => e.subrows ? /* @__PURE__ */ P(io, {
								row: e,
								defaultIsOpen: t === 0,
								visibleColumns: i
							}, e.uuid) : /* @__PURE__ */ P(no, {
								row: e,
								visibleColumns: i
							}, e.uuid)),
							n && /* @__PURE__ */ P(ao, { caption: n })
						]
					})
				}), t]
			})
		})]
	}) : null;
}, co = () => yt(`(min-width: ${A(Er)}px)`).at(0) ?? !1, lo = "Amended overall total", uo = ({ isInsidePricingTable: e = !1 }) => {
	let t = co(), n = A(Tr), r = A(Xr), i = A(Qr);
	return t && n || !r ? null : M(i).with("AMENDMENT", () => /* @__PURE__ */ P(po, { isInsidePricingTable: e })).with("NEW_BUSINESS", "RENEWAL", () => /* @__PURE__ */ P(fo, { isInsidePricingTable: e })).exhaustive();
}, fo = ({ isInsidePricingTable: e }) => {
	let t = A(wr), n = A(ei), r = A(ti), i = A(ni), a = A(Zr), o = A(Ar);
	Et(t, "presentationVersion is undefined");
	let s = t === 3 && !!a;
	return !n && !s ? null : t === 3 && o?.columns.lineTotal && i && r ? /* @__PURE__ */ P(ho, {
		isInsidePricingTable: e,
		rows: [...n ? [{
			label: go(t),
			amount: n,
			amountBeforeDiscount: i && r ? r : void 0
		}] : [], ...s && a ? [{
			label: _n,
			amount: a
		}] : []]
	}) : /* @__PURE__ */ F(mo, { children: [n && /* @__PURE__ */ F(O, {
		...w,
		children: [
			go(t),
			":",
			" ",
			i && r && /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(O, {
				...w,
				as: "span",
				textDecoration: "line-through",
				color: x,
				children: r
			}), " "] }),
			/* @__PURE__ */ P(O, {
				as: "span",
				...w,
				children: n
			})
		]
	}), s && /* @__PURE__ */ F(O, {
		...w,
		children: [
			"Due upfront",
			": ",
			a
		]
	})] });
}, po = ({ isInsidePricingTable: e }) => {
	let t = A($r), n = A(Zr), r = A(wr), i = A(Ar);
	return !t && !n ? null : r === 3 && i?.columns.lineTotal ? /* @__PURE__ */ P(ho, {
		isInsidePricingTable: e,
		rows: [...t ? [{
			label: lo,
			amount: t.amendedOverallTotal
		}, {
			label: bn,
			amount: t.netDifference
		}] : [], ...n ? [{
			label: _n,
			amount: n
		}] : []]
	}) : /* @__PURE__ */ F(mo, { children: [t && /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ F(O, {
		...w,
		children: [
			lo,
			":",
			" ",
			t.amendedOverallTotal
		]
	}), /* @__PURE__ */ F(O, {
		...w,
		children: [
			"Net difference",
			": ",
			t.netDifference
		]
	})] }), n && /* @__PURE__ */ F(O, {
		...w,
		children: [
			"Due upfront",
			": ",
			n
		]
	})] });
}, mo = ({ children: e }) => /* @__PURE__ */ P(v, {
	flexDir: "column",
	alignItems: "flex-end",
	paddingTop: "12px",
	...Wa(),
	children: e
}), ho = ({ isInsidePricingTable: e, rows: t }) => {
	let n = A(Ha) ?? [], r = Wa();
	return /* @__PURE__ */ P(v, {
		flexDirection: "column",
		paddingTop: "12px",
		...e ? { width: "100%" } : r,
		children: t.map(({ label: e, amount: t, amountBeforeDiscount: r }) => /* @__PURE__ */ P(no, {
			row: {
				description: {
					type: "TEXT",
					text: e,
					style: { fontWeight: "bold" }
				},
				totalBeforeDiscount: r ? {
					type: "TEXT",
					text: r,
					style: {
						color: "GreyGrey60",
						textDecoration: "line-through"
					}
				} : void 0,
				total: {
					type: "TEXT",
					text: t,
					style: { fontWeight: "bold" }
				},
				"data-testid": `quote.total.${e.toLowerCase().replaceAll(" ", "-")}`
			},
			visibleColumns: n
		}, e))
	});
}, go = (e) => M(e).with(3, () => "Overall total").with(2, () => "Total").exhaustive(), _o = ({ config: e }) => {
	let t = A(Ar), n = A(qr), r = A(oi), i = A(Jr), a = A(wr);
	Et(t, "quoteSettings is undefined"), Et(a, "presentationVersion is undefined");
	let { pricingTables: o } = Ba({
		config: e,
		context: M(a).with(3, () => "react_v3").with(2, () => "react").exhaustive(),
		settings: t,
		phaseSubTotals: n,
		priceCommitments: r,
		quotePriceTotalsPerPhase: i
	}), s = a === 3 && t.columns.lineTotal && o.length > 0;
	return /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(qa, { children: o.map((e, t) => /* @__PURE__ */ P(so, {
		pricingTable: e,
		footer: s && t === o.length - 1 ? /* @__PURE__ */ P(uo, { isInsidePricingTable: !0 }) : void 0
	}, e.uuid)) }), !s && /* @__PURE__ */ P(uo, {})] });
}, vo = ({ config: e, font: t }) => {
	let n = e.textAlignment ?? "left", r = V(e.textColor), i = H(e.backgroundColor);
	return /* @__PURE__ */ P(O, {
		...t,
		color: r,
		textAlign: n,
		minWidth: "1px",
		minHeight: t.fontSize,
		wordBreak: "break-word",
		overflowWrap: "anywhere",
		backgroundColor: i,
		children: bi({
			text: e.text,
			font: t
		})
	});
}, yo = () => /* @__PURE__ */ P(_, {
	borderColor: y,
	marginY: "8px"
}), bo = { borderColor: `${y} 1px solid` }, xo = ({ config: e }) => {
	let t = s(() => e.rows.map((e) => ({
		...e,
		key: crypto.randomUUID(),
		cells: e.cells.map((e) => ({
			...e,
			key: crypto.randomUUID()
		}))
	})), [e.rows]);
	return /* @__PURE__ */ P(Ge, {
		variant: "unstyled",
		width: "fit-content",
		"data-testid": "quote.tableBlock",
		children: /* @__PURE__ */ P(Ke, {
			border: bo.borderColor,
			padding: "0",
			children: t.map((t, n) => /* @__PURE__ */ P(Ye, {
				borderBottom: bo.borderColor,
				height: "35px",
				children: t.cells.map((t, r) => {
					let i = n === 0 && e.headerRow || r === 0 && e.headerColumn;
					return /* @__PURE__ */ P(qe, {
						paddingX: "8px",
						paddingY: "6px",
						borderRight: bo.borderColor,
						textAlign: t.textAlignment,
						color: t.textColor === "default" ? V(e.textColor) : V(t.textColor),
						backgroundColor: H(t.backgroundColor),
						width: e.columnWidths.at(r) ?? "fit-content",
						minWidth: "120px",
						verticalAlign: "top",
						children: bi({
							text: t.text,
							font: i ? je : T
						})
					}, t.key);
				})
			}, t.key))
		})
	});
}, So = ({ uuid: e, assetLoader: t, config: { items: n, startsFrom: r, children: i }, font: a }) => {
	let o = n[0], s = H(o.backgroundColor);
	return /* @__PURE__ */ P(Ee, {
		start: r,
		position: "relative",
		paddingLeft: "8px",
		paddingTop: "3px",
		paddingBottom: i?.length ? "0px" : "3px",
		_before: {
			content: "\"\"",
			position: "absolute",
			width: "calc(100% + 16px)",
			height: "100%",
			top: 0,
			left: "-16px",
			backgroundColor: s,
			zIndex: 1
		},
		children: n.map((o, s) => {
			let c = H(o.backgroundColor), l = V(o.textColor), u = Bn(o.textAlignment);
			return /* @__PURE__ */ F(Te, {
				zIndex: 2,
				position: "relative",
				...a,
				paddingBottom: s === n.length - 1 ? void 0 : "6px",
				style: {
					backgroundColor: c,
					color: l
				},
				textAlign: o.textAlignment,
				listStyleType: u ? "none" : void 0,
				children: [/* @__PURE__ */ F(O, {
					...a,
					color: o.text.length ? l : "transparent",
					width: "100%",
					marginLeft: "2px",
					paddingBottom: i?.length ? "6px" : void 0,
					wordBreak: "break-word",
					overflowWrap: "anywhere",
					children: [u && /* @__PURE__ */ P(wo, {
						color: l,
						children: `${(r ?? 1) + s}.`
					}), o.text.length ? bi({
						text: o.text,
						font: a
					}) : "List item"]
				}), i && i.map((n, r) => /* @__PURE__ */ P(f, {
					backgroundColor: c,
					marginLeft: "6px",
					children: Do({ assetLoader: t })({
						...n,
						uuid: `${e}-${n.blockType}-${r}`
					})
				}, r))]
			}, s);
		})
	});
}, Co = (e) => {
	let t = [
		"disc",
		"circle",
		"square"
	];
	return t[(e - 1) % t.length] ?? t[0];
}, wo = ({ color: e, children: t }) => /* @__PURE__ */ P(f, {
	as: "span",
	color: e,
	marginRight: "6px",
	children: t
}), To = ({ color: e, depth: t }) => /* @__PURE__ */ P(f, {
	as: "span",
	display: "inline-block",
	color: e,
	marginRight: "-4px",
	children: /* @__PURE__ */ P(f, {
		as: "span",
		display: "list-item",
		listStyleType: Co(t),
		listStylePosition: "inside"
	})
}), Eo = ({ uuid: e, assetLoader: t, config: { items: n, children: r }, font: i, depth: a }) => {
	let o = n[0], s = H(o.backgroundColor);
	return /* @__PURE__ */ P(Xe, {
		position: "relative",
		styleType: `${Co(a)}`,
		paddingLeft: "8px",
		paddingTop: "2px",
		paddingBottom: r?.length ? "0px" : "2px",
		_before: {
			content: "\"\"",
			position: "absolute",
			width: "calc(100% + 16px)",
			height: "100%",
			top: 0,
			left: "-16px",
			backgroundColor: s,
			zIndex: 1
		},
		children: n.map((o, s) => {
			let c = H(o.backgroundColor), l = V(o.textColor), u = Bn(o.textAlignment);
			return /* @__PURE__ */ F(Te, {
				position: "relative",
				zIndex: 2,
				...i,
				paddingBottom: s === n.length - 1 ? void 0 : "4px",
				style: {
					backgroundColor: c,
					color: l
				},
				textAlign: o.textAlignment,
				listStyleType: u ? "none" : void 0,
				children: [/* @__PURE__ */ F(O, {
					...i,
					color: o.text.length ? l : "transparent",
					paddingBottom: r?.length ? "4px" : void 0,
					wordBreak: "break-word",
					overflowWrap: "anywhere",
					children: [u && /* @__PURE__ */ P(To, {
						color: l,
						depth: a
					}), o.text.length ? bi({
						text: o.text,
						font: i
					}) : "List item"]
				}), r && r.map((n, r) => /* @__PURE__ */ P(f, {
					marginLeft: "6px",
					children: Do({
						assetLoader: t,
						depth: a + 1
					})({
						...n,
						uuid: `${e}-${n.blockType}-${r}`
					})
				}, r))]
			}, s);
		})
	});
}, Do = ({ assetLoader: e, depth: t = 1 }) => (n) => M(n).with({ blockType: "heading1" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(vo, {
	config: t,
	font: Pe
}, e) : null).with({ blockType: "heading2" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(vo, {
	config: t,
	font: Ne
}, e) : null).with({ blockType: "heading3" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(vo, {
	config: t,
	font: Me
}, e) : null).with({ blockType: "paragraph" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(vo, {
	config: t,
	font: T
}, e) : null).with({ blockType: "bulletList" }, ({ uuid: n, config: r, version: i }) => i === 3 && sn(r) ? /* @__PURE__ */ P(Eo, {
	uuid: n,
	assetLoader: e,
	config: r,
	font: T,
	depth: t
}, n) : i === 2 && on(r) ? /* @__PURE__ */ P(wi, {
	config: r,
	font: T
}, n) : i === 1 && an(r) ? /* @__PURE__ */ P(yi, { config: r }, n) : null).with({ blockType: "numberList" }, ({ uuid: t, config: n, version: r }) => r === 3 && sn(n) ? /* @__PURE__ */ P(So, {
	uuid: t,
	assetLoader: e,
	config: n,
	font: T
}, t) : r === 2 && on(n) ? /* @__PURE__ */ P(Di, {
	config: n,
	font: T
}, t) : r === 1 && an(n) ? /* @__PURE__ */ P(Ei, { config: n }, t) : null).with({ blockType: "image" }, ({ uuid: t, config: n }) => rn(n) ? /* @__PURE__ */ P(Ti, {
	config: n,
	assetLoader: e
}, t) : null).with({ blockType: "phases" }, ({ uuid: e, config: t }) => cn(t) ? /* @__PURE__ */ P(_o, { config: t }, e) : null).with({ blockType: "divider" }, ({ uuid: e }) => /* @__PURE__ */ P(yo, {}, e)).with({ blockType: "table" }, ({ uuid: e, version: t, config: n }) => t === 1 && pn(n) ? /* @__PURE__ */ P(xo, { config: n }, e) : null).with({ blockType: "coverImage" }, () => null).with({ blockType: "pdfCoverImage" }, () => null).exhaustive(), Oo = ({ assetLoader: e, "data-testid": t }) => {
	let n = A(kr), r = A(Dr), i = n.map(Do({ assetLoader: e })), a = c(null), s = typeof r == "number", [u, d] = l(s ? Math.min(1, n.length) : n.length);
	o(() => {
		if (!s) {
			u !== n.length && d(n.length);
			return;
		}
		u >= n.length || (a.current?.offsetHeight ?? 0) < r && d((e) => Math.min(e + 1, n.length));
	}, [
		s,
		r,
		u,
		n.length
	]);
	let p = s ? i.slice(0, u) : i;
	return /* @__PURE__ */ P(v, {
		ref: a,
		flexDirection: "column",
		pt: "24px",
		"data-testid": t ? `${t}.blocks` : void 0,
		children: p.map((e, t) => {
			let r = ["bulletList", "numberList"].includes(n[t].blockType), i = n[t + 1] ? ["bulletList", "numberList"].includes(n[t + 1].blockType) : !1;
			return /* @__PURE__ */ P(f, {
				marginBottom: r && i ? "0" : "6px",
				children: e
			}, t);
		})
	});
}, ko = ({ leadingSideContent: e, trailingSideContent: t, paddingTop: n, ...r }) => {
	let i = co(), a = A(Ua), o = !!(i && t), s = ((a ?? 762) - 762) / 2, c = 104 + s, l = `max(${s}px, calc((100% - 1206px) / 2))`;
	return /* @__PURE__ */ F(oe, {
		templateColumns: o ? `${Sn} 340px` : "1fr",
		maxWidth: o ? void 0 : Sn,
		width: o ? void 0 : "100%",
		px: o ? void 0 : {
			base: "16px",
			lg: "0"
		},
		pt: n,
		style: r,
		gap: `${c}px`,
		marginLeft: o ? l : "auto",
		marginRight: o ? "0" : "auto",
		children: [/* @__PURE__ */ P(se, {
			as: v,
			flexDir: "column",
			minWidth: "0",
			children: e
		}), o && /* @__PURE__ */ P(se, { children: t })]
	});
}, Ao = (e) => {
	let t = A(Kr);
	return t.length ? /* @__PURE__ */ P(ko, {
		leadingSideContent: /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(jo, {}), /* @__PURE__ */ F(v, {
			flexDirection: "column",
			mt: "16px",
			children: [/* @__PURE__ */ F(v, {
				px: "4px",
				py: "6px",
				children: [/* @__PURE__ */ P(O, {
					...Me,
					flex: 1,
					pl: "2px",
					children: "Filename"
				}), /* @__PURE__ */ P(O, {
					...Me,
					pr: 8,
					children: "Size"
				})]
			}), t.map((e, n) => /* @__PURE__ */ P(Mo, {
				attachment: e,
				showBorder: n < t.length
			}, n))]
		})] }),
		trailingSideContent: e.hasTrailingSideContent
	}) : null;
}, jo = () => {
	let e = A(Kr), t = e.reduce((e, t) => e + t.fileSizeBytes, 0);
	return /* @__PURE__ */ F(v, {
		flexDirection: "column",
		gap: 2,
		children: [/* @__PURE__ */ P(O, {
			...Pe,
			children: "Attachments"
		}), /* @__PURE__ */ F(v, {
			gap: "6px",
			children: [
				/* @__PURE__ */ F(O, {
					...C,
					color: x,
					children: [`${e.length} ${e.length === 1 ? "file" : "files"}`, " "]
				}),
				/* @__PURE__ */ P(O, {
					...C,
					color: x,
					children: "•"
				}),
				/* @__PURE__ */ P(O, {
					...C,
					color: x,
					children: `${st(t)}`
				})
			]
		})]
	});
}, Mo = ({ attachment: e, showBorder: t }) => /* @__PURE__ */ P(we, {
	to: e.url,
	target: "_blank",
	rel: "noopener noreferrer",
	style: { textDecoration: "none" },
	_hover: { background: re },
	role: "group",
	children: /* @__PURE__ */ F(v, {
		gap: 2,
		px: "4px",
		py: "6px",
		alignItems: "center",
		borderTop: t ? `${y} 1px solid` : void 0,
		height: "36px",
		children: [
			/* @__PURE__ */ F(v, {
				flex: 1,
				gap: 2,
				alignItems: "center",
				children: [/* @__PURE__ */ P(ye, { color: x }), /* @__PURE__ */ P(O, {
					...C,
					fontWeight: "semibold",
					color: S,
					noOfLines: 1,
					children: e.fileName
				})]
			}),
			/* @__PURE__ */ P(O, {
				...C,
				color: x,
				children: st(e.fileSizeBytes)
			}),
			/* @__PURE__ */ P(f, {
				width: "24px",
				p: "8px",
				children: /* @__PURE__ */ P(h, { children: /* @__PURE__ */ P(f, {
					color: x,
					_groupHover: { color: S },
					children: /* @__PURE__ */ P(ce, {})
				}) })
			})
		]
	})
}), J = Object.assign(({ children: e, variant: t = "card", "data-testid": n }) => {
	let r = /* @__PURE__ */ P(v, {
		flexDir: "column",
		gap: "20px",
		children: e
	});
	return t === "bare" ? /* @__PURE__ */ P("div", {
		style: { width: "100%" },
		"data-testid": n,
		children: r
	}) : /* @__PURE__ */ P(m, {
		padding: "20px",
		"data-testid": n,
		children: r
	});
}, {
	Sections: ({ children: e }) => /* @__PURE__ */ P(v, {
		flexDir: "column",
		gap: "20px",
		sx: { "& > *:last-child": {
			borderBottom: "none",
			paddingBottom: 0
		} },
		children: e
	}),
	Section: ({ children: e, title: t, withBorderBottom: n = !0, gap: r }) => /* @__PURE__ */ F(v, {
		flexDir: "column",
		gap: r,
		...n ? {
			paddingBottom: "20px",
			borderBottom: `${y} 1px solid`
		} : {},
		children: [t && /* @__PURE__ */ P(O, {
			...Me,
			color: S,
			children: t
		}), e]
	}),
	TermsRow: ({ label: e, value: t, "data-testid": n }) => /* @__PURE__ */ F(v, {
		justifyContent: "space-between",
		gap: "8px",
		"data-testid": n,
		children: [/* @__PURE__ */ P(O, {
			...C,
			color: x,
			children: e
		}), /* @__PURE__ */ P(O, {
			...C,
			color: S,
			textAlign: "right",
			children: t
		})]
	}),
	SummaryRow: ({ label: e, value: t, children: n }) => /* @__PURE__ */ F(v, {
		flexDir: "column",
		gap: "8px",
		children: [/* @__PURE__ */ F(v, {
			justifyContent: "space-between",
			gap: "8px",
			children: [/* @__PURE__ */ P(O, {
				...w,
				color: S,
				children: e
			}), t && /* @__PURE__ */ P(O, {
				...w,
				color: S,
				textAlign: "right",
				children: t
			})]
		}), n && /* @__PURE__ */ P(v, {
			flexDir: "column",
			gap: "4px",
			children: n
		})]
	}),
	SummaryRowText: ({ children: e, marginLeft: t }) => /* @__PURE__ */ P(O, {
		...C,
		color: x,
		marginLeft: t,
		children: e
	}),
	TotalRow: ({ label: e, value: t, "data-testid": n }) => /* @__PURE__ */ F(v, {
		justifyContent: "space-between",
		"data-testid": n,
		children: [/* @__PURE__ */ P(O, {
			...w,
			color: S,
			children: e
		}), /* @__PURE__ */ P(O, {
			...w,
			color: S,
			children: t
		})]
	})
}), No = ({ phases: e, phaseMinimumTotals: t, currency: n }) => {
	let r = Array.from(new Set(t));
	return r.length === 0 || r.length === 1 && r.at(0) === 0 ? [] : r.length > 1 ? e.map((e, r) => {
		let i = t.at(r);
		if (!(i === void 0 || i === 0)) return {
			subTotal: j({
				value: `${i}`,
				currency: n
			}),
			phaseLabels: [rr(e)]
		};
	}).filter(Boolean) : [{
		subTotal: j({
			value: `${t.reduce((e, t) => e.plus(new I(t)), new I(0))}`,
			currency: n
		}),
		phaseLabels: e.map(rr)
	}];
}, Po = ({ phases: e, phaseMinimumTotals: t, currency: n }) => {
	let r = e.flatMap((e) => e.prices);
	return {
		products: Array.from([...new Set(r.map((e) => e.productId))]).map((t) => ({
			productId: t,
			label: r.find((e) => e.productId === t)?.name ?? "",
			phases: e.filter((e) => !!e.prices.find((e) => e.productId === t)).map((e) => ({
				phaseId: e.id,
				label: rr(e)
			}))
		})),
		minimums: No({
			phases: e,
			phaseMinimumTotals: t,
			currency: n
		})
	};
}, Fo = "Minimum commitment", Io = () => {
	let e = A(Ar);
	return A(ii) ? /* @__PURE__ */ P(J.Section, {
		title: "Summary",
		gap: "16px",
		withBorderBottom: !e?.showTotals,
		children: e?.groupPricesByPhase ? /* @__PURE__ */ P(Lo, {}) : /* @__PURE__ */ P(Ro, {})
	}) : null;
}, Lo = () => {
	let e = A(ii), t = A(qr), n = A(Yr), r = A(Ar);
	return e ? ir({
		phases: e.config.phases,
		subTotals: t
	}).map((e) => {
		let t = nr({
			products: e.prices,
			orderedProductIds: r?.priceEditorProductOrder ?? []
		}), i = nr({
			products: e.minimum ?? [],
			orderedProductIds: r?.priceEditorProductOrder ?? []
		}), a = !!r?.showTotals && e.totalFullRate !== void 0 && e.totalFullRate !== 0;
		return /* @__PURE__ */ F(J.SummaryRow, {
			label: e.label,
			value: a ? j({
				value: `${e.subTotal}`,
				currency: n
			}) : void 0,
			children: [t.map((e) => /* @__PURE__ */ P(J.SummaryRowText, { children: e.name }, e.priceId)), i.length > 0 && /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(J.SummaryRowText, { children: Fo }), i.map((e) => /* @__PURE__ */ P(J.SummaryRowText, {
				marginLeft: "8px",
				children: e.name
			}, e.priceId))] })]
		}, e.phaseId);
	}) : null;
}, Ro = () => {
	let e = A(ii), t = A(Ar), n = A(ai), r = A(Yr);
	if (!e) return null;
	let i = Po({
		phases: e.config.phases,
		phaseMinimumTotals: n ?? [],
		currency: r
	});
	return /* @__PURE__ */ F(N, { children: [nr({
		products: i.products,
		orderedProductIds: t?.priceEditorProductOrder ?? []
	}).map((e) => /* @__PURE__ */ P(J.SummaryRow, {
		label: e.label,
		children: e.phases.map((e) => /* @__PURE__ */ P(J.SummaryRowText, { children: e.label }, e.phaseId))
	}, e.productId)), i.minimums.map((e, t) => /* @__PURE__ */ P(J.SummaryRow, {
		label: Fo,
		value: e.subTotal,
		children: e.phaseLabels.map((e) => /* @__PURE__ */ P(J.SummaryRowText, { children: e }, e))
	}, t))] });
}, zo = ({ currentUserEmail: e, footer: t, createdByEmail: n, isCounterSigner: r, variant: i, "data-testid": a }) => /* @__PURE__ */ F(J, {
	"data-testid": a,
	variant: i,
	children: [/* @__PURE__ */ F(J.Sections, { children: [
		r && /* @__PURE__ */ P(Bo, { createdByEmail: n }),
		/* @__PURE__ */ P(Vo, {}),
		/* @__PURE__ */ P(Io, {}),
		/* @__PURE__ */ P(Ho, {}),
		/* @__PURE__ */ P(Ko, { currentUserEmail: e })
	] }), t && /* @__PURE__ */ P(J.Section, {
		gap: "8px",
		withBorderBottom: !1,
		children: t
	})]
}), Bo = ({ createdByEmail: e }) => /* @__PURE__ */ P(J.Section, {
	gap: "8px",
	children: /* @__PURE__ */ P(J.TermsRow, {
		label: "Created by",
		value: e || "Unknown"
	})
}), Vo = () => {
	let e = A(Vr), t = A(Hr), n = A(Wr), r = A(Gr);
	return /* @__PURE__ */ P(J.Section, {
		title: "Terms",
		gap: "16px",
		children: /* @__PURE__ */ F(v, {
			gap: "8px",
			flexDir: "column",
			children: [
				t?.formatShort && /* @__PURE__ */ P(J.TermsRow, {
					label: "Start date",
					value: t.formatShort,
					"data-testid": "quote.summary.startDate"
				}),
				e && /* @__PURE__ */ P(J.TermsRow, {
					label: "Duration",
					value: e,
					"data-testid": "quote.summary.contractLength"
				}),
				n?.formatShort && /* @__PURE__ */ P(J.TermsRow, {
					label: "Valid until",
					value: n.formatShort
				}),
				r && /* @__PURE__ */ P(J.TermsRow, {
					label: "Payment terms",
					value: r
				})
			]
		})
	});
}, Ho = () => {
	let e = A(Qr), t = A(Ar), n = A(ii);
	return !t?.showTotals || !n ? null : M(e).with("AMENDMENT", () => /* @__PURE__ */ P(Wo, { config: n.config })).with("NEW_BUSINESS", "RENEWAL", () => /* @__PURE__ */ P(Uo, { config: n.config })).exhaustive();
}, Uo = ({ config: e }) => {
	let t = A(ei), n = A(Zr);
	return t ? /* @__PURE__ */ F(J.Section, {
		gap: "8px",
		children: [
			/* @__PURE__ */ P(J.TotalRow, {
				label: vn,
				value: t,
				"data-testid": "quote.summary.total"
			}),
			n && /* @__PURE__ */ P(J.TotalRow, {
				label: "Due upfront",
				value: n,
				"data-testid": "quote.summary.dueUpfront"
			}),
			/* @__PURE__ */ P(Go, { config: e })
		]
	}) : null;
}, Wo = ({ config: e }) => {
	let t = A($r), n = A(Zr);
	return t ? /* @__PURE__ */ F(J.Section, {
		gap: "8px",
		children: [
			/* @__PURE__ */ P(J.TotalRow, {
				label: yn,
				value: t.amendedOverallTotal,
				"data-testid": "quote.summary.amendedTotal"
			}),
			/* @__PURE__ */ P(J.TotalRow, {
				label: bn,
				value: t.netDifference,
				"data-testid": "quote.summary.netDifference"
			}),
			n && /* @__PURE__ */ P(J.TotalRow, {
				label: "Due upfront",
				value: n,
				"data-testid": "quote.summary.dueUpfront"
			}),
			/* @__PURE__ */ P(Go, { config: e })
		]
	}) : null;
}, Go = ({ config: e }) => {
	let t = s(() => e.phases.some((e) => e.prices.some(lt)), [e]);
	return /* @__PURE__ */ P(O, {
		...Ae,
		color: x,
		marginTop: "4px",
		width: "75%",
		children: Dn({ hasUsageBasedPrices: t })
	});
}, Ko = ({ currentUserEmail: e }) => {
	let t = A(Nr);
	return t.length === 0 ? null : /* @__PURE__ */ P(J.Section, {
		title: "Signers",
		gap: "16px",
		children: /* @__PURE__ */ P(Ue, {
			"data-testid": "quoteSummary.signers",
			children: t.map((t) => /* @__PURE__ */ P(Ue.Item, {
				name: t.name,
				email: t.email,
				status: t.signedAt ? "SIGNED" : "READY",
				badgeText: e === t.email ? "You" : void 0
			}, t.email))
		})
	});
}, qo = (e) => Yo(e)?.config.phases, Jo = (e, t) => {
	let n = Yo(e);
	return Array.isArray(e) || !n ? e : {
		...e,
		blocks: e.blocks.map((e) => e === n ? {
			...n,
			config: {
				...n.config,
				phases: t
			}
		} : e)
	};
}, Yo = (e) => Array.isArray(e) ? void 0 : e?.blocks?.find(Xo), Xo = (e) => e.blockType === "phases" && cn(e.config), Zo = ({ presentation: e, phases: t }) => {
	let n = Qo(e);
	if (!(n && "hideOpenEndedPhases" in n && n.hideOpenEndedPhases === !0) || !t.some((e) => dt(e.duration))) return {
		presentation: e,
		phases: t
	};
	let r = $o(e);
	return r ? {
		presentation: r,
		phases: t.filter((e) => !dt(e.duration))
	} : {
		presentation: e,
		phases: t
	};
}, Qo = (e) => Array.isArray(e) ? void 0 : e?.settings, $o = (e) => {
	let t = qo(e), n = t?.at(-1);
	if (!(!t || !n || !dt(n.dates.duration))) return Jo(e, t.slice(0, -1));
}, es = ({ presentation: e, phases: t, dealType: n, preliminaryBillingStartDate: r, amendment: i }) => {
	let a = {
		presentation: e,
		phases: t,
		startDate: r
	}, o = i?.effectiveFrom;
	if (n !== "AMENDMENT" || !o) return a;
	let s = ts({
		preliminaryBillingStartDate: r,
		phases: t
	}), c = s.findIndex((e) => !e || e >= o), l = s.at(c), u = qo(e);
	return !(c > 0 && l && u?.length === t.length) || !u ? a : {
		presentation: Jo(e, u.slice(c)),
		phases: t.slice(c),
		startDate: l
	};
}, ts = ({ preliminaryBillingStartDate: e, phases: t }) => t.reduce((e, { duration: t }) => {
	let n = e.nextStartDate, r = n && typeof t == "object" ? bt(bt(n, t), { days: 1 }) : void 0;
	return {
		startDates: [...e.startDates, n && St.toApi(n)],
		nextStartDate: r
	};
}, {
	startDates: [],
	nextStartDate: e ? St.fromApi(e) : void 0
}).startDates, ns = (e) => e.flatMap((e) => [e, ...ns("children" in e.config && Array.isArray(e.config.children) ? e.config.children : [])]), rs = ({ rows: e, defaultVisibleColumns: t }) => [...t.filter((t) => t === "total" || Qa(e).some((e) => !!e[t]))].sort((e, t) => En.indexOf(e) - En.indexOf(t)), is = ({ blocks: e, settings: t, phaseSubTotals: n, priceCommitments: r, quotePriceTotalsPerPhase: i = [], context: a = "react_v3" }) => {
	let o = ns(e).flatMap((e) => e.blockType !== "phases" || !cn(e.config) ? [] : [za({
		config: e.config,
		context: a,
		settings: t,
		phaseSubTotals: n,
		priceCommitments: r,
		quotePriceTotalsPerPhase: i
	})]);
	return {
		pricingTables: o.flatMap(({ pricingTables: e }) => e),
		defaultVisibleColumns: o.at(0)?.defaultVisibleColumns ?? En
	};
}, as = ({ blocks: e, settings: t, phaseSubTotals: n, priceCommitments: r, quotePriceTotalsPerPhase: i = [], context: a }) => {
	let { pricingTables: o, defaultVisibleColumns: s } = is({
		blocks: e,
		settings: t,
		phaseSubTotals: n,
		priceCommitments: r,
		quotePriceTotalsPerPhase: i,
		context: a
	});
	return rs({
		rows: o.flatMap(({ rows: e }) => e),
		defaultVisibleColumns: s
	});
}, os = (e, t, n) => {
	let [r, a] = l(void 0), [c, u] = l(void 0), [d, f] = l(void 0), [p, m] = l(void 0), [h, g] = l(void 0), [_, v] = l(void 0), [ee, te] = l(void 0), [ne, re] = l(void 0), y = i(({ columnId: e, setBestWidth: n, minWidth: r = 80, maxWidth: i = Infinity }) => {
		let a = t?.querySelectorAll(`[data-phase-column-id="${e}"]`);
		if (!a) return;
		let o = Array.from(a).map((e) => ss(e)).sort((e, t) => t - e).at(0);
		!o || o <= 0 || n(`${Math.min(Math.max(Math.ceil(o), r), i)}px`);
	}, [t]);
	o(() => {
		let e = !0, n = () => {
			e && (y({
				columnId: "description",
				setBestWidth: u,
				minWidth: Number.parseInt(Ya, 10)
			}), y({
				columnId: "billingFrequency",
				setBestWidth: f,
				maxWidth: 176
			}), y({
				columnId: "quantity",
				setBestWidth: m,
				maxWidth: 104
			}), y({
				columnId: "discount",
				setBestWidth: v
			}), y({
				columnId: "rate",
				setBestWidth: g
			}), y({
				columnId: "billingPeriods",
				setBestWidth: te
			}), y({
				columnId: "total",
				setBestWidth: re,
				minWidth: 120
			}));
		};
		n(), document.fonts.ready.then(n);
		let r = new MutationObserver(n);
		return t && r.observe(t, {
			childList: !0,
			characterData: !0,
			subtree: !0
		}), () => {
			e = !1, r.disconnect();
		};
	}, [
		y,
		t,
		e
	]), o(() => {
		if (!t) return;
		let e = () => a(t.clientWidth);
		e();
		let n = new ResizeObserver(e);
		return n.observe(t), () => n.disconnect();
	}, [t]);
	let b = s(() => ({
		description: c,
		billingFrequency: d,
		quantity: p,
		rate: h,
		discount: _,
		billingPeriods: ee,
		total: ne
	}), [
		d,
		ee,
		c,
		_,
		p,
		h,
		ne
	]);
	return {
		bestColumnWidths: b,
		pricingTableWidth: s(() => {
			if (e.length < 5) return 762;
			let t = e.reduce((e, t) => t === "description" ? e + Number.parseFloat(b.description ?? "104px") : e + Number.parseFloat(b[t] ?? "80"), 0), i = typeof r == "number" ? Math.max(762, r - n) : 970;
			return Math.min(Math.max(Math.ceil(t), 762), 970, i);
		}, [
			r,
			b,
			n,
			e
		])
	};
}, ss = (e) => {
	let t = e.cloneNode(!0);
	Object.assign(t.style, {
		position: "absolute",
		visibility: "hidden",
		width: "max-content",
		minWidth: "0",
		maxWidth: "none",
		flex: "none",
		whiteSpace: "nowrap"
	}), document.body.append(t);
	let n = t.getBoundingClientRect().width;
	return t.remove(), n;
}, cs = "48px", ls = "24px", us = 768, ds = 1244, fs = (e) => {
	let [t, n] = et(U);
	return a(() => {
		ys(t, e.data) || n(e.data);
	}, [
		t,
		e.data,
		n
	]), /* @__PURE__ */ F(v, {
		ref: e.onRendererRootChange,
		direction: "column",
		pb: cs,
		gap: {
			base: "24px",
			lg: cs
		},
		width: "100%",
		"data-testid": e["data-testid"],
		children: [
			/* @__PURE__ */ P(si, { assetLoader: e.assetLoader }),
			/* @__PURE__ */ P(gs, {
				assetLoader: e.assetLoader,
				trailingSideContent: e.trailingSideContent,
				createdByEmail: e.createdByEmail,
				isCounterSigner: e.isCounterSigner,
				"data-testid": e["data-testid"]
			}),
			/* @__PURE__ */ P(Ao, { hasTrailingSideContent: !!e.trailingSideContent })
		]
	});
}, ps = ({ visibleColumns: e }) => {
	let t = tt(Ha);
	return a(() => {
		t(e);
	}, [t, e]), null;
}, ms = ({ hasTrailingSideContent: e, rendererRoot: t, visibleColumns: n }) => {
	let [r, i] = et(Va), [o, s] = et(Ua), c = co(), { bestColumnWidths: l, pricingTableWidth: u } = os(n, t, e && c ? 548 : 0);
	return a(() => {
		rt(r, l) || i(l), o !== u && s(u);
	}, [
		l,
		r,
		o,
		u,
		i,
		s
	]), null;
}, hs = (e) => {
	let [t, n] = l(null), r = s(() => {
		let t = _r({ presentation: e.data.presentation });
		return as({
			blocks: t.blocks,
			settings: t.settings,
			phaseSubTotals: e.data.phaseSubTotals,
			priceCommitments: e.data.priceCommitments,
			quotePriceTotalsPerPhase: e.data.quotePriceTotalsPerPhase
		});
	}, [
		e.data.phaseSubTotals,
		e.data.presentation,
		e.data.priceCommitments,
		e.data.quotePriceTotalsPerPhase
	]);
	return /* @__PURE__ */ F(nt, {
		atoms: [
			U,
			[Tr, !!e.trailingSideContent],
			[wr, _s({
				data: e.data,
				forceLatestPresentationStyling: e.forceLatestPresentationStyling
			})],
			Va,
			Ua,
			[Ha, r],
			[Er, typeof e.trailingContentMinWidth == "number" ? e.trailingContentMinWidth : ds],
			[Dr, e.maxRenderedHeight]
		],
		children: [
			/* @__PURE__ */ P(ps, { visibleColumns: r }),
			/* @__PURE__ */ P(ms, {
				rendererRoot: t,
				visibleColumns: r,
				hasTrailingSideContent: !!e.trailingSideContent
			}),
			/* @__PURE__ */ P(fs, {
				...e,
				onRendererRootChange: n
			})
		]
	});
}, gs = ({ assetLoader: e, trailingSideContent: t, "data-testid": n }) => {
	let r = A(ri), [i] = yt(`(min-width: ${us}px)`);
	return /* @__PURE__ */ P(ko, {
		leadingSideContent: /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(di, { "data-testid": n }), /* @__PURE__ */ P(Oo, {
			assetLoader: e,
			"data-testid": n
		})] }),
		trailingSideContent: t,
		paddingTop: r ? "0px" : i ? cs : ls
	});
}, _s = ({ data: e, forceLatestPresentationStyling: t }) => t ? 3 : !e.presentation.version || typeof e.presentation.version != "number" ? 2 : e.presentation.version === 3 ? e.presentation.version : 2, vs = (e) => ({
	...e,
	url: ""
}), ys = (e, t) => rt(e ? {
	...e,
	attachmentAssets: e.attachmentAssets.map(vs)
} : void 0, t ? {
	...t,
	attachmentAssets: t.attachmentAssets.map(vs)
} : void 0), bs = "LETTER", Y = {
	Lato24SemiBold: {
		fontFamily: "Lato",
		fontWeight: 600,
		lineHeight: 1,
		fontSize: "24px"
	},
	Lato13SemiBold: {
		fontFamily: "Lato",
		fontWeight: 600,
		lineHeight: On,
		fontSize: "13px"
	},
	Lato13Regular: {
		fontFamily: "Lato",
		fontWeight: 400,
		lineHeight: On,
		fontSize: "13px"
	},
	Lato12SemiBold: {
		fontFamily: "Lato",
		fontWeight: 600,
		lineHeight: kn,
		fontSize: "12px"
	},
	Lato11SemiBold: {
		fontFamily: "Lato",
		fontWeight: 600,
		lineHeight: An,
		fontSize: "11px"
	},
	Lato11Regular: {
		fontFamily: "Lato",
		fontWeight: 400,
		lineHeight: An,
		fontSize: "11px"
	}
}, xs = ({ textLeading: e, textTrailing: t }) => {
	let n = {
		...Y.Lato11Regular,
		flex: 1,
		color: S,
		height: "16px",
		overflow: "hidden"
	}, r = {
		...Y.Lato11Regular,
		color: S,
		width: "100px",
		textAlign: "right"
	};
	return /* @__PURE__ */ P(D, {
		style: {
			position: "absolute",
			bottom: 0,
			left: 0,
			width: "100%",
			paddingTop: "24px",
			paddingLeft: "32px",
			paddingBottom: "32px",
			paddingRight: "32px"
		},
		fixed: !0,
		children: /* @__PURE__ */ F(D, {
			style: {
				display: "flex",
				gap: "16px",
				justifyContent: "flex-end"
			},
			children: [/* @__PURE__ */ P(D, { style: {
				height: "1px",
				backgroundColor: y
			} }), /* @__PURE__ */ F(D, {
				style: {
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					width: "100%",
					gap: "8px"
				},
				children: [/* @__PURE__ */ P(E, {
					style: n,
					children: e
				}), typeof t == "function" ? /* @__PURE__ */ P(E, {
					style: r,
					render: t
				}) : /* @__PURE__ */ P(E, {
					style: r,
					children: t
				})]
			})]
		})
	});
}, Ss = (e) => {
	if (e.version === 2 && un(e.config)) return e.config.assetPath;
	if (e.version === 1 && ln(e.config)) return e.config.asset.url;
}, Cs = ({ merchantName: e, merchantAddress: t, merchantEmailAddress: n }) => [
	e,
	...t,
	n
].filter(Boolean), ws = ({ prospectName: e, prospectAddress: t }) => [e, ...t ?? []].filter((e) => !!e), Ts = (e) => {
	let t = ["coverImage", "pdfCoverImage"], n = e.reduce(({ result: n, skipNext: r }, i, a) => {
		if (r) return {
			result: n,
			skipNext: !1
		};
		if (t.includes(i.blockType)) {
			let t = e[a + 1];
			return {
				result: n,
				skipNext: t && Es(t)
			};
		}
		return {
			result: [...n, {
				...i,
				uuid: crypto.randomUUID()
			}],
			skipNext: !1
		};
	}, {
		result: [],
		skipNext: !1
	}).result;
	return n.every((e) => Es(e)) ? [] : n.filter((e, t, n) => !(t === 0 && Es(n[t]) || t === n.length - 1 && Es(n[t])));
}, Es = (e) => e.blockType !== "paragraph" || !z(e.config) ? !1 : e.config.text.length === 0, Ds = async ({ presentation: e, assetLoader: t, getImageDimensions: n }) => {
	let { blocks: r } = _r({ presentation: e }), i = r.map((e) => {
		if (e.blockType === "pdfCoverImage" && un(e.config) || e.blockType === "coverImage" && un(e.config)) return {
			urlUnsigned: e.config.assetPath,
			resolveDimensions: !1
		};
		if (e.blockType === "coverImage" && ln(e.config)) return {
			urlUnsigned: e.config.asset.url,
			resolveDimensions: !1
		};
		if (e.blockType === "image" && rn(e.config)) return {
			urlUnsigned: e.config.src,
			resolveDimensions: !0
		};
	}).filter((e) => !!e?.urlUnsigned);
	return (await Promise.all(i.map(async ({ urlUnsigned: e, resolveDimensions: r }) => {
		let i = await ct({
			url: e,
			assetLoader: t
		});
		if (i) return {
			urlUnsigned: e,
			urlSigned: i,
			...r ? await n(i) : {
				width: void 0,
				height: void 0
			}
		};
	}))).filter(Boolean);
}, Os = k([]), X = k(), ks = k((e) => {
	let t = e(X)?.presentation;
	if (t) return _r({ presentation: t });
}), As = k((e) => {
	if (!e(Hs)?.showPdfCoverPage) return;
	let t = e(ks), n = e(Os);
	if (!t || !n) return;
	let r = t.blocks.find((e) => e.blockType === "pdfCoverImage");
	if (r) {
		let e = r.config.assetPath, t = n.find((t) => t.urlUnsigned === e);
		if (t) return t.urlSigned;
	}
	let i = t.blocks.find((e) => e.blockType === "coverImage");
	if (!i) return;
	let a = Ss(i);
	if (!a) return;
	let o = n.find((e) => e.urlUnsigned === a);
	if (o) return o.urlSigned;
}), js = k((e) => e(X)?.quoteNumber ?? ""), Ms = k((e) => Kn(e(X)?.publishedAt)), Ns = k((e) => Hn(e(X)?.title)), Ps = k((e) => e(X)?.prospectName), Fs = k((e) => e(X)?.merchantLogoUrl), Is = k((e) => {
	let t = e(X);
	return t ? Cs(t) : [];
}), Ls = k((e) => {
	let t = e(X);
	return t ? ws(t) : [];
}), Rs = k((e) => {
	let t = e(X);
	return t ? Kn(Wn(t)) : void 0;
}), zs = k((e) => In(e(X)?.phases ?? [])), Bs = k((e) => {
	let t = e(X)?.dealType;
	return t ? Gn(t) : "";
}), Vs = k((e) => Kn(e(X)?.expiresAt)), Hs = k((e) => e(ks)?.settings), Us = k((e) => Ts(e(ks)?.blocks ?? [])), Ws = k((e) => e(X)?.includeSignaturePage), Gs = k((e) => e(X)?.signers ?? []), Ks = k((e) => e(X)?.currency ?? "USD"), qs = k((e) => e(Hs)?.showTotals ?? !1), Js = k((e) => e(Hs)?.showImagesInPdfBody ?? !1), Ys = k((e) => e(X)?.dealType ?? "NEW_BUSINESS"), Xs = k((e) => yr({
	currency: e(Ks),
	amendment: e(X)?.amendment
})), Zs = k((e) => Zn({
	currency: e(Ks),
	value: e(X)?.totalDiscountedRate
})), Qs = k((e) => Qn({
	currency: e(Ks),
	value: e(X)?.totalDueOnStartDate
})), $s = k((e) => br({
	dealType: e(Ys),
	overallTotal: e(Zs),
	amendmentTotals: e(Xs),
	dueUpfront: e(Qs)
})), ec = k((e) => e(X)?.phaseSubTotals ?? []), tc = k((e) => e(X)?.priceCommitments ?? []), nc = k((e) => e(X)?.quotePriceTotalsPerPhase ?? []), rc = k((e) => [e(Ns), e(js)].filter(Boolean).join(" - ")), ic = k((e) => qn(e(X)?.defaultDueDateDays)), ac = {
	display: "flex",
	flexDirection: "column",
	gap: "24px",
	paddingLeft: "32px",
	paddingRight: "32px"
}, oc = ({ children: e, footer: t, pageStyle: n, wrapperStyle: r }) => {
	let i = A(As), a = A(rc);
	return /* @__PURE__ */ F(Ve, {
		size: bs,
		dpi: 72,
		style: n ?? {
			backgroundColor: ae,
			paddingBottom: "88px",
			paddingTop: "32px"
		},
		wrap: !0,
		children: [/* @__PURE__ */ P(D, {
			style: r ?? ac,
			children: e
		}), t ?? /* @__PURE__ */ P(xs, {
			textLeading: a,
			textTrailing: ({ pageNumber: e, totalPages: t }) => {
				let n = +!!i;
				return `Page ${e - n} of ${t - n}`;
			}
		})]
	});
}, sc = () => {
	let e = A(Fs);
	return e ? /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row"
		},
		children: /* @__PURE__ */ P(ze, {
			src: e,
			style: { height: "24px" }
		})
	}) : null;
}, cc = ({ rowIndex: e, rows: t, groupPricesByPhase: n }) => {
	if (n) return e === 0 ? te : void 0;
	let r = t.some((e) => e.description.type === "DATE_RANGE");
	return e === 0 && r ? te : void 0;
}, lc = y, uc = k(), dc = k(), fc = () => {
	let e = A(uc), n = A(dc), r = wn({ lineTotal: A(Hs)?.columns.lineTotal ?? !1 }), i = {
		...Y.Lato11SemiBold,
		color: S,
		lineHeight: Mn
	}, a = {
		paddingLeft: "4px",
		paddingRight: "4px",
		paddingTop: "8px",
		paddingBottom: "8px",
		textAlign: "left"
	};
	if (!n || !e) return null;
	let o = {
		description: /* @__PURE__ */ P(D, {
			style: {
				...a,
				flex: "1"
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.description
			})
		}),
		billingFrequency: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.billingFrequency}px`
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.billingFrequency
			})
		}),
		quantity: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.quantity}px`
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.quantity
			})
		}),
		discount: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.discount}px`,
				textAlign: pc("discount")
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.discount
			})
		}),
		rate: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.rate}px`,
				textAlign: pc("rate")
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.rate
			})
		}),
		billingPeriods: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.billingPeriods}px`,
				textAlign: pc("billingPeriods")
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.billingPeriods
			})
		}),
		total: /* @__PURE__ */ P(D, {
			style: {
				...a,
				width: `${e.total}px`,
				textAlign: pc("total")
			},
			children: /* @__PURE__ */ P(E, {
				style: i,
				children: r.total
			})
		})
	};
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			borderBottomColor: lc,
			borderBottomStyle: "solid",
			borderBottomWidth: "1px"
		},
		children: n.map((e) => /* @__PURE__ */ P(t, { children: o[e] }, e))
	});
}, pc = (e) => Tn.includes(e) ? "right" : "left", mc = ({ dates: e, additionalText: t }) => /* @__PURE__ */ P(E, {
	style: {
		...Y.Lato11Regular,
		color: S,
		lineHeight: Mn
	},
	children: Rn(e, t)
}), hc = {
	left: "flex-start",
	right: "flex-end"
}, gc = ({ row: e, style: n, borderBottom: r = {
	borderBottomColor: lc,
	borderBottomStyle: "solid",
	borderBottomWidth: "1px"
} }) => {
	let a = A(uc), o = A(dc), s = {
		paddingLeft: "4px",
		paddingRight: "4px",
		paddingTop: "8px",
		paddingBottom: "8px",
		textAlign: "left"
	}, c = i(({ style: e, text: t, secondaryText: n }, r) => {
		let i = [
			M(e?.fontWeight).with("regular", void 0, () => ({
				...Y.Lato11Regular,
				color: ne,
				lineHeight: Mn
			})).with("bold", () => ({
				...Y.Lato11SemiBold,
				color: ne,
				lineHeight: Mn
			})).exhaustive(),
			M(e?.color).with("GreyGrey60", () => ({ color: x })).with("GreyGrey80", void 0, () => ({ color: S })).exhaustive(),
			...M(e?.textDecoration).with("line-through", () => [{
				...Y.Lato11Regular,
				lineHeight: Mn,
				textDecoration: "line-through",
				textDecorationStyle: "solid",
				textDecorationColor: x
			}]).with(void 0, () => []).exhaustive()
		];
		return /* @__PURE__ */ F(D, {
			style: {
				display: "flex",
				flexDirection: "column",
				gap: "4px",
				alignItems: hc[r]
			},
			children: [/* @__PURE__ */ P(E, {
				style: [...i, { textAlign: r }],
				children: t
			}), n && /* @__PURE__ */ P(E, {
				style: {
					...Y.Lato11Regular,
					color: x,
					lineHeight: 1.2,
					textAlign: r
				},
				children: n
			})]
		});
	}, []), l = i((e, n) => e ? M(e).with({ type: "DATE_RANGE" }, (e) => /* @__PURE__ */ P(mc, {
		dates: e.dates,
		additionalText: e.additionalText
	})).with({ type: "TEXT" }, (e) => c(e, n)).with({ type: "STACK" }, (e) => /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "column",
			gap: "16px",
			alignItems: hc[n]
		},
		children: e.cells.map((e, r) => /* @__PURE__ */ P(t, { children: c(e, n) }, `${e.text}-${String(r)}`))
	})).exhaustive() : null, [c]), u = e.indentation ? `${4 + e.indentation * 8}px` : "4px";
	if (!a || !o) return null;
	let d = e.descriptionAlignment === "end", f = {
		description: /* @__PURE__ */ P(D, {
			style: {
				...s,
				paddingLeft: u,
				flex: "1",
				alignItems: d ? "flex-end" : "flex-start",
				textAlign: d ? "right" : "left"
			},
			children: l(e.description, d ? "right" : "left")
		}),
		billingFrequency: /* @__PURE__ */ P(D, {
			style: {
				...s,
				width: `${a.billingFrequency}px`
			},
			children: l(e.billingFrequency, "left")
		}),
		quantity: /* @__PURE__ */ P(D, {
			style: {
				...s,
				width: `${a.quantity}px`
			},
			children: l(e.quantity, "left")
		}),
		discount: /* @__PURE__ */ P(D, {
			style: {
				...s,
				width: `${a.discount}px`,
				alignItems: "flex-end",
				textAlign: "right"
			},
			children: e.discount && l(e.discount, "right")
		}),
		rate: /* @__PURE__ */ F(D, {
			style: {
				...s,
				width: `${a.rate}px`,
				display: "flex",
				flexDirection: "column",
				gap: "4px",
				alignItems: "flex-end",
				textAlign: "right"
			},
			children: [e.discountedRate && l(e.discountedRate, "right"), l(e.rate, "right")]
		}),
		billingPeriods: /* @__PURE__ */ P(D, {
			style: {
				...s,
				width: `${a.billingPeriods}px`,
				alignItems: "flex-start",
				textAlign: "left"
			},
			children: l(e.billingPeriods, "left")
		}),
		total: /* @__PURE__ */ F(D, {
			style: {
				...s,
				width: `${a.total}px`,
				display: "flex",
				flexDirection: "column",
				gap: "4px",
				alignItems: "flex-end",
				textAlign: "right"
			},
			children: [e.totalBeforeDiscount && l(e.totalBeforeDiscount, "right"), l(e.total, "right")]
		})
	}, p = eo({
		row: e,
		visibleColumns: o
	}), m = o.filter((e) => !p.includes(e));
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			...r,
			...n
		},
		wrap: !1,
		children: m.map((e) => /* @__PURE__ */ P(t, { children: f[e] }, e))
	});
}, _c = ({ config: e }) => {
	let t = A(Hs), n = A(ec), r = A(tc), i = A(nc);
	Et(t, "Quote settings is undefined");
	let { pricingTables: a } = Ba({
		config: e,
		settings: t,
		context: "pdf_v3",
		phaseSubTotals: n,
		priceCommitments: r,
		quotePriceTotalsPerPhase: i
	});
	return /* @__PURE__ */ F(D, {
		style: {
			display: "flex",
			flexDirection: "column"
		},
		children: [
			/* @__PURE__ */ P(fc, {}),
			a.map((e, n) => e.rows.map((r, i) => {
				let o = n === a.length - 1 && i === e.rows.length - 1;
				return /* @__PURE__ */ P(gc, {
					row: r,
					style: { backgroundColor: cc({
						rowIndex: i,
						rows: e.rows,
						groupPricesByPhase: t.groupPricesByPhase
					}) },
					borderBottom: o ? {} : void 0
				}, i);
			})),
			/* @__PURE__ */ P(vc, { config: e })
		]
	});
}, vc = ({ config: e }) => {
	let t = A(qs), n = A(Hs), { rows: r, showDisclaimer: i } = A($s), a = s(() => e.phases.some((e) => e.prices.some(lt)), [e]);
	return !t || r.length === 0 ? null : /* @__PURE__ */ F(D, {
		style: {
			gap: "16px",
			borderTopColor: r.length > 1 ? lc : x,
			borderTopStyle: "solid",
			borderTopWidth: "1px"
		},
		wrap: !1,
		children: [/* @__PURE__ */ P(D, {
			wrap: !1,
			children: r.map((e, t) => /* @__PURE__ */ P(gc, {
				row: {
					description: {
						type: "TEXT",
						text: e.label,
						style: { fontWeight: "bold" }
					},
					...n?.columns.lineTotal ? { total: {
						type: "TEXT",
						text: e.amount,
						style: { fontWeight: "bold" }
					} } : { rate: {
						type: "TEXT",
						text: e.amount,
						style: { fontWeight: "bold" }
					} }
				},
				borderBottom: yc({
					index: t,
					rowCount: r.length
				})
			}, e.label))
		}), i && /* @__PURE__ */ P(E, {
			style: {
				...Y.Lato11Regular,
				color: x
			},
			children: Dn({ hasUsageBasedPrices: a })
		})]
	});
}, yc = ({ index: e, rowCount: t }) => e === t - 1 ? t > 1 ? {} : bc(ae) : bc(x), bc = (e) => ({
	borderBottomColor: e,
	borderBottomStyle: "solid",
	borderBottomWidth: "1px"
}), xc = () => {
	let e = A(As), t = A(Ms), n = A(Ns), r = A(Ps), i = A(rc);
	return e ? /* @__PURE__ */ P(oc, {
		pageStyle: {
			backgroundColor: ae,
			paddingBottom: "88px"
		},
		wrapperStyle: {},
		footer: /* @__PURE__ */ P(xs, {
			textLeading: i,
			textTrailing: t
		}),
		children: /* @__PURE__ */ F(D, {
			style: {
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column"
			},
			children: [/* @__PURE__ */ P(Sc, { src: e }), /* @__PURE__ */ F(Cc, { children: [/* @__PURE__ */ F(D, {
				style: {
					display: "flex",
					gap: "8px"
				},
				children: [/* @__PURE__ */ P(E, {
					style: {
						...Y.Lato24SemiBold,
						color: S
					},
					children: n
				}), r && /* @__PURE__ */ P(E, {
					style: {
						...Y.Lato13Regular,
						color: S
					},
					children: Jn(r)
				})]
			}), /* @__PURE__ */ P(sc, {})] })]
		})
	}) : null;
}, Sc = ({ src: e }) => /* @__PURE__ */ P(D, {
	style: {
		width: "100%",
		height: "335px"
	},
	children: /* @__PURE__ */ P(ze, {
		src: e,
		style: {
			width: "100%",
			height: "100%",
			objectFit: "cover"
		}
	})
}), Cc = ({ children: e }) => /* @__PURE__ */ P(D, {
	style: {
		display: "flex",
		flex: 1,
		justifyContent: "space-between",
		paddingTop: "32px",
		paddingLeft: "32px",
		paddingRight: "32px"
	},
	children: e
}), wc = () => {
	let e = A(Is), t = A(Ls);
	return /* @__PURE__ */ F(D, {
		style: {
			display: "flex",
			flexDirection: "row"
		},
		children: [/* @__PURE__ */ P(Tc, {
			subheading: xn.from,
			lines: e,
			width: "45%"
		}), !!t.length && /* @__PURE__ */ P(Tc, {
			subheading: xn.to,
			lines: t,
			width: "55%"
		})]
	});
}, Tc = ({ subheading: e, lines: t, width: n }) => /* @__PURE__ */ F(D, {
	style: {
		width: n,
		gap: "4px"
	},
	children: [/* @__PURE__ */ P(E, {
		style: {
			...Y.Lato11SemiBold,
			color: S
		},
		children: e
	}), /* @__PURE__ */ P(D, { children: t.map((e, t) => /* @__PURE__ */ P(E, {
		style: {
			...Y.Lato11Regular,
			color: S,
			lineHeight: jn
		},
		children: e
	}, t)) })]
}), Ec = ({ children: e }) => /* @__PURE__ */ F(D, {
	style: { gap: "8px" },
	children: [/* @__PURE__ */ P(E, {
		style: {
			...Y.Lato13SemiBold,
			fontWeight: "bold",
			color: S
		},
		children: B.heading
	}), /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			gap: "8px"
		},
		children: e
	})]
}), Dc = ({ title: e, value: t }) => /* @__PURE__ */ F(D, {
	style: {
		flex: 1,
		padding: "12px",
		gap: "4px",
		borderWidth: "1px",
		borderColor: y,
		borderRadius: "4px"
	},
	children: [/* @__PURE__ */ P(E, {
		style: {
			...Y.Lato11SemiBold,
			color: S
		},
		children: e
	}), /* @__PURE__ */ P(E, {
		style: {
			...Y.Lato11Regular,
			color: S
		},
		children: t ?? "-"
	})]
}), Oc = ({ text: e, blockTextColor: t, font: n }) => (Array.isArray(e) ? e : [e]).filter((e) => !!e).map((e, r) => typeof e == "string" ? /* @__PURE__ */ P(E, {
	style: {
		...n,
		color: t
	},
	children: e
}, r) : Ac({
	font: n,
	blockTextColor: t
})(e)), kc = (e, t, n) => ({
	fontWeight: e.bold || n.fontWeight > 400 ? "bold" : "normal",
	fontStyle: e.italic ? "italic" : "normal",
	textDecoration: e.underline && e.strike ? "line-through underline" : e.underline ? "underline" : e.strike ? "line-through" : "none",
	color: e.textColor ? V(e.textColor) : t,
	backgroundColor: e.backgroundColor ? H(e.backgroundColor) : void 0
}), Ac = ({ font: e, blockTextColor: t }) => (n) => {
	let r = {
		...e,
		...kc(n.styles, t, e)
	}, i = typeof e.fontSize == "string" ? parseInt(e.fontSize) : e.fontSize;
	if (n.href) {
		let e = n.href.startsWith("http") ? n.href : `https://${n.href}`;
		return [
			...(jc(n.text) ?? []).map((e, t) => /* @__PURE__ */ P(E, {
				style: r,
				children: e
			}, t)),
			...(jc(` (${e})`) ?? []).map((t, i) => /* @__PURE__ */ P(Be, {
				href: e,
				style: {
					...r,
					color: n.styles.textColor ? V(n.styles.textColor) : Cn
				},
				children: t
			}, i)),
			...n.text.endsWith("\n") ? [/* @__PURE__ */ P(D, { style: { width: "100%" } }, "line-break")] : []
		];
	}
	return jc(n.text)?.map((e, t) => {
		if (e.includes("\n")) {
			let t = e.split("\n").length - 2;
			return /* @__PURE__ */ P(D, { style: {
				width: "100%",
				height: i * t
			} });
		}
		return /* @__PURE__ */ P(E, {
			style: r,
			children: e
		}, t);
	});
}, jc = (e) => e.match(/\w+|\W+/g)?.map((e) => e.replace(/ /g, "\xA0")), Mc = ({ config: e, font: t }) => {
	let n = e.textAlignment ?? "left", r = e.textColor ? V(e.textColor) : t.color, i = H(e.backgroundColor), a = Oc({
		text: e.text,
		blockTextColor: r,
		font: t
	});
	return a ? /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap",
			justifyContent: zn(n),
			minWidth: "1px",
			minHeight: `${t.fontSize}px`,
			backgroundColor: i
		},
		children: a
	}) : null;
}, Nc = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(D, {
	style: {
		display: "flex",
		gap: "3px"
	},
	children: e.map((e) => /* @__PURE__ */ F(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap",
			gap: "8px"
		},
		children: [/* @__PURE__ */ P(E, {
			style: t,
			children: "•"
		}), /* @__PURE__ */ P(E, {
			style: {
				...t,
				flex: "1"
			},
			children: e
		})]
	}, e))
}), Pc = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(D, {
	style: {
		display: "flex",
		gap: "3px"
	},
	children: e.map((e, n) => {
		let r = Oc({
			text: e,
			blockTextColor: S,
			font: t
		});
		return r ? /* @__PURE__ */ F(D, {
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				gap: "8px"
			},
			children: [/* @__PURE__ */ P(E, {
				style: t,
				children: "•"
			}), /* @__PURE__ */ P(D, {
				style: {
					display: "flex",
					flexDirection: "row",
					flexWrap: "wrap",
					flex: 1
				},
				children: r
			})]
		}, n) : null;
	})
}), Fc = (e) => `${`${String(e + 1)}`.length * 10}px`, Ic = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(D, {
	style: {
		display: "flex",
		gap: "4.5px"
	},
	children: e.map((n, r) => {
		let i = `${String(r + 1)}.`;
		return /* @__PURE__ */ F(D, {
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				gap: "8px"
			},
			children: [/* @__PURE__ */ P(E, {
				style: {
					...t,
					width: Fc(e.length)
				},
				children: i
			}), /* @__PURE__ */ P(E, {
				style: {
					...t,
					flex: "1"
				},
				children: n
			})]
		}, n);
	})
}), Lc = ({ config: { items: e }, font: t }) => /* @__PURE__ */ P(D, {
	style: {
		display: "flex",
		gap: "4.5px"
	},
	children: e.map((n, r) => {
		let i = `${String(r + 1)}.`, a = Oc({
			text: n,
			blockTextColor: S,
			font: t
		});
		return a ? /* @__PURE__ */ F(D, {
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				gap: "8px"
			},
			children: [/* @__PURE__ */ P(E, {
				style: {
					...t,
					width: Fc(e.length)
				},
				children: i
			}), /* @__PURE__ */ P(D, {
				style: {
					display: "flex",
					flexDirection: "row",
					flexWrap: "wrap",
					flex: 1
				},
				children: a
			})]
		}, r) : null;
	})
}), Rc = () => /* @__PURE__ */ P(D, { style: {
	width: "100%",
	height: "1px",
	backgroundColor: y,
	marginTop: "4px",
	marginBottom: "4px"
} }), zc = 635, Bc = (t) => e.toArray(t).filter((e) => r(e) && e.type === Wc), Vc = (t) => e.toArray(t).filter((e) => r(e) && e.type === Gc), Hc = ({ children: e }) => /* @__PURE__ */ P(D, { children: e }), Uc = ({ children: e, border: t }) => {
	let i = Bc(e);
	return /* @__PURE__ */ P(D, {
		style: {
			border: t,
			width: (() => {
				let t = Bc(e).map((e) => r(e) ? Vc(e.props.children).map((e) => {
					if (r(e)) return e.props.width;
				}).filter(Boolean) : []).filter((e) => e.length > 0).sort((e, t) => t.length - e.length).at(0);
				if (!t) return;
				let n = t.reduce((e, t) => parseInt(t) + e, 0);
				return `${Math.min(n, zc)}px`;
			})()
		},
		children: i.map((e, t) => r(e) ? n(e, { isLast: t === i.length - 1 }) : e)
	});
}, Wc = ({ children: e, borderBottom: t, isLast: i }) => {
	let a = Vc(e);
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			borderBottom: i ? void 0 : t,
			minHeight: "30px"
		},
		children: a.map((e, t) => r(e) ? n(e, { isLast: t === a.length - 1 }) : e)
	});
}, Gc = ({ children: e, borderRight: t, isLast: n, textAlign: r, backgroundColor: i, width: a }) => {
	let o = zn(r);
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			borderRight: n ? void 0 : t,
			marginRight: "-1px",
			backgroundColor: i,
			width: a
		},
		children: /* @__PURE__ */ P(D, {
			style: { margin: "6px" },
			children: /* @__PURE__ */ P(D, {
				style: {
					display: "flex",
					flexDirection: "row",
					flexWrap: "wrap",
					justifyContent: o,
					minWidth: "1px"
				},
				children: e
			})
		})
	});
}, Kc = Object.assign(Hc, {
	Tbody: Uc,
	Tr: Wc,
	Td: Gc
}), qc = { borderColor: `1px solid ${y}` }, Jc = ({ config: e }) => {
	let t = Vn(e.columnWidths);
	return /* @__PURE__ */ P(Kc, { children: /* @__PURE__ */ P(Kc.Tbody, {
		border: qc.borderColor,
		children: e.rows.map((n, r) => /* @__PURE__ */ P(Kc.Tr, {
			borderBottom: qc.borderColor,
			children: n.cells.map((n, i) => {
				let a = r === 0 && e.headerRow || i === 0 && e.headerColumn, o = n.textColor === "default" ? e.textColor : n.textColor, s = Oc({
					text: n.text,
					blockTextColor: o === "default" ? S : V(o),
					font: {
						...a ? Y.Lato11SemiBold : Y.Lato11Regular,
						color: S
					}
				});
				return /* @__PURE__ */ P(Kc.Td, {
					borderRight: qc.borderColor,
					width: `${t.at(i)}px`,
					textAlign: n.textAlignment,
					backgroundColor: H(n.backgroundColor),
					children: s
				}, `${r}-${i}`);
			})
		}, r))
	}) });
}, Yc = ({ height: e, width: t }) => {
	if (e === void 0 || t === void 0) return 300;
	if (t > e) {
		if (e < 300 && t <= 564) return e;
		let n = 564 / (t / e);
		return n < 300 ? n : 300;
	} else return e > 300 ? 300 : e;
}, Xc = ({ width: e, height: t }, n) => !e || !t ? {
	width: e,
	height: t
} : {
	width: n,
	height: t / (e / n)
}, Zc = ({ config: { src: e, width: t } }) => {
	let n = A(Js), r = A(Os).find((t) => t.urlUnsigned === e);
	if (!n || !r) return null;
	let i = t ? Xc(r, t) : r;
	return /* @__PURE__ */ P(D, {
		style: { height: Yc({
			height: i.height,
			width: i.width
		}) },
		wrap: !1,
		children: /* @__PURE__ */ P(ze, {
			src: r.urlSigned,
			style: {
				width: "100%",
				height: "100%",
				objectFit: "contain"
			}
		})
	});
}, Qc = {
	...Y.Lato11Regular,
	color: S
}, $c = (e) => {
	let t = [
		Le,
		Re,
		He
	];
	return t[(e - 1) % t.length] ?? t[0];
}, el = `${Nn}px`, tl = (e) => Bn(e) ? { flexShrink: 1 } : { flex: 1 }, nl = ({ uuid: e, config: { items: t, children: n }, font: r, depth: i }) => {
	let a = t[0];
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			backgroundColor: H(a.backgroundColor)
		},
		children: t.map((a, o) => {
			let s = V(a.textColor), c = zn(a.textAlignment ?? "left"), l = tl(a.textAlignment), u = Oc({
				text: a.text,
				blockTextColor: s,
				font: r
			});
			if (!u) return null;
			let d = $c(i);
			return /* @__PURE__ */ F(N, { children: [
				/* @__PURE__ */ P(D, { wrap: !1 }, `${e}.item.${o}.break`),
				/* @__PURE__ */ F(D, {
					wrap: !1,
					style: {
						display: "flex",
						flexDirection: "row",
						flexWrap: "nowrap",
						justifyContent: c,
						gap: "8px",
						paddingLeft: "8px",
						paddingTop: "4px",
						alignItems: "flex-start",
						backgroundColor: H(a.backgroundColor),
						marginBottom: o !== t.length - 1 || o === t.length - 1 && n?.length ? el : void 0
					},
					children: [/* @__PURE__ */ P(D, {
						style: { marginTop: "3px" },
						children: /* @__PURE__ */ P(d, {
							height: 6,
							width: 6
						})
					}), /* @__PURE__ */ P(D, {
						style: {
							display: "flex",
							flexDirection: "row",
							flexWrap: "wrap",
							...l,
							justifyContent: c
						},
						children: u
					})]
				}, `${e}.item.${o}`),
				n && n?.map((t, r) => /* @__PURE__ */ F(D, {
					style: {
						paddingLeft: "16px",
						marginBottom: r === n.length - 1 ? void 0 : el
					},
					children: [/* @__PURE__ */ P(D, { wrap: !1 }), il({ depth: i + 1 })({
						...t,
						uuid: `${e}.children.${r}`
					})]
				}, `${e}.children.${r}`))
			] });
		})
	});
}, rl = ({ uuid: e, config: { items: t, startsFrom: n, children: r }, font: i }) => {
	let a = t[0];
	return /* @__PURE__ */ P(D, {
		style: {
			display: "flex",
			paddingLeft: "8px",
			backgroundColor: H(a.backgroundColor),
			paddingTop: "4px",
			paddingBottom: r?.length ? 0 : "3px"
		},
		children: t.map((a, o) => {
			let s = `${String(o + (n ?? 1))}.`, c = V(a.textColor), l = zn(a.textAlignment ?? "left"), u = tl(a.textAlignment), d = Oc({
				text: a.text,
				blockTextColor: c,
				font: i
			});
			return d ? /* @__PURE__ */ F(N, { children: [
				/* @__PURE__ */ P(D, { wrap: !1 }, `${e}.item.${o}.break`),
				/* @__PURE__ */ F(D, {
					wrap: !1,
					style: {
						display: "flex",
						flexDirection: "row",
						flexWrap: "nowrap",
						justifyContent: l,
						gap: "5px",
						backgroundColor: H(a.backgroundColor),
						marginBottom: o !== t.length - 1 || o === t.length - 1 && r?.length ? el : void 0
					},
					children: [/* @__PURE__ */ P(E, {
						style: {
							...i,
							width: Fc(t.length),
							color: c
						},
						children: s
					}), /* @__PURE__ */ P(D, {
						style: {
							display: "flex",
							flexDirection: "row",
							flexWrap: "wrap",
							...u,
							justifyContent: l
						},
						children: d
					})]
				}, `${e}.item.${o}`),
				r?.length && r?.map((t, n) => /* @__PURE__ */ F(D, {
					style: { marginLeft: "20px" },
					children: [/* @__PURE__ */ P(D, { wrap: !1 }), il()({
						...t,
						uuid: `${e}.children.${n}`
					})]
				}, `${e}.children.${n}`))
			] }) : null;
		})
	});
}, il = ({ depth: e = 1 } = {}) => (t) => M(t).with({ blockType: "heading1" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(Mc, {
	config: t,
	font: {
		...Y.Lato13SemiBold,
		color: S
	}
}, e) : null).with({ blockType: "heading2" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(Mc, {
	config: t,
	font: {
		...Y.Lato12SemiBold,
		color: S
	}
}, e) : null).with({ blockType: "heading3" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(Mc, {
	config: t,
	font: {
		...Y.Lato11SemiBold,
		color: S
	}
}, e) : null).with({ blockType: "paragraph" }, ({ uuid: e, config: t }) => z(t) ? /* @__PURE__ */ P(Mc, {
	config: t,
	font: Qc
}, e) : null).with({ blockType: "bulletList" }, ({ uuid: t, config: n, version: r }) => r === 3 && sn(n) ? /* @__PURE__ */ P(nl, {
	config: n,
	font: Qc,
	uuid: t,
	depth: e
}, t) : r === 2 && on(n) ? /* @__PURE__ */ P(Pc, {
	config: n,
	font: Qc
}, t) : r === 1 && an(n) ? /* @__PURE__ */ P(Nc, {
	config: n,
	font: Qc
}, t) : null).with({ blockType: "numberList" }, ({ uuid: e, config: t, version: n }) => n === 3 && sn(t) ? /* @__PURE__ */ P(rl, {
	config: t,
	font: Qc,
	uuid: e
}, e) : n === 2 && on(t) ? /* @__PURE__ */ P(Lc, {
	config: t,
	font: Qc
}, e) : n === 1 && an(t) ? /* @__PURE__ */ P(Ic, {
	config: t,
	font: Qc
}, e) : null).with({ blockType: "phases" }, ({ uuid: e, config: t }) => cn(t) ? /* @__PURE__ */ P(_c, { config: t }, e) : null).with({ blockType: "divider" }, ({ uuid: e }) => /* @__PURE__ */ P(Rc, {}, e)).with({ blockType: "table" }, ({ uuid: e, version: t, config: n }) => t === 1 && pn(n) ? /* @__PURE__ */ P(Jc, { config: n }, e) : null).with({ blockType: "image" }, ({ uuid: e, config: t }) => rn(t) ? /* @__PURE__ */ P(Zc, { config: t }, e) : null).with({ blockType: "coverImage" }, { blockType: "pdfCoverImage" }, () => null).exhaustive(), al = () => {
	let e = A(Us);
	return /* @__PURE__ */ P(D, {
		style: { display: "flex" },
		children: e.map(il()).map((t, n) => {
			let r = ["bulletList", "numberList"].includes(e[n].blockType), i = e[n + 1] ? ["bulletList", "numberList"].includes(e[n + 1].blockType) : !1;
			return /* @__PURE__ */ P(D, {
				style: { marginBottom: r && i ? "0" : "6px" },
				children: t
			}, n);
		})
	});
}, ol = () => {
	let e = A(Rs), t = A(zs), n = A(Bs), r = A(Vs), i = A(ic);
	return /* @__PURE__ */ F(oc, { children: [
		/* @__PURE__ */ P(sc, {}),
		/* @__PURE__ */ P(wc, {}),
		/* @__PURE__ */ F(Ec, { children: [
			/* @__PURE__ */ P(Dc, {
				title: B.startDate,
				value: e
			}),
			/* @__PURE__ */ P(Dc, {
				title: B.duration,
				value: t
			}),
			/* @__PURE__ */ P(Dc, {
				title: B.type,
				value: n
			}),
			/* @__PURE__ */ P(Dc, {
				title: B.validUntil,
				value: r
			}),
			i && /* @__PURE__ */ P(Dc, {
				title: B.paymentTerms,
				value: i
			})
		] }),
		/* @__PURE__ */ P(al, {})
	] });
}, sl = () => {
	let e = A(Ws), t = A(Gs);
	return e ? /* @__PURE__ */ F(oc, {
		wrapperStyle: {
			...ac,
			gap: "32px"
		},
		children: [
			/* @__PURE__ */ P(sc, {}),
			/* @__PURE__ */ F(D, {
				style: {
					gap: "8px",
					width: "42%"
				},
				children: [/* @__PURE__ */ P(E, {
					style: {
						...Y.Lato11SemiBold,
						color: S
					},
					children: "Signature"
				}), /* @__PURE__ */ P(E, {
					style: {
						...Y.Lato11Regular,
						color: S
					},
					hyphenationCallback: (e) => [e],
					children: "Please find your name below and sign this document to execute this order."
				})]
			}),
			/* @__PURE__ */ P(D, {
				style: { gap: "16px" },
				children: t.map((e, t) => /* @__PURE__ */ P(cl, {
					...e,
					index: t + 1
				}, t))
			})
		]
	}) : null;
}, cl = ({ name: e, email: t, index: n }) => /* @__PURE__ */ F(D, {
	style: {
		display: "flex",
		flexDirection: "row",
		gap: "16px"
	},
	wrap: !1,
	children: [/* @__PURE__ */ F(D, {
		style: { width: "42%" },
		children: [/* @__PURE__ */ P(E, {
			style: {
				...Y.Lato11SemiBold,
				color: S
			},
			children: e
		}), /* @__PURE__ */ P(E, {
			style: {
				...Y.Lato11Regular,
				color: x
			},
			children: t
		})]
	}), /* @__PURE__ */ P(D, {
		style: {
			flex: 1,
			height: "32px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			border: "1px",
			borderRadius: "2px",
			borderColor: b
		},
		children: /* @__PURE__ */ P(E, {
			style: {
				...Y.Lato11Regular,
				color: ae
			},
			children: `[sig|req|signer${n}]`
		})
	})]
}), ll = (e, t) => {
	let n = e.charCodeAt(0).toString();
	return t[n] === void 0 ? t.avg : t[n];
}, ul = (e, t) => e.split("").map((e) => ll(e, t)).reduce((e, t) => e + t, 0), dl = (e, t, n) => e.flatMap((e) => Qa(e.rows)).filter((e) => e[t]).flatMap((e) => {
	let r = e[t];
	return r ? M(r).with({ type: "TEXT" }, (e) => [e]).with({ type: "STACK" }, (e) => e.cells).with({ type: "DATE_RANGE" }, () => []).exhaustive().filter((e) => (e.style?.fontWeight ?? "regular") === n).map((e) => e.text) : [];
}), fl = (e, t) => ({
	regular: dl(e, t, "regular"),
	bold: dl(e, t, "bold")
}), pl = (e, t, { metrics: n, paddingX: r, defaultWidth: i }) => {
	let a = fl(e, t), o = a.regular.map((e) => ul(e, n.regular)), s = a.bold.map((e) => ul(e, n.bold)), c = [...o, ...s].map((e) => e + r * 2).sort((e, t) => t - e);
	if (c.length === 0) return i;
	let l = Math.ceil(c[0]);
	return l < i ? i : l;
}, ml = (e, t) => {
	let n = e.filter(Boolean);
	if (!n.length) return 0;
	let r = n.map((e) => ul(e, t));
	return Math.max(...r);
}, hl = ({ pricingTables: e, totals: t, totalsColumn: n, metrics: r, paddingX: i, defaultWidth: a }) => {
	let o = {
		metrics: r,
		paddingX: i,
		defaultWidth: a
	}, s = ml(t, r.bold), c = s ? s + i * 2 : 0;
	return {
		billingFrequency: pl(e, "billingFrequency", o),
		quantity: pl(e, "quantity", o),
		rate: Math.max(pl(e, "rate", o), pl(e, "discountedRate", o), n === "rate" ? c : 0),
		discount: pl(e, "discount", o),
		billingPeriods: pl(e, "billingPeriods", o),
		total: Math.max(pl(e, "total", o), pl(e, "totalBeforeDiscount", o), n === "total" ? c : 0)
	};
}, gl = {
	regular: {
		13: 0,
		32: 2.1229999999999998,
		33: 3.7729999999999997,
		34: 4.367,
		35: 6.38,
		36: 6.38,
		37: 8.645999999999999,
		38: 7.733,
		39: 2.53,
		40: 3.3,
		41: 3.3,
		42: 4.3999999999999995,
		43: 6.38,
		44: 2.332,
		45: 3.8169999999999997,
		46: 2.332,
		47: 4.103,
		48: 6.38,
		49: 6.38,
		50: 6.38,
		51: 6.38,
		52: 6.38,
		53: 6.38,
		54: 6.38,
		55: 6.38,
		56: 6.38,
		57: 6.38,
		58: 2.772,
		59: 2.772,
		60: 6.38,
		61: 6.38,
		62: 6.38,
		63: 4.378,
		64: 9.042,
		65: 7.4799999999999995,
		66: 7.117,
		67: 7.534999999999999,
		68: 8.283,
		69: 6.391,
		70: 6.226,
		71: 8.074,
		72: 8.315999999999999,
		73: 3.377,
		74: 4.8839999999999995,
		75: 7.491,
		76: 5.654,
		77: 10.12,
		78: 8.315999999999999,
		79: 8.777999999999999,
		80: 6.720999999999999,
		81: 8.777999999999999,
		82: 7.084,
		83: 5.83,
		84: 6.489999999999999,
		85: 8.03,
		86: 7.4799999999999995,
		87: 11.209,
		88: 7.0729999999999995,
		89: 6.919,
		90: 6.864,
		91: 3.3,
		92: 4.125,
		93: 3.3,
		94: 6.38,
		95: 4.334,
		96: 3.377,
		97: 5.577,
		98: 6.149,
		99: 5.137,
		100: 6.149,
		101: 5.763999999999999,
		102: 3.707,
		103: 5.6209999999999996,
		104: 6.116,
		105: 2.816,
		106: 2.794,
		107: 5.763999999999999,
		108: 2.816,
		109: 9.030999999999999,
		110: 6.116,
		111: 6.116,
		112: 6.072,
		113: 6.149,
		114: 4.433,
		115: 4.774,
		116: 4.103,
		117: 6.116,
		118: 5.632,
		119: 8.426,
		120: 5.544,
		121: 5.632,
		122: 5.082,
		123: 3.3,
		124: 3.3,
		125: 3.3,
		126: 6.38,
		160: 2.1229999999999998,
		161: 3.7729999999999997,
		162: 6.38,
		163: 6.38,
		164: 6.38,
		165: 6.38,
		166: 3.3,
		167: 5.5329999999999995,
		168: 3.377,
		169: 8.777999999999999,
		170: 3.7619999999999996,
		171: 5.093,
		172: 6.38,
		173: 3.8169999999999997,
		174: 8.777999999999999,
		175: 3.377,
		176: 4.367,
		177: 6.38,
		178: 3.6519999999999997,
		179: 3.6519999999999997,
		180: 3.377,
		181: 6.116,
		182: 7.359,
		183: 3.0029999999999997,
		184: 3.377,
		185: 3.6519999999999997,
		186: 4.191,
		187: 5.093,
		188: 7.832,
		189: 7.832,
		190: 7.843,
		191: 4.378,
		192: 7.4799999999999995,
		193: 7.4799999999999995,
		194: 7.4799999999999995,
		195: 7.4799999999999995,
		196: 7.4799999999999995,
		197: 7.4799999999999995,
		198: 10.219,
		199: 7.534999999999999,
		200: 6.391,
		201: 6.391,
		202: 6.391,
		203: 6.391,
		204: 3.377,
		205: 3.377,
		206: 3.377,
		207: 3.377,
		208: 8.679,
		209: 8.315999999999999,
		210: 8.777999999999999,
		211: 8.777999999999999,
		212: 8.777999999999999,
		213: 8.777999999999999,
		214: 8.777999999999999,
		215: 6.38,
		216: 8.777999999999999,
		217: 8.03,
		218: 8.03,
		219: 8.03,
		220: 8.03,
		221: 6.919,
		222: 6.720999999999999,
		223: 6.699,
		224: 5.577,
		225: 5.577,
		226: 5.577,
		227: 5.577,
		228: 5.577,
		229: 5.577,
		230: 8.975999999999999,
		231: 5.137,
		232: 5.763999999999999,
		233: 5.763999999999999,
		234: 5.763999999999999,
		235: 5.763999999999999,
		236: 2.816,
		237: 2.816,
		238: 2.816,
		239: 2.816,
		240: 6.082999999999999,
		241: 6.116,
		242: 6.116,
		243: 6.116,
		244: 6.116,
		245: 6.116,
		246: 6.116,
		247: 6.38,
		248: 6.116,
		249: 6.116,
		250: 6.116,
		251: 6.116,
		252: 6.116,
		253: 5.632,
		254: 6.072,
		255: 5.632,
		260: 7.4799999999999995,
		261: 5.577,
		262: 7.534999999999999,
		263: 5.137,
		280: 6.534,
		281: 5.763999999999999,
		305: 2.816,
		321: 5.973,
		322: 3.5309999999999997,
		323: 8.315999999999999,
		324: 6.116,
		338: 12.056,
		339: 9.536999999999999,
		346: 6.028,
		347: 4.774,
		352: 5.83,
		353: 4.774,
		376: 6.919,
		377: 6.864,
		378: 5.082,
		379: 6.864,
		380: 5.082,
		381: 6.864,
		382: 5.082,
		402: 6.38,
		710: 3.377,
		711: 3.377,
		713: 3.377,
		728: 3.377,
		729: 3.377,
		730: 3.377,
		731: 3.377,
		732: 3.377,
		733: 3.377,
		960: 6.798,
		8211: 6.116,
		8212: 9.030999999999999,
		8216: 2.332,
		8217: 2.332,
		8218: 2.332,
		8220: 4.004,
		8221: 4.004,
		8222: 4.004,
		8224: 6.38,
		8225: 6.38,
		8226: 6.38,
		8230: 7.997,
		8240: 12.683,
		8249: 3.476,
		8250: 3.476,
		8260: 3.377,
		8364: 6.38,
		8482: 7.92,
		8486: 8.216999999999999,
		8706: 6.38,
		8710: 7.656,
		8719: 7.523999999999999,
		8721: 7.523999999999999,
		8722: 6.38,
		8730: 6.303,
		8734: 7.523999999999999,
		8747: 4.3999999999999995,
		8776: 6.38,
		8800: 6.38,
		8804: 6.38,
		8805: 6.38,
		9674: 6.38,
		9833: 0,
		64257: 6.27,
		64258: 6.534,
		avg: 5.80636259541985
	},
	bold: {
		32: 2.739,
		33: 3.0305,
		34: 4.2185,
		35: 6.38,
		36: 6.38,
		37: 8.921,
		38: 7.898,
		39: 2.288,
		40: 2.981,
		41: 2.981,
		42: 4.675,
		43: 6.38,
		44: 2.5355,
		45: 4.0975,
		46: 2.6014999999999997,
		47: 5.0545,
		48: 6.38,
		49: 6.38,
		50: 6.38,
		51: 6.38,
		52: 6.38,
		53: 6.38,
		54: 6.38,
		55: 6.38,
		56: 6.38,
		57: 6.38,
		58: 2.794,
		59: 2.9314999999999998,
		60: 6.38,
		61: 6.38,
		62: 6.38,
		63: 4.994,
		64: 9.24,
		65: 7.5515,
		66: 7.183,
		67: 7.3095,
		68: 8.365499999999999,
		69: 6.335999999999999,
		70: 6.2204999999999995,
		71: 8.008,
		72: 8.442499999999999,
		73: 3.1734999999999998,
		74: 4.686,
		75: 7.419499999999999,
		76: 5.6815,
		77: 10.306999999999999,
		78: 8.442499999999999,
		79: 8.849499999999999,
		80: 6.7155,
		81: 8.849499999999999,
		82: 6.984999999999999,
		83: 6.0005,
		84: 6.5504999999999995,
		85: 8.1345,
		86: 7.5515,
		87: 11.478499999999999,
		88: 7.26,
		89: 7.001499999999999,
		90: 6.643999999999999,
		91: 3.4099999999999997,
		92: 5.0545,
		93: 3.4099999999999997,
		94: 6.38,
		95: 5.093,
		96: 4.3999999999999995,
		97: 5.5275,
		98: 6.204,
		99: 5.279999999999999,
		100: 6.204,
		101: 5.840999999999999,
		102: 3.8994999999999997,
		103: 5.7695,
		104: 6.170999999999999,
		105: 2.7224999999999997,
		106: 2.7224999999999997,
		107: 5.742,
		108: 2.6675,
		109: 9.135499999999999,
		110: 6.170999999999999,
		111: 6.281,
		112: 6.209499999999999,
		113: 6.204,
		114: 4.059,
		115: 4.8015,
		116: 4.0205,
		117: 6.170999999999999,
		118: 5.7475,
		119: 8.7395,
		120: 5.6155,
		121: 5.742,
		122: 5.016,
		123: 3.3385,
		124: 2.816,
		125: 3.3385,
		126: 6.38,
		161: 2.8764999999999996,
		162: 6.38,
		163: 6.38,
		164: 6.38,
		165: 6.38,
		166: 2.8489999999999998,
		167: 5.4944999999999995,
		168: 4.3999999999999995,
		169: 9.1025,
		170: 4.0424999999999995,
		171: 4.872999999999999,
		172: 6.38,
		174: 9.1025,
		175: 4.3999999999999995,
		176: 4.5649999999999995,
		177: 6.38,
		178: 3.674,
		179: 3.674,
		180: 4.3999999999999995,
		181: 7.204999999999999,
		182: 7.914499999999999,
		183: 2.9425,
		184: 4.3999999999999995,
		185: 3.674,
		186: 4.4165,
		187: 4.872999999999999,
		188: 8.1235,
		189: 8.035499999999999,
		190: 8.206,
		191: 4.928,
		192: 7.5515,
		193: 7.5515,
		194: 7.5515,
		195: 7.5515,
		196: 7.5515,
		197: 7.5515,
		198: 10.2465,
		199: 7.3095,
		200: 6.335999999999999,
		201: 6.335999999999999,
		202: 6.335999999999999,
		203: 6.335999999999999,
		204: 3.1734999999999998,
		205: 3.1734999999999998,
		206: 3.1734999999999998,
		207: 3.1734999999999998,
		208: 8.4645,
		209: 8.442499999999999,
		210: 8.849499999999999,
		211: 8.849499999999999,
		212: 8.849499999999999,
		213: 8.849499999999999,
		214: 8.849499999999999,
		215: 6.38,
		216: 8.849499999999999,
		217: 8.1345,
		218: 8.1345,
		219: 8.1345,
		220: 8.1345,
		221: 7.001499999999999,
		222: 6.682499999999999,
		223: 6.512,
		224: 5.5275,
		225: 5.5275,
		226: 5.5275,
		227: 5.5275,
		228: 5.5275,
		229: 5.5275,
		230: 8.8825,
		231: 5.2855,
		232: 5.840999999999999,
		233: 5.840999999999999,
		234: 5.840999999999999,
		235: 5.840999999999999,
		236: 2.7224999999999997,
		237: 2.7224999999999997,
		238: 2.7224999999999997,
		239: 2.7224999999999997,
		240: 6.2535,
		241: 6.170999999999999,
		242: 6.281,
		243: 6.281,
		244: 6.281,
		245: 6.281,
		246: 6.281,
		247: 6.38,
		248: 6.2755,
		249: 6.170999999999999,
		250: 6.170999999999999,
		251: 6.170999999999999,
		252: 6.170999999999999,
		253: 5.742,
		254: 6.209499999999999,
		255: 5.742,
		256: 7.5515,
		257: 5.5275,
		258: 7.5515,
		259: 5.5275,
		260: 7.5405,
		261: 5.5275,
		262: 7.3095,
		263: 5.279999999999999,
		264: 7.3095,
		265: 5.279999999999999,
		266: 7.3095,
		267: 5.279999999999999,
		268: 7.3095,
		269: 5.279999999999999,
		270: 8.365499999999999,
		271: 6.204,
		272: 8.4645,
		273: 6.209499999999999,
		274: 6.335999999999999,
		275: 5.840999999999999,
		276: 6.335999999999999,
		277: 5.840999999999999,
		278: 6.335999999999999,
		279: 5.840999999999999,
		280: 6.335999999999999,
		281: 5.840999999999999,
		282: 6.335999999999999,
		283: 5.840999999999999,
		284: 8.008,
		285: 5.7695,
		286: 8.008,
		287: 5.7695,
		288: 8.008,
		289: 5.7695,
		290: 8.008,
		291: 5.7695,
		292: 8.442499999999999,
		293: 6.170999999999999,
		294: 8.536,
		295: 6.170999999999999,
		296: 3.1734999999999998,
		297: 2.7224999999999997,
		298: 3.1734999999999998,
		299: 2.7224999999999997,
		300: 3.1734999999999998,
		301: 2.7224999999999997,
		302: 3.179,
		303: 2.7224999999999997,
		304: 3.1734999999999998,
		305: 2.7279999999999998,
		306: 8.129,
		307: 5.588,
		308: 4.686,
		309: 2.7224999999999997,
		310: 7.419499999999999,
		311: 5.742,
		312: 5.742,
		313: 5.6815,
		314: 2.6675,
		315: 5.6815,
		316: 2.6675,
		317: 5.6815,
		318: 2.6675,
		319: 5.917999999999999,
		320: 4.1964999999999995,
		321: 5.851999999999999,
		322: 3.5145,
		323: 8.442499999999999,
		324: 6.170999999999999,
		325: 8.442499999999999,
		326: 6.170999999999999,
		327: 8.442499999999999,
		328: 6.170999999999999,
		329: 6.7924999999999995,
		330: 8.442499999999999,
		331: 6.170999999999999,
		332: 8.849499999999999,
		333: 6.281,
		334: 8.849499999999999,
		335: 6.281,
		336: 8.849499999999999,
		337: 6.281,
		338: 11.9405,
		339: 9.619499999999999,
		340: 6.984999999999999,
		341: 4.059,
		342: 6.984999999999999,
		343: 4.059,
		344: 6.984999999999999,
		345: 4.0535,
		346: 6.0005,
		347: 4.8015,
		348: 6.0005,
		349: 4.8015,
		350: 6.0005,
		351: 4.8015,
		352: 6.0005,
		353: 4.8015,
		354: 6.5504999999999995,
		355: 4.026,
		356: 6.5504999999999995,
		357: 4.015,
		358: 6.699,
		359: 4.0645,
		360: 8.1345,
		361: 6.170999999999999,
		362: 8.1345,
		363: 6.170999999999999,
		364: 8.1345,
		365: 6.170999999999999,
		366: 8.1345,
		367: 6.170999999999999,
		368: 8.1345,
		369: 6.1655,
		370: 8.1345,
		371: 6.170999999999999,
		372: 11.478499999999999,
		373: 8.7395,
		374: 7.001499999999999,
		375: 5.742,
		376: 7.001499999999999,
		377: 6.643999999999999,
		378: 5.0215,
		379: 6.643999999999999,
		380: 5.016,
		381: 6.643999999999999,
		382: 5.016,
		383: 3.2285,
		384: 6.209499999999999,
		385: 8.904499999999999,
		386: 6.875,
		387: 6.204,
		388: 7.579,
		389: 6.4075,
		390: 7.3534999999999995,
		391: 7.359,
		392: 5.318499999999999,
		393: 8.4645,
		394: 10.0925,
		395: 6.875,
		396: 6.204,
		397: 5.7695,
		398: 6.3084999999999996,
		399: 8.0025,
		400: 6.528499999999999,
		401: 6.2204999999999995,
		402: 3.7895,
		403: 8.0465,
		404: 7.496499999999999,
		405: 9.388499999999999,
		406: 3.63,
		407: 3.4265,
		408: 7.678,
		409: 5.742,
		410: 3.102,
		411: 5.9455,
		412: 11.946,
		413: 8.442499999999999,
		414: 6.5945,
		415: 8.849499999999999,
		416: 9.410499999999999,
		417: 6.808999999999999,
		418: 11.165,
		419: 8.849499999999999,
		420: 8.437,
		421: 6.209499999999999,
		422: 6.6715,
		423: 5.956499999999999,
		424: 4.8015,
		425: 6.7155,
		426: 3.8169999999999997,
		427: 4.1415,
		428: 7.436,
		429: 4.0205,
		430: 6.5504999999999995,
		431: 9.410499999999999,
		432: 7.100499999999999,
		433: 8.931999999999999,
		434: 8.03,
		435: 8.0245,
		436: 6.6495,
		437: 6.677,
		438: 5.0545,
		439: 6.4845,
		440: 6.4845,
		441: 4.8839999999999995,
		442: 4.872999999999999,
		443: 6.38,
		444: 6.369,
		445: 4.917,
		446: 4.911499999999999,
		447: 6.149,
		448: 2.3594999999999997,
		449: 5.6594999999999995,
		450: 5.879499999999999,
		451: 2.3265,
		452: 15.103,
		453: 13.4035,
		454: 11.363,
		455: 10.5655,
		456: 8.5305,
		457: 5.560499999999999,
		458: 13.210999999999999,
		459: 11.170499999999999,
		460: 8.981499999999999,
		461: 7.5515,
		462: 5.5275,
		463: 3.1734999999999998,
		464: 2.7224999999999997,
		465: 8.849499999999999,
		466: 6.281,
		467: 8.1345,
		468: 6.170999999999999,
		469: 8.1345,
		470: 6.170999999999999,
		471: 8.1345,
		472: 6.170999999999999,
		473: 8.1345,
		474: 6.170999999999999,
		475: 8.1345,
		476: 6.170999999999999,
		477: 5.840999999999999,
		478: 7.5515,
		479: 5.5275,
		480: 7.5515,
		481: 5.5275,
		482: 10.2465,
		483: 8.8825,
		484: 8.288499999999999,
		485: 6.082999999999999,
		486: 8.008,
		487: 5.7695,
		488: 7.419499999999999,
		489: 5.742,
		490: 8.844,
		491: 6.2755,
		492: 8.849499999999999,
		493: 6.281,
		494: 6.4845,
		495: 4.8785,
		496: 2.7224999999999997,
		497: 15.103,
		498: 13.4035,
		499: 11.363,
		500: 8.008,
		501: 5.7695,
		502: 11.6875,
		503: 7.7935,
		504: 8.442499999999999,
		505: 6.170999999999999,
		506: 7.5515,
		507: 5.5275,
		508: 10.2465,
		509: 8.8825,
		510: 8.833,
		511: 6.281,
		512: 7.5515,
		513: 5.5275,
		514: 7.5515,
		515: 5.5275,
		516: 6.335999999999999,
		517: 5.840999999999999,
		518: 6.335999999999999,
		519: 5.840999999999999,
		520: 3.1734999999999998,
		521: 2.7224999999999997,
		522: 3.1734999999999998,
		523: 2.7224999999999997,
		524: 8.849499999999999,
		525: 6.281,
		526: 8.849499999999999,
		527: 6.281,
		528: 6.984999999999999,
		529: 4.0535,
		530: 6.984999999999999,
		531: 4.0535,
		532: 8.1345,
		533: 6.170999999999999,
		534: 8.1345,
		535: 6.170999999999999,
		536: 6.0005,
		537: 4.8015,
		538: 6.5504999999999995,
		539: 4.015,
		540: 6.4845,
		541: 4.8785,
		542: 8.442499999999999,
		543: 6.170999999999999,
		544: 8.090499999999999,
		545: 7.1114999999999995,
		546: 7.089499999999999,
		547: 5.896,
		548: 6.7265,
		549: 5.1315,
		550: 7.5515,
		551: 5.5275,
		552: 6.335999999999999,
		553: 5.840999999999999,
		554: 8.849499999999999,
		555: 6.281,
		556: 8.849499999999999,
		557: 6.281,
		558: 8.849499999999999,
		559: 6.281,
		560: 8.849499999999999,
		561: 6.281,
		562: 7.001499999999999,
		563: 5.742,
		564: 3.223,
		565: 6.781499999999999,
		566: 4.1635,
		567: 2.7279999999999998,
		568: 9.7845,
		569: 9.7845,
		570: 7.601,
		571: 7.457999999999999,
		572: 5.3075,
		573: 5.7805,
		574: 6.7485,
		575: 4.8015,
		576: 4.7245,
		577: 5.2909999999999995,
		578: 5.0985,
		579: 7.271,
		580: 8.3105,
		581: 7.5295,
		582: 6.611,
		583: 5.874,
		584: 4.7905,
		585: 3.1294999999999997,
		586: 8.497499999999999,
		587: 6.204,
		588: 7.0455,
		589: 4.224,
		590: 7.864999999999999,
		591: 6.3965,
		592: 5.5275,
		593: 6.204,
		594: 6.204,
		595: 6.204,
		596: 5.313,
		597: 5.467,
		598: 6.204,
		599: 6.204,
		600: 5.840999999999999,
		601: 5.840999999999999,
		602: 7.909,
		603: 5.0104999999999995,
		604: 4.939,
		605: 6.8035,
		606: 6.247999999999999,
		607: 3.3825,
		608: 6.204,
		609: 6.204,
		610: 5.885,
		611: 5.4505,
		612: 5.714499999999999,
		613: 6.170999999999999,
		614: 6.170999999999999,
		615: 6.170999999999999,
		616: 3.3714999999999997,
		617: 3.1405,
		618: 2.6235,
		619: 4.29,
		620: 4.3614999999999995,
		621: 2.6235,
		622: 6.6,
		623: 9.135499999999999,
		624: 9.141,
		625: 9.135499999999999,
		626: 6.170999999999999,
		627: 6.170999999999999,
		628: 6.2315,
		629: 6.281,
		630: 8.596499999999999,
		631: 8.491999999999999,
		632: 8.3105,
		633: 4.0535,
		634: 4.0535,
		635: 4.0535,
		636: 4.059,
		637: 4.059,
		638: 3.5915,
		639: 3.5915,
		640: 5.346,
		641: 5.346,
		642: 4.834499999999999,
		643: 2.6235,
		644: 3.377,
		645: 2.6235,
		646: 3.1955,
		647: 4.059,
		648: 3.9654999999999996,
		649: 6.7485,
		650: 6.5889999999999995,
		651: 5.9455,
		652: 5.7364999999999995,
		653: 8.7395,
		654: 5.731,
		655: 5.335,
		656: 5.016,
		657: 6.363499999999999,
		658: 4.8785,
		659: 4.9555,
		660: 3.9764999999999997,
		661: 3.9764999999999997,
		662: 5.3845,
		663: 5.1205,
		664: 8.1235,
		665: 5.4944999999999995,
		666: 6.247999999999999,
		667: 5.9235,
		668: 6.2315,
		669: 3.2009999999999996,
		670: 5.7364999999999995,
		671: 4.1305,
		672: 6.204,
		673: 4.444,
		674: 4.3945,
		675: 10.1145,
		676: 10.427999999999999,
		677: 11.4565,
		678: 7.584499999999999,
		679: 5.7695,
		680: 8.283,
		681: 9.360999999999999,
		682: 7.215999999999999,
		683: 7.249,
		684: 5.840999999999999,
		685: 5.8575,
		686: 6.170999999999999,
		687: 6.170999999999999,
		688: 3.4595,
		689: 3.542,
		690: 1.7874999999999999,
		691: 2.3649999999999998,
		692: 2.3649999999999998,
		693: 2.4749999999999996,
		694: 3.223,
		695: 4.7135,
		696: 3.267,
		697: 3.6685,
		698: 5.851999999999999,
		699: 2.409,
		700: 2.409,
		701: 2.409,
		702: 2.1999999999999997,
		703: 2.1999999999999997,
		704: 3.0524999999999998,
		705: 3.0524999999999998,
		706: 6.38,
		707: 6.38,
		708: 5.2635,
		709: 5.2635,
		710: 4.3999999999999995,
		711: 4.3999999999999995,
		712: 2.7555,
		714: 4.3999999999999995,
		715: 4.3999999999999995,
		716: 2.7555,
		717: 4.3999999999999995,
		718: 4.3999999999999995,
		719: 4.3999999999999995,
		720: 4.031499999999999,
		721: 4.031499999999999,
		722: 2.1999999999999997,
		723: 2.1999999999999997,
		724: 4.3065,
		725: 4.3065,
		726: 4.3065,
		727: 4.3065,
		728: 4.3999999999999995,
		729: 4.3999999999999995,
		730: 4.3999999999999995,
		731: 4.3999999999999995,
		732: 4.3999999999999995,
		733: 4.3999999999999995,
		734: 0,
		735: 4.3065,
		736: 3.3825,
		737: 1.738,
		738: 2.7335,
		739: 3.3714999999999997,
		740: 3.0524999999999998,
		741: 4.0975,
		742: 4.0975,
		743: 4.0975,
		744: 4.0975,
		745: 4.0975,
		746: 5.5,
		747: 5.5,
		748: 4.3999999999999995,
		749: 5.5,
		750: 4.1635,
		751: 4.3065,
		752: 4.3065,
		753: 4.3065,
		754: 4.3065,
		755: 4.3999999999999995,
		756: 4.3999999999999995,
		757: 4.3999999999999995,
		758: 4.3999999999999995,
		759: 4.3999999999999995,
		760: 3.1184999999999996,
		761: 4.3065,
		762: 4.3065,
		763: 4.3065,
		764: 4.3065,
		765: 6.875,
		766: 6.875,
		767: 6.2315,
		768: 0,
		769: 0,
		770: 0,
		771: 0,
		772: 0,
		773: 0,
		774: 0,
		775: 0,
		776: 0,
		777: 0,
		778: 0,
		779: 0,
		780: 0,
		781: 0,
		782: 0,
		783: 0,
		784: 0,
		785: 0,
		786: 0,
		787: 0,
		788: 0,
		789: 0,
		790: 0,
		791: 0,
		792: 0,
		793: 0,
		794: 0,
		795: 0,
		796: 0,
		797: 0,
		798: 0,
		799: 0,
		800: 0,
		801: 0,
		802: 0,
		803: 0,
		804: 0,
		805: 0,
		806: 0,
		807: 0,
		808: 0,
		809: 0,
		810: 0,
		811: 0,
		812: 0,
		813: 0,
		814: 0,
		815: 0,
		816: 0,
		817: 0,
		818: 0,
		819: 0,
		820: 0,
		821: 0,
		822: 0,
		823: 0,
		824: 0,
		825: 0,
		826: 0,
		827: 0,
		828: 0,
		829: 0,
		830: 0,
		831: 0,
		832: 0,
		833: 0,
		834: 0,
		835: 0,
		836: 0,
		837: 0,
		838: 0,
		839: 0,
		840: 0,
		841: 0,
		842: 0,
		843: 0,
		844: 0,
		845: 0,
		846: 0,
		847: 0,
		848: 0,
		849: 0,
		850: 0,
		851: 0,
		852: 0,
		853: 0,
		854: 0,
		855: 0,
		856: 0,
		857: 0,
		858: 0,
		859: 0,
		860: 0,
		861: 0,
		862: 0,
		863: 0,
		864: 0,
		865: 0,
		866: 0,
		867: 0,
		868: 0,
		869: 0,
		870: 0,
		871: 0,
		872: 0,
		873: 0,
		874: 0,
		875: 0,
		876: 0,
		877: 0,
		878: 0,
		879: 0,
		884: 2.409,
		885: 2.409,
		890: 2.134,
		891: 5.2635,
		892: 5.279999999999999,
		893: 5.279999999999999,
		894: 2.9314999999999998,
		900: 4.3999999999999995,
		901: 4.3999999999999995,
		902: 7.5515,
		903: 2.9425,
		904: 7.254499999999999,
		905: 8.469999999999999,
		906: 3.1734999999999998,
		908: 8.8385,
		910: 6.9959999999999996,
		911: 8.9155,
		912: 3.0029999999999997,
		913: 7.5515,
		914: 7.183,
		915: 6.044499999999999,
		916: 7.573499999999999,
		917: 6.335999999999999,
		918: 6.643999999999999,
		919: 8.442499999999999,
		920: 8.849499999999999,
		921: 3.1734999999999998,
		922: 7.419499999999999,
		923: 7.534999999999999,
		924: 10.306999999999999,
		925: 8.442499999999999,
		926: 6.8309999999999995,
		927: 8.849499999999999,
		928: 8.442499999999999,
		929: 6.7155,
		931: 6.7155,
		932: 6.5504999999999995,
		933: 7.001499999999999,
		934: 9.2675,
		935: 7.26,
		936: 9.075,
		937: 8.931999999999999,
		938: 3.1734999999999998,
		939: 7.001499999999999,
		940: 6.5725,
		941: 5.0104999999999995,
		942: 6.4735,
		943: 3.0029999999999997,
		944: 6.116,
		945: 6.5725,
		946: 6.193,
		947: 6.072,
		948: 6.1105,
		949: 5.0104999999999995,
		950: 4.3835,
		951: 6.4735,
		952: 6.6,
		953: 3.0029999999999997,
		954: 5.7475,
		955: 5.9895,
		956: 6.616499999999999,
		957: 5.6979999999999995,
		958: 4.3945,
		959: 6.281,
		960: 6.864,
		961: 6.226,
		962: 5.153499999999999,
		963: 6.677,
		964: 5.1975,
		965: 6.116,
		966: 8.3105,
		967: 5.3515,
		968: 8.5525,
		969: 8.568999999999999,
		970: 3.0029999999999997,
		971: 6.116,
		972: 6.281,
		973: 6.116,
		974: 8.568999999999999,
		976: 6.286499999999999,
		977: 7.0565,
		978: 7.0785,
		979: 7.0785,
		980: 7.0785,
		981: 8.315999999999999,
		982: 9.6855,
		983: 6.919,
		984: 7.755,
		985: 6.281,
		986: 6.457,
		987: 5.137,
		988: 6.2535,
		989: 5.0104999999999995,
		990: 6.3415,
		991: 5.637499999999999,
		992: 7.969499999999999,
		993: 6.5889999999999995,
		994: 11.9515,
		995: 9.135499999999999,
		996: 7.281999999999999,
		997: 6.121499999999999,
		998: 7.0729999999999995,
		999: 6.132499999999999,
		1e3: 5.9784999999999995,
		1001: 4.9665,
		1002: 7.5184999999999995,
		1003: 6.226,
		1004: 7.930999999999999,
		1005: 6.4185,
		1006: 6.3469999999999995,
		1007: 5.2855,
		1008: 6.528499999999999,
		1009: 6.226,
		1010: 5.279999999999999,
		1011: 2.618,
		1012: 8.849499999999999,
		1013: 5.153499999999999,
		1014: 5.159,
		1015: 6.682499999999999,
		1016: 6.209499999999999,
		1017: 7.326,
		1018: 9.427,
		1019: 7.3755,
		1020: 6.2315,
		1021: 7.337,
		1022: 7.326,
		1023: 7.337,
		1024: 6.335999999999999,
		1025: 6.335999999999999,
		1026: 8.206,
		1027: 5.9345,
		1028: 7.3919999999999995,
		1029: 6.0005,
		1030: 3.1734999999999998,
		1031: 3.1734999999999998,
		1032: 4.686,
		1033: 11.6655,
		1034: 12.0175,
		1035: 8.2775,
		1036: 7.523999999999999,
		1037: 8.442499999999999,
		1038: 6.9905,
		1039: 8.1455,
		1040: 7.5184999999999995,
		1041: 6.875,
		1042: 7.183,
		1043: 5.9345,
		1044: 8.772499999999999,
		1045: 6.335999999999999,
		1046: 11.594,
		1047: 6.363499999999999,
		1048: 8.442499999999999,
		1049: 8.442499999999999,
		1050: 7.523999999999999,
		1051: 8.084999999999999,
		1052: 10.306999999999999,
		1053: 8.442499999999999,
		1054: 8.849499999999999,
		1055: 8.1455,
		1056: 6.7155,
		1057: 7.3095,
		1058: 6.5504999999999995,
		1059: 6.9905,
		1060: 8.734,
		1061: 7.26,
		1062: 8.6625,
		1063: 7.359,
		1064: 11.891,
		1065: 12.408,
		1066: 8.216999999999999,
		1067: 10.0045,
		1068: 6.7485,
		1069: 7.3865,
		1070: 11.616,
		1071: 7.3975,
		1072: 5.5275,
		1073: 6.468,
		1074: 5.4944999999999995,
		1075: 4.587,
		1076: 6.8915,
		1077: 5.840999999999999,
		1078: 8.8385,
		1079: 4.9445,
		1080: 6.374499999999999,
		1081: 6.374499999999999,
		1082: 5.840999999999999,
		1083: 6.512,
		1084: 7.826499999999999,
		1085: 6.2315,
		1086: 6.281,
		1087: 6.2315,
		1088: 6.204,
		1089: 5.279999999999999,
		1090: 5.6045,
		1091: 5.742,
		1092: 7.903499999999999,
		1093: 5.6155,
		1094: 6.731999999999999,
		1095: 5.7364999999999995,
		1096: 9.1025,
		1097: 9.6085,
		1098: 6.478999999999999,
		1099: 8.052,
		1100: 5.302,
		1101: 5.335,
		1102: 8.722999999999999,
		1103: 5.5055,
		1104: 5.840999999999999,
		1105: 5.840999999999999,
		1106: 6.121499999999999,
		1107: 4.587,
		1108: 5.335,
		1109: 4.8015,
		1110: 2.7224999999999997,
		1111: 2.7224999999999997,
		1112: 2.7224999999999997,
		1113: 9.2455,
		1114: 8.965,
		1115: 6.170999999999999,
		1116: 5.8355,
		1117: 6.374499999999999,
		1118: 5.742,
		1119: 6.2315,
		1120: 11.835999999999999,
		1121: 8.5855,
		1122: 8.035499999999999,
		1123: 6.226,
		1124: 10.494,
		1125: 7.672499999999999,
		1126: 7.821,
		1127: 6.2535,
		1128: 11.132,
		1129: 8.811,
		1130: 9.218,
		1131: 7.215999999999999,
		1132: 12.567499999999999,
		1133: 9.8065,
		1134: 6.1819999999999995,
		1135: 4.862,
		1136: 9.075,
		1137: 8.5525,
		1138: 8.849499999999999,
		1139: 6.281,
		1140: 7.765999999999999,
		1141: 5.994999999999999,
		1142: 7.765999999999999,
		1143: 5.994999999999999,
		1144: 14.52,
		1145: 11.9955,
		1146: 9.388499999999999,
		1147: 7.050999999999999,
		1148: 11.8415,
		1149: 8.591,
		1150: 11.835999999999999,
		1151: 8.5855,
		1152: 7.007,
		1153: 5.093,
		1154: 8.0245,
		1155: 0,
		1156: 0,
		1157: 0,
		1158: 0,
		1160: 12.386,
		1161: 11.979,
		1162: 8.8055,
		1163: 6.8035,
		1164: 7.331499999999999,
		1165: 5.786,
		1166: 6.7155,
		1167: 6.204,
		1168: 5.9345,
		1169: 4.587,
		1170: 6.528499999999999,
		1171: 5.082,
		1172: 6.973999999999999,
		1173: 5.433999999999999,
		1174: 12.1275,
		1175: 9.383,
		1176: 6.363499999999999,
		1177: 4.949999999999999,
		1178: 7.975,
		1179: 6.3854999999999995,
		1180: 7.9585,
		1181: 6.297499999999999,
		1182: 8.1015,
		1183: 6.324999999999999,
		1184: 8.9925,
		1185: 7.018,
		1186: 8.953999999999999,
		1187: 6.731999999999999,
		1188: 11.2035,
		1189: 8.195,
		1190: 11.924,
		1191: 8.998,
		1192: 9.119,
		1193: 6.8365,
		1194: 7.3095,
		1195: 5.279999999999999,
		1196: 6.5945,
		1197: 5.654,
		1198: 6.973999999999999,
		1199: 5.714499999999999,
		1200: 7.177499999999999,
		1201: 5.7585,
		1202: 7.601,
		1203: 6.0995,
		1204: 10.131,
		1205: 7.909,
		1206: 7.8759999999999994,
		1207: 6.236999999999999,
		1208: 7.359,
		1209: 5.725499999999999,
		1210: 7.0785,
		1211: 5.6925,
		1212: 9.437999999999999,
		1213: 7.2325,
		1214: 9.437999999999999,
		1215: 7.2325,
		1216: 3.1734999999999998,
		1217: 11.594,
		1218: 8.8385,
		1219: 7.826499999999999,
		1220: 6.0225,
		1221: 8.519499999999999,
		1222: 7.012499999999999,
		1223: 8.442499999999999,
		1224: 6.226,
		1225: 8.8715,
		1226: 6.731999999999999,
		1227: 7.359,
		1228: 5.725499999999999,
		1229: 10.735999999999999,
		1230: 8.3215,
		1231: 3.1734999999999998,
		1232: 7.5184999999999995,
		1233: 5.5275,
		1234: 7.5184999999999995,
		1235: 5.5275,
		1236: 10.2355,
		1237: 8.8825,
		1238: 6.335999999999999,
		1239: 5.840999999999999,
		1240: 8.0025,
		1241: 5.840999999999999,
		1242: 8.0025,
		1243: 5.840999999999999,
		1244: 11.594,
		1245: 8.8385,
		1246: 6.363499999999999,
		1247: 4.9445,
		1248: 6.4845,
		1249: 4.9334999999999996,
		1250: 8.442499999999999,
		1251: 6.374499999999999,
		1252: 8.442499999999999,
		1253: 6.374499999999999,
		1254: 8.849499999999999,
		1255: 6.281,
		1256: 8.849499999999999,
		1257: 6.281,
		1258: 8.849499999999999,
		1259: 6.281,
		1260: 7.3865,
		1261: 5.335,
		1262: 6.9905,
		1263: 5.742,
		1264: 6.9905,
		1265: 5.742,
		1266: 6.9905,
		1267: 5.742,
		1268: 7.359,
		1269: 5.7364999999999995,
		1270: 5.951,
		1271: 4.6034999999999995,
		1272: 10.0045,
		1273: 8.052,
		1274: 6.534,
		1275: 5.0874999999999995,
		1276: 7.6834999999999996,
		1277: 6.093999999999999,
		1278: 7.765999999999999,
		1279: 5.9784999999999995,
		1280: 6.682499999999999,
		1281: 6.204,
		1282: 8.767,
		1283: 8.5525,
		1284: 8.558,
		1285: 7.271,
		1286: 6.742999999999999,
		1287: 5.401,
		1288: 10.0925,
		1289: 8.866,
		1290: 10.4445,
		1291: 8.58,
		1292: 8.382,
		1293: 6.121499999999999,
		1294: 7.050999999999999,
		1295: 6.5009999999999994,
		1296: 6.528499999999999,
		1297: 5.0104999999999995,
		1298: 8.503,
		1299: 6.952,
		3647: 7.348,
		7424: 5.7035,
		7425: 7.414,
		7426: 8.866,
		7427: 5.6705,
		7428: 5.4174999999999995,
		7429: 6.138,
		7430: 6.198499999999999,
		7431: 4.697,
		7432: 5.0104999999999995,
		7433: 2.6235,
		7434: 3.4429999999999996,
		7435: 5.6265,
		7436: 4.4715,
		7437: 7.826499999999999,
		7438: 6.374499999999999,
		7439: 6.523,
		7440: 5.4174999999999995,
		7441: 6.5945,
		7442: 6.6495,
		7443: 7.359,
		7444: 9.619499999999999,
		7445: 5.313,
		7446: 6.4845,
		7447: 6.489999999999999,
		7448: 5.0435,
		7449: 5.346,
		7450: 5.346,
		7451: 4.6419999999999995,
		7452: 6.005999999999999,
		7453: 6.7155,
		7454: 8.7835,
		7455: 6.682499999999999,
		7456: 5.6925,
		7457: 8.3545,
		7458: 4.988499999999999,
		7459: 4.862,
		7460: 4.785,
		7461: 6.0885,
		7462: 4.3614999999999995,
		7463: 5.686999999999999,
		7464: 6.2315,
		7465: 5.0435,
		7466: 6.688,
		7467: 6.0775,
		7468: 4.2185,
		7469: 5.406499999999999,
		7470: 3.9435,
		7471: 4.048,
		7472: 4.4605,
		7473: 3.4484999999999997,
		7474: 3.4484999999999997,
		7475: 4.2515,
		7476: 4.5649999999999995,
		7477: 1.9634999999999998,
		7478: 2.629,
		7479: 4.1745,
		7480: 2.904,
		7481: 5.5714999999999995,
		7482: 4.5649999999999995,
		7483: 4.350499999999999,
		7484: 4.7299999999999995,
		7485: 3.718,
		7486: 3.7619999999999996,
		7487: 3.949,
		7488: 3.509,
		7489: 4.3999999999999995,
		7490: 6.170999999999999,
		7491: 3.0909999999999997,
		7492: 3.0909999999999997,
		7493: 3.4044999999999996,
		7494: 4.7355,
		7495: 3.4099999999999997,
		7496: 3.4099999999999997,
		7497: 3.2064999999999997,
		7498: 3.2009999999999996,
		7499: 2.7115,
		7500: 2.7609999999999997,
		7501: 3.19,
		7502: 1.6775,
		7503: 3.3385,
		7504: 4.960999999999999,
		7505: 3.4044999999999996,
		7506: 3.4154999999999998,
		7507: 2.9314999999999998,
		7508: 3.4044999999999996,
		7509: 3.4099999999999997,
		7510: 3.4099999999999997,
		7511: 2.409,
		7512: 3.399,
		7513: 3.5805,
		7514: 4.9555,
		7515: 3.0469999999999997,
		7516: 3.2009999999999996,
		7517: 3.4265,
		7518: 3.2175,
		7519: 3.3385,
		7520: 4.6475,
		7521: 2.9204999999999997,
		7522: 1.6609999999999998,
		7523: 2.31,
		7524: 3.399,
		7525: 3.0469999999999997,
		7526: 3.4265,
		7527: 3.2394999999999996,
		7528: 3.4099999999999997,
		7529: 4.6475,
		7530: 2.937,
		7531: 9.526,
		7532: 6.204,
		7533: 6.204,
		7534: 4.669499999999999,
		7535: 10.934,
		7536: 7.980499999999999,
		7537: 6.204,
		7538: 4.829,
		7539: 5.027,
		7540: 6.358,
		7541: 4.872999999999999,
		7542: 5.560499999999999,
		7543: 5.802499999999999,
		7544: 3.9985,
		7545: 5.39,
		7546: 10.3345,
		7547: 3.135,
		7548: 3.586,
		7549: 6.204,
		7550: 6.7924999999999995,
		7551: 6.8915,
		7552: 6.215,
		7553: 6.633,
		7554: 4.031499999999999,
		7555: 7.9475,
		7556: 6.2425,
		7557: 3.0799999999999996,
		7558: 9.5975,
		7559: 6.633,
		7560: 6.2204999999999995,
		7561: 4.0975,
		7562: 5.269,
		7563: 4.4165,
		7564: 5.797,
		7565: 6.072,
		7566: 5.4174999999999995,
		7567: 5.9399999999999995,
		7568: 6.6,
		7569: 6.204,
		7570: 5.879499999999999,
		7571: 5.0655,
		7572: 4.988499999999999,
		7573: 5.874,
		7574: 3.014,
		7575: 5.346,
		7576: 3.5639999999999996,
		7577: 6.5615,
		7578: 5.159,
		7579: 3.4099999999999997,
		7580: 2.9314999999999998,
		7581: 3.0084999999999997,
		7582: 3.4154999999999998,
		7583: 2.7115,
		7584: 2.2329999999999997,
		7585: 1.958,
		7586: 3.19,
		7587: 3.399,
		7588: 1.9689999999999999,
		7589: 1.914,
		7590: 1.65,
		7591: 2.046,
		7592: 2.1065,
		7593: 1.914,
		7594: 1.9469999999999998,
		7595: 2.299,
		7596: 4.9555,
		7597: 4.9555,
		7598: 3.4099999999999997,
		7599: 3.4099999999999997,
		7600: 3.4429999999999996,
		7601: 3.4154999999999998,
		7602: 4.6475,
		7603: 2.7224999999999997,
		7604: 1.6775,
		7605: 2.4749999999999996,
		7606: 3.6189999999999998,
		7607: 3.5915,
		7608: 3.4979999999999998,
		7609: 3.2725,
		7610: 3.0469999999999997,
		7611: 2.783,
		7612: 2.772,
		7613: 3.5199999999999996,
		7614: 2.6895,
		7615: 3.6024999999999996,
		7616: 0,
		7617: 0,
		7618: 0,
		7619: 0,
		7620: 0,
		7621: 0,
		7622: 0,
		7623: 0,
		7624: 0,
		7625: 0,
		7626: 0,
		7678: 0,
		7679: 0,
		7680: 7.5515,
		7681: 5.5275,
		7682: 7.183,
		7683: 6.204,
		7684: 7.183,
		7685: 6.204,
		7686: 7.183,
		7687: 6.204,
		7688: 7.3095,
		7689: 5.2855,
		7690: 8.365499999999999,
		7691: 6.204,
		7692: 8.365499999999999,
		7693: 6.204,
		7694: 8.365499999999999,
		7695: 6.204,
		7696: 8.365499999999999,
		7697: 6.204,
		7698: 8.365499999999999,
		7699: 6.204,
		7700: 6.335999999999999,
		7701: 5.840999999999999,
		7702: 6.335999999999999,
		7703: 5.840999999999999,
		7704: 6.335999999999999,
		7705: 5.840999999999999,
		7706: 6.335999999999999,
		7707: 5.840999999999999,
		7708: 6.335999999999999,
		7709: 5.840999999999999,
		7710: 6.2204999999999995,
		7711: 3.8994999999999997,
		7712: 8.008,
		7713: 5.7695,
		7714: 8.442499999999999,
		7715: 6.170999999999999,
		7716: 8.442499999999999,
		7717: 6.170999999999999,
		7718: 8.442499999999999,
		7719: 6.170999999999999,
		7720: 8.442499999999999,
		7721: 6.170999999999999,
		7722: 8.442499999999999,
		7723: 6.170999999999999,
		7724: 3.1734999999999998,
		7725: 2.7224999999999997,
		7726: 3.1734999999999998,
		7727: 2.7224999999999997,
		7728: 7.419499999999999,
		7729: 5.742,
		7730: 7.419499999999999,
		7731: 5.742,
		7732: 7.419499999999999,
		7733: 5.742,
		7734: 5.6815,
		7735: 2.6675,
		7736: 5.6815,
		7737: 2.6675,
		7738: 5.6815,
		7739: 2.6675,
		7740: 5.6815,
		7741: 2.6675,
		7742: 10.306999999999999,
		7743: 9.135499999999999,
		7744: 10.306999999999999,
		7745: 9.135499999999999,
		7746: 10.306999999999999,
		7747: 9.135499999999999,
		7748: 8.442499999999999,
		7749: 6.170999999999999,
		7750: 8.442499999999999,
		7751: 6.170999999999999,
		7752: 8.442499999999999,
		7753: 6.170999999999999,
		7754: 8.442499999999999,
		7755: 6.170999999999999,
		7756: 8.849499999999999,
		7757: 6.281,
		7758: 8.849499999999999,
		7759: 6.281,
		7760: 8.849499999999999,
		7761: 6.281,
		7762: 8.849499999999999,
		7763: 6.281,
		7764: 6.7155,
		7765: 6.204,
		7766: 6.7155,
		7767: 6.204,
		7768: 6.984999999999999,
		7769: 4.059,
		7770: 6.984999999999999,
		7771: 4.059,
		7772: 6.984999999999999,
		7773: 4.059,
		7774: 6.984999999999999,
		7775: 4.059,
		7776: 6.0005,
		7777: 4.8015,
		7778: 6.0005,
		7779: 4.8015,
		7780: 6.0005,
		7781: 4.8015,
		7782: 6.0005,
		7783: 4.8015,
		7784: 6.0005,
		7785: 4.8015,
		7786: 6.5504999999999995,
		7787: 4.015,
		7788: 6.5504999999999995,
		7789: 4.0205,
		7790: 6.5504999999999995,
		7791: 4.0205,
		7792: 6.5504999999999995,
		7793: 4.0205,
		7794: 8.1345,
		7795: 6.170999999999999,
		7796: 8.1345,
		7797: 6.170999999999999,
		7798: 8.1345,
		7799: 6.170999999999999,
		7800: 8.1345,
		7801: 6.170999999999999,
		7802: 8.1345,
		7803: 6.170999999999999,
		7804: 7.5515,
		7805: 5.7475,
		7806: 7.5515,
		7807: 5.7475,
		7808: 11.478499999999999,
		7809: 8.7395,
		7810: 11.478499999999999,
		7811: 8.7395,
		7812: 11.478499999999999,
		7813: 8.7395,
		7814: 11.478499999999999,
		7815: 8.7395,
		7816: 11.478499999999999,
		7817: 8.7395,
		7818: 7.26,
		7819: 5.6155,
		7820: 7.26,
		7821: 5.6155,
		7822: 7.001499999999999,
		7823: 5.742,
		7824: 6.643999999999999,
		7825: 5.016,
		7826: 6.643999999999999,
		7827: 5.016,
		7828: 6.643999999999999,
		7829: 5.016,
		7830: 6.170999999999999,
		7831: 4.0205,
		7832: 8.7395,
		7833: 5.742,
		7834: 2.3649999999999998,
		7835: 3.2285,
		7838: 7.892499999999999,
		7840: 7.5515,
		7841: 5.5275,
		7842: 7.5515,
		7843: 5.5275,
		7844: 7.5515,
		7845: 5.5275,
		7846: 7.5515,
		7847: 5.5329999999999995,
		7848: 7.5515,
		7849: 5.5275,
		7850: 7.5515,
		7851: 5.5275,
		7852: 7.5515,
		7853: 5.5275,
		7854: 7.5515,
		7855: 5.5275,
		7856: 7.5515,
		7857: 5.5275,
		7858: 7.5515,
		7859: 5.5275,
		7860: 7.5515,
		7861: 5.5275,
		7862: 7.5515,
		7863: 5.5275,
		7864: 6.335999999999999,
		7865: 5.840999999999999,
		7866: 6.335999999999999,
		7867: 5.840999999999999,
		7868: 6.335999999999999,
		7869: 5.840999999999999,
		7870: 6.335999999999999,
		7871: 5.840999999999999,
		7872: 6.335999999999999,
		7873: 5.840999999999999,
		7874: 6.335999999999999,
		7875: 5.840999999999999,
		7876: 6.335999999999999,
		7877: 5.840999999999999,
		7878: 6.335999999999999,
		7879: 5.840999999999999,
		7880: 3.1734999999999998,
		7881: 2.7224999999999997,
		7882: 3.1734999999999998,
		7883: 2.7224999999999997,
		7884: 8.849499999999999,
		7885: 6.281,
		7886: 8.849499999999999,
		7887: 6.281,
		7888: 8.849499999999999,
		7889: 6.2755,
		7890: 8.849499999999999,
		7891: 6.281,
		7892: 8.849499999999999,
		7893: 6.281,
		7894: 8.849499999999999,
		7895: 6.281,
		7896: 8.849499999999999,
		7897: 6.281,
		7898: 9.3995,
		7899: 6.808999999999999,
		7900: 9.3995,
		7901: 6.808999999999999,
		7902: 9.3995,
		7903: 6.808999999999999,
		7904: 9.3995,
		7905: 6.808999999999999,
		7906: 9.405,
		7907: 6.808999999999999,
		7908: 8.1345,
		7909: 6.170999999999999,
		7910: 8.1345,
		7911: 6.170999999999999,
		7912: 9.410499999999999,
		7913: 7.100499999999999,
		7914: 9.410499999999999,
		7915: 7.100499999999999,
		7916: 9.410499999999999,
		7917: 7.100499999999999,
		7918: 9.410499999999999,
		7919: 7.100499999999999,
		7920: 9.410499999999999,
		7921: 7.100499999999999,
		7922: 7.001499999999999,
		7923: 5.742,
		7924: 7.001499999999999,
		7925: 5.742,
		7926: 7.001499999999999,
		7927: 5.742,
		7928: 7.001499999999999,
		7929: 5.742,
		7936: 6.5725,
		7937: 6.5725,
		7938: 6.5725,
		7939: 6.5725,
		7940: 6.5725,
		7941: 6.5725,
		7942: 6.5725,
		7943: 6.5725,
		7944: 7.5515,
		7945: 7.5515,
		7946: 7.5515,
		7947: 7.5515,
		7948: 7.5515,
		7949: 7.5515,
		7950: 7.5515,
		7951: 7.5515,
		7952: 5.0104999999999995,
		7953: 5.0104999999999995,
		7954: 5.0104999999999995,
		7955: 5.0104999999999995,
		7956: 5.0104999999999995,
		7957: 5.0104999999999995,
		7960: 6.335999999999999,
		7961: 6.335999999999999,
		7962: 6.335999999999999,
		7963: 6.335999999999999,
		7964: 6.335999999999999,
		7965: 6.335999999999999,
		7968: 6.4735,
		7969: 6.4735,
		7970: 6.4735,
		7971: 6.4735,
		7972: 6.4735,
		7973: 6.4735,
		7974: 6.4735,
		7975: 6.4735,
		7976: 8.442499999999999,
		7977: 8.442499999999999,
		7978: 8.442499999999999,
		7979: 8.442499999999999,
		7980: 8.442499999999999,
		7981: 8.442499999999999,
		7982: 8.442499999999999,
		7983: 8.442499999999999,
		7984: 3.0029999999999997,
		7985: 3.0029999999999997,
		7986: 3.0029999999999997,
		7987: 3.0029999999999997,
		7988: 3.0029999999999997,
		7989: 3.0029999999999997,
		7990: 3.0029999999999997,
		7991: 3.0029999999999997,
		7992: 3.1734999999999998,
		7993: 3.1734999999999998,
		7994: 3.1734999999999998,
		7995: 3.1734999999999998,
		7996: 3.1734999999999998,
		7997: 3.1734999999999998,
		7998: 3.1734999999999998,
		7999: 3.1734999999999998,
		8e3: 6.281,
		8001: 6.2755,
		8002: 6.281,
		8003: 6.281,
		8004: 6.2755,
		8005: 6.2755,
		8008: 8.849499999999999,
		8009: 8.849499999999999,
		8010: 8.849499999999999,
		8011: 8.849499999999999,
		8012: 8.849499999999999,
		8013: 8.849499999999999,
		8016: 6.116,
		8017: 6.116,
		8018: 6.116,
		8019: 6.116,
		8020: 6.116,
		8021: 6.116,
		8022: 6.116,
		8023: 6.116,
		8025: 6.9959999999999996,
		8027: 6.9959999999999996,
		8029: 6.9959999999999996,
		8031: 6.9959999999999996,
		8032: 8.568999999999999,
		8033: 8.568999999999999,
		8034: 8.568999999999999,
		8035: 8.568999999999999,
		8036: 8.568999999999999,
		8037: 8.568999999999999,
		8038: 8.568999999999999,
		8039: 8.568999999999999,
		8040: 8.931999999999999,
		8041: 8.931999999999999,
		8042: 8.931999999999999,
		8043: 8.931999999999999,
		8044: 8.931999999999999,
		8045: 8.931999999999999,
		8046: 8.931999999999999,
		8047: 8.931999999999999,
		8048: 6.5725,
		8049: 6.5725,
		8050: 5.0104999999999995,
		8051: 5.0104999999999995,
		8052: 6.4735,
		8053: 6.4735,
		8054: 3.0029999999999997,
		8055: 3.0029999999999997,
		8056: 6.281,
		8057: 6.281,
		8058: 6.116,
		8059: 6.116,
		8060: 8.568999999999999,
		8061: 8.568999999999999,
		8064: 6.5725,
		8065: 6.5725,
		8066: 6.5725,
		8067: 6.5725,
		8068: 6.5725,
		8069: 6.5725,
		8070: 6.5725,
		8071: 6.5725,
		8072: 7.5515,
		8073: 7.5515,
		8074: 7.5515,
		8075: 7.5515,
		8076: 7.5515,
		8077: 7.5515,
		8078: 7.5515,
		8079: 7.5515,
		8080: 6.4735,
		8081: 6.4735,
		8082: 6.4735,
		8083: 6.4735,
		8084: 6.4735,
		8085: 6.4735,
		8086: 6.4735,
		8087: 6.4735,
		8088: 8.442499999999999,
		8089: 8.442499999999999,
		8090: 8.442499999999999,
		8091: 8.442499999999999,
		8092: 8.442499999999999,
		8093: 8.442499999999999,
		8094: 8.442499999999999,
		8095: 8.442499999999999,
		8096: 8.568999999999999,
		8097: 8.568999999999999,
		8098: 8.568999999999999,
		8099: 8.568999999999999,
		8100: 8.568999999999999,
		8101: 8.568999999999999,
		8102: 8.568999999999999,
		8103: 8.568999999999999,
		8104: 8.931999999999999,
		8105: 8.931999999999999,
		8106: 8.931999999999999,
		8107: 8.931999999999999,
		8108: 8.931999999999999,
		8109: 8.931999999999999,
		8110: 8.931999999999999,
		8111: 8.931999999999999,
		8112: 6.5725,
		8113: 6.5725,
		8114: 6.5725,
		8115: 6.5725,
		8116: 6.5725,
		8118: 6.5725,
		8119: 6.5725,
		8120: 7.5515,
		8121: 7.5515,
		8122: 7.5515,
		8123: 7.5515,
		8124: 7.5515,
		8125: 4.3999999999999995,
		8127: 4.3999999999999995,
		8128: 4.3999999999999995,
		8129: 4.3999999999999995,
		8130: 6.4735,
		8131: 6.4735,
		8132: 6.4735,
		8134: 6.4735,
		8135: 6.4735,
		8136: 6.335999999999999,
		8137: 6.369,
		8138: 8.442499999999999,
		8139: 8.469999999999999,
		8140: 8.442499999999999,
		8141: 4.3999999999999995,
		8142: 4.3999999999999995,
		8143: 4.3999999999999995,
		8144: 3.0029999999999997,
		8145: 3.0029999999999997,
		8146: 3.0029999999999997,
		8147: 3.0029999999999997,
		8150: 3.0029999999999997,
		8151: 3.0029999999999997,
		8152: 3.1734999999999998,
		8153: 3.1734999999999998,
		8154: 3.1734999999999998,
		8155: 3.1734999999999998,
		8157: 4.3999999999999995,
		8158: 4.3999999999999995,
		8159: 4.3999999999999995,
		8160: 6.116,
		8161: 6.116,
		8162: 6.116,
		8163: 6.116,
		8164: 6.226,
		8165: 6.226,
		8166: 6.116,
		8167: 6.116,
		8168: 7.001499999999999,
		8169: 7.001499999999999,
		8170: 6.9959999999999996,
		8171: 6.9959999999999996,
		8172: 6.7155,
		8173: 4.3999999999999995,
		8174: 4.3999999999999995,
		8175: 4.3999999999999995,
		8178: 8.568999999999999,
		8179: 8.568999999999999,
		8180: 8.568999999999999,
		8182: 8.568999999999999,
		8183: 8.568999999999999,
		8184: 8.849499999999999,
		8185: 8.849499999999999,
		8186: 8.926499999999999,
		8187: 8.931999999999999,
		8188: 8.931999999999999,
		8189: 4.3999999999999995,
		8190: 4.3999999999999995,
		8192: 5.5,
		8193: 8.25,
		8194: 5.5,
		8195: 8.25,
		8196: 3.663,
		8197: 2.75,
		8198: 1.8315,
		8199: 6.38,
		8200: 2.409,
		8201: 1.375,
		8202: .6875,
		8203: 0,
		8204: 0,
		8205: 0,
		8206: 0,
		8207: 0,
		8210: 5.9399999999999995,
		8211: 6.38,
		8212: 8.750499999999999,
		8213: 8.750499999999999,
		8214: 4.939,
		8215: 5.1095,
		8216: 2.3925,
		8217: 2.387,
		8218: 2.3815,
		8219: 2.3925,
		8220: 4.146999999999999,
		8221: 4.1415,
		8222: 4.136,
		8223: 4.1415,
		8224: 6.38,
		8225: 6.38,
		8226: 6.38,
		8230: 8.3765,
		8239: 2.75,
		8240: 12.930499999999999,
		8244: 8.008,
		8249: 3.146,
		8250: 3.1515,
		8252: 5.2195,
		8253: 5.483499999999999,
		8254: 7.226999999999999,
		8260: 1.5399999999999998,
		8286: 2.9314999999999998,
		8287: 2.1999999999999997,
		8304: 3.674,
		8305: 2.2769999999999997,
		8308: 3.674,
		8309: 3.674,
		8310: 3.674,
		8311: 3.674,
		8312: 3.674,
		8313: 3.674,
		8314: 3.674,
		8315: 3.674,
		8316: 3.674,
		8317: 1.837,
		8318: 1.837,
		8319: 3.399,
		8320: 3.674,
		8321: 3.674,
		8322: 3.674,
		8323: 3.674,
		8324: 3.674,
		8325: 3.674,
		8326: 3.674,
		8327: 3.674,
		8328: 3.674,
		8329: 3.674,
		8330: 3.674,
		8331: 3.674,
		8332: 3.674,
		8333: 1.837,
		8334: 1.837,
		8335: 3.8059999999999996,
		8336: 3.0854999999999997,
		8337: 3.2009999999999996,
		8338: 3.4154999999999998,
		8339: 3.256,
		8340: 3.1955,
		8352: 8.062999999999999,
		8353: 7.579,
		8354: 7.699999999999999,
		8355: 6.38,
		8356: 6.38,
		8357: 9.184999999999999,
		8358: 8.772499999999999,
		8359: 6.38,
		8360: 10.648,
		8361: 11.7645,
		8362: 9.405,
		8363: 6.7485,
		8364: 6.38,
		8365: 8.365499999999999,
		8366: 7.012499999999999,
		8367: 13.607,
		8368: 6.9025,
		8369: 6.38,
		8370: 8.0795,
		8371: 8.2445,
		8372: 6.6605,
		8373: 7.601,
		8376: 7.0565,
		8377: 6.363499999999999,
		8378: 6.38,
		8413: 10.439,
		8453: 9.273,
		8467: 6.121499999999999,
		8470: 12.8425,
		8471: 9.1025,
		8480: 8.2555,
		8482: 8.288499999999999,
		8486: 9.02,
		8494: 9.042,
		8498: 6.2315,
		8525: 9.141,
		8526: 4.5375,
		8531: 8.0465,
		8532: 8.195,
		8533: 7.898,
		8534: 8.03,
		8535: 7.991499999999999,
		8536: 8.228,
		8537: 8.013499999999999,
		8538: 8.238999999999999,
		8539: 7.980499999999999,
		8540: 8.074,
		8541: 8.2115,
		8542: 7.545999999999999,
		8543: 4.7299999999999995,
		8579: 7.3755,
		8580: 5.313,
		8592: 11,
		8593: 8.25,
		8594: 11,
		8595: 8.25,
		8596: 11,
		8597: 8.25,
		8598: 8.25,
		8599: 8.25,
		8600: 8.25,
		8601: 8.25,
		8616: 8.25,
		8706: 6.3854999999999995,
		8719: 7.6834999999999996,
		8721: 7.513,
		8722: 6.38,
		8725: 5.406499999999999,
		8730: 6.853,
		8734: 8.0795,
		8735: 6.4955,
		8745: 6.539499999999999,
		8747: 5.5329999999999995,
		8776: 6.38,
		8800: 6.38,
		8801: 6.38,
		8804: 6.38,
		8805: 6.38,
		8962: 8.392999999999999,
		8976: 6.38,
		8992: 4.4825,
		8993: 4.4825,
		9312: 12.237499999999999,
		9313: 12.237499999999999,
		9314: 12.237499999999999,
		9315: 12.237499999999999,
		9316: 12.237499999999999,
		9317: 12.237499999999999,
		9318: 12.237499999999999,
		9319: 12.237499999999999,
		9320: 12.237499999999999,
		9321: 12.237499999999999,
		9322: 12.237499999999999,
		9323: 12.237499999999999,
		9324: 12.237499999999999,
		9325: 12.237499999999999,
		9326: 12.237499999999999,
		9327: 12.237499999999999,
		9328: 12.237499999999999,
		9329: 12.237499999999999,
		9330: 12.237499999999999,
		9331: 12.237499999999999,
		9450: 12.237499999999999,
		9451: 12.237499999999999,
		9452: 12.237499999999999,
		9453: 12.237499999999999,
		9454: 12.237499999999999,
		9455: 12.237499999999999,
		9456: 12.237499999999999,
		9457: 12.237499999999999,
		9458: 12.237499999999999,
		9459: 12.237499999999999,
		9460: 12.237499999999999,
		9471: 12.237499999999999,
		9472: 8.25,
		9474: 8.25,
		9484: 8.25,
		9488: 8.25,
		9492: 8.25,
		9496: 8.25,
		9633: 6.6,
		9642: 4.5264999999999995,
		9643: 4.5264999999999995,
		9674: 6.38,
		9675: 7.292999999999999,
		9676: 7.292999999999999,
		9679: 6.6,
		9702: 4.5264999999999995,
		9728: 8.5635,
		9788: 8.5635,
		9833: 0,
		10102: 12.237499999999999,
		10103: 12.237499999999999,
		10104: 12.237499999999999,
		10105: 12.237499999999999,
		10106: 12.237499999999999,
		10107: 12.237499999999999,
		10108: 12.237499999999999,
		10109: 12.237499999999999,
		10110: 12.237499999999999,
		10111: 12.237499999999999,
		11360: 5.8245,
		11361: 3.4924999999999997,
		11362: 5.8629999999999995,
		11363: 6.808999999999999,
		11364: 6.973999999999999,
		11365: 5.5329999999999995,
		11366: 4.169,
		11367: 8.854999999999999,
		11368: 6.6495,
		11369: 7.903499999999999,
		11370: 6.369,
		11371: 6.7265,
		11372: 5.1315,
		11380: 5.7585,
		11381: 6.38,
		11382: 4.598,
		11383: 8.315999999999999,
		11799: 3.8884999999999996,
		42775: 4.3999999999999995,
		42776: 4.3999999999999995,
		42777: 4.3999999999999995,
		42778: 4.3065,
		42784: 7.523999999999999,
		42785: 7.523999999999999,
		63743: 8.679,
		64256: 7.419499999999999,
		64257: 6.4624999999999995,
		64258: 6.616499999999999,
		64259: 9.976999999999999,
		64260: 10.125499999999999,
		65056: 0,
		65057: 0,
		65058: 0,
		65059: 0,
		65279: 0,
		avg: 5.972767749419962
	}
}, _l = ({ visibleColumns: e }) => {
	let t = e.length - 1;
	return (349.7142857142857 - (t * 2 - 1) * 4) / t;
}, vl = ({ pricingTables: e, totals: t, visibleColumns: n }) => hl({
	pricingTables: e,
	totals: t,
	totalsColumn: n.includes("total") ? "total" : "rate",
	metrics: gl,
	paddingX: 4,
	defaultWidth: _l({ visibleColumns: n }) + 8
});
//#endregion
//#region src/renderers/PdfQuoteRenderer/PdfQuoteRendererV3.tsx
ft();
var yl = (e) => {
	let t = s(() => _r({ presentation: e.data.presentation }), [e.data.presentation]), n = s(() => Ts(t.blocks), [t.blocks]), { pricingTables: r, defaultVisibleColumns: i } = s(() => is({
		blocks: n,
		settings: t.settings,
		phaseSubTotals: e.data.phaseSubTotals,
		priceCommitments: e.data.priceCommitments,
		quotePriceTotalsPerPhase: e.data.quotePriceTotalsPerPhase,
		context: "pdf_v3"
	}), [
		n,
		t.settings,
		e.data
	]), a = s(() => rs({
		rows: r.flatMap(({ rows: e }) => e),
		defaultVisibleColumns: i
	}), [i, r]), o = s(() => br({
		dealType: e.data.dealType,
		overallTotal: Zn({
			currency: e.data.currency,
			value: e.data.totalDiscountedRate
		}),
		amendmentTotals: yr({
			currency: e.data.currency,
			amendment: e.data.amendment
		}),
		dueUpfront: Qn({
			currency: e.data.currency,
			value: e.data.totalDueOnStartDate
		})
	}), [e.data]), c = vl({
		pricingTables: r,
		totals: t.settings.showTotals ? o.rows.map((e) => e.amount) : [],
		visibleColumns: a
	});
	return At([
		[Os, e.imageData],
		[X, e.data],
		[uc, c],
		[dc, a]
	]), /* @__PURE__ */ F(Ot, { children: [
		/* @__PURE__ */ P(xc, {}),
		/* @__PURE__ */ P(ol, {}),
		/* @__PURE__ */ P(sl, {})
	] });
}, bl = (e) => /* @__PURE__ */ P($e, { children: /* @__PURE__ */ P(yl, { ...e }) }), xl = async (e) => {
	let t = await fetch(e, {
		cache: "no-cache",
		headers: ut(e) ? {} : { "sequence-skip-optimizer": "true" }
	});
	if (!t.ok) return;
	let n = await t.blob(), { width: r, height: i } = await Sl(n);
	return {
		blob: n,
		width: r,
		height: i
	};
}, Sl = (e) => {
	let t = URL.createObjectURL(e);
	return new Promise((e) => {
		let n = new Image();
		n.onload = () => {
			URL.revokeObjectURL(t), e({
				width: n.naturalWidth,
				height: n.naturalHeight
			});
		}, n.onerror = () => {
			URL.revokeObjectURL(t), e({
				width: void 0,
				height: void 0
			});
		}, n.src = t;
	});
};
//#endregion
//#region src/renderers/PdfQuoteRenderer/hooks/useQuotePdfDownload.tsx
ft();
var Cl = ({ fetchPdfQuoteRendererData: e, assetLoader: t }) => {
	let { displayPromiseNotification: n } = Qe(), r = i(async () => {
		let n = await e();
		if (!n) throw Error("Unable to fetch quote data for PDF v2 generation");
		let r = await kt(/* @__PURE__ */ P(bl, {
			data: n,
			imageData: await Ds({
				presentation: n.presentation,
				assetLoader: t,
				getImageDimensions: wl
			})
		})).toBlob();
		return ot(`${n.quoteNumber}.pdf`)(r), r;
	}, [e, t]);
	return { onClick: i(async () => {
		await n(r(), {
			loading: "Preparing download",
			success: "Download ready",
			error: "PDF download failed"
		});
	}, [n, r]) };
}, wl = async (e) => {
	let t = await xl(e);
	return {
		width: t?.width,
		height: t?.height
	};
}, Tl = ({ fileName: e, downloadPdfEndpoint: t }) => {
	let { displayPromiseNotification: n } = Qe(), r = i(async () => {
		let n = await t();
		if (await El(n.res)) return "notReady";
		if (!n.data || n.error) throw Error("Unable to download remote quote PDF");
		return ot(e(n.res))(n.data), "downloaded";
	}, [t, e]);
	return { onClick: i(async () => {
		await n(r(), {
			loading: "Preparing download",
			success: (e) => e === "notReady" ? "PDF not ready yet — please try again shortly." : "Download ready",
			error: "PDF download failed"
		});
	}, [n, r]) };
}, El = async (e) => e.status === 404 && (await e.clone().json().catch(() => void 0))?.code === "QUOTE_PDF_NOT_READY", Dl = Ie, Ol = 20, kl = 72, Al = 96, jl = 2, Ml = 8, Z = (e) => Math.round(e * Dl * 2) / 2, Q = (e) => e * Ol, Nl = (e, t) => Math.round(e * t * Ol), Pl = (e) => e * jl, Fl = (e) => e * Ml, Il = (e) => e / kl * Al, Ll = (e) => e * 1e5, Rl = () => {
	let e = new Vt("w:r"), t = new Vt("w:pict");
	return t.push(new Vt("v:rect", {
		style: `width:0.0pt;height:${Z(1)}pt`,
		"o:hr": "t",
		"o:hrstd": "t",
		"o:hralign": "center",
		fillcolor: y,
		stroked: "f"
	})), e.push(t), e;
}, zl = () => new L({
	spacing: {
		before: Q(14),
		after: Q(3),
		line: Q(Z(1)),
		lineRule: Ut.EXACT
	},
	children: [Rl()]
}), Bl = (e) => {
	if (!(e === "inherit" || e === "transparent")) return e.replace("#", "");
}, Vl = Bl(Cn), $ = Bl(S), Hl = Bl(y), Ul = Bl(x), Wl = Pl(Z(11)), Gl = Pl(Z(13)), Kl = Pl(Z(12)), ql = Nl(An, Z(11)), Jl = Nl(On, Z(13)), Yl = Nl(kn, Z(12)), Xl = Nl(An, Z(11)), Zl = Nl(jn, Z(11)), Ql = Nl(Mn, Z(11)), $l = Q(Z(6)), eu = Q(Z(16)), tu = 612, nu = 792, ru = Q(tu), iu = Q(nu), au = Q(Z(32)), ou = Q(Z(88)), su = Q(Z(32)), cu = tu - 2 * Z(32), lu = Q(cu), uu = Il(cu), du = Il(tu), fu = Il(Z(335)), pu = { default: {
	document: {
		run: {
			font: "Arial",
			size: Wl,
			color: $
		},
		paragraph: { spacing: {
			before: 0,
			after: 0
		} }
	},
	heading1: {
		run: {
			bold: !0,
			color: $,
			size: Gl
		},
		paragraph: { spacing: {
			before: 0,
			after: 0
		} }
	},
	heading2: {
		run: {
			bold: !0,
			color: $,
			size: Kl
		},
		paragraph: { spacing: {
			before: 0,
			after: 0
		} }
	},
	heading3: {
		run: {
			bold: !0,
			color: $,
			size: Wl
		},
		paragraph: { spacing: {
			before: 0,
			after: 0
		} }
	}
} }, mu = (e, t = []) => new L({
	spacing: {
		before: 0,
		after: e,
		line: 1,
		lineRule: Ut.EXACT
	},
	children: t
}), hu = (e) => {
	let t = Bl(H(e));
	return t ? {
		type: Kt.CLEAR,
		color: "auto",
		fill: t
	} : void 0;
}, gu = (e, t) => {
	let n = e.textColor ? Bl(V(e.textColor)) : t.color;
	return {
		bold: t.bold || e.bold,
		italics: e.italic,
		underline: e.underline ? { type: Qt.SINGLE } : void 0,
		strike: e.strike,
		color: n,
		shading: hu(e.backgroundColor)
	};
}, _u = (e, t) => e.split("\n").map((e, n) => new R({
	...t,
	text: e,
	break: n === 0 ? void 0 : 1
})), vu = (e, t) => e.href ? [new Pt({
	link: e.href,
	children: _u(e.text, gu(e.styles, {
		...t,
		color: Vl
	}))
})] : _u(e.text, gu(e.styles, t)), yu = (e, t = {}) => (Array.isArray(e) ? e : [e]).filter(Boolean).flatMap((e) => typeof e == "string" ? _u(e, {
	bold: t.bold,
	color: t.color
}) : vu(e, t)), bu = (e) => M(e).with("left", () => jt.LEFT).with("center", () => jt.CENTER).with("right", () => jt.RIGHT).with("justify", () => jt.JUSTIFIED).with(void 0, () => void 0).exhaustive(), xu = (e, t) => {
	let { level: n, lineHeight: r } = M(e).with("heading1", () => ({
		level: It.HEADING_1,
		lineHeight: Jl
	})).with("heading2", () => ({
		level: It.HEADING_2,
		lineHeight: Yl
	})).with("heading3", () => ({
		level: It.HEADING_3,
		lineHeight: Xl
	})).exhaustive();
	return new L({
		heading: n,
		alignment: bu(t.textAlignment),
		shading: hu(t.backgroundColor),
		spacing: {
			line: r,
			lineRule: Ut.AT_LEAST
		},
		children: yu(t.text, { color: Bl(V(t.textColor)) })
	});
}, Su = (e, t) => {
	let n = t.find((t) => t.urlUnsigned === e.src);
	if (!n) return [];
	let r = Cu({
		width: n.width,
		height: n.height
	}, e.width);
	return [new L({
		alignment: jt.CENTER,
		children: [new Bt({
			type: n.type,
			data: n.data,
			transformation: r,
			altText: e.alt ? { name: e.alt } : void 0
		})]
	})];
}, Cu = (e, t) => {
	let { width: n, height: r } = t ? Xc(e, t) : e, i = Yc({
		width: n,
		height: r
	}), a = Il(n && r ? n / r * i : 564), o = Il(i), s = Math.min(1, uu / a);
	return {
		width: Math.round(a * s),
		height: Math.round(o * s)
	};
}, wu = Q(Z(Nn)), Tu = 16, Eu = (e, t) => {
	let { levelIndentPx: n, markerColumnPx: r } = M(e).with("bulletList", () => ({
		levelIndentPx: 16,
		markerColumnPx: 14
	})).with("numberList", () => ({
		levelIndentPx: 20,
		markerColumnPx: Tu + 5
	})).exhaustive();
	return {
		left: Q(Z(8 + n * t + r)),
		hanging: Q(Z(r))
	};
}, Du = ({ blockType: e, version: t, config: n, level: r, registerNumbering: i, renderChildBlock: a }) => {
	let o = i(e, sn(n) ? n.startsFrom ?? 1 : 1), s = (t, n, i) => {
		let a = Bl(V(n.textColor)), s = i === 0 && r === 0;
		return new L({
			alignment: bu(n.textAlignment),
			shading: hu(n.backgroundColor),
			spacing: {
				line: ql,
				lineRule: Ut.AT_LEAST,
				before: s ? 0 : wu
			},
			indent: Eu(e, r),
			numbering: {
				reference: o,
				level: r
			},
			...e === "numberList" ? { run: { color: a } } : {},
			children: yu(t, { color: a })
		});
	};
	return M(t).with(3, () => {
		if (!sn(n)) return [];
		let e = n.items.map((e, t) => s(e.text, {
			textColor: e.textColor,
			backgroundColor: e.backgroundColor,
			textAlignment: e.textAlignment
		}, t)), t = (n.children ?? []).flatMap((e) => a(e, r + 1));
		return [...e, ...t];
	}).with(2, () => on(n) ? n.items.map((e, t) => s(e, {}, t)) : []).otherwise(() => an(n) ? n.items.map((e, t) => s(e, {}, t)) : []);
}, Ou = [
	"●",
	"○",
	"■"
], ku = (e, t, n) => ({
	reference: e,
	levels: Array.from({ length: 9 }, (e, r) => {
		let i = M(t).with("bulletList", () => ({
			format: Ht.BULLET,
			text: Ou[r % 3]
		})).with("numberList", () => ({
			format: Ht.DECIMAL,
			text: `%${r + 1}.`,
			start: n
		})).exhaustive();
		return {
			level: r,
			alignment: jt.START,
			style: { paragraph: { indent: Eu(t, r) } },
			...i
		};
	})
}), Au = () => {
	let e = [];
	return {
		configs: e,
		register: (t, n) => {
			let r = `${t}-${e.length}`;
			return e.push(ku(r, t, n)), r;
		}
	};
}, ju = (e) => new L({
	alignment: bu(e.textAlignment),
	shading: hu(e.backgroundColor),
	spacing: {
		line: ql,
		lineRule: Ut.AT_LEAST
	},
	children: yu(e.text, { color: Bl(V(e.textColor)) })
}), Mu = {
	style: Mt.NONE,
	size: 0,
	color: "auto"
}, Nu = {
	top: Mu,
	bottom: Mu,
	left: Mu,
	right: Mu
}, Pu = {
	...Nu,
	insideHorizontal: Mu,
	insideVertical: Mu
}, Fu = {
	top: 0,
	bottom: 0,
	left: 0,
	right: 0
}, Iu = {
	style: Mt.SINGLE,
	size: Fl(Z(1)),
	color: Hl
}, Lu = {
	top: Iu,
	bottom: Iu,
	left: Iu,
	right: Iu
}, Ru = {
	...Lu,
	insideHorizontal: Iu,
	insideVertical: Iu
}, zu = Q(Z(6)), Bu = {
	top: zu,
	bottom: zu,
	left: zu,
	right: zu
}, Vu = (e) => ({
	style: Mt.SINGLE,
	size: Fl(Z(1)),
	color: e
}), Hu = (e) => Tn.includes(e) ? jt.RIGHT : jt.LEFT, Uu = (e) => e.indentation ? e.indentation * Q(Z(8)) : void 0, Wu = Q(Z(4)), Gu = {
	line: Ql,
	lineRule: Ut.AT_LEAST
}, Ku = (e, t) => {
	if (!e) return [];
	let n = {
		alignment: t.alignment,
		indent: t.indentLeft ? { left: t.indentLeft } : void 0
	}, r = t.spacingBeforeTwips ? { before: t.spacingBeforeTwips } : void 0;
	return M(e).with({ type: "DATE_RANGE" }, (e) => [new L({
		...n,
		spacing: {
			...Gu,
			...r
		},
		children: [new R({
			text: Rn(e.dates, e.additionalText),
			color: $
		})]
	})]).with({ type: "TEXT" }, (e) => {
		let t = e.style?.color === "GreyGrey60" ? Ul : $, i = [new L({
			...n,
			spacing: {
				...Gu,
				...r
			},
			children: [new R({
				text: e.text,
				bold: e.style?.fontWeight === "bold",
				strike: e.style?.textDecoration === "line-through",
				color: t
			})]
		})];
		return e.secondaryText && i.push(new L({
			...n,
			spacing: {
				...Gu,
				before: Wu
			},
			children: [new R({
				text: e.secondaryText,
				color: Ul
			})]
		})), i;
	}).with({ type: "STACK" }, (e) => e.cells.flatMap((e, n) => Ku(e, {
		...t,
		spacingBeforeTwips: n === 0 ? t.spacingBeforeTwips : Q(Z(16))
	}))).exhaustive();
}, qu = (e, t) => {
	let n = e === "description" && t.descriptionAlignment === "end" ? jt.RIGHT : Hu(e);
	return M(e).with("description", () => Ku(t.description, {
		alignment: n,
		indentLeft: Uu(t)
	})).with("rate", () => {
		let e = Ku(t.discountedRate, { alignment: n });
		return [...e, ...Ku(t.rate, {
			alignment: n,
			spacingBeforeTwips: e.length ? Wu : void 0
		})];
	}).with("total", () => {
		let e = Ku(t.totalBeforeDiscount, { alignment: n });
		return [...e, ...Ku(t.total, {
			alignment: n,
			spacingBeforeTwips: e.length ? Wu : void 0
		})];
	}).with("quantity", () => Ku(t.quantity, { alignment: n })).with("billingFrequency", () => Ku(t.billingFrequency, { alignment: n })).with("billingPeriods", () => Ku(t.billingPeriods, { alignment: n })).with("discount", () => Ku(t.discount, { alignment: n })).exhaustive();
}, Ju = (e, t, n) => {
	let r = wn({ lineTotal: n });
	return new Xt({ children: e.map((e, n) => new Jt({
		width: {
			size: t[n],
			type: nn.DXA
		},
		borders: { bottom: Vu(Hl) },
		children: [new L({
			alignment: Hu(e),
			spacing: Gu,
			children: [new R({
				text: r[e],
				bold: !0,
				color: $
			})]
		})]
	})) });
}, Yu = (e) => e.length ? e : [new L({})], Xu = ({ row: e, backgroundColour: t, isLastRow: n, visibleColumns: r, columnWidths: i }) => {
	let a = t ? {
		type: Kt.CLEAR,
		color: "auto",
		fill: Bl(t)
	} : void 0, o = n ? void 0 : { bottom: Vu(Hl) }, s = eo({
		row: e,
		visibleColumns: r
	});
	return new Xt({ children: r.flatMap((t, n) => s.includes(t) ? [] : [new Jt({
		width: {
			size: r.reduce((e, n, r) => t === "description" && s.includes(n) ? e + i[r] : e, i[n]),
			type: nn.DXA
		},
		columnSpan: t === "description" ? 1 + s.length : 1,
		shading: a,
		borders: o,
		children: Yu(qu(t, e))
	})]) });
}, Zu = ({ settings: e, totals: t }) => {
	let n = e.showTotals && t.rows.length > 0, r = t.rows.length > 1, i = t.rows.length - 1, a = r ? Hl : Ul;
	return {
		rows: (r, o) => n ? t.rows.map((t, n) => {
			let s = n === 0, c = n === i, l = {
				top: s ? Vu(a) : void 0,
				bottom: c ? void 0 : Vu(Ul)
			};
			return new Xt({ children: r.map((n, r) => {
				let i = M(n).with("description", () => t.label).with("rate", () => e.columns.lineTotal ? void 0 : t.amount).with("total", () => e.columns.lineTotal ? t.amount : void 0).otherwise(() => void 0);
				return new Jt({
					width: {
						size: o[r],
						type: nn.DXA
					},
					borders: l,
					children: [new L({
						alignment: Hu(n),
						spacing: Gu,
						children: i ? [new R({
							text: i,
							bold: !0,
							color: $
						})] : []
					})]
				});
			}) });
		}) : [],
		disclaimer: (e) => {
			if (!n || !t.showDisclaimer) return [];
			let r = e.phases.some((e) => e.prices.some(lt));
			return [new L({
				spacing: { before: eu },
				children: [new R({
					text: Dn({ hasUsageBasedPrices: r }),
					color: Ul
				})]
			})];
		}
	};
}, Qu = Q(Z(4)), $u = Q(Z(8)), ed = ({ config: e, data: t, settings: n, visibleColumns: r, columnWidths: i }) => {
	let { phaseSubTotals: a, priceCommitments: o, quotePriceTotalsPerPhase: s = [], currency: c, totalDiscountedRate: l, totalDueOnStartDate: u, dealType: d, amendment: f } = t, { pricingTables: p } = za({
		config: e,
		context: "pdf_v3",
		settings: n,
		phaseSubTotals: a,
		priceCommitments: o,
		quotePriceTotalsPerPhase: s
	}), m = br({
		dealType: d,
		overallTotal: Zn({
			currency: c,
			value: l
		}),
		amendmentTotals: yr({
			currency: c,
			amendment: f
		}),
		dueUpfront: Qn({
			currency: c,
			value: u
		})
	}), h = p.length - 1, g = p.flatMap((e, t) => e.rows.map((a, o) => {
		let s = t === h && o === e.rows.length - 1;
		return Xu({
			row: a,
			backgroundColour: cc({
				rowIndex: o,
				rows: e.rows,
				groupPricesByPhase: n.groupPricesByPhase
			}),
			isLastRow: s,
			visibleColumns: r,
			columnWidths: i
		});
	})), _ = Zu({
		settings: n,
		totals: m
	});
	return [new qt({
		columnWidths: i,
		layout: Yt.FIXED,
		borders: Pu,
		margins: {
			top: $u,
			bottom: $u,
			left: Qu,
			right: Qu
		},
		rows: [
			Ju(r, i, n.columns.lineTotal),
			...g,
			..._.rows(r, i)
		]
	}), ..._.disclaimer(e)];
}, td = (e) => {
	let t = e.reduce((e, t) => e + t, 0), n = t > lu ? lu / t : 1;
	return e.map((e) => Math.round(e * n));
}, nd = (e) => {
	let t = e.reduce((e, t) => e + t, 0), n = e.map((e) => Math.round(e / t * lu)), r = n.slice(0, -1).reduce((e, t) => e + t, 0);
	return n.map((e, t) => t === n.length - 1 ? lu - r : e);
}, rd = (e) => td(Vn(e).map((e) => Q(Z(e)))), id = (e, t, n, r) => {
	let i = e.textColor === "default" ? n : e.textColor;
	return new Jt({
		width: {
			size: r,
			type: nn.DXA
		},
		shading: hu(e.backgroundColor),
		children: [new L({
			alignment: bu(e.textAlignment),
			children: yu(e.text, {
				bold: t,
				color: Bl(V(i))
			})
		})]
	});
}, ad = (e) => {
	let t = rd(e.columnWidths);
	return new qt({
		columnWidths: t,
		borders: Ru,
		margins: Bu,
		layout: Yt.FIXED,
		rows: e.rows.map((n, r) => new Xt({ children: n.cells.map((n, i) => id(n, e.headerRow && r === 0 || e.headerColumn && i === 0, e.textColor, t[i])) }))
	});
}, od = (e) => {
	let t = e.find((e) => e.blockType === "pdfCoverImage");
	if (t && un(t.config)) return t.config.assetPath;
	let n = e.find((e) => e.blockType === "coverImage");
	if (n) return Ss(n);
}, sd = (e, t) => {
	if (!e.settings.showPdfCoverPage) return;
	let n = od(e.blocks);
	if (n) return t.find((e) => e.urlUnsigned === n);
}, cd = Q(Z(4)), ld = {
	line: Zl,
	lineRule: Ut.AT_LEAST
}, ud = (e, t, n) => new Jt({
	width: {
		size: n,
		type: nn.DXA
	},
	borders: Nu,
	children: [new L({
		spacing: {
			line: ql,
			lineRule: Ut.AT_LEAST,
			after: cd
		},
		children: [new R({
			text: e,
			bold: !0,
			color: $
		})]
	}), ...t.map((e) => new L({
		spacing: ld,
		children: [new R({
			text: e,
			color: $
		})]
	}))]
}), dd = (e) => {
	let t = ws(e), n = t.length > 0, r = nd(n ? [45, 55] : [100]), i = [ud(xn.from, Cs(e), r[0]), ...n ? [ud(xn.to, t, r[1])] : []];
	return [new qt({
		columnWidths: r,
		layout: Yt.FIXED,
		borders: Pu,
		margins: Fu,
		rows: [new Xt({ children: i })]
	})];
}, fd = (e) => String(Math.round(Ll(e))), pd = (e, t) => {
	if (!e.width || !e.height) return;
	let n = t.width / t.height, r = e.width / e.height, i = r > n, a = i ? (1 - n / r) / 2 : 0, o = i ? 0 : (1 - r / n) / 2;
	return {
		l: fd(a),
		t: fd(o),
		r: fd(a),
		b: fd(o)
	};
}, md = (e, t) => {
	gd(e, "a:srcRect", new Vt("a:srcRect", t));
}, hd = (e) => typeof e == "object" && !!e && Array.isArray(e.root), gd = (e, t, n) => e.root.some((r, i) => hd(r) ? r.rootKey === t ? (e.root[i] = n, !0) : gd(r, t, n) : !1), _d = Q(Z(24)), vd = (e, t) => {
	let n = t.find((t) => t.urlUnsigned === e.merchantLogoUrl);
	if (!n) return [];
	let r = yd(n);
	return r ? [new L({
		spacing: { after: _d },
		children: [new Bt({
			type: n.type,
			data: n.data,
			transformation: r
		})]
	})] : [];
}, yd = ({ width: e, height: t }) => {
	if (!e || !t) return;
	let n = Il(Z(24)), r = e / t * n, i = Math.min(1, uu / r);
	return {
		width: Math.round(r * i),
		height: Math.round(n * i)
	};
}, bd = Pl(Z(24)), xd = Pl(Z(13)), Sd = Q(Z(32)), Cd = Q(Z(8)), wd = {
	width: du,
	height: fu
}, Td = (e, t, n) => {
	let r = new L({
		spacing: { before: Sd },
		children: [new R({
			text: Hn(e.title),
			bold: !0,
			size: bd,
			color: $
		}), ...Dd(n)]
	});
	return [
		...Ed(t),
		r,
		...e.prospectName ? [new L({
			spacing: { before: Cd },
			children: [new R({
				text: Jn(e.prospectName),
				size: xd,
				color: $
			})]
		})] : []
	];
}, Ed = (e) => {
	let t = pd(e, wd);
	if (!t) return [];
	let n = new Bt({
		type: e.type,
		data: e.data,
		transformation: wd
	});
	return md(n, t), [new L({
		spacing: {
			before: 0,
			after: 0
		},
		indent: {
			left: -au,
			right: -au
		},
		children: [n]
	})];
}, Dd = (e) => {
	if (!e) return [];
	let t = yd(e);
	return t ? [new Bt({
		type: e.type,
		data: e.data,
		transformation: t,
		floating: {
			horizontalPosition: {
				relative: zt.MARGIN,
				align: Rt.LEFT
			},
			verticalPosition: {
				relative: tn.MARGIN,
				align: en.BOTTOM
			},
			allowOverlap: !0,
			wrap: { type: Zt.NONE }
		}
	})] : [];
}, Od = Q(Z(24)), kd = Q(Z(100)), Ad = lu - kd, jd = Q(13), Md = (e) => new R({
	text: e,
	color: $,
	size: Wl
}), Nd = (e) => [Hn(e.title), e.quoteNumber].filter(Boolean).join(" - "), Pd = () => new L({
	spacing: {
		before: Od,
		after: 0,
		line: 1,
		lineRule: Ut.EXACT
	},
	border: { top: {
		style: Mt.SINGLE,
		size: Fl(Z(1)),
		color: Hl,
		space: Z(16)
	} }
}), Fd = (e, t, n) => new Jt({
	width: {
		size: e,
		type: nn.DXA
	},
	verticalAlign: $t.TOP,
	children: [new L({
		alignment: t,
		children: n
	})]
}), Id = (e, t) => new qt({
	columnWidths: [Ad, kd],
	layout: Yt.FIXED,
	borders: Pu,
	margins: Fu,
	rows: [new Xt({
		height: {
			value: jd,
			rule: Lt.EXACT
		},
		children: [Fd(Ad, jt.LEFT, [Md(Nd(e))]), Fd(kd, jt.RIGHT, t)]
	})]
}), Ld = (e, t) => [Pd(), Id(e, t)], Rd = (e) => {
	let t = Kn(e.publishedAt);
	return new Ft({ children: Ld(e, t ? [new R({
		color: $,
		size: Wl,
		children: [t]
	})] : []) });
}, zd = (e) => new Ft({ children: Ld(e, [new R({
	color: $,
	size: Wl,
	children: ["Page ", Gt.CURRENT]
})]) }), Bd = Q(Z(12)), Vd = Q(Z(24)), Hd = Q(Z(8)), Ud = Q(Z(4)), Wd = (e, t) => new Jt({
	width: {
		size: t,
		type: nn.DXA
	},
	borders: Lu,
	margins: {
		top: Bd,
		bottom: Bd,
		left: Bd,
		right: Bd
	},
	children: [new L({
		spacing: { after: Ud },
		children: [new R({
			text: e.title,
			bold: !0,
			color: $
		})]
	}), new L({ children: [new R({
		text: e.value ?? "-",
		color: $
	})] })]
}), Gd = (e) => {
	let t = qn(e.defaultDueDateDays), n = [
		{
			title: B.startDate,
			value: Kn(Wn(e))
		},
		{
			title: B.duration,
			value: In(e.phases)
		},
		{
			title: B.type,
			value: Gn(e.dealType)
		},
		{
			title: B.validUntil,
			value: Kn(e.expiresAt)
		},
		...t ? [{
			title: B.paymentTerms,
			value: t
		}] : []
	], r = nd(n.map(() => 1));
	return [
		new L({
			spacing: {
				before: Vd,
				after: Hd
			},
			children: [new R({
				text: B.heading,
				bold: !0,
				color: $,
				size: Gl
			})]
		}),
		new qt({
			columnWidths: r,
			layout: Yt.FIXED,
			rows: [new Xt({ children: n.map((e, t) => Wd(e, r[t])) })]
		}),
		mu(Vd)
	];
}, Kd = {
	regular: {
		32: 3.05615234375,
		33: 3.05615234375,
		34: 3.90478515625,
		35: 6.11767578125,
		36: 6.11767578125,
		37: 9.78076171875,
		38: 7.3369140625,
		39: 2.10009765625,
		40: 3.6630859375,
		41: 3.6630859375,
		42: 4.28076171875,
		43: 6.423828125,
		44: 3.05615234375,
		45: 3.6630859375,
		46: 3.05615234375,
		47: 3.05615234375,
		48: 6.11767578125,
		49: 6.11767578125,
		50: 6.11767578125,
		51: 6.11767578125,
		52: 6.11767578125,
		53: 6.11767578125,
		54: 6.11767578125,
		55: 6.11767578125,
		56: 6.11767578125,
		57: 6.11767578125,
		58: 3.05615234375,
		59: 3.05615234375,
		60: 6.423828125,
		61: 6.423828125,
		62: 6.423828125,
		63: 6.11767578125,
		64: 11.16650390625,
		65: 7.3369140625,
		66: 7.3369140625,
		67: 7.94384765625,
		68: 7.94384765625,
		69: 7.3369140625,
		70: 6.71923828125,
		71: 8.55615234375,
		72: 7.94384765625,
		73: 3.05615234375,
		74: 5.5,
		75: 7.3369140625,
		76: 6.11767578125,
		77: 9.1630859375,
		78: 7.94384765625,
		79: 8.55615234375,
		80: 7.3369140625,
		81: 8.55615234375,
		82: 7.94384765625,
		83: 7.3369140625,
		84: 6.71923828125,
		85: 7.94384765625,
		86: 7.3369140625,
		87: 10.38232421875,
		88: 7.3369140625,
		89: 7.3369140625,
		90: 6.71923828125,
		91: 3.05615234375,
		92: 3.05615234375,
		93: 3.05615234375,
		94: 5.16162109375,
		95: 6.11767578125,
		96: 3.6630859375,
		97: 6.11767578125,
		98: 6.11767578125,
		99: 5.5,
		100: 6.11767578125,
		101: 6.11767578125,
		102: 3.05615234375,
		103: 6.11767578125,
		104: 6.11767578125,
		105: 2.44384765625,
		106: 2.44384765625,
		107: 5.5,
		108: 2.44384765625,
		109: 9.1630859375,
		110: 6.11767578125,
		111: 6.11767578125,
		112: 6.11767578125,
		113: 6.11767578125,
		114: 3.6630859375,
		115: 5.5,
		116: 3.05615234375,
		117: 6.11767578125,
		118: 5.5,
		119: 7.94384765625,
		120: 5.5,
		121: 5.5,
		122: 5.5,
		123: 3.673828125,
		124: 2.857421875,
		125: 3.673828125,
		126: 6.423828125,
		160: 3.05615234375,
		161: 3.6630859375,
		162: 6.11767578125,
		163: 6.11767578125,
		164: 6.11767578125,
		165: 6.11767578125,
		166: 2.857421875,
		167: 6.11767578125,
		168: 3.6630859375,
		169: 8.10498046875,
		170: 4.0712890625,
		171: 6.11767578125,
		172: 6.423828125,
		173: 3.6630859375,
		174: 8.10498046875,
		175: 6.07470703125,
		176: 4.39892578125,
		177: 6.037109375,
		178: 3.6630859375,
		179: 3.6630859375,
		180: 3.6630859375,
		181: 6.337890625,
		182: 5.908203125,
		183: 3.6630859375,
		184: 3.6630859375,
		185: 3.6630859375,
		186: 4.017578125,
		187: 6.11767578125,
		188: 9.173828125,
		189: 9.173828125,
		190: 9.173828125,
		191: 6.71923828125,
		192: 7.3369140625,
		193: 7.3369140625,
		194: 7.3369140625,
		195: 7.3369140625,
		196: 7.3369140625,
		197: 7.3369140625,
		198: 11,
		199: 7.94384765625,
		200: 7.3369140625,
		201: 7.3369140625,
		202: 7.3369140625,
		203: 7.3369140625,
		204: 3.05615234375,
		205: 3.05615234375,
		206: 3.05615234375,
		207: 3.05615234375,
		208: 7.94384765625,
		209: 7.94384765625,
		210: 8.55615234375,
		211: 8.55615234375,
		212: 8.55615234375,
		213: 8.55615234375,
		214: 8.55615234375,
		215: 6.423828125,
		216: 8.55615234375,
		217: 7.94384765625,
		218: 7.94384765625,
		219: 7.94384765625,
		220: 7.94384765625,
		221: 7.3369140625,
		222: 7.3369140625,
		223: 6.71923828125,
		224: 6.11767578125,
		225: 6.11767578125,
		226: 6.11767578125,
		227: 6.11767578125,
		228: 6.11767578125,
		229: 6.11767578125,
		230: 9.78076171875,
		231: 5.5,
		232: 6.11767578125,
		233: 6.11767578125,
		234: 6.11767578125,
		235: 6.11767578125,
		236: 3.05615234375,
		237: 3.05615234375,
		238: 3.05615234375,
		239: 3.05615234375,
		240: 6.11767578125,
		241: 6.11767578125,
		242: 6.11767578125,
		243: 6.11767578125,
		244: 6.11767578125,
		245: 6.11767578125,
		246: 6.11767578125,
		247: 6.037109375,
		248: 6.71923828125,
		249: 6.11767578125,
		250: 6.11767578125,
		251: 6.11767578125,
		252: 6.11767578125,
		253: 5.5,
		254: 6.11767578125,
		255: 5.5,
		256: 7.3369140625,
		257: 6.11767578125,
		258: 7.3369140625,
		259: 6.11767578125,
		260: 7.3369140625,
		261: 6.11767578125,
		262: 7.94384765625,
		263: 5.5,
		264: 7.94384765625,
		265: 5.5,
		266: 7.94384765625,
		267: 5.5,
		268: 7.94384765625,
		269: 5.5,
		270: 7.94384765625,
		271: 6.76220703125,
		272: 7.94384765625,
		273: 6.11767578125,
		274: 7.3369140625,
		275: 6.11767578125,
		276: 7.3369140625,
		277: 6.11767578125,
		278: 7.3369140625,
		279: 6.11767578125,
		280: 7.3369140625,
		281: 6.11767578125,
		282: 7.3369140625,
		283: 6.11767578125,
		284: 8.55615234375,
		285: 6.11767578125,
		286: 8.55615234375,
		287: 6.11767578125,
		288: 8.55615234375,
		289: 6.11767578125,
		290: 8.55615234375,
		291: 6.11767578125,
		292: 7.94384765625,
		293: 6.11767578125,
		294: 7.94384765625,
		295: 6.11767578125,
		296: 3.05615234375,
		297: 3.05615234375,
		298: 3.05615234375,
		299: 3.05615234375,
		300: 3.05615234375,
		301: 3.05615234375,
		302: 3.05615234375,
		303: 2.44384765625,
		304: 3.05615234375,
		305: 3.05615234375,
		306: 8.08349609375,
		307: 4.88232421875,
		308: 5.5,
		309: 2.44384765625,
		310: 7.3369140625,
		311: 5.5,
		312: 5.5,
		313: 6.11767578125,
		314: 2.44384765625,
		315: 6.11767578125,
		316: 2.44384765625,
		317: 6.11767578125,
		318: 3.20654296875,
		319: 6.11767578125,
		320: 3.673828125,
		321: 6.11767578125,
		322: 2.44384765625,
		323: 7.94384765625,
		324: 6.11767578125,
		325: 7.94384765625,
		326: 6.11767578125,
		327: 7.94384765625,
		328: 6.11767578125,
		329: 6.64404296875,
		330: 7.95458984375,
		331: 6.11767578125,
		332: 8.55615234375,
		333: 6.11767578125,
		334: 8.55615234375,
		335: 6.11767578125,
		336: 8.55615234375,
		337: 6.11767578125,
		338: 11,
		339: 10.38232421875,
		340: 7.94384765625,
		341: 3.6630859375,
		342: 7.94384765625,
		343: 3.6630859375,
		344: 7.94384765625,
		345: 3.6630859375,
		346: 7.3369140625,
		347: 5.5,
		348: 7.3369140625,
		349: 5.5,
		350: 7.3369140625,
		351: 5.5,
		352: 7.3369140625,
		353: 5.5,
		354: 6.71923828125,
		355: 3.05615234375,
		356: 6.71923828125,
		357: 4.125,
		358: 6.71923828125,
		359: 3.05615234375,
		360: 7.94384765625,
		361: 6.11767578125,
		362: 7.94384765625,
		363: 6.11767578125,
		364: 7.94384765625,
		365: 6.11767578125,
		366: 7.94384765625,
		367: 6.11767578125,
		368: 7.94384765625,
		369: 6.11767578125,
		370: 7.94384765625,
		371: 6.11767578125,
		372: 10.38232421875,
		373: 7.94384765625,
		374: 7.3369140625,
		375: 5.5,
		376: 7.3369140625,
		377: 6.71923828125,
		378: 5.5,
		379: 6.71923828125,
		380: 5.5,
		381: 6.71923828125,
		382: 5.5,
		383: 2.44384765625,
		384: 6.11767578125,
		385: 8.34130859375,
		386: 7.21875,
		387: 6.11767578125,
		388: 7.21875,
		389: 6.11767578125,
		390: 7.94384765625,
		391: 7.94384765625,
		392: 5.5,
		393: 7.94384765625,
		394: 8.9052734375,
		395: 7.21875,
		396: 6.11767578125,
		397: 6.123046875,
		398: 7.3369140625,
		399: 8.27685546875,
		400: 6.64404296875,
		401: 6.71923828125,
		402: 6.11767578125,
		403: 8.55615234375,
		404: 6.8642578125,
		405: 9.689453125,
		406: 2.44384765625,
		407: 3.05615234375,
		408: 7.3369140625,
		409: 5.5,
		410: 2.44384765625,
		411: 5.5,
		412: 9.796875,
		413: 7.94384765625,
		414: 6.11767578125,
		415: 8.55615234375,
		416: 9.431640625,
		417: 7.21337890625,
		418: 9.5498046875,
		419: 7.34228515625,
		420: 8.29833984375,
		421: 6.11767578125,
		422: 7.3369140625,
		423: 7.3369140625,
		424: 5.5,
		425: 6.7998046875,
		426: 4.18408203125,
		427: 3.05615234375,
		428: 6.71923828125,
		429: 3.05615234375,
		430: 6.71923828125,
		431: 9.39404296875,
		432: 7.36376953125,
		433: 8.22314453125,
		434: 7.94384765625,
		435: 8.4970703125,
		436: 5.5,
		437: 6.71923828125,
		438: 5.5,
		439: 6.71923828125,
		440: 6.71923828125,
		441: 5.994140625,
		442: 5.994140625,
		443: 6.11767578125,
		444: 6.11767578125,
		445: 5.04345703125,
		446: 5.35498046875,
		447: 6.11767578125,
		448: 2.857421875,
		449: 4.5439453125,
		450: 6.423828125,
		451: 3.05615234375,
		452: 14.6630859375,
		453: 13.44384765625,
		454: 11.537109375,
		455: 11.68212890625,
		456: 9.1630859375,
		457: 4.962890625,
		458: 13.44384765625,
		459: 10.3876953125,
		460: 8.48095703125,
		461: 7.3369140625,
		462: 6.11767578125,
		463: 3.05615234375,
		464: 2.44384765625,
		465: 8.55615234375,
		466: 6.11767578125,
		467: 7.94384765625,
		468: 6.11767578125,
		469: 7.94384765625,
		470: 6.11767578125,
		471: 7.94384765625,
		472: 6.11767578125,
		473: 7.94384765625,
		474: 6.11767578125,
		475: 7.94384765625,
		476: 6.11767578125,
		477: 6.11767578125,
		478: 7.3369140625,
		479: 6.11767578125,
		480: 7.3369140625,
		481: 6.11767578125,
		482: 11,
		483: 9.78076171875,
		484: 8.55615234375,
		485: 6.11767578125,
		486: 8.55615234375,
		487: 6.11767578125,
		488: 7.3369140625,
		489: 5.5,
		490: 8.55615234375,
		491: 6.11767578125,
		492: 8.55615234375,
		493: 6.11767578125,
		494: 6.71923828125,
		495: 5.994140625,
		496: 2.44384765625,
		497: 14.6630859375,
		498: 13.44384765625,
		499: 11.537109375,
		500: 8.55615234375,
		501: 6.11767578125,
		502: 11.3759765625,
		503: 6.7998046875,
		504: 7.94384765625,
		505: 6.11767578125,
		506: 7.3369140625,
		507: 6.11767578125,
		508: 11,
		509: 9.78076171875,
		510: 8.55615234375,
		511: 6.71923828125,
		512: 7.3369140625,
		513: 6.11767578125,
		514: 7.3369140625,
		515: 6.11767578125,
		516: 7.3369140625,
		517: 6.11767578125,
		518: 7.3369140625,
		519: 6.11767578125,
		520: 3.05615234375,
		521: 3.05615234375,
		522: 3.05615234375,
		523: 3.05615234375,
		524: 8.55615234375,
		525: 6.11767578125,
		526: 8.55615234375,
		527: 6.11767578125,
		528: 7.94384765625,
		529: 3.6630859375,
		530: 7.94384765625,
		531: 3.6630859375,
		532: 7.94384765625,
		533: 6.11767578125,
		534: 7.94384765625,
		535: 6.11767578125,
		536: 7.3369140625,
		537: 5.5,
		538: 6.71923828125,
		539: 3.05615234375,
		540: 5.994140625,
		541: 4.8017578125,
		542: 7.94384765625,
		543: 6.11767578125,
		544: 7.7666015625,
		545: 7.498046875,
		546: 6.6494140625,
		547: 6.2197265625,
		548: 6.71923828125,
		549: 5.5,
		550: 7.3369140625,
		551: 6.11767578125,
		552: 7.3369140625,
		553: 6.11767578125,
		554: 8.55615234375,
		555: 6.11767578125,
		556: 8.55615234375,
		557: 6.11767578125,
		558: 8.55615234375,
		559: 6.11767578125,
		560: 8.55615234375,
		561: 6.11767578125,
		562: 7.3369140625,
		563: 5.5,
		564: 3.84033203125,
		565: 7.5302734375,
		566: 4.0390625,
		567: 2.44384765625,
		568: 9.75390625,
		569: 9.75390625,
		570: 7.3369140625,
		571: 7.94384765625,
		572: 5.5,
		573: 6.11767578125,
		574: 6.71923828125,
		575: 5.5,
		576: 5.5,
		577: 6.38623046875,
		578: 4.984375,
		579: 7.3369140625,
		580: 7.94384765625,
		581: 7.34765625,
		582: 7.3369140625,
		583: 6.11767578125,
		584: 5.5,
		585: 2.44384765625,
		586: 8.1103515625,
		587: 6.11767578125,
		588: 7.94384765625,
		589: 3.6630859375,
		590: 7.3369140625,
		591: 5.5,
		592: 6.11767578125,
		593: 6.11767578125,
		594: 6.11767578125,
		595: 6.11767578125,
		596: 5.5,
		597: 5.5,
		598: 6.11767578125,
		599: 6.11767578125,
		600: 6.11767578125,
		601: 6.11767578125,
		602: 8.12646484375,
		603: 5.04345703125,
		604: 5.04345703125,
		605: 6.94482421875,
		606: 5.58056640625,
		607: 3.05615234375,
		608: 6.11767578125,
		609: 6.11767578125,
		610: 6.14453125,
		611: 5.5107421875,
		612: 6.78369140625,
		613: 6.11767578125,
		614: 6.11767578125,
		615: 6.11767578125,
		616: 2.44384765625,
		617: 2.44384765625,
		618: 3.91552734375,
		619: 3.5986328125,
		620: 3.3408203125,
		621: 2.44384765625,
		622: 6.28955078125,
		623: 9.1630859375,
		624: 9.1630859375,
		625: 9.1630859375,
		626: 6.11767578125,
		627: 6.11767578125,
		628: 6.080078125,
		629: 6.11767578125,
		630: 8.69580078125,
		631: 8.58837890625,
		632: 6.0478515625,
		633: 3.6630859375,
		634: 3.6630859375,
		635: 3.6630859375,
		636: 3.6630859375,
		637: 3.6630859375,
		638: 3.6630859375,
		639: 3.6630859375,
		640: 5.95654296875,
		641: 5.95654296875,
		642: 5.5,
		643: 2.44384765625,
		644: 2.857421875,
		645: 2.44384765625,
		646: 3.84033203125,
		647: 3.05615234375,
		648: 3.05615234375,
		649: 6.11767578125,
		650: 6.251953125,
		651: 6.015625,
		652: 5.5,
		653: 7.94384765625,
		654: 5.5,
		655: 5.71484375,
		656: 5.5,
		657: 5.951171875,
		658: 5.994140625,
		659: 5.994140625,
		660: 5.5,
		661: 5.5,
		662: 5.5,
		663: 5.5,
		664: 8.55615234375,
		665: 5.84375,
		666: 5.58056640625,
		667: 6.14453125,
		668: 6.07470703125,
		669: 4.3720703125,
		670: 5.5,
		671: 4.44189453125,
		672: 6.11767578125,
		673: 5.5,
		674: 5.5,
		675: 10.60791015625,
		676: 9.96875,
		677: 11.05908203125,
		678: 7.83642578125,
		679: 4.72119140625,
		680: 7.90625,
		681: 8.400390625,
		682: 7.2724609375,
		683: 6.95556640625,
		684: 5.3388671875,
		685: 5.80078125,
		686: 7.55712890625,
		687: 7.55712890625,
		688: 4.21630859375,
		689: 4.21630859375,
		690: 1.7509765625,
		691: 2.63720703125,
		692: 2.63720703125,
		693: 2.63720703125,
		694: 4.0068359375,
		695: 5.29052734375,
		696: 3.52880859375,
		697: 2.10009765625,
		698: 3.90478515625,
		699: 2.44384765625,
		700: 2.44384765625,
		701: 2.44384765625,
		702: 3.6630859375,
		703: 3.6630859375,
		704: 3.8349609375,
		705: 3.8349609375,
		706: 6.423828125,
		707: 6.423828125,
		708: 6.423828125,
		709: 6.423828125,
		710: 3.6630859375,
		711: 3.6630859375,
		712: 3.6630859375,
		713: 3.6630859375,
		714: 3.6630859375,
		715: 3.6630859375,
		716: 3.6630859375,
		717: 3.6630859375,
		718: 3.6630859375,
		719: 3.6630859375,
		720: 3.05615234375,
		721: 3.05615234375,
		722: 3.6630859375,
		723: 3.6630859375,
		724: 3.6630859375,
		725: 3.6630859375,
		726: 3.6630859375,
		727: 3.6630859375,
		728: 3.6630859375,
		729: 3.6630859375,
		730: 3.6630859375,
		731: 3.6630859375,
		732: 3.6630859375,
		733: 3.6630859375,
		734: 3.6630859375,
		735: 3.6630859375,
		736: 3.544921875,
		737: 1.7294921875,
		738: 3.73828125,
		739: 3.609375,
		740: 3.8349609375,
		741: 4.2109375,
		742: 4.2109375,
		743: 4.2109375,
		744: 4.2109375,
		745: 4.2109375,
		746: 3.6630859375,
		747: 3.6630859375,
		748: 3.6630859375,
		749: 3.6630859375,
		750: 3.6630859375,
		751: 3.6630859375,
		752: 3.6630859375,
		753: 3.6630859375,
		754: 3.6630859375,
		755: 3.6630859375,
		756: 3.6630859375,
		757: 3.6630859375,
		758: 3.6630859375,
		759: 3.6630859375,
		760: 3.05615234375,
		761: 3.6630859375,
		762: 3.6630859375,
		763: 3.6630859375,
		764: 3.6630859375,
		765: 4.3720703125,
		766: 4.3720703125,
		767: 3.6630859375,
		768: 0,
		769: 0,
		770: 0,
		771: 0,
		772: 0,
		773: 0,
		774: 0,
		775: 0,
		776: 0,
		777: 0,
		778: 0,
		779: 0,
		780: 0,
		781: 0,
		782: 0,
		783: 0,
		784: 0,
		785: 0,
		786: 0,
		787: 0,
		788: 0,
		789: 0,
		790: 0,
		791: 0,
		792: 0,
		793: 0,
		794: 0,
		795: 0,
		796: 0,
		797: 0,
		798: 0,
		799: 0,
		800: 0,
		801: 0,
		802: 0,
		803: 0,
		804: 0,
		805: 0,
		806: 0,
		807: 0,
		808: 0,
		809: 0,
		810: 0,
		811: 0,
		812: 0,
		813: 0,
		814: 0,
		815: 0,
		816: 0,
		817: 0,
		818: 0,
		819: 0,
		820: 0,
		821: 0,
		822: 0,
		823: 0,
		824: 0,
		825: 0,
		826: 0,
		827: 0,
		828: 0,
		829: 0,
		830: 0,
		831: 0,
		832: 0,
		833: 0,
		834: 0,
		835: 0,
		836: 0,
		837: 0,
		838: 0,
		839: 0,
		840: 0,
		841: 0,
		842: 0,
		843: 0,
		844: 0,
		845: 0,
		846: 0,
		847: 0,
		848: 0,
		849: 0,
		850: 0,
		851: 0,
		852: 0,
		853: 0,
		854: 0,
		855: 0,
		856: 0,
		857: 0,
		858: 0,
		859: 0,
		860: 0,
		861: 0,
		862: 0,
		863: 0,
		864: 0,
		865: 0,
		866: 0,
		867: 0,
		868: 0,
		869: 0,
		870: 0,
		871: 0,
		872: 0,
		873: 0,
		874: 0,
		875: 0,
		876: 0,
		877: 0,
		878: 0,
		879: 0,
		884: 3.6630859375,
		885: 3.6630859375,
		890: 3.6630859375,
		891: 5.5,
		892: 5.5,
		893: 5.5,
		894: 3.05615234375,
		900: 3.6630859375,
		901: 3.6630859375,
		902: 7.34228515625,
		903: 3.05615234375,
		904: 8.6259765625,
		905: 9.216796875,
		906: 4.2216796875,
		908: 8.5185546875,
		910: 9.41015625,
		911: 8.27685546875,
		912: 2.44384765625,
		913: 7.3369140625,
		914: 7.3369140625,
		915: 6.05859375,
		916: 7.34765625,
		917: 7.3369140625,
		918: 6.71923828125,
		919: 7.94384765625,
		920: 8.55615234375,
		921: 3.05615234375,
		922: 7.3369140625,
		923: 7.34765625,
		924: 9.1630859375,
		925: 7.94384765625,
		926: 7.14892578125,
		927: 8.55615234375,
		928: 7.94384765625,
		929: 7.3369140625,
		931: 6.7998046875,
		932: 6.71923828125,
		933: 7.3369140625,
		934: 8.7763671875,
		935: 7.3369140625,
		936: 9.18994140625,
		937: 8.22314453125,
		938: 3.05615234375,
		939: 7.3369140625,
		940: 6.359375,
		941: 4.90380859375,
		942: 6.11767578125,
		943: 2.44384765625,
		944: 6.015625,
		945: 6.359375,
		946: 6.3271484375,
		947: 5.5,
		948: 6.123046875,
		949: 4.90380859375,
		950: 4.85009765625,
		951: 6.11767578125,
		952: 6.11767578125,
		953: 2.44384765625,
		954: 5.5,
		955: 5.5,
		956: 6.337890625,
		957: 5.5,
		958: 4.92529296875,
		959: 6.11767578125,
		960: 7.58935546875,
		961: 6.25732421875,
		962: 5.30126953125,
		963: 6.7890625,
		964: 4.34521484375,
		965: 6.015625,
		966: 7.1328125,
		967: 5.77392578125,
		968: 7.841796875,
		969: 8.58837890625,
		970: 2.44384765625,
		971: 6.015625,
		972: 6.11767578125,
		973: 6.015625,
		974: 8.58837890625,
		976: 6.3271484375,
		977: 6.015625,
		978: 8.4970703125,
		979: 10.5380859375,
		980: 8.4970703125,
		981: 6.16064453125,
		982: 8.58837890625,
		983: 6.61181640625,
		984: 8.55615234375,
		985: 6.11767578125,
		986: 7.94384765625,
		987: 5.5,
		988: 6.71923828125,
		989: 4.44189453125,
		990: 6.86962890625,
		991: 5.822265625,
		992: 8.31982421875,
		993: 6.34326171875,
		994: 9.796875,
		995: 9.1630859375,
		996: 7.41748046875,
		997: 6.11767578125,
		998: 7.412109375,
		999: 5.5,
		1e3: 7.3369140625,
		1001: 7.3369140625,
		1002: 6.703125,
		1003: 6.55810546875,
		1004: 8.10498046875,
		1005: 6.0908203125,
		1006: 5.1025390625,
		1007: 4.50634765625,
		1008: 6.61181640625,
		1009: 6.30029296875,
		1010: 5.5,
		1011: 2.44384765625,
		1012: 8.55615234375,
		1013: 4.86083984375,
		1014: 4.86083984375,
		1015: 7.3369140625,
		1016: 6.11767578125,
		1017: 7.94384765625,
		1018: 9.1630859375,
		1019: 7.5625,
		1020: 6.25732421875,
		1021: 7.94384765625,
		1022: 7.94384765625,
		1023: 7.94384765625,
		1024: 7.3369140625,
		1025: 7.34228515625,
		1026: 9.51220703125,
		1027: 5.95654296875,
		1028: 7.90625,
		1029: 7.3369140625,
		1030: 3.05615234375,
		1031: 3.05615234375,
		1032: 5.5,
		1033: 11.62841796875,
		1034: 11.11279296875,
		1035: 9.39404296875,
		1036: 6.40771484375,
		1037: 7.90625,
		1038: 6.98779296875,
		1039: 7.90625,
		1040: 7.3369140625,
		1041: 7.21875,
		1042: 7.3369140625,
		1043: 5.95654296875,
		1044: 7.44970703125,
		1045: 7.3369140625,
		1046: 10.15673828125,
		1047: 6.64404296875,
		1048: 7.90625,
		1049: 7.90625,
		1050: 6.40771484375,
		1051: 7.21875,
		1052: 9.1630859375,
		1053: 7.94384765625,
		1054: 8.55615234375,
		1055: 7.90625,
		1056: 7.3369140625,
		1057: 7.94384765625,
		1058: 6.71923828125,
		1059: 6.98779296875,
		1060: 8.36279296875,
		1061: 7.3369140625,
		1062: 8.13720703125,
		1063: 7.33154296875,
		1064: 10.08154296875,
		1065: 10.3125,
		1066: 8.70654296875,
		1067: 9.73779296875,
		1068: 7.21875,
		1069: 7.90625,
		1070: 11.11279296875,
		1071: 7.94384765625,
		1072: 6.11767578125,
		1073: 6.30029296875,
		1074: 5.84375,
		1075: 4.01220703125,
		1076: 6.41845703125,
		1077: 6.11767578125,
		1078: 7.3583984375,
		1079: 5.04345703125,
		1080: 6.14453125,
		1081: 6.14453125,
		1082: 4.8125,
		1083: 6.41845703125,
		1084: 7.5625,
		1085: 6.07470703125,
		1086: 6.11767578125,
		1087: 5.95654296875,
		1088: 6.11767578125,
		1089: 5.5,
		1090: 5.0380859375,
		1091: 5.5,
		1092: 9.05029296875,
		1093: 5.5,
		1094: 6.30029296875,
		1095: 5.73095703125,
		1096: 8.82470703125,
		1097: 9.05029296875,
		1098: 6.875,
		1099: 7.90625,
		1100: 5.73095703125,
		1101: 5.61279296875,
		1102: 8.25,
		1103: 5.95654296875,
		1104: 6.11767578125,
		1105: 6.11767578125,
		1106: 6.11767578125,
		1107: 4.01220703125,
		1108: 5.61279296875,
		1109: 5.5,
		1110: 2.44384765625,
		1111: 3.05615234375,
		1112: 2.44384765625,
		1113: 9.96875,
		1114: 8.9375,
		1115: 6.11767578125,
		1116: 4.8125,
		1117: 6.14453125,
		1118: 5.5,
		1119: 6.07470703125,
		1120: 14.716796875,
		1121: 6.8642578125,
		1122: 8.55615234375,
		1123: 6.74072265625,
		1124: 10.44677734375,
		1125: 7.84716796875,
		1126: 7.34765625,
		1127: 5.5,
		1128: 9.8720703125,
		1129: 7.6484375,
		1130: 9.11474609375,
		1131: 7.53564453125,
		1132: 11.58544921875,
		1133: 9.5390625,
		1134: 6.64404296875,
		1135: 5.04345703125,
		1136: 8.76025390625,
		1137: 7.5732421875,
		1138: 8.55615234375,
		1139: 6.11767578125,
		1140: 8.83544921875,
		1141: 6.939453125,
		1142: 8.83544921875,
		1143: 6.939453125,
		1144: 11.81640625,
		1145: 9.861328125,
		1146: 9.1630859375,
		1147: 6.7353515625,
		1148: 13.10009765625,
		1149: 9.3671875,
		1150: 14.716796875,
		1151: 6.8642578125,
		1152: 7.94384765625,
		1153: 5.5,
		1154: 5.53759765625,
		1155: 0,
		1156: 0,
		1157: 0,
		1158: 0,
		1159: 0,
		1160: 0,
		1161: 0,
		1162: 7.90625,
		1163: 6.14453125,
		1164: 7.21875,
		1165: 5.73095703125,
		1166: 7.3369140625,
		1167: 6.11767578125,
		1168: 5.37646484375,
		1169: 4.5224609375,
		1170: 5.95654296875,
		1171: 4.01220703125,
		1172: 7.37451171875,
		1173: 6.037109375,
		1174: 10.15673828125,
		1175: 7.3583984375,
		1176: 6.64404296875,
		1177: 5.04345703125,
		1178: 6.40771484375,
		1179: 4.8125,
		1180: 6.40771484375,
		1181: 4.8125,
		1182: 6.40771484375,
		1183: 4.8125,
		1184: 8.15869140625,
		1185: 5.89208984375,
		1186: 7.94384765625,
		1187: 6.07470703125,
		1188: 9.67333984375,
		1189: 7.12744140625,
		1190: 12.50390625,
		1191: 9.5712890625,
		1192: 8.2822265625,
		1193: 5.73095703125,
		1194: 7.94384765625,
		1195: 5.5,
		1196: 6.71923828125,
		1197: 5.0380859375,
		1198: 6.11767578125,
		1199: 5.5,
		1200: 6.11767578125,
		1201: 5.5,
		1202: 7.3369140625,
		1203: 5.5,
		1204: 10.17822265625,
		1205: 7.60009765625,
		1206: 7.33154296875,
		1207: 5.73095703125,
		1208: 7.33154296875,
		1209: 5.73095703125,
		1210: 7.33154296875,
		1211: 6.11767578125,
		1212: 9.474609375,
		1213: 7.326171875,
		1214: 9.474609375,
		1215: 7.326171875,
		1216: 3.05615234375,
		1217: 10.15673828125,
		1218: 7.3583984375,
		1219: 7.34228515625,
		1220: 6.05859375,
		1221: 7.21875,
		1222: 6.41845703125,
		1223: 7.94384765625,
		1224: 6.07470703125,
		1225: 7.94384765625,
		1226: 6.07470703125,
		1227: 7.33154296875,
		1228: 5.73095703125,
		1229: 9.1630859375,
		1230: 7.5625,
		1231: 2.44384765625,
		1232: 7.3369140625,
		1233: 6.11767578125,
		1234: 7.3369140625,
		1235: 6.11767578125,
		1236: 11,
		1237: 9.78076171875,
		1238: 7.3369140625,
		1239: 6.11767578125,
		1240: 8.27685546875,
		1241: 6.11767578125,
		1242: 8.27685546875,
		1243: 6.11767578125,
		1244: 10.15673828125,
		1245: 7.3583984375,
		1246: 6.64404296875,
		1247: 5.04345703125,
		1248: 6.64404296875,
		1249: 5.994140625,
		1250: 7.90625,
		1251: 6.14453125,
		1252: 7.90625,
		1253: 6.14453125,
		1254: 8.55615234375,
		1255: 6.11767578125,
		1256: 8.55615234375,
		1257: 6.11767578125,
		1258: 8.55615234375,
		1259: 6.11767578125,
		1260: 7.90625,
		1261: 5.61279296875,
		1262: 6.98779296875,
		1263: 5.5,
		1264: 6.98779296875,
		1265: 5.5,
		1266: 6.98779296875,
		1267: 5.5,
		1268: 7.33154296875,
		1269: 5.73095703125,
		1270: 5.95654296875,
		1271: 4.01220703125,
		1272: 9.73779296875,
		1273: 7.90625,
		1274: 5.95654296875,
		1275: 4.01220703125,
		1276: 7.3369140625,
		1277: 5.5,
		1278: 7.3369140625,
		1279: 5.5,
		1280: 7.21875,
		1281: 6.11767578125,
		1282: 10.65087890625,
		1283: 9.64111328125,
		1284: 10.5166015625,
		1285: 8.9697265625,
		1286: 7.28857421875,
		1287: 5.60205078125,
		1288: 10.67236328125,
		1289: 10.00634765625,
		1290: 11.3759765625,
		1291: 9.66259765625,
		1292: 8.55615234375,
		1293: 6.14453125,
		1294: 8.21240234375,
		1295: 7.32080078125,
		1296: 6.64404296875,
		1297: 5.04345703125,
		1298: 7.21875,
		1299: 6.41845703125,
		1306: 8.55615234375,
		1307: 6.11767578125,
		1308: 10.38232421875,
		1309: 7.94384765625,
		1425: 0,
		1426: 0,
		1427: 0,
		1428: 0,
		1429: 0,
		1430: 0,
		1431: 0,
		1432: 0,
		1433: 0,
		1434: 0,
		1435: 0,
		1436: 0,
		1437: 0,
		1438: 0,
		1439: 0,
		1440: 0,
		1441: 0,
		1442: 0,
		1443: 0,
		1444: 0,
		1445: 0,
		1446: 0,
		1447: 0,
		1448: 0,
		1449: 0,
		1450: 0,
		1451: 0,
		1452: 0,
		1453: 0,
		1454: 0,
		1455: 0,
		1456: 0,
		1457: 0,
		1458: 0,
		1459: 0,
		1460: 0,
		1461: 0,
		1462: 0,
		1463: 0,
		1464: 0,
		1465: 0,
		1466: 0,
		1467: 0,
		1468: 0,
		1469: 0,
		1470: 4.2109375,
		1471: 0,
		1472: 6.19287109375,
		1473: 0,
		1474: 0,
		1475: 3.05615234375,
		1476: 0,
		1477: 0,
		1478: 4.16796875,
		1479: 0,
		1488: 6.9072265625,
		1489: 6.57958984375,
		1490: 4.6513671875,
		1491: 6.09619140625,
		1492: 6.9716796875,
		1493: 2.857421875,
		1494: 3.5556640625,
		1495: 7.240234375,
		1496: 7.18115234375,
		1497: 2.857421875,
		1498: 5.8759765625,
		1499: 5.77392578125,
		1500: 5.82763671875,
		1501: 7.46044921875,
		1502: 7.55712890625,
		1503: 2.857421875,
		1504: 4.28076171875,
		1505: 7.21337890625,
		1506: 6.40234375,
		1507: 6.853515625,
		1508: 6.70849609375,
		1509: 5.54296875,
		1510: 5.994140625,
		1511: 6.48828125,
		1512: 5.8759765625,
		1513: 8.02978515625,
		1514: 7.60009765625,
		1520: 5.5966796875,
		1521: 5.5966796875,
		1522: 5.5966796875,
		1523: 4.232421875,
		1524: 6.63330078125,
		7424: 5.45703125,
		7425: 8.22314453125,
		7426: 9.78076171875,
		7427: 5.84375,
		7428: 5.5,
		7429: 6.06396484375,
		7430: 6.06396484375,
		7431: 5.38720703125,
		7432: 5.04345703125,
		7433: 2.44384765625,
		7434: 4.64599609375,
		7435: 5.5,
		7436: 4.4150390625,
		7437: 7.5625,
		7438: 6.14453125,
		7439: 6.11767578125,
		7440: 5.5,
		7441: 6.6923828125,
		7442: 6.6923828125,
		7443: 6.6923828125,
		7444: 10.38232421875,
		7445: 5.02734375,
		7446: 6.11767578125,
		7447: 6.11767578125,
		7448: 5.73095703125,
		7449: 5.95654296875,
		7450: 5.95654296875,
		7451: 5.0380859375,
		7452: 6.015625,
		7453: 6.5634765625,
		7454: 8.0673828125,
		7455: 6.5634765625,
		7456: 5.5,
		7457: 7.94384765625,
		7458: 5.5,
		7459: 5.04345703125,
		7460: 4.69970703125,
		7461: 6.67626953125,
		7462: 4.01220703125,
		7463: 5.5,
		7464: 5.95654296875,
		7465: 5.73095703125,
		7466: 7.841796875,
		7467: 6.41845703125,
		7468: 4.984375,
		7469: 7.29931640625,
		7470: 4.56005859375,
		7471: 4.56005859375,
		7472: 4.94140625,
		7473: 4.51171875,
		7474: 4.51171875,
		7475: 5.45703125,
		7476: 4.7158203125,
		7477: 1.8369140625,
		7478: 3.458984375,
		7479: 4.6728515625,
		7480: 3.8671875,
		7481: 5.61279296875,
		7482: 4.73193359375,
		7483: 4.72119140625,
		7484: 5.62890625,
		7485: 4.20556640625,
		7486: 4.60302734375,
		7487: 4.962890625,
		7488: 4.7587890625,
		7489: 4.72119140625,
		7490: 6.84814453125,
		7491: 4.0927734375,
		7492: 4.0927734375,
		7493: 4.146484375,
		7494: 6.595703125,
		7495: 4.15185546875,
		7496: 4.15185546875,
		7497: 4.08740234375,
		7498: 4.08740234375,
		7499: 3.501953125,
		7500: 3.501953125,
		7501: 4.146484375,
		7502: 1.7294921875,
		7503: 3.7275390625,
		7504: 6.30029296875,
		7505: 4.20556640625,
		7506: 4.15185546875,
		7507: 3.89404296875,
		7508: 4.15185546875,
		7509: 4.15185546875,
		7510: 4.1572265625,
		7511: 2.4169921875,
		7512: 4.20556640625,
		7513: 4.4794921875,
		7514: 6.30029296875,
		7515: 3.5341796875,
		7516: 4.296875,
		7517: 4.23779296875,
		7518: 3.5341796875,
		7519: 4.1572265625,
		7520: 4.83935546875,
		7521: 3.77587890625,
		7522: 1.7294921875,
		7523: 2.63720703125,
		7524: 4.20556640625,
		7525: 3.5341796875,
		7526: 4.23779296875,
		7527: 3.5341796875,
		7528: 4.17333984375,
		7529: 4.83935546875,
		7530: 3.77587890625,
		7531: 9.990234375,
		7532: 6.11767578125,
		7533: 6.11767578125,
		7534: 3.05615234375,
		7535: 9.1630859375,
		7536: 6.11767578125,
		7537: 6.11767578125,
		7538: 3.6630859375,
		7539: 3.6630859375,
		7540: 5.5,
		7541: 3.05615234375,
		7542: 5.5,
		7543: 6.11767578125,
		7544: 4.18408203125,
		7545: 6.123046875,
		7546: 8.64208984375,
		7547: 2.44384765625,
		7548: 2.44384765625,
		7549: 6.11767578125,
		7550: 6.015625,
		7551: 6.251953125,
		7552: 6.11767578125,
		7553: 6.11767578125,
		7554: 3.05615234375,
		7555: 7.841796875,
		7556: 5.5,
		7557: 2.44384765625,
		7558: 9.1630859375,
		7559: 6.11767578125,
		7560: 6.11767578125,
		7561: 3.6630859375,
		7562: 5.5,
		7563: 4.25390625,
		7564: 5.5,
		7565: 5.5,
		7566: 5.5,
		7567: 6.11767578125,
		7568: 6.11767578125,
		7569: 6.11767578125,
		7570: 6.11767578125,
		7571: 5.04345703125,
		7572: 5.04345703125,
		7573: 7.154296875,
		7574: 2.44384765625,
		7575: 5.5,
		7576: 2.44384765625,
		7577: 6.11767578125,
		7578: 5.994140625,
		7579: 4.146484375,
		7580: 3.89404296875,
		7581: 3.82958984375,
		7582: 4.103515625,
		7583: 3.501953125,
		7584: 2.51904296875,
		7585: 2.51904296875,
		7586: 4.146484375,
		7587: 4.21630859375,
		7588: 1.7294921875,
		7589: 1.7294921875,
		7590: 1.7294921875,
		7591: 1.7294921875,
		7592: 2.9755859375,
		7593: 1.7294921875,
		7594: 1.7294921875,
		7595: 3.02392578125,
		7596: 6.28955078125,
		7597: 6.28955078125,
		7598: 4.20556640625,
		7599: 4.20556640625,
		7600: 4.2001953125,
		7601: 4.15185546875,
		7602: 4.125,
		7603: 3.73828125,
		7604: 1.7294921875,
		7605: 2.4169921875,
		7606: 4.20556640625,
		7607: 4.2646484375,
		7608: 4.1572265625,
		7609: 3.888671875,
		7610: 3.5341796875,
		7611: 3.9423828125,
		7612: 3.9423828125,
		7613: 3.9423828125,
		7614: 4.060546875,
		7615: 4.0068359375,
		7616: 0,
		7617: 0,
		7618: 0,
		7619: 0,
		7620: 0,
		7621: 0,
		7622: 0,
		7623: 0,
		7624: 0,
		7625: 0,
		7626: 0,
		7678: 0,
		7679: 0,
		7680: 7.3369140625,
		7681: 6.11767578125,
		7682: 7.3369140625,
		7683: 6.11767578125,
		7684: 7.3369140625,
		7685: 6.11767578125,
		7686: 7.3369140625,
		7687: 6.11767578125,
		7688: 7.94384765625,
		7689: 5.5,
		7690: 7.94384765625,
		7691: 6.11767578125,
		7692: 7.94384765625,
		7693: 6.11767578125,
		7694: 7.94384765625,
		7695: 6.11767578125,
		7696: 7.94384765625,
		7697: 6.11767578125,
		7698: 7.94384765625,
		7699: 6.11767578125,
		7700: 7.3369140625,
		7701: 6.11767578125,
		7702: 7.3369140625,
		7703: 6.11767578125,
		7704: 7.3369140625,
		7705: 6.11767578125,
		7706: 7.3369140625,
		7707: 6.11767578125,
		7708: 7.3369140625,
		7709: 6.11767578125,
		7710: 6.71923828125,
		7711: 3.05615234375,
		7712: 8.55615234375,
		7713: 6.11767578125,
		7714: 7.94384765625,
		7715: 6.11767578125,
		7716: 7.94384765625,
		7717: 6.11767578125,
		7718: 7.94384765625,
		7719: 6.11767578125,
		7720: 7.94384765625,
		7721: 6.11767578125,
		7722: 7.94384765625,
		7723: 6.11767578125,
		7724: 3.05615234375,
		7725: 2.44384765625,
		7726: 3.05615234375,
		7727: 3.05615234375,
		7728: 7.3369140625,
		7729: 5.5,
		7730: 7.3369140625,
		7731: 5.5,
		7732: 7.3369140625,
		7733: 5.5,
		7734: 6.11767578125,
		7735: 2.44384765625,
		7736: 6.11767578125,
		7737: 2.44384765625,
		7738: 6.11767578125,
		7739: 2.44384765625,
		7740: 6.11767578125,
		7741: 2.44384765625,
		7742: 9.1630859375,
		7743: 9.1630859375,
		7744: 9.1630859375,
		7745: 9.1630859375,
		7746: 9.1630859375,
		7747: 9.1630859375,
		7748: 7.94384765625,
		7749: 6.11767578125,
		7750: 7.94384765625,
		7751: 6.11767578125,
		7752: 7.94384765625,
		7753: 6.11767578125,
		7754: 7.94384765625,
		7755: 6.11767578125,
		7756: 8.55615234375,
		7757: 6.11767578125,
		7758: 8.55615234375,
		7759: 6.11767578125,
		7760: 8.55615234375,
		7761: 6.11767578125,
		7762: 8.55615234375,
		7763: 6.11767578125,
		7764: 7.3369140625,
		7765: 6.11767578125,
		7766: 7.3369140625,
		7767: 6.11767578125,
		7768: 7.94384765625,
		7769: 3.6630859375,
		7770: 7.94384765625,
		7771: 3.6630859375,
		7772: 7.94384765625,
		7773: 3.6630859375,
		7774: 7.94384765625,
		7775: 3.6630859375,
		7776: 7.3369140625,
		7777: 5.5,
		7778: 7.3369140625,
		7779: 5.5,
		7780: 7.3369140625,
		7781: 5.5,
		7782: 7.3369140625,
		7783: 5.5,
		7784: 7.3369140625,
		7785: 5.5,
		7786: 6.71923828125,
		7787: 3.05615234375,
		7788: 6.71923828125,
		7789: 3.05615234375,
		7790: 6.71923828125,
		7791: 3.05615234375,
		7792: 6.71923828125,
		7793: 3.05615234375,
		7794: 7.94384765625,
		7795: 6.11767578125,
		7796: 7.94384765625,
		7797: 6.11767578125,
		7798: 7.94384765625,
		7799: 6.11767578125,
		7800: 7.94384765625,
		7801: 6.11767578125,
		7802: 7.94384765625,
		7803: 6.11767578125,
		7804: 7.3369140625,
		7805: 5.5,
		7806: 7.3369140625,
		7807: 5.5,
		7808: 10.38232421875,
		7809: 7.94384765625,
		7810: 10.38232421875,
		7811: 7.94384765625,
		7812: 10.38232421875,
		7813: 7.94384765625,
		7814: 10.38232421875,
		7815: 7.94384765625,
		7816: 10.38232421875,
		7817: 7.94384765625,
		7818: 7.3369140625,
		7819: 5.5,
		7820: 7.3369140625,
		7821: 5.5,
		7822: 7.3369140625,
		7823: 5.5,
		7824: 6.71923828125,
		7825: 5.5,
		7826: 6.71923828125,
		7827: 5.5,
		7828: 6.71923828125,
		7829: 5.5,
		7830: 6.11767578125,
		7831: 3.05615234375,
		7832: 7.94384765625,
		7833: 5.5,
		7834: 6.11767578125,
		7835: 2.44384765625,
		7838: 7.72900390625,
		7840: 7.3369140625,
		7841: 6.11767578125,
		7842: 7.3369140625,
		7843: 6.11767578125,
		7844: 7.3369140625,
		7845: 6.11767578125,
		7846: 7.3369140625,
		7847: 6.11767578125,
		7848: 7.3369140625,
		7849: 6.11767578125,
		7850: 7.3369140625,
		7851: 6.11767578125,
		7852: 7.3369140625,
		7853: 6.11767578125,
		7854: 7.3369140625,
		7855: 6.11767578125,
		7856: 7.3369140625,
		7857: 6.11767578125,
		7858: 7.3369140625,
		7859: 6.11767578125,
		7860: 7.3369140625,
		7861: 6.11767578125,
		7862: 7.3369140625,
		7863: 6.11767578125,
		7864: 7.3369140625,
		7865: 6.11767578125,
		7866: 7.3369140625,
		7867: 6.11767578125,
		7868: 7.3369140625,
		7869: 6.11767578125,
		7870: 7.3369140625,
		7871: 6.11767578125,
		7872: 7.3369140625,
		7873: 6.11767578125,
		7874: 7.3369140625,
		7875: 6.11767578125,
		7876: 7.3369140625,
		7877: 6.11767578125,
		7878: 7.3369140625,
		7879: 6.11767578125,
		7880: 3.05615234375,
		7881: 2.44384765625,
		7882: 3.05615234375,
		7883: 2.44384765625,
		7884: 8.55615234375,
		7885: 6.11767578125,
		7886: 8.55615234375,
		7887: 6.11767578125,
		7888: 8.55615234375,
		7889: 6.11767578125,
		7890: 8.55615234375,
		7891: 6.11767578125,
		7892: 8.55615234375,
		7893: 6.11767578125,
		7894: 8.55615234375,
		7895: 6.11767578125,
		7896: 8.55615234375,
		7897: 6.11767578125,
		7898: 9.431640625,
		7899: 7.21337890625,
		7900: 9.431640625,
		7901: 7.21337890625,
		7902: 9.431640625,
		7903: 7.21337890625,
		7904: 9.431640625,
		7905: 7.21337890625,
		7906: 9.431640625,
		7907: 7.21337890625,
		7908: 7.94384765625,
		7909: 6.11767578125,
		7910: 7.94384765625,
		7911: 6.11767578125,
		7912: 9.39404296875,
		7913: 7.36376953125,
		7914: 9.39404296875,
		7915: 7.36376953125,
		7916: 9.39404296875,
		7917: 7.36376953125,
		7918: 9.39404296875,
		7919: 7.36376953125,
		7920: 9.39404296875,
		7921: 7.36376953125,
		7922: 7.3369140625,
		7923: 5.5,
		7924: 7.3369140625,
		7925: 5.5,
		7926: 7.3369140625,
		7927: 5.5,
		7928: 7.3369140625,
		7929: 5.5,
		7936: 6.359375,
		7937: 6.359375,
		7938: 6.359375,
		7939: 6.359375,
		7940: 6.359375,
		7941: 6.359375,
		7942: 6.359375,
		7943: 6.359375,
		7944: 7.3369140625,
		7945: 7.3369140625,
		7946: 8.9482421875,
		7947: 8.9482421875,
		7948: 8.9482421875,
		7949: 8.9482421875,
		7950: 8.9482421875,
		7951: 8.9482421875,
		7952: 4.90380859375,
		7953: 4.90380859375,
		7954: 4.90380859375,
		7955: 4.90380859375,
		7956: 4.90380859375,
		7957: 4.90380859375,
		7960: 8.4111328125,
		7961: 8.4111328125,
		7962: 10.205078125,
		7963: 10.205078125,
		7964: 10.205078125,
		7965: 10.205078125,
		7968: 6.11767578125,
		7969: 6.11767578125,
		7970: 6.11767578125,
		7971: 6.11767578125,
		7972: 6.11767578125,
		7973: 6.11767578125,
		7974: 6.11767578125,
		7975: 6.11767578125,
		7976: 9.01806640625,
		7977: 9.01806640625,
		7978: 11.16650390625,
		7979: 11.16650390625,
		7980: 11.16650390625,
		7981: 11.16650390625,
		7982: 11.16650390625,
		7983: 11.16650390625,
		7984: 2.44384765625,
		7985: 2.44384765625,
		7986: 2.44384765625,
		7987: 2.44384765625,
		7988: 2.44384765625,
		7989: 2.44384765625,
		7990: 2.44384765625,
		7991: 2.44384765625,
		7992: 4.13037109375,
		7993: 4.13037109375,
		7994: 6.27880859375,
		7995: 6.27880859375,
		7996: 6.27880859375,
		7997: 6.27880859375,
		7998: 6.27880859375,
		7999: 6.27880859375,
		8e3: 6.11767578125,
		8001: 6.11767578125,
		8002: 6.11767578125,
		8003: 6.11767578125,
		8004: 6.11767578125,
		8005: 6.11767578125,
		8008: 9.09326171875,
		8009: 9.09326171875,
		8010: 11.24169921875,
		8011: 11.24169921875,
		8012: 10.70458984375,
		8013: 10.70458984375,
		8016: 6.015625,
		8017: 6.015625,
		8018: 6.015625,
		8019: 6.015625,
		8020: 6.015625,
		8021: 6.015625,
		8022: 6.015625,
		8023: 6.015625,
		8025: 8.9482421875,
		8027: 10.5595703125,
		8029: 11.0966796875,
		8031: 10.5595703125,
		8032: 8.58837890625,
		8033: 8.58837890625,
		8034: 8.58837890625,
		8035: 8.58837890625,
		8036: 8.58837890625,
		8037: 8.58837890625,
		8038: 8.58837890625,
		8039: 8.58837890625,
		8040: 8.76025390625,
		8041: 8.76025390625,
		8042: 10.90869140625,
		8043: 10.90869140625,
		8044: 10.37158203125,
		8045: 10.37158203125,
		8046: 10.37158203125,
		8047: 10.37158203125,
		8048: 6.359375,
		8049: 6.359375,
		8050: 4.90380859375,
		8051: 4.90380859375,
		8052: 6.11767578125,
		8053: 6.11767578125,
		8054: 2.44384765625,
		8055: 2.44384765625,
		8056: 6.11767578125,
		8057: 6.11767578125,
		8058: 6.015625,
		8059: 6.015625,
		8060: 8.58837890625,
		8061: 8.58837890625,
		8064: 6.359375,
		8065: 6.359375,
		8066: 6.359375,
		8067: 6.359375,
		8068: 6.359375,
		8069: 6.359375,
		8070: 6.359375,
		8071: 6.359375,
		8072: 7.3369140625,
		8073: 7.3369140625,
		8074: 8.9482421875,
		8075: 8.9482421875,
		8076: 8.9482421875,
		8077: 8.9482421875,
		8078: 8.9482421875,
		8079: 8.9482421875,
		8080: 6.11767578125,
		8081: 6.11767578125,
		8082: 6.11767578125,
		8083: 6.11767578125,
		8084: 6.11767578125,
		8085: 6.11767578125,
		8086: 6.11767578125,
		8087: 6.11767578125,
		8088: 9.01806640625,
		8089: 9.01806640625,
		8090: 11.16650390625,
		8091: 11.16650390625,
		8092: 11.16650390625,
		8093: 11.16650390625,
		8094: 11.16650390625,
		8095: 11.16650390625,
		8096: 8.58837890625,
		8097: 8.58837890625,
		8098: 8.58837890625,
		8099: 8.58837890625,
		8100: 8.58837890625,
		8101: 8.58837890625,
		8102: 8.58837890625,
		8103: 8.58837890625,
		8104: 8.76025390625,
		8105: 8.76025390625,
		8106: 10.90869140625,
		8107: 10.90869140625,
		8108: 10.37158203125,
		8109: 10.37158203125,
		8110: 10.37158203125,
		8111: 10.37158203125,
		8112: 6.359375,
		8113: 6.359375,
		8114: 6.359375,
		8115: 6.359375,
		8116: 6.359375,
		8118: 6.359375,
		8119: 6.359375,
		8120: 7.3369140625,
		8121: 7.3369140625,
		8122: 7.3369140625,
		8123: 7.3369140625,
		8124: 7.3369140625,
		8125: 3.6630859375,
		8126: 3.6630859375,
		8127: 3.6630859375,
		8128: 3.6630859375,
		8129: 3.6630859375,
		8130: 6.11767578125,
		8131: 6.11767578125,
		8132: 6.11767578125,
		8134: 6.11767578125,
		8135: 6.11767578125,
		8136: 8.9482421875,
		8137: 8.9482421875,
		8138: 9.55517578125,
		8139: 9.55517578125,
		8140: 7.94384765625,
		8141: 3.6630859375,
		8142: 3.6630859375,
		8143: 3.6630859375,
		8144: 2.44384765625,
		8145: 2.44384765625,
		8146: 2.44384765625,
		8147: 2.44384765625,
		8150: 2.44384765625,
		8151: 2.44384765625,
		8152: 3.05615234375,
		8153: 3.05615234375,
		8154: 4.66748046875,
		8155: 4.66748046875,
		8157: 3.6630859375,
		8158: 3.6630859375,
		8159: 3.6630859375,
		8160: 6.015625,
		8161: 6.015625,
		8162: 6.015625,
		8163: 6.015625,
		8164: 6.25732421875,
		8165: 6.25732421875,
		8166: 6.015625,
		8167: 6.015625,
		8168: 7.3369140625,
		8169: 7.3369140625,
		8170: 9.4853515625,
		8171: 9.75390625,
		8172: 8.4111328125,
		8173: 3.6630859375,
		8174: 3.6630859375,
		8175: 3.6630859375,
		8178: 8.58837890625,
		8179: 8.58837890625,
		8180: 8.58837890625,
		8182: 8.58837890625,
		8183: 8.58837890625,
		8184: 10.16748046875,
		8185: 9.09326171875,
		8186: 9.83447265625,
		8187: 8.76025390625,
		8188: 8.22314453125,
		8189: 3.6630859375,
		8190: 3.6630859375,
		8192: 5.5,
		8193: 11,
		8194: 5.5,
		8195: 11,
		8196: 3.66845703125,
		8197: 2.75,
		8198: 1.83154296875,
		8199: 6.11767578125,
		8200: 3.05615234375,
		8201: 2.2021484375,
		8202: .91845703125,
		8203: 0,
		8204: 0,
		8205: 0,
		8206: 0,
		8207: 0,
		8210: 6.11767578125,
		8211: 6.11767578125,
		8212: 11,
		8213: 11,
		8214: 4.5439453125,
		8215: 6.07470703125,
		8216: 2.44384765625,
		8217: 2.44384765625,
		8218: 2.44384765625,
		8219: 2.44384765625,
		8220: 3.6630859375,
		8221: 3.6630859375,
		8222: 3.6630859375,
		8223: 3.6630859375,
		8224: 6.11767578125,
		8225: 6.11767578125,
		8226: 3.85107421875,
		8230: 11,
		8234: 0,
		8235: 0,
		8236: 0,
		8237: 0,
		8238: 0,
		8239: 2.2021484375,
		8240: 11,
		8242: 2.0625,
		8243: 3.89404296875,
		8244: 3.89404296875,
		8249: 3.6630859375,
		8250: 3.6630859375,
		8252: 5.5,
		8254: 3.6630859375,
		8260: 1.8369140625,
		8286: 3.05615234375,
		8298: 0,
		8299: 0,
		8300: 0,
		8301: 0,
		8302: 0,
		8303: 0,
		8308: 3.6630859375,
		8309: 3.6630859375,
		8311: 3.6630859375,
		8312: 3.6630859375,
		8319: 4.01220703125,
		8336: 4.0927734375,
		8337: 4.08740234375,
		8338: 4.15185546875,
		8339: 3.609375,
		8340: 4.08740234375,
		8352: 6.11767578125,
		8353: 7.94384765625,
		8354: 7.94384765625,
		8355: 6.11767578125,
		8356: 6.11767578125,
		8357: 9.1630859375,
		8358: 7.94384765625,
		8359: 12.03125,
		8360: 12.8046875,
		8361: 10.38232421875,
		8362: 9.34033203125,
		8363: 5.64501953125,
		8364: 6.11767578125,
		8365: 7.3369140625,
		8366: 6.71923828125,
		8367: 11,
		8368: 5.73095703125,
		8369: 7.3369140625,
		8370: 8.55615234375,
		8371: 7.3369140625,
		8372: 6.11767578125,
		8373: 7.94384765625,
		8432: 0,
		8453: 9.73779296875,
		8467: 3.5556640625,
		8470: 11.80029296875,
		8471: 8.10498046875,
		8482: 11,
		8486: 8.44873046875,
		8494: 6.60107421875,
		8525: 10.37158203125,
		8526: 5.38720703125,
		8531: 9.173828125,
		8532: 9.173828125,
		8539: 9.173828125,
		8540: 9.173828125,
		8541: 9.173828125,
		8542: 9.173828125,
		8580: 5.5,
		8592: 11,
		8593: 5.5,
		8594: 11,
		8595: 5.5,
		8596: 11,
		8597: 5.5,
		8616: 5.5,
		8706: 5.435546875,
		8710: 6.72998046875,
		8719: 9.0556640625,
		8721: 7.841796875,
		8722: 6.423828125,
		8725: 1.8369140625,
		8729: 3.05615234375,
		8730: 6.037109375,
		8734: 7.841796875,
		8735: 10.76904296875,
		8745: 7.90625,
		8747: 3.01318359375,
		8776: 6.037109375,
		8800: 6.037109375,
		8801: 6.41845703125,
		8804: 6.037109375,
		8805: 6.037109375,
		8962: 6.64404296875,
		8976: 6.423828125,
		8992: 6.64404296875,
		8993: 6.64404296875,
		9472: 7.79345703125,
		9474: 6.875,
		9484: 7.79345703125,
		9488: 7.79345703125,
		9492: 7.79345703125,
		9496: 7.79345703125,
		9500: 7.79345703125,
		9508: 7.79345703125,
		9516: 7.79345703125,
		9524: 7.79345703125,
		9532: 7.79345703125,
		9552: 7.79345703125,
		9553: 7.79345703125,
		9554: 7.79345703125,
		9555: 7.79345703125,
		9556: 7.79345703125,
		9557: 7.79345703125,
		9558: 7.79345703125,
		9559: 7.79345703125,
		9560: 7.79345703125,
		9561: 7.79345703125,
		9562: 7.79345703125,
		9563: 7.79345703125,
		9564: 7.79345703125,
		9565: 7.79345703125,
		9566: 7.79345703125,
		9567: 7.79345703125,
		9568: 7.79345703125,
		9569: 7.79345703125,
		9570: 7.79345703125,
		9571: 7.79345703125,
		9572: 7.79345703125,
		9573: 7.79345703125,
		9574: 7.79345703125,
		9575: 7.79345703125,
		9576: 7.79345703125,
		9577: 7.79345703125,
		9578: 7.79345703125,
		9579: 7.79345703125,
		9580: 7.79345703125,
		9600: 7.79345703125,
		9604: 7.79345703125,
		9608: 7.79345703125,
		9612: 7.79345703125,
		9616: 7.79345703125,
		9617: 7.79345703125,
		9618: 7.79345703125,
		9619: 8.01904296875,
		9632: 6.64404296875,
		9633: 6.64404296875,
		9642: 3.8994140625,
		9643: 3.8994140625,
		9644: 11,
		9650: 10.88720703125,
		9658: 10.88720703125,
		9660: 10.88720703125,
		9668: 10.88720703125,
		9674: 5.435546875,
		9675: 6.64404296875,
		9676: 6.53662109375,
		9679: 6.64404296875,
		9688: 6.64404296875,
		9689: 6.64404296875,
		9702: 3.8994140625,
		9786: 11.23095703125,
		9787: 11.57470703125,
		9788: 10.08154296875,
		9792: 8.25,
		9794: 8.25,
		9824: 5.84375,
		9827: 7.21875,
		9829: 6.53125,
		9830: 5.61279296875,
		9834: 5.5,
		9835: 8.25,
		9839: 5.5,
		11360: 6.11767578125,
		11361: 2.44384765625,
		11362: 6.11767578125,
		11363: 7.3369140625,
		11364: 7.94384765625,
		11365: 6.11767578125,
		11366: 3.05615234375,
		11367: 7.94384765625,
		11368: 6.11767578125,
		11369: 7.3369140625,
		11370: 5.5,
		11371: 6.71923828125,
		11372: 5.5,
		11373: 8.056640625,
		11377: 6.5634765625,
		11378: 11.408203125,
		11379: 9.2490234375,
		11380: 5.5,
		11381: 6.3486328125,
		11382: 4.67822265625,
		11383: 7.1328125,
		11799: 3.6630859375,
		42775: 0,
		42776: 0,
		42777: 0,
		42778: 0,
		42779: 5.5,
		42780: 5.5,
		42781: 3.05615234375,
		42782: 3.05615234375,
		42783: 3.05615234375,
		42784: 0,
		42785: 0,
		42888: 3.6630859375,
		42889: 3.05615234375,
		42890: 4.8125,
		42891: 2.10009765625,
		42892: 2.10009765625,
		64257: 5.5,
		64258: 5.5,
		64285: 2.857421875,
		64286: 0,
		64287: 5.5966796875,
		64288: 6.40234375,
		64289: 6.9072265625,
		64290: 6.09619140625,
		64291: 6.9716796875,
		64292: 5.77392578125,
		64293: 5.82763671875,
		64294: 7.46044921875,
		64295: 5.8759765625,
		64296: 7.60009765625,
		64297: 6.18212890625,
		64298: 8.02978515625,
		64299: 8.02978515625,
		64300: 8.02978515625,
		64301: 8.02978515625,
		64302: 6.9072265625,
		64303: 6.9072265625,
		64304: 6.9072265625,
		64305: 6.57958984375,
		64306: 4.6513671875,
		64307: 6.09619140625,
		64308: 6.9716796875,
		64309: 2.857421875,
		64310: 3.5556640625,
		64312: 7.18115234375,
		64313: 2.857421875,
		64314: 5.8759765625,
		64315: 5.77392578125,
		64316: 5.82763671875,
		64318: 7.55712890625,
		64320: 4.28076171875,
		64321: 7.21337890625,
		64323: 6.853515625,
		64324: 6.70849609375,
		64326: 5.994140625,
		64327: 6.48828125,
		64328: 5.8759765625,
		64329: 8.02978515625,
		64330: 7.60009765625,
		64331: 2.857421875,
		64332: 6.57958984375,
		64333: 5.77392578125,
		64334: 6.70849609375,
		64335: 6.9072265625,
		65056: 0,
		65057: 0,
		65058: 0,
		65059: 0,
		65532: 11,
		avg: 5.785990840575959
	},
	bold: {
		32: 3.05615234375,
		33: 3.6630859375,
		34: 5.21533203125,
		35: 6.11767578125,
		36: 6.11767578125,
		37: 9.78076171875,
		38: 7.94384765625,
		39: 2.61572265625,
		40: 3.6630859375,
		41: 3.6630859375,
		42: 4.28076171875,
		43: 6.423828125,
		44: 3.05615234375,
		45: 3.6630859375,
		46: 3.05615234375,
		47: 3.05615234375,
		48: 6.11767578125,
		49: 6.11767578125,
		50: 6.11767578125,
		51: 6.11767578125,
		52: 6.11767578125,
		53: 6.11767578125,
		54: 6.11767578125,
		55: 6.11767578125,
		56: 6.11767578125,
		57: 6.11767578125,
		58: 3.6630859375,
		59: 3.6630859375,
		60: 6.423828125,
		61: 6.423828125,
		62: 6.423828125,
		63: 6.71923828125,
		64: 10.72607421875,
		65: 7.94384765625,
		66: 7.94384765625,
		67: 7.94384765625,
		68: 7.94384765625,
		69: 7.3369140625,
		70: 6.71923828125,
		71: 8.55615234375,
		72: 7.94384765625,
		73: 3.05615234375,
		74: 6.11767578125,
		75: 7.94384765625,
		76: 6.71923828125,
		77: 9.1630859375,
		78: 7.94384765625,
		79: 8.55615234375,
		80: 7.3369140625,
		81: 8.55615234375,
		82: 7.94384765625,
		83: 7.3369140625,
		84: 6.71923828125,
		85: 7.94384765625,
		86: 7.3369140625,
		87: 10.38232421875,
		88: 7.3369140625,
		89: 7.3369140625,
		90: 6.71923828125,
		91: 3.6630859375,
		92: 3.05615234375,
		93: 3.6630859375,
		94: 6.423828125,
		95: 6.11767578125,
		96: 3.6630859375,
		97: 6.11767578125,
		98: 6.71923828125,
		99: 6.11767578125,
		100: 6.71923828125,
		101: 6.11767578125,
		102: 3.6630859375,
		103: 6.71923828125,
		104: 6.71923828125,
		105: 3.05615234375,
		106: 3.05615234375,
		107: 6.11767578125,
		108: 3.05615234375,
		109: 9.78076171875,
		110: 6.71923828125,
		111: 6.71923828125,
		112: 6.71923828125,
		113: 6.71923828125,
		114: 4.28076171875,
		115: 6.11767578125,
		116: 3.6630859375,
		117: 6.71923828125,
		118: 6.11767578125,
		119: 8.55615234375,
		120: 6.11767578125,
		121: 6.11767578125,
		122: 5.5,
		123: 4.28076171875,
		124: 3.07763671875,
		125: 4.28076171875,
		126: 6.423828125,
		160: 3.05615234375,
		161: 3.6630859375,
		162: 6.11767578125,
		163: 6.11767578125,
		164: 6.11767578125,
		165: 6.11767578125,
		166: 3.07763671875,
		167: 6.11767578125,
		168: 3.6630859375,
		169: 8.10498046875,
		170: 4.0712890625,
		171: 6.11767578125,
		172: 6.423828125,
		173: 3.6630859375,
		174: 8.10498046875,
		175: 6.07470703125,
		176: 4.39892578125,
		177: 6.037109375,
		178: 3.6630859375,
		179: 3.6630859375,
		180: 3.6630859375,
		181: 6.337890625,
		182: 6.11767578125,
		183: 3.6630859375,
		184: 3.6630859375,
		185: 3.6630859375,
		186: 4.017578125,
		187: 6.11767578125,
		188: 9.173828125,
		189: 9.173828125,
		190: 9.173828125,
		191: 6.71923828125,
		192: 7.94384765625,
		193: 7.94384765625,
		194: 7.94384765625,
		195: 7.94384765625,
		196: 7.94384765625,
		197: 7.94384765625,
		198: 11,
		199: 7.94384765625,
		200: 7.3369140625,
		201: 7.3369140625,
		202: 7.3369140625,
		203: 7.3369140625,
		204: 3.05615234375,
		205: 3.05615234375,
		206: 3.05615234375,
		207: 3.05615234375,
		208: 7.94384765625,
		209: 7.94384765625,
		210: 8.55615234375,
		211: 8.55615234375,
		212: 8.55615234375,
		213: 8.55615234375,
		214: 8.55615234375,
		215: 6.423828125,
		216: 8.55615234375,
		217: 7.94384765625,
		218: 7.94384765625,
		219: 7.94384765625,
		220: 7.94384765625,
		221: 7.3369140625,
		222: 7.3369140625,
		223: 6.71923828125,
		224: 6.11767578125,
		225: 6.11767578125,
		226: 6.11767578125,
		227: 6.11767578125,
		228: 6.11767578125,
		229: 6.11767578125,
		230: 9.78076171875,
		231: 6.11767578125,
		232: 6.11767578125,
		233: 6.11767578125,
		234: 6.11767578125,
		235: 6.11767578125,
		236: 3.05615234375,
		237: 3.05615234375,
		238: 3.05615234375,
		239: 3.05615234375,
		240: 6.71923828125,
		241: 6.71923828125,
		242: 6.71923828125,
		243: 6.71923828125,
		244: 6.71923828125,
		245: 6.71923828125,
		246: 6.71923828125,
		247: 6.037109375,
		248: 6.71923828125,
		249: 6.71923828125,
		250: 6.71923828125,
		251: 6.71923828125,
		252: 6.71923828125,
		253: 6.11767578125,
		254: 6.71923828125,
		255: 6.11767578125,
		256: 7.94384765625,
		257: 6.11767578125,
		258: 7.94384765625,
		259: 6.11767578125,
		260: 7.94384765625,
		261: 6.11767578125,
		262: 7.94384765625,
		263: 6.11767578125,
		264: 7.94384765625,
		265: 6.11767578125,
		266: 7.94384765625,
		267: 6.11767578125,
		268: 7.94384765625,
		269: 6.11767578125,
		270: 7.94384765625,
		271: 7.90625,
		272: 7.94384765625,
		273: 6.71923828125,
		274: 7.3369140625,
		275: 6.11767578125,
		276: 7.3369140625,
		277: 6.11767578125,
		278: 7.3369140625,
		279: 6.11767578125,
		280: 7.3369140625,
		281: 6.11767578125,
		282: 7.3369140625,
		283: 6.11767578125,
		284: 8.55615234375,
		285: 6.71923828125,
		286: 8.55615234375,
		287: 6.71923828125,
		288: 8.55615234375,
		289: 6.71923828125,
		290: 8.55615234375,
		291: 6.71923828125,
		292: 7.94384765625,
		293: 6.71923828125,
		294: 7.94384765625,
		295: 6.71923828125,
		296: 3.05615234375,
		297: 3.05615234375,
		298: 3.05615234375,
		299: 3.05615234375,
		300: 3.05615234375,
		301: 3.05615234375,
		302: 3.05615234375,
		303: 3.05615234375,
		304: 3.05615234375,
		305: 3.05615234375,
		306: 8.63134765625,
		307: 6.11767578125,
		308: 6.11767578125,
		309: 3.05615234375,
		310: 7.94384765625,
		311: 6.11767578125,
		312: 6.11767578125,
		313: 6.71923828125,
		314: 3.05615234375,
		315: 6.71923828125,
		316: 3.05615234375,
		317: 6.71923828125,
		318: 4.23779296875,
		319: 6.71923828125,
		320: 5.26904296875,
		321: 6.71923828125,
		322: 3.05615234375,
		323: 7.94384765625,
		324: 6.71923828125,
		325: 7.94384765625,
		326: 6.71923828125,
		327: 7.94384765625,
		328: 6.71923828125,
		329: 7.79345703125,
		330: 7.95458984375,
		331: 6.71923828125,
		332: 8.55615234375,
		333: 6.71923828125,
		334: 8.55615234375,
		335: 6.71923828125,
		336: 8.55615234375,
		337: 6.71923828125,
		338: 11,
		339: 10.38232421875,
		340: 7.94384765625,
		341: 4.28076171875,
		342: 7.94384765625,
		343: 4.28076171875,
		344: 7.94384765625,
		345: 4.28076171875,
		346: 7.3369140625,
		347: 6.11767578125,
		348: 7.3369140625,
		349: 6.11767578125,
		350: 7.3369140625,
		351: 6.11767578125,
		352: 7.3369140625,
		353: 6.11767578125,
		354: 6.71923828125,
		355: 3.6630859375,
		356: 6.71923828125,
		357: 5.26904296875,
		358: 6.71923828125,
		359: 3.6630859375,
		360: 7.94384765625,
		361: 6.71923828125,
		362: 7.94384765625,
		363: 6.71923828125,
		364: 7.94384765625,
		365: 6.71923828125,
		366: 7.94384765625,
		367: 6.71923828125,
		368: 7.94384765625,
		369: 6.71923828125,
		370: 7.94384765625,
		371: 6.71923828125,
		372: 10.38232421875,
		373: 8.55615234375,
		374: 7.3369140625,
		375: 6.11767578125,
		376: 7.3369140625,
		377: 6.71923828125,
		378: 5.5,
		379: 6.71923828125,
		380: 5.5,
		381: 6.71923828125,
		382: 5.5,
		383: 3.05615234375,
		384: 6.71923828125,
		385: 9.20068359375,
		386: 7.90625,
		387: 6.71923828125,
		388: 7.90625,
		389: 6.71923828125,
		390: 7.94384765625,
		391: 7.94384765625,
		392: 6.11767578125,
		393: 7.94384765625,
		394: 9.21142578125,
		395: 7.90625,
		396: 6.71923828125,
		397: 6.6708984375,
		398: 7.3369140625,
		399: 7.98681640625,
		400: 6.89111328125,
		401: 6.71923828125,
		402: 6.11767578125,
		403: 8.55615234375,
		404: 7.00390625,
		405: 10.2373046875,
		406: 3.05615234375,
		407: 3.05615234375,
		408: 7.94384765625,
		409: 6.11767578125,
		410: 3.05615234375,
		411: 6.11767578125,
		412: 10.90869140625,
		413: 7.94384765625,
		414: 6.71923828125,
		415: 8.55615234375,
		416: 9.38330078125,
		417: 7.8203125,
		418: 9.75390625,
		419: 8.18017578125,
		420: 8.59912109375,
		421: 6.71923828125,
		422: 7.3369140625,
		423: 7.3369140625,
		424: 6.11767578125,
		425: 6.60107421875,
		426: 3.95849609375,
		427: 3.6630859375,
		428: 6.71923828125,
		429: 3.6630859375,
		430: 6.71923828125,
		431: 9.12548828125,
		432: 7.96533203125,
		433: 8.8193359375,
		434: 7.94384765625,
		435: 8.47021484375,
		436: 6.11767578125,
		437: 6.71923828125,
		438: 5.5,
		439: 6.71923828125,
		440: 6.71923828125,
		441: 5.7900390625,
		442: 5.7900390625,
		443: 6.11767578125,
		444: 6.11767578125,
		445: 5.4677734375,
		446: 6.3701171875,
		447: 6.71923828125,
		448: 3.07763671875,
		449: 5.47314453125,
		450: 6.42919921875,
		451: 3.6630859375,
		452: 14.6630859375,
		453: 13.44384765625,
		454: 12.21923828125,
		455: 12.8369140625,
		456: 9.775390625,
		457: 6.1123046875,
		458: 14.0615234375,
		459: 11,
		460: 9.775390625,
		461: 7.94384765625,
		462: 6.11767578125,
		463: 3.05615234375,
		464: 3.05615234375,
		465: 8.55615234375,
		466: 6.71923828125,
		467: 7.94384765625,
		468: 6.71923828125,
		469: 7.94384765625,
		470: 6.71923828125,
		471: 7.94384765625,
		472: 6.71923828125,
		473: 7.94384765625,
		474: 6.71923828125,
		475: 7.94384765625,
		476: 6.71923828125,
		477: 6.11767578125,
		478: 7.94384765625,
		479: 6.11767578125,
		480: 7.94384765625,
		481: 6.11767578125,
		482: 11,
		483: 9.78076171875,
		484: 8.55615234375,
		485: 6.71923828125,
		486: 8.55615234375,
		487: 6.71923828125,
		488: 7.94384765625,
		489: 6.11767578125,
		490: 8.55615234375,
		491: 6.71923828125,
		492: 8.55615234375,
		493: 6.71923828125,
		494: 6.71923828125,
		495: 5.7900390625,
		496: 3.05615234375,
		497: 14.6630859375,
		498: 13.44384765625,
		499: 12.21923828125,
		500: 8.55615234375,
		501: 6.71923828125,
		502: 11.35986328125,
		503: 7.3154296875,
		504: 7.94384765625,
		505: 6.71923828125,
		506: 7.94384765625,
		507: 6.11767578125,
		508: 11,
		509: 9.78076171875,
		510: 8.55615234375,
		511: 6.71923828125,
		512: 7.94384765625,
		513: 6.11767578125,
		514: 7.94384765625,
		515: 6.11767578125,
		516: 7.3369140625,
		517: 6.11767578125,
		518: 7.3369140625,
		519: 6.11767578125,
		520: 3.05615234375,
		521: 3.05615234375,
		522: 3.05615234375,
		523: 3.05615234375,
		524: 8.55615234375,
		525: 6.71923828125,
		526: 8.55615234375,
		527: 6.71923828125,
		528: 7.94384765625,
		529: 4.28076171875,
		530: 7.94384765625,
		531: 4.28076171875,
		532: 7.94384765625,
		533: 6.71923828125,
		534: 7.94384765625,
		535: 6.71923828125,
		536: 7.3369140625,
		537: 6.11767578125,
		538: 6.71923828125,
		539: 3.6630859375,
		540: 6.3486328125,
		541: 5.72021484375,
		542: 7.94384765625,
		543: 6.71923828125,
		544: 7.72900390625,
		545: 9.21142578125,
		546: 6.939453125,
		547: 6.939453125,
		548: 6.71923828125,
		549: 5.5,
		550: 7.94384765625,
		551: 6.11767578125,
		552: 7.3369140625,
		553: 6.11767578125,
		554: 8.55615234375,
		555: 6.71923828125,
		556: 8.55615234375,
		557: 6.71923828125,
		558: 8.55615234375,
		559: 6.71923828125,
		560: 8.55615234375,
		561: 6.71923828125,
		562: 7.3369140625,
		563: 6.11767578125,
		564: 5.4892578125,
		565: 9.16845703125,
		566: 5.564453125,
		567: 3.05615234375,
		568: 10.48974609375,
		569: 10.48974609375,
		570: 7.94384765625,
		571: 7.94384765625,
		572: 6.11767578125,
		573: 6.71923828125,
		574: 6.71923828125,
		575: 6.11767578125,
		576: 5.5,
		577: 7.09521484375,
		578: 5.32275390625,
		579: 7.94384765625,
		580: 7.94384765625,
		581: 7.3369140625,
		582: 7.3369140625,
		583: 6.11767578125,
		584: 6.11767578125,
		585: 3.05615234375,
		586: 8.52392578125,
		587: 6.71923828125,
		588: 7.94384765625,
		589: 4.28076171875,
		590: 7.3369140625,
		591: 6.11767578125,
		592: 6.11767578125,
		593: 6.71923828125,
		594: 6.71923828125,
		595: 6.71923828125,
		596: 6.11767578125,
		597: 6.11767578125,
		598: 6.71923828125,
		599: 6.71923828125,
		600: 6.11767578125,
		601: 6.11767578125,
		602: 8.59912109375,
		603: 5.4677734375,
		604: 5.4677734375,
		605: 7.60009765625,
		606: 6.2412109375,
		607: 3.6630859375,
		608: 6.71923828125,
		609: 6.71923828125,
		610: 6.4453125,
		611: 6.11767578125,
		612: 6.6064453125,
		613: 6.71923828125,
		614: 6.71923828125,
		615: 6.71923828125,
		616: 3.05615234375,
		617: 3.05615234375,
		618: 4.4580078125,
		619: 3.65234375,
		620: 3.91552734375,
		621: 3.05615234375,
		622: 6.638671875,
		623: 9.78076171875,
		624: 9.78076171875,
		625: 9.78076171875,
		626: 6.71923828125,
		627: 6.71923828125,
		628: 6.76220703125,
		629: 6.71923828125,
		630: 9.16845703125,
		631: 9.2919921875,
		632: 8.24462890625,
		633: 4.28076171875,
		634: 4.28076171875,
		635: 4.28076171875,
		636: 4.28076171875,
		637: 4.28076171875,
		638: 4.28076171875,
		639: 4.28076171875,
		640: 6.41845703125,
		641: 6.41845703125,
		642: 6.11767578125,
		643: 3.6630859375,
		644: 3.6630859375,
		645: 3.6630859375,
		646: 5.93505859375,
		647: 3.6630859375,
		648: 3.6630859375,
		649: 6.71923828125,
		650: 6.83203125,
		651: 6.40234375,
		652: 6.11767578125,
		653: 8.55615234375,
		654: 6.11767578125,
		655: 6.27880859375,
		656: 5.5,
		657: 7.4765625,
		658: 5.7900390625,
		659: 5.7900390625,
		660: 6.11767578125,
		661: 6.11767578125,
		662: 6.11767578125,
		663: 6.11767578125,
		664: 8.55615234375,
		665: 6.76220703125,
		666: 6.2412109375,
		667: 6.4453125,
		668: 6.64404296875,
		669: 5.04345703125,
		670: 6.11767578125,
		671: 4.9736328125,
		672: 6.71923828125,
		673: 6.11767578125,
		674: 6.11767578125,
		675: 11.33837890625,
		676: 10.36083984375,
		677: 13.31494140625,
		678: 8.9482421875,
		679: 5.8759765625,
		680: 9.06640625,
		681: 9.560546875,
		682: 8.53466796875,
		683: 7.6162109375,
		684: 5.87060546875,
		685: 6.1982421875,
		686: 8.0244140625,
		687: 8.0244140625,
		688: 4.04443359375,
		689: 4.04443359375,
		690: 2.1376953125,
		691: 2.771484375,
		692: 2.771484375,
		693: 2.771484375,
		694: 4.125,
		695: 5.75244140625,
		696: 3.9638671875,
		697: 2.61572265625,
		698: 5.21533203125,
		699: 3.05615234375,
		700: 3.05615234375,
		701: 3.05615234375,
		702: 3.6630859375,
		703: 3.6630859375,
		704: 4.125,
		705: 4.125,
		706: 6.423828125,
		707: 6.423828125,
		708: 6.423828125,
		709: 6.423828125,
		710: 3.6630859375,
		711: 3.6630859375,
		712: 3.6630859375,
		713: 3.6630859375,
		714: 3.6630859375,
		715: 3.6630859375,
		716: 3.6630859375,
		717: 3.6630859375,
		718: 3.6630859375,
		719: 3.6630859375,
		720: 3.6630859375,
		721: 3.6630859375,
		722: 3.6630859375,
		723: 3.6630859375,
		724: 3.6630859375,
		725: 3.6630859375,
		726: 3.6630859375,
		727: 3.6630859375,
		728: 3.6630859375,
		729: 3.6630859375,
		730: 3.6630859375,
		731: 3.6630859375,
		732: 3.6630859375,
		733: 3.6630859375,
		734: 3.6630859375,
		735: 3.6630859375,
		736: 4.02294921875,
		737: 1.55224609375,
		738: 4.1357421875,
		739: 4.0283203125,
		740: 4.125,
		741: 4.2109375,
		742: 4.2109375,
		743: 4.2109375,
		744: 4.2109375,
		745: 4.2109375,
		746: 3.6630859375,
		747: 3.6630859375,
		748: 3.6630859375,
		749: 3.6630859375,
		750: 5.5,
		751: 3.6630859375,
		752: 3.6630859375,
		753: 3.6630859375,
		754: 3.6630859375,
		755: 3.6630859375,
		756: 3.6630859375,
		757: 3.6630859375,
		758: 3.6630859375,
		759: 3.6630859375,
		760: 3.6630859375,
		761: 3.6630859375,
		762: 3.6630859375,
		763: 3.6630859375,
		764: 3.6630859375,
		765: 4.3720703125,
		766: 4.3720703125,
		767: 3.6630859375,
		768: 0,
		769: 0,
		770: 0,
		771: 0,
		772: 0,
		773: 0,
		774: 0,
		775: 0,
		776: 0,
		777: 0,
		778: 0,
		779: 0,
		780: 0,
		781: 0,
		782: 0,
		783: 0,
		784: 0,
		785: 0,
		786: 0,
		787: 0,
		788: 0,
		789: 0,
		790: 0,
		791: 0,
		792: 0,
		793: 0,
		794: 0,
		795: 0,
		796: 0,
		797: 0,
		798: 0,
		799: 0,
		800: 0,
		801: 0,
		802: 0,
		803: 0,
		804: 0,
		805: 0,
		806: 0,
		807: 0,
		808: 0,
		809: 0,
		810: 0,
		811: 0,
		812: 0,
		813: 0,
		814: 0,
		815: 0,
		816: 0,
		817: 0,
		818: 0,
		819: 0,
		820: 0,
		821: 0,
		822: 0,
		823: 0,
		824: 0,
		825: 0,
		826: 0,
		827: 0,
		828: 0,
		829: 0,
		830: 0,
		831: 0,
		832: 0,
		833: 0,
		834: 0,
		835: 0,
		836: 0,
		837: 0,
		838: 0,
		839: 0,
		840: 0,
		841: 0,
		842: 0,
		843: 0,
		844: 0,
		845: 0,
		846: 0,
		847: 0,
		848: 0,
		849: 0,
		850: 0,
		851: 0,
		852: 0,
		853: 0,
		854: 0,
		855: 0,
		856: 0,
		857: 0,
		858: 0,
		859: 0,
		860: 0,
		861: 0,
		862: 0,
		863: 0,
		864: 0,
		865: 0,
		866: 0,
		867: 0,
		868: 0,
		869: 0,
		870: 0,
		871: 0,
		872: 0,
		873: 0,
		874: 0,
		875: 0,
		876: 0,
		877: 0,
		878: 0,
		879: 0,
		884: 3.6630859375,
		885: 3.6630859375,
		890: 3.6630859375,
		891: 6.11767578125,
		892: 6.11767578125,
		893: 6.11767578125,
		894: 3.6630859375,
		900: 3.6630859375,
		901: 5.11328125,
		902: 7.94384765625,
		903: 3.6630859375,
		904: 9.38330078125,
		905: 9.96337890625,
		906: 5.2099609375,
		908: 9.07177734375,
		910: 10.19970703125,
		911: 9.216796875,
		912: 3.05615234375,
		913: 7.94384765625,
		914: 7.94384765625,
		915: 6.61181640625,
		916: 7.90625,
		917: 7.3369140625,
		918: 6.71923828125,
		919: 7.94384765625,
		920: 8.55615234375,
		921: 3.05615234375,
		922: 7.94384765625,
		923: 7.3369140625,
		924: 9.1630859375,
		925: 7.94384765625,
		926: 7.0791015625,
		927: 8.55615234375,
		928: 7.94384765625,
		929: 7.3369140625,
		931: 6.60107421875,
		932: 6.71923828125,
		933: 7.3369140625,
		934: 9.02880859375,
		935: 7.3369140625,
		936: 8.89990234375,
		937: 8.8193359375,
		938: 3.05615234375,
		939: 7.3369140625,
		940: 6.76220703125,
		941: 4.962890625,
		942: 6.71923828125,
		943: 3.05615234375,
		944: 6.40234375,
		945: 6.76220703125,
		946: 6.7138671875,
		947: 6.11767578125,
		948: 6.6708984375,
		949: 5.220703125,
		950: 5.06494140625,
		951: 6.71923828125,
		952: 5.94580078125,
		953: 3.05615234375,
		954: 6.1337890625,
		955: 6.11767578125,
		956: 6.72998046875,
		957: 6.11767578125,
		958: 4.8984375,
		959: 6.71923828125,
		960: 8.421875,
		961: 6.80517578125,
		962: 5.72021484375,
		963: 7.52490234375,
		964: 4.9091796875,
		965: 6.40234375,
		966: 7.86865234375,
		967: 6.33251953125,
		968: 8.28759765625,
		969: 9.2919921875,
		970: 3.05615234375,
		971: 6.40234375,
		972: 6.71923828125,
		973: 6.40234375,
		974: 9.2919921875,
		976: 6.7138671875,
		977: 6.40234375,
		978: 8.47021484375,
		979: 11.0107421875,
		980: 8.47021484375,
		981: 8.24462890625,
		982: 9.2919921875,
		983: 7.43896484375,
		984: 8.55615234375,
		985: 6.71923828125,
		986: 7.94384765625,
		987: 6.11767578125,
		988: 6.71923828125,
		989: 4.9736328125,
		990: 8.26611328125,
		991: 5.822265625,
		992: 8.84619140625,
		993: 6.7138671875,
		994: 10.90869140625,
		995: 9.78076171875,
		996: 7.72900390625,
		997: 6.71923828125,
		998: 7.72900390625,
		999: 6.65478515625,
		1e3: 7.3369140625,
		1001: 7.3369140625,
		1002: 7.068359375,
		1003: 6.638671875,
		1004: 8.08349609375,
		1005: 6.359375,
		1006: 5.5751953125,
		1007: 4.833984375,
		1008: 7.43896484375,
		1009: 6.79443359375,
		1010: 6.11767578125,
		1011: 3.05615234375,
		1012: 8.55615234375,
		1013: 5.263671875,
		1014: 5.263671875,
		1015: 7.3369140625,
		1016: 6.71923828125,
		1017: 7.94384765625,
		1018: 9.1630859375,
		1019: 8.13720703125,
		1020: 6.80517578125,
		1021: 7.94384765625,
		1022: 7.94384765625,
		1023: 7.94384765625,
		1024: 7.3369140625,
		1025: 7.3583984375,
		1026: 9.73779296875,
		1027: 6.23583984375,
		1028: 7.82568359375,
		1029: 7.3369140625,
		1030: 3.05615234375,
		1031: 3.03466796875,
		1032: 6.11767578125,
		1033: 12.03125,
		1034: 11.6875,
		1035: 9.625,
		1036: 6.7138671875,
		1037: 7.90625,
		1038: 6.8427734375,
		1039: 7.90625,
		1040: 7.94384765625,
		1041: 7.90625,
		1042: 7.94384765625,
		1043: 6.23583984375,
		1044: 7.83642578125,
		1045: 7.3369140625,
		1046: 9.94189453125,
		1047: 6.89111328125,
		1048: 7.90625,
		1049: 7.90625,
		1050: 6.7138671875,
		1051: 7.71826171875,
		1052: 9.1630859375,
		1053: 7.94384765625,
		1054: 8.55615234375,
		1055: 7.90625,
		1056: 7.3369140625,
		1057: 7.94384765625,
		1058: 6.71923828125,
		1059: 6.8427734375,
		1060: 9.388671875,
		1061: 7.3369140625,
		1062: 8.03515625,
		1063: 7.72900390625,
		1064: 11.0537109375,
		1065: 11.20947265625,
		1066: 9.56591796875,
		1067: 10.76904296875,
		1068: 7.90625,
		1069: 7.82568359375,
		1070: 11.34375,
		1071: 7.90625,
		1072: 6.11767578125,
		1073: 6.79443359375,
		1074: 6.76220703125,
		1075: 4.58154296875,
		1076: 6.982421875,
		1077: 6.11767578125,
		1078: 7.798828125,
		1079: 5.4677734375,
		1080: 6.76220703125,
		1081: 6.76220703125,
		1082: 5.50537109375,
		1083: 6.98779296875,
		1084: 8.13720703125,
		1085: 6.64404296875,
		1086: 6.71923828125,
		1087: 6.64404296875,
		1088: 6.71923828125,
		1089: 6.11767578125,
		1090: 5.38720703125,
		1091: 6.11767578125,
		1092: 9.625,
		1093: 6.11767578125,
		1094: 6.76220703125,
		1095: 6.38623046875,
		1096: 9.16845703125,
		1097: 9.28125,
		1098: 8.01904296875,
		1099: 9.39404296875,
		1100: 6.76220703125,
		1101: 6.07470703125,
		1102: 9.39404296875,
		1103: 6.41845703125,
		1104: 6.11767578125,
		1105: 6.11767578125,
		1106: 6.71923828125,
		1107: 4.58154296875,
		1108: 6.07470703125,
		1109: 6.11767578125,
		1110: 3.05615234375,
		1111: 3.09375,
		1112: 3.05615234375,
		1113: 10.65625,
		1114: 9.96875,
		1115: 6.71923828125,
		1116: 5.50537109375,
		1117: 6.76220703125,
		1118: 6.11767578125,
		1119: 6.64404296875,
		1120: 14.07763671875,
		1121: 8.5615234375,
		1122: 9.560546875,
		1123: 7.72900390625,
		1124: 10.7314453125,
		1125: 8.7548828125,
		1126: 7.3369140625,
		1127: 6.11767578125,
		1128: 10.18359375,
		1129: 8.80322265625,
		1130: 8.89990234375,
		1131: 8.28759765625,
		1132: 11.8486328125,
		1133: 10.78515625,
		1134: 6.89111328125,
		1135: 5.4677734375,
		1136: 8.89990234375,
		1137: 8.28759765625,
		1138: 8.55615234375,
		1139: 6.71923828125,
		1140: 8.96435546875,
		1141: 7.111328125,
		1142: 8.96435546875,
		1143: 7.111328125,
		1144: 12.3212890625,
		1145: 10.71533203125,
		1146: 8.958984375,
		1147: 7.0146484375,
		1148: 14.07763671875,
		1149: 9.90966796875,
		1150: 14.07763671875,
		1151: 8.5615234375,
		1152: 7.94384765625,
		1153: 6.11767578125,
		1154: 6.423828125,
		1155: 0,
		1156: 0,
		1157: 0,
		1158: 0,
		1159: 0,
		1160: 0,
		1161: 0,
		1162: 7.90625,
		1163: 6.76220703125,
		1164: 7.90625,
		1165: 6.76220703125,
		1166: 7.3369140625,
		1167: 6.71923828125,
		1168: 5.35498046875,
		1169: 4.91455078125,
		1170: 6.23583984375,
		1171: 4.58154296875,
		1172: 7.72900390625,
		1173: 6.57958984375,
		1174: 9.94189453125,
		1175: 7.798828125,
		1176: 6.89111328125,
		1177: 5.4677734375,
		1178: 6.7138671875,
		1179: 5.50537109375,
		1180: 6.7138671875,
		1181: 5.50537109375,
		1182: 6.7138671875,
		1183: 5.50537109375,
		1184: 8.37353515625,
		1185: 6.853515625,
		1186: 7.94384765625,
		1187: 6.64404296875,
		1188: 9.67333984375,
		1189: 7.8525390625,
		1190: 12.3857421875,
		1191: 10.13525390625,
		1192: 7.94384765625,
		1193: 6.35400390625,
		1194: 7.94384765625,
		1195: 6.11767578125,
		1196: 6.71923828125,
		1197: 5.38720703125,
		1198: 6.11767578125,
		1199: 6.11767578125,
		1200: 6.11767578125,
		1201: 6.11767578125,
		1202: 7.3369140625,
		1203: 6.11767578125,
		1204: 9.3779296875,
		1205: 7.57861328125,
		1206: 7.72900390625,
		1207: 6.38623046875,
		1208: 7.72900390625,
		1209: 6.38623046875,
		1210: 7.72900390625,
		1211: 6.71923828125,
		1212: 9.4208984375,
		1213: 7.46044921875,
		1214: 9.4208984375,
		1215: 7.46044921875,
		1216: 3.05615234375,
		1217: 9.94189453125,
		1218: 7.798828125,
		1219: 7.71826171875,
		1220: 6.57421875,
		1221: 7.71826171875,
		1222: 6.98779296875,
		1223: 7.94384765625,
		1224: 6.64404296875,
		1225: 7.94384765625,
		1226: 6.64404296875,
		1227: 7.72900390625,
		1228: 6.38623046875,
		1229: 9.1630859375,
		1230: 8.13720703125,
		1231: 3.05615234375,
		1232: 7.94384765625,
		1233: 6.11767578125,
		1234: 7.94384765625,
		1235: 6.11767578125,
		1236: 11,
		1237: 9.78076171875,
		1238: 7.3369140625,
		1239: 6.11767578125,
		1240: 7.98681640625,
		1241: 6.11767578125,
		1242: 7.98681640625,
		1243: 6.11767578125,
		1244: 9.94189453125,
		1245: 7.798828125,
		1246: 6.89111328125,
		1247: 5.4677734375,
		1248: 6.89111328125,
		1249: 5.7900390625,
		1250: 7.90625,
		1251: 6.76220703125,
		1252: 7.90625,
		1253: 6.76220703125,
		1254: 8.55615234375,
		1255: 6.71923828125,
		1256: 8.55615234375,
		1257: 6.71923828125,
		1258: 8.55615234375,
		1259: 6.71923828125,
		1260: 7.82568359375,
		1261: 6.07470703125,
		1262: 6.8427734375,
		1263: 6.11767578125,
		1264: 6.8427734375,
		1265: 6.11767578125,
		1266: 6.8427734375,
		1267: 6.11767578125,
		1268: 7.72900390625,
		1269: 6.38623046875,
		1270: 6.23583984375,
		1271: 4.58154296875,
		1272: 10.76904296875,
		1273: 9.39404296875,
		1274: 6.23583984375,
		1275: 4.58154296875,
		1276: 7.3369140625,
		1277: 6.11767578125,
		1278: 7.3369140625,
		1279: 6.11767578125,
		1280: 7.90625,
		1281: 6.71923828125,
		1282: 11.3330078125,
		1283: 10.2802734375,
		1284: 10.55419921875,
		1285: 9.302734375,
		1286: 7.23486328125,
		1287: 5.8974609375,
		1288: 11.1396484375,
		1289: 10.51123046875,
		1290: 11.35986328125,
		1291: 10.1728515625,
		1292: 8.55615234375,
		1293: 6.4453125,
		1294: 8.421875,
		1295: 7.70751953125,
		1296: 6.89111328125,
		1297: 5.4677734375,
		1298: 7.71826171875,
		1299: 6.98779296875,
		1306: 8.55615234375,
		1307: 6.71923828125,
		1308: 10.38232421875,
		1309: 8.55615234375,
		1425: 0,
		1426: 0,
		1427: 0,
		1428: 0,
		1429: 0,
		1430: 0,
		1431: 0,
		1432: 0,
		1433: 0,
		1434: 0,
		1435: 0,
		1436: 0,
		1437: 0,
		1438: 0,
		1439: 0,
		1440: 0,
		1441: 0,
		1442: 0,
		1443: 0,
		1444: 0,
		1445: 0,
		1446: 0,
		1447: 0,
		1448: 0,
		1449: 0,
		1450: 0,
		1451: 0,
		1452: 0,
		1453: 0,
		1454: 0,
		1455: 0,
		1456: 0,
		1457: 0,
		1458: 0,
		1459: 0,
		1460: 0,
		1461: 0,
		1462: 0,
		1463: 0,
		1464: 0,
		1465: 0,
		1466: 0,
		1467: 0,
		1468: 0,
		1469: 0,
		1470: 4.2109375,
		1471: 0,
		1472: 6.19287109375,
		1473: 0,
		1474: 0,
		1475: 3.6630859375,
		1476: 0,
		1477: 0,
		1478: 4.6298828125,
		1479: 0,
		1488: 7.50341796875,
		1489: 7.04150390625,
		1490: 5.26904296875,
		1491: 6.40234375,
		1492: 7.43359375,
		1493: 3.3193359375,
		1494: 4.017578125,
		1495: 7.7021484375,
		1496: 7.56787109375,
		1497: 3.3193359375,
		1498: 6.337890625,
		1499: 6.08544921875,
		1500: 6.28955078125,
		1501: 7.92236328125,
		1502: 7.98681640625,
		1503: 3.3193359375,
		1504: 4.74267578125,
		1505: 7.6806640625,
		1506: 6.7998046875,
		1507: 7.4228515625,
		1508: 7.17041015625,
		1509: 6.05859375,
		1510: 6.69775390625,
		1511: 7.19189453125,
		1512: 6.337890625,
		1513: 8.85693359375,
		1514: 7.8955078125,
		1520: 6.64404296875,
		1521: 6.64404296875,
		1522: 6.64404296875,
		1523: 4.46337890625,
		1524: 6.8642578125,
		7424: 6.47216796875,
		7425: 8.53466796875,
		7426: 9.78076171875,
		7427: 6.76220703125,
		7428: 6.11767578125,
		7429: 6.32177734375,
		7430: 6.32177734375,
		7431: 5.50537109375,
		7432: 5.4677734375,
		7433: 3.05615234375,
		7434: 5.58056640625,
		7435: 6.1337890625,
		7436: 4.9736328125,
		7437: 8.13720703125,
		7438: 6.76220703125,
		7439: 6.71923828125,
		7440: 6.11767578125,
		7441: 6.79443359375,
		7442: 6.79443359375,
		7443: 6.79443359375,
		7444: 10.38232421875,
		7445: 6.2841796875,
		7446: 6.71923828125,
		7447: 6.71923828125,
		7448: 6.75146484375,
		7449: 6.41845703125,
		7450: 6.41845703125,
		7451: 5.38720703125,
		7452: 6.40234375,
		7453: 6.71923828125,
		7454: 8.443359375,
		7455: 6.703125,
		7456: 6.11767578125,
		7457: 8.55615234375,
		7458: 5.5,
		7459: 5.32275390625,
		7460: 5.4248046875,
		7461: 6.767578125,
		7462: 4.58154296875,
		7463: 6.11767578125,
		7464: 6.64404296875,
		7465: 6.75146484375,
		7466: 8.28759765625,
		7467: 6.98779296875,
		7468: 5.34423828125,
		7469: 7.65380859375,
		7470: 4.9951171875,
		7471: 4.9951171875,
		7472: 5.00048828125,
		7473: 4.58154296875,
		7474: 4.58154296875,
		7475: 5.51611328125,
		7476: 4.791015625,
		7477: 1.9873046875,
		7478: 3.9423828125,
		7479: 5.0703125,
		7480: 4.2861328125,
		7481: 5.6826171875,
		7482: 4.76416015625,
		7483: 4.76953125,
		7484: 5.7041015625,
		7485: 4.7802734375,
		7486: 4.61376953125,
		7487: 5.048828125,
		7488: 4.76416015625,
		7489: 4.78564453125,
		7490: 6.982421875,
		7491: 4.15185546875,
		7492: 4.15185546875,
		7493: 4.30224609375,
		7494: 6.4775390625,
		7495: 4.30224609375,
		7496: 4.30224609375,
		7497: 4.1357421875,
		7498: 4.1357421875,
		7499: 3.86181640625,
		7500: 3.86181640625,
		7501: 4.296875,
		7502: 1.55224609375,
		7503: 3.8349609375,
		7504: 6.208984375,
		7505: 4.0498046875,
		7506: 4.51171875,
		7507: 4.1787109375,
		7508: 4.51708984375,
		7509: 4.51708984375,
		7510: 4.296875,
		7511: 2.384765625,
		7512: 4.0498046875,
		7513: 4.4794921875,
		7514: 6.208984375,
		7515: 4.00146484375,
		7516: 4.533203125,
		7517: 4.27001953125,
		7518: 4.00146484375,
		7519: 4.48486328125,
		7520: 5.2958984375,
		7521: 4.16796875,
		7522: 1.55224609375,
		7523: 2.771484375,
		7524: 4.0498046875,
		7525: 4.00146484375,
		7526: 4.27001953125,
		7527: 4.00146484375,
		7528: 4.4794921875,
		7529: 5.2958984375,
		7530: 4.16796875,
		7531: 10.140625,
		7532: 6.71923828125,
		7533: 6.71923828125,
		7534: 3.6630859375,
		7535: 9.78076171875,
		7536: 6.71923828125,
		7537: 6.71923828125,
		7538: 4.28076171875,
		7539: 4.28076171875,
		7540: 6.11767578125,
		7541: 3.6630859375,
		7542: 5.5,
		7543: 6.71923828125,
		7544: 4.0390625,
		7545: 6.681640625,
		7546: 9.59814453125,
		7547: 3.05615234375,
		7548: 3.05615234375,
		7549: 6.71923828125,
		7550: 6.40234375,
		7551: 6.83203125,
		7552: 6.71923828125,
		7553: 6.71923828125,
		7554: 3.6630859375,
		7555: 8.44873046875,
		7556: 6.11767578125,
		7557: 3.05615234375,
		7558: 9.78076171875,
		7559: 6.71923828125,
		7560: 6.71923828125,
		7561: 4.28076171875,
		7562: 6.11767578125,
		7563: 5.1240234375,
		7564: 6.11767578125,
		7565: 6.11767578125,
		7566: 5.5,
		7567: 6.11767578125,
		7568: 6.71923828125,
		7569: 6.71923828125,
		7570: 6.11767578125,
		7571: 5.4677734375,
		7572: 5.4677734375,
		7573: 7.2080078125,
		7574: 3.05615234375,
		7575: 6.11767578125,
		7576: 3.6630859375,
		7577: 6.71923828125,
		7578: 5.7900390625,
		7579: 4.30224609375,
		7580: 4.1787109375,
		7581: 4.1787109375,
		7582: 4.51171875,
		7583: 3.86181640625,
		7584: 2.6640625,
		7585: 2.6640625,
		7586: 4.296875,
		7587: 4.04443359375,
		7588: 1.998046875,
		7589: 1.55224609375,
		7590: 1.55224609375,
		7591: 1.998046875,
		7592: 3.3837890625,
		7593: 2.1376953125,
		7594: 1.8046875,
		7595: 3.14208984375,
		7596: 6.208984375,
		7597: 6.208984375,
		7598: 4.63525390625,
		7599: 4.63525390625,
		7600: 4.0927734375,
		7601: 4.51171875,
		7602: 5.51611328125,
		7603: 4.1357421875,
		7604: 3.05615234375,
		7605: 2.384765625,
		7606: 4.46875,
		7607: 4.6298828125,
		7608: 4.0068359375,
		7609: 4.0068359375,
		7610: 4.00146484375,
		7611: 3.974609375,
		7612: 3.974609375,
		7613: 5.1455078125,
		7614: 4.1787109375,
		7615: 3.99609375,
		7616: 0,
		7617: 0,
		7618: 0,
		7619: 0,
		7620: 0,
		7621: 0,
		7622: 0,
		7623: 0,
		7624: 0,
		7625: 0,
		7626: 0,
		7678: 0,
		7679: 0,
		7680: 7.94384765625,
		7681: 6.11767578125,
		7682: 7.94384765625,
		7683: 6.71923828125,
		7684: 7.94384765625,
		7685: 6.71923828125,
		7686: 7.94384765625,
		7687: 6.71923828125,
		7688: 7.94384765625,
		7689: 6.11767578125,
		7690: 7.94384765625,
		7691: 6.71923828125,
		7692: 7.94384765625,
		7693: 6.71923828125,
		7694: 7.94384765625,
		7695: 6.71923828125,
		7696: 7.94384765625,
		7697: 6.71923828125,
		7698: 7.94384765625,
		7699: 6.71923828125,
		7700: 7.3369140625,
		7701: 6.11767578125,
		7702: 7.3369140625,
		7703: 6.11767578125,
		7704: 7.3369140625,
		7705: 6.11767578125,
		7706: 7.3369140625,
		7707: 6.11767578125,
		7708: 7.3369140625,
		7709: 6.11767578125,
		7710: 6.71923828125,
		7711: 3.6630859375,
		7712: 8.55615234375,
		7713: 6.71923828125,
		7714: 7.94384765625,
		7715: 6.71923828125,
		7716: 7.94384765625,
		7717: 6.71923828125,
		7718: 7.94384765625,
		7719: 6.71923828125,
		7720: 7.94384765625,
		7721: 6.71923828125,
		7722: 7.94384765625,
		7723: 6.71923828125,
		7724: 3.05615234375,
		7725: 3.05615234375,
		7726: 3.05615234375,
		7727: 3.05615234375,
		7728: 7.94384765625,
		7729: 6.11767578125,
		7730: 7.94384765625,
		7731: 6.11767578125,
		7732: 7.94384765625,
		7733: 6.11767578125,
		7734: 6.71923828125,
		7735: 3.05615234375,
		7736: 6.71923828125,
		7737: 3.05615234375,
		7738: 6.71923828125,
		7739: 3.05615234375,
		7740: 6.71923828125,
		7741: 3.05615234375,
		7742: 9.1630859375,
		7743: 9.78076171875,
		7744: 9.1630859375,
		7745: 9.78076171875,
		7746: 9.1630859375,
		7747: 9.78076171875,
		7748: 7.94384765625,
		7749: 6.71923828125,
		7750: 7.94384765625,
		7751: 6.71923828125,
		7752: 7.94384765625,
		7753: 6.71923828125,
		7754: 7.94384765625,
		7755: 6.71923828125,
		7756: 8.55615234375,
		7757: 6.71923828125,
		7758: 8.55615234375,
		7759: 6.71923828125,
		7760: 8.55615234375,
		7761: 6.71923828125,
		7762: 8.55615234375,
		7763: 6.71923828125,
		7764: 7.3369140625,
		7765: 6.71923828125,
		7766: 7.3369140625,
		7767: 6.71923828125,
		7768: 7.94384765625,
		7769: 4.28076171875,
		7770: 7.94384765625,
		7771: 4.28076171875,
		7772: 7.94384765625,
		7773: 4.28076171875,
		7774: 7.94384765625,
		7775: 4.28076171875,
		7776: 7.3369140625,
		7777: 6.11767578125,
		7778: 7.3369140625,
		7779: 6.11767578125,
		7780: 7.3369140625,
		7781: 6.11767578125,
		7782: 7.3369140625,
		7783: 6.11767578125,
		7784: 7.3369140625,
		7785: 6.11767578125,
		7786: 6.71923828125,
		7787: 3.6630859375,
		7788: 6.71923828125,
		7789: 3.6630859375,
		7790: 6.71923828125,
		7791: 3.6630859375,
		7792: 6.71923828125,
		7793: 3.6630859375,
		7794: 7.94384765625,
		7795: 6.71923828125,
		7796: 7.94384765625,
		7797: 6.71923828125,
		7798: 7.94384765625,
		7799: 6.71923828125,
		7800: 7.94384765625,
		7801: 6.71923828125,
		7802: 7.94384765625,
		7803: 6.71923828125,
		7804: 7.3369140625,
		7805: 6.11767578125,
		7806: 7.3369140625,
		7807: 6.11767578125,
		7808: 10.38232421875,
		7809: 8.55615234375,
		7810: 10.38232421875,
		7811: 8.55615234375,
		7812: 10.38232421875,
		7813: 8.55615234375,
		7814: 10.38232421875,
		7815: 8.55615234375,
		7816: 10.38232421875,
		7817: 8.55615234375,
		7818: 7.3369140625,
		7819: 6.11767578125,
		7820: 7.3369140625,
		7821: 6.11767578125,
		7822: 7.3369140625,
		7823: 6.11767578125,
		7824: 6.71923828125,
		7825: 5.5,
		7826: 6.71923828125,
		7827: 5.5,
		7828: 6.71923828125,
		7829: 5.5,
		7830: 6.71923828125,
		7831: 3.6630859375,
		7832: 8.55615234375,
		7833: 6.11767578125,
		7834: 6.11767578125,
		7835: 3.05615234375,
		7838: 7.86865234375,
		7840: 7.94384765625,
		7841: 6.11767578125,
		7842: 7.94384765625,
		7843: 6.11767578125,
		7844: 7.94384765625,
		7845: 6.11767578125,
		7846: 7.94384765625,
		7847: 6.11767578125,
		7848: 7.94384765625,
		7849: 6.11767578125,
		7850: 7.94384765625,
		7851: 6.11767578125,
		7852: 7.94384765625,
		7853: 6.11767578125,
		7854: 7.94384765625,
		7855: 6.11767578125,
		7856: 7.94384765625,
		7857: 6.11767578125,
		7858: 7.94384765625,
		7859: 6.11767578125,
		7860: 7.94384765625,
		7861: 6.11767578125,
		7862: 7.94384765625,
		7863: 6.11767578125,
		7864: 7.3369140625,
		7865: 6.11767578125,
		7866: 7.3369140625,
		7867: 6.11767578125,
		7868: 7.3369140625,
		7869: 6.11767578125,
		7870: 7.3369140625,
		7871: 6.11767578125,
		7872: 7.3369140625,
		7873: 6.11767578125,
		7874: 7.3369140625,
		7875: 6.11767578125,
		7876: 7.3369140625,
		7877: 6.11767578125,
		7878: 7.3369140625,
		7879: 6.11767578125,
		7880: 3.05615234375,
		7881: 3.05615234375,
		7882: 3.05615234375,
		7883: 3.05615234375,
		7884: 8.55615234375,
		7885: 6.71923828125,
		7886: 8.55615234375,
		7887: 6.71923828125,
		7888: 8.55615234375,
		7889: 6.71923828125,
		7890: 8.55615234375,
		7891: 6.71923828125,
		7892: 8.55615234375,
		7893: 6.71923828125,
		7894: 8.55615234375,
		7895: 6.71923828125,
		7896: 8.55615234375,
		7897: 6.71923828125,
		7898: 9.38330078125,
		7899: 7.8203125,
		7900: 9.38330078125,
		7901: 7.8203125,
		7902: 9.38330078125,
		7903: 7.8203125,
		7904: 9.38330078125,
		7905: 7.8203125,
		7906: 9.38330078125,
		7907: 7.8203125,
		7908: 7.94384765625,
		7909: 6.71923828125,
		7910: 7.94384765625,
		7911: 6.71923828125,
		7912: 9.12548828125,
		7913: 7.96533203125,
		7914: 9.12548828125,
		7915: 7.96533203125,
		7916: 9.12548828125,
		7917: 7.96533203125,
		7918: 9.12548828125,
		7919: 7.96533203125,
		7920: 9.12548828125,
		7921: 7.96533203125,
		7922: 7.3369140625,
		7923: 6.11767578125,
		7924: 7.3369140625,
		7925: 6.11767578125,
		7926: 7.3369140625,
		7927: 6.11767578125,
		7928: 7.3369140625,
		7929: 6.11767578125,
		7936: 6.76220703125,
		7937: 6.76220703125,
		7938: 6.76220703125,
		7939: 6.76220703125,
		7940: 6.76220703125,
		7941: 6.76220703125,
		7942: 6.76220703125,
		7943: 6.76220703125,
		7944: 7.94384765625,
		7945: 7.94384765625,
		7946: 9.55517578125,
		7947: 9.55517578125,
		7948: 9.55517578125,
		7949: 9.55517578125,
		7950: 9.55517578125,
		7951: 9.55517578125,
		7952: 5.220703125,
		7953: 5.220703125,
		7954: 5.220703125,
		7955: 5.220703125,
		7956: 5.220703125,
		7957: 5.220703125,
		7960: 8.4111328125,
		7961: 8.4111328125,
		7962: 10.5595703125,
		7963: 10.5595703125,
		7964: 10.5595703125,
		7965: 10.5595703125,
		7968: 6.71923828125,
		7969: 6.71923828125,
		7970: 6.71923828125,
		7971: 6.71923828125,
		7972: 6.71923828125,
		7973: 6.71923828125,
		7974: 6.71923828125,
		7975: 6.71923828125,
		7976: 9.01806640625,
		7977: 9.01806640625,
		7978: 11.16650390625,
		7979: 11.16650390625,
		7980: 11.16650390625,
		7981: 11.16650390625,
		7982: 11.16650390625,
		7983: 11.16650390625,
		7984: 3.05615234375,
		7985: 3.05615234375,
		7986: 3.05615234375,
		7987: 3.05615234375,
		7988: 3.05615234375,
		7989: 3.05615234375,
		7990: 3.05615234375,
		7991: 3.05615234375,
		7992: 4.13037109375,
		7993: 4.13037109375,
		7994: 6.27880859375,
		7995: 6.27880859375,
		7996: 6.27880859375,
		7997: 6.27880859375,
		7998: 6.27880859375,
		7999: 6.27880859375,
		8e3: 6.71923828125,
		8001: 6.71923828125,
		8002: 6.71923828125,
		8003: 6.71923828125,
		8004: 6.71923828125,
		8005: 6.71923828125,
		8008: 9.09326171875,
		8009: 9.09326171875,
		8010: 11.45654296875,
		8011: 11.45654296875,
		8012: 10.70458984375,
		8013: 10.70458984375,
		8016: 6.40234375,
		8017: 6.40234375,
		8018: 6.40234375,
		8019: 6.40234375,
		8020: 6.40234375,
		8021: 6.40234375,
		8022: 6.40234375,
		8023: 6.40234375,
		8025: 8.9482421875,
		8027: 10.9892578125,
		8029: 11.5263671875,
		8031: 10.5595703125,
		8032: 9.2919921875,
		8033: 9.2919921875,
		8034: 9.2919921875,
		8035: 9.2919921875,
		8036: 9.2919921875,
		8037: 9.2919921875,
		8038: 9.2919921875,
		8039: 9.2919921875,
		8040: 9.3564453125,
		8041: 9.3564453125,
		8042: 11.7197265625,
		8043: 11.7197265625,
		8044: 10.9677734375,
		8045: 10.9677734375,
		8046: 10.9677734375,
		8047: 10.9677734375,
		8048: 6.76220703125,
		8049: 6.76220703125,
		8050: 5.220703125,
		8051: 5.220703125,
		8052: 6.71923828125,
		8053: 6.71923828125,
		8054: 3.05615234375,
		8055: 3.05615234375,
		8056: 6.71923828125,
		8057: 6.71923828125,
		8058: 6.40234375,
		8059: 6.40234375,
		8060: 9.2919921875,
		8061: 9.2919921875,
		8064: 6.76220703125,
		8065: 6.76220703125,
		8066: 6.76220703125,
		8067: 6.76220703125,
		8068: 6.76220703125,
		8069: 6.76220703125,
		8070: 6.76220703125,
		8071: 6.76220703125,
		8072: 7.94384765625,
		8073: 7.94384765625,
		8074: 9.55517578125,
		8075: 9.55517578125,
		8076: 9.55517578125,
		8077: 9.55517578125,
		8078: 9.55517578125,
		8079: 9.55517578125,
		8080: 6.71923828125,
		8081: 6.71923828125,
		8082: 6.71923828125,
		8083: 6.71923828125,
		8084: 6.71923828125,
		8085: 6.71923828125,
		8086: 6.71923828125,
		8087: 6.71923828125,
		8088: 9.01806640625,
		8089: 9.01806640625,
		8090: 11.16650390625,
		8091: 11.16650390625,
		8092: 11.16650390625,
		8093: 11.16650390625,
		8094: 11.16650390625,
		8095: 11.16650390625,
		8096: 9.2919921875,
		8097: 9.2919921875,
		8098: 9.2919921875,
		8099: 9.2919921875,
		8100: 9.2919921875,
		8101: 9.2919921875,
		8102: 9.2919921875,
		8103: 9.2919921875,
		8104: 9.3564453125,
		8105: 9.3564453125,
		8106: 11.7197265625,
		8107: 11.7197265625,
		8108: 10.9677734375,
		8109: 10.9677734375,
		8110: 10.9677734375,
		8111: 10.9677734375,
		8112: 6.76220703125,
		8113: 6.76220703125,
		8114: 6.76220703125,
		8115: 6.76220703125,
		8116: 6.76220703125,
		8118: 6.76220703125,
		8119: 6.76220703125,
		8120: 7.94384765625,
		8121: 7.94384765625,
		8122: 7.94384765625,
		8123: 7.94384765625,
		8124: 7.94384765625,
		8125: 3.6630859375,
		8126: 3.6630859375,
		8127: 3.6630859375,
		8128: 3.6630859375,
		8129: 3.6630859375,
		8130: 6.71923828125,
		8131: 6.71923828125,
		8132: 6.71923828125,
		8134: 6.71923828125,
		8135: 6.71923828125,
		8136: 9.4853515625,
		8137: 9.4853515625,
		8138: 10.09228515625,
		8139: 10.09228515625,
		8140: 7.94384765625,
		8141: 3.6630859375,
		8142: 3.6630859375,
		8143: 3.6630859375,
		8144: 3.05615234375,
		8145: 3.05615234375,
		8146: 3.05615234375,
		8147: 3.05615234375,
		8150: 3.05615234375,
		8151: 3.05615234375,
		8152: 3.05615234375,
		8153: 3.05615234375,
		8154: 5.20458984375,
		8155: 5.20458984375,
		8157: 3.6630859375,
		8158: 3.6630859375,
		8159: 3.6630859375,
		8160: 6.40234375,
		8161: 6.40234375,
		8162: 6.40234375,
		8163: 6.40234375,
		8164: 6.80517578125,
		8165: 6.80517578125,
		8166: 6.40234375,
		8167: 6.40234375,
		8168: 7.3369140625,
		8169: 7.3369140625,
		8170: 9.4853515625,
		8171: 10.0224609375,
		8172: 8.4111328125,
		8173: 5.11328125,
		8174: 5.11328125,
		8175: 3.6630859375,
		8178: 9.2919921875,
		8179: 9.2919921875,
		8180: 9.2919921875,
		8182: 9.2919921875,
		8183: 9.2919921875,
		8184: 10.16748046875,
		8185: 9.09326171875,
		8186: 10.4306640625,
		8187: 9.3564453125,
		8188: 8.8193359375,
		8189: 3.6630859375,
		8190: 3.6630859375,
		8192: 5.5,
		8193: 11,
		8194: 5.5,
		8195: 11,
		8196: 3.66845703125,
		8197: 2.75,
		8198: 1.83154296875,
		8199: 6.11767578125,
		8200: 3.05615234375,
		8201: 2.2021484375,
		8202: .91845703125,
		8203: 0,
		8204: 0,
		8205: 0,
		8206: 0,
		8207: 0,
		8210: 6.11767578125,
		8211: 6.11767578125,
		8212: 11,
		8213: 11,
		8214: 5.47314453125,
		8215: 6.07470703125,
		8216: 3.05615234375,
		8217: 3.05615234375,
		8218: 3.05615234375,
		8219: 3.05615234375,
		8220: 5.5,
		8221: 5.5,
		8222: 5.5,
		8223: 5.5,
		8224: 6.11767578125,
		8225: 6.11767578125,
		8226: 3.85107421875,
		8230: 11,
		8234: 0,
		8235: 0,
		8236: 0,
		8237: 0,
		8238: 0,
		8239: 2.2021484375,
		8240: 11,
		8242: 2.63720703125,
		8243: 5.26904296875,
		8244: 5.26904296875,
		8249: 3.6630859375,
		8250: 3.6630859375,
		8252: 6.64404296875,
		8254: 3.6630859375,
		8260: 1.8369140625,
		8286: 3.6630859375,
		8298: 0,
		8299: 0,
		8300: 0,
		8301: 0,
		8302: 0,
		8303: 0,
		8308: 3.6630859375,
		8309: 3.6630859375,
		8311: 3.6630859375,
		8312: 3.6630859375,
		8319: 4.35595703125,
		8336: 4.15185546875,
		8337: 4.1357421875,
		8338: 4.51171875,
		8339: 4.0283203125,
		8340: 4.1357421875,
		8352: 6.11767578125,
		8353: 7.94384765625,
		8354: 7.94384765625,
		8355: 6.11767578125,
		8356: 6.11767578125,
		8357: 9.78076171875,
		8358: 7.94384765625,
		8359: 12.03125,
		8360: 13.47607421875,
		8361: 10.38232421875,
		8362: 9.7216796875,
		8363: 5.64501953125,
		8364: 6.11767578125,
		8365: 7.94384765625,
		8366: 6.71923828125,
		8367: 11.9453125,
		8368: 6.11767578125,
		8369: 7.3369140625,
		8370: 8.55615234375,
		8371: 7.94384765625,
		8372: 7.3369140625,
		8373: 7.94384765625,
		8432: 0,
		8453: 9.73779296875,
		8467: 5.37646484375,
		8470: 12.26220703125,
		8471: 8.10498046875,
		8482: 11,
		8486: 8.44873046875,
		8494: 6.60107421875,
		8525: 11,
		8526: 5.50537109375,
		8531: 9.173828125,
		8532: 9.173828125,
		8539: 9.173828125,
		8540: 9.173828125,
		8541: 9.173828125,
		8542: 9.173828125,
		8580: 6.11767578125,
		8592: 11,
		8593: 5.5,
		8594: 11,
		8595: 5.5,
		8596: 11,
		8597: 5.5,
		8616: 5.5,
		8706: 5.435546875,
		8710: 6.72998046875,
		8719: 9.0556640625,
		8721: 7.841796875,
		8722: 6.423828125,
		8725: 1.8369140625,
		8729: 3.05615234375,
		8730: 6.037109375,
		8734: 7.841796875,
		8735: 10.76904296875,
		8745: 7.94384765625,
		8747: 3.01318359375,
		8776: 6.037109375,
		8800: 6.037109375,
		8801: 6.41845703125,
		8804: 6.037109375,
		8805: 6.037109375,
		8962: 6.64404296875,
		8976: 6.423828125,
		8992: 6.64404296875,
		8993: 6.64404296875,
		9472: 7.79345703125,
		9474: 6.875,
		9484: 7.79345703125,
		9488: 7.79345703125,
		9492: 7.79345703125,
		9496: 7.79345703125,
		9500: 7.79345703125,
		9508: 7.79345703125,
		9516: 7.79345703125,
		9524: 7.79345703125,
		9532: 7.79345703125,
		9552: 7.79345703125,
		9553: 7.79345703125,
		9554: 7.79345703125,
		9555: 7.79345703125,
		9556: 7.79345703125,
		9557: 7.79345703125,
		9558: 7.79345703125,
		9559: 7.79345703125,
		9560: 7.79345703125,
		9561: 7.79345703125,
		9562: 7.79345703125,
		9563: 7.79345703125,
		9564: 7.79345703125,
		9565: 7.79345703125,
		9566: 7.79345703125,
		9567: 7.79345703125,
		9568: 7.79345703125,
		9569: 7.79345703125,
		9570: 7.79345703125,
		9571: 7.79345703125,
		9572: 7.79345703125,
		9573: 7.79345703125,
		9574: 7.79345703125,
		9575: 7.79345703125,
		9576: 7.79345703125,
		9577: 7.79345703125,
		9578: 7.79345703125,
		9579: 7.79345703125,
		9580: 7.79345703125,
		9600: 7.79345703125,
		9604: 7.79345703125,
		9608: 7.79345703125,
		9612: 7.79345703125,
		9616: 7.79345703125,
		9617: 7.79345703125,
		9618: 7.79345703125,
		9619: 8.01904296875,
		9632: 6.64404296875,
		9633: 6.64404296875,
		9642: 3.8994140625,
		9643: 3.8994140625,
		9644: 11,
		9650: 10.88720703125,
		9658: 10.88720703125,
		9660: 10.88720703125,
		9668: 10.88720703125,
		9674: 5.435546875,
		9675: 6.64404296875,
		9676: 6.53662109375,
		9679: 6.64404296875,
		9688: 6.64404296875,
		9689: 6.64404296875,
		9702: 3.8994140625,
		9786: 11.23095703125,
		9787: 11.57470703125,
		9788: 10.08154296875,
		9792: 8.25,
		9794: 8.25,
		9824: 5.84375,
		9827: 7.21875,
		9829: 6.53125,
		9830: 5.61279296875,
		9834: 5.5,
		9835: 8.25,
		9839: 5.5,
		11360: 6.71923828125,
		11361: 3.05615234375,
		11362: 6.71923828125,
		11363: 7.3369140625,
		11364: 7.94384765625,
		11365: 6.11767578125,
		11366: 3.6630859375,
		11367: 7.94384765625,
		11368: 6.71923828125,
		11369: 7.94384765625,
		11370: 6.11767578125,
		11371: 6.71923828125,
		11372: 5.5,
		11373: 8.39501953125,
		11377: 6.66552734375,
		11378: 11.48876953125,
		11379: 9.4423828125,
		11380: 6.11767578125,
		11381: 5.951171875,
		11382: 4.791015625,
		11383: 7.86865234375,
		11799: 3.6630859375,
		42775: 0,
		42776: 0,
		42777: 0,
		42778: 0,
		42779: 5.5,
		42780: 5.5,
		42781: 3.6630859375,
		42782: 3.6630859375,
		42783: 3.6630859375,
		42784: 0,
		42785: 0,
		42888: 3.6630859375,
		42889: 3.6630859375,
		42890: 4.275390625,
		42891: 2.61572265625,
		42892: 2.61572265625,
		64257: 6.71923828125,
		64258: 6.71923828125,
		64285: 3.3193359375,
		64286: 0,
		64287: 6.64404296875,
		64288: 6.7998046875,
		64289: 7.50341796875,
		64290: 6.40234375,
		64291: 7.43359375,
		64292: 6.08544921875,
		64293: 6.28955078125,
		64294: 7.92236328125,
		64295: 6.337890625,
		64296: 7.8955078125,
		64297: 6.64404296875,
		64298: 8.85693359375,
		64299: 8.85693359375,
		64300: 8.85693359375,
		64301: 8.85693359375,
		64302: 7.50341796875,
		64303: 7.50341796875,
		64304: 7.50341796875,
		64305: 7.04150390625,
		64306: 5.26904296875,
		64307: 6.40234375,
		64308: 7.43359375,
		64309: 3.3193359375,
		64310: 4.017578125,
		64312: 7.56787109375,
		64313: 3.3193359375,
		64314: 6.337890625,
		64315: 6.08544921875,
		64316: 6.28955078125,
		64318: 7.98681640625,
		64320: 4.74267578125,
		64321: 7.6806640625,
		64323: 7.4228515625,
		64324: 7.17041015625,
		64326: 6.69775390625,
		64327: 7.19189453125,
		64328: 6.337890625,
		64329: 8.85693359375,
		64330: 7.8955078125,
		64331: 3.3193359375,
		64332: 7.04150390625,
		64333: 6.08544921875,
		64334: 7.17041015625,
		64335: 7.34765625,
		65056: 0,
		65057: 0,
		65058: 0,
		65059: 0,
		65532: 11,
		avg: 6.083756411085985
	}
}, qd = Q(120), Jd = Q(2), Yd = (e) => e !== "description", Xd = (e, t) => Math.ceil(ul(wn({ lineTotal: t })[e], Kd.bold) + 8), Zd = ({ pricingTables: e, visibleColumns: t, totals: n, lineTotal: r }) => {
	let i = hl({
		pricingTables: e,
		totals: n,
		totalsColumn: r ? "total" : "rate",
		metrics: Kd,
		paddingX: 4,
		defaultWidth: 0
	}), a = new Map(t.filter(Yd).map((e) => [e, Math.round(Q(Math.max(i[e], Xd(e, r)))) + Jd])), o = [...a.values()].reduce((e, t) => e + t, 0), s = Math.max(lu - o, qd);
	return td(t.map((e) => e === "description" ? s : a.get(e) ?? 0));
}, Qd = ({ registerNumbering: e, imageData: t, data: n, settings: r, visibleColumns: i, columnWidths: a }) => {
	let o = (s, c) => M(s).with({ blockType: "heading1" }, { blockType: "heading2" }, { blockType: "heading3" }, ({ blockType: e, config: t }) => z(t) ? [xu(e, t)] : []).with({ blockType: "paragraph" }, ({ config: e }) => z(e) ? [ju(e)] : []).with({ blockType: "bulletList" }, { blockType: "numberList" }, ({ blockType: t, version: n, config: r }) => Du({
		blockType: t,
		version: n,
		config: r,
		level: c,
		registerNumbering: e,
		renderChildBlock: o
	})).with({ blockType: "table" }, ({ version: e, config: t }) => e === 1 && pn(t) ? [ad(t), mu(0)] : []).with({ blockType: "divider" }, () => [zl()]).with({ blockType: "image" }, ({ config: e }) => rn(e) ? Su(e, t) : []).with({ blockType: "phases" }, ({ config: e }) => cn(e) ? [...ed({
		config: e,
		data: n,
		settings: r,
		visibleColumns: i,
		columnWidths: a
	}), mu(0)] : []).with({ blockType: "coverImage" }, { blockType: "pdfCoverImage" }, () => []).exhaustive();
	return o;
}, $d = ["bulletList", "numberList"], ef = (e) => $d.includes(e.blockType), tf = (e, t) => e.flatMap((n, r) => {
	let i = t(n, 0), a = e[r + 1];
	if (!a) return i;
	let o = ef(n) && ef(a);
	return [...i, mu(o ? 0 : $l)];
}), nf = (e, t = []) => {
	let n = Au(), r = _r({ presentation: e.presentation }), i = Ts(r.blocks), { pricingTables: a, defaultVisibleColumns: o } = is({
		blocks: i,
		settings: r.settings,
		phaseSubTotals: e.phaseSubTotals,
		priceCommitments: e.priceCommitments,
		quotePriceTotalsPerPhase: e.quotePriceTotalsPerPhase,
		context: "pdf_v3"
	}), s = rs({
		rows: a.flatMap(({ rows: e }) => e),
		defaultVisibleColumns: o
	}), c = Zd({
		pricingTables: a,
		visibleColumns: s,
		totals: br({
			dealType: e.dealType,
			overallTotal: Zn({
				currency: e.currency,
				value: e.totalDiscountedRate
			}),
			amendmentTotals: yr({
				currency: e.currency,
				amendment: e.amendment
			}),
			dueUpfront: Qn({
				currency: e.currency,
				value: e.totalDueOnStartDate
			})
		}).rows.map((e) => e.amount),
		lineTotal: r.settings.columns.lineTotal
	}), l = Qd({
		registerNumbering: n.register,
		imageData: t,
		data: e,
		settings: r.settings,
		visibleColumns: s,
		columnWidths: c
	}), u = [
		...vd(e, t),
		...dd(e),
		...Gd(e),
		...tf(i, l)
	], d = sd(r, t), f = d?.width && d.height ? d : void 0, p = t.find((t) => t.urlUnsigned === e.merchantLogoUrl), m = {
		properties: { page: {
			size: {
				width: ru,
				height: iu
			},
			margin: {
				top: au,
				bottom: ou,
				left: au,
				right: au,
				footer: su
			},
			pageNumbers: { start: 1 }
		} },
		footers: { default: zd(e) },
		children: u
	};
	return new Nt({
		styles: pu,
		numbering: { config: n.configs },
		sections: f ? [{
			properties: { page: {
				size: {
					width: ru,
					height: iu
				},
				margin: {
					top: 0,
					bottom: ou,
					left: au,
					right: au,
					footer: su
				}
			} },
			footers: { default: Rd(e) },
			children: Td(e, f, p)
		}, m] : [m]
	});
}, rf = (e, t = []) => Wt.toBlob(nf(e, t)), af = ({ fetchQuoteData: e, assetLoader: t }) => {
	let { displayPromiseNotification: n } = Qe(), r = i(async () => {
		let n = e(), r = await rf(n, await of(n, t));
		return ot(`${n.quoteNumber}.docx`)(r), r;
	}, [e, t]);
	return { onClick: i(async () => {
		await n(r(), {
			loading: "Preparing download",
			success: "Download ready",
			error: "DOCX download failed"
		});
	}, [n, r]) };
}, of = async (e, t) => {
	let { settings: n, blocks: r } = _r({ presentation: e.presentation }), i = od(r), a = await Ds({
		presentation: e.presentation,
		assetLoader: t,
		getImageDimensions: async () => ({
			width: void 0,
			height: void 0
		})
	}), o = n.showImagesInPdfBody ? a : a.filter((e) => e.urlUnsigned === i);
	return (await Promise.all([...o.map(({ urlUnsigned: e, urlSigned: t }) => sf(t, e)), e.merchantLogoUrl ? sf(e.merchantLogoUrl, e.merchantLogoUrl) : void 0])).filter((e) => !!e);
}, sf = async (e, t) => {
	let n = await xl(e);
	if (n) return {
		urlUnsigned: t,
		data: await n.blob.arrayBuffer(),
		type: cf(n.blob.type),
		width: n.width,
		height: n.height
	};
}, cf = (e) => M(e).with("image/png", () => "png").with("image/jpeg", () => "jpg").with("image/gif", () => "gif").with("image/bmp", () => "bmp").otherwise(() => "jpg"), lf = {
	NEW_BUSINESS: "New business",
	RENEWAL: "Renewal",
	AMENDMENT: "Amendment"
};
//#endregion
export { er as ContactRow, bl as PdfQuoteRendererV3, tr as PopoverContacts, $n as PopoverCustomerCard, Sn as QUOTE_CONTAINER_WIDTH, lf as QUOTE_DEAL_TYPE_LABELS, zo as QuoteSummary, hs as ReactQuoteRenderer, _r as apiPresentationToQuotePresentation, ir as getGroupByPhaseData, Ds as getPdfImageDataV3, rr as getPhaseLabel, qo as getPresentationPhases, Dn as getTotalDisclaimerText, ln as isCoverImageBlockConfig, un as isCoverImageBlockConfigV2, fn as isEnrichedTextArray, rn as isImageBlockConfig, an as isListBlockConfig, on as isListBlockConfigV2, sn as isListBlockConfigV3, cn as isPhaseBlockConfig, dn as isQuoteBlock, pn as isTableBlockConfig, z as isTextBlockConfig, Pn as presentationBlocksToQuoteBlocks, U as quoteDataAtom, rf as quoteToDocxBlob, In as renderContractLength, nr as sortProductsByPresentationOrder, Zo as stripHiddenOpenEndedPhases, es as stripPhasesBeforeAmendmentEffectiveFrom, af as useQuoteDocxDownload, Cl as useQuotePdfDownload, Tl as useRemoteQuotePdfDownload, Jo as withPresentationPhases };

//# sourceMappingURL=index.js.map